import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Upload: any;
};

export type IAddCompanyInput = {
  company_type_id: Scalars['Int'];
  info?: InputMaybe<Scalars['String']>;
  market_activity_id: Scalars['Int'];
  market_second_specialty?: InputMaybe<Scalars['String']>;
  member_index?: InputMaybe<Scalars['Boolean']>;
  membership_id: Scalars['Int'];
  name: Scalars['String'];
  unique_stock_code?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type IAddCventContact = {
  company_name?: InputMaybe<Scalars['String']>;
  date_created: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  is_approved?: InputMaybe<Scalars['Boolean']>;
  last_name: Scalars['String'];
  location_id: Scalars['Int'];
  role_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type IAddInterestResult = {
  __typename?: 'AddInterestResult';
  id: Scalars['ID'];
  interest_group_id: Scalars['ID'];
  name: Scalars['String'];
};

export type IAddMeetingInput = {
  contact_id?: InputMaybe<Scalars['Int']>;
  contacts?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  end_time?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  meeting_details?: InputMaybe<Scalars['String']>;
  meeting_type_id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type IAddNewEventInput = {
  company_id: Scalars['Int'];
  creator_id: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  location?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  title: Scalars['String'];
  type_id: Scalars['Int'];
};

export type IAddValueResult = {
  __typename?: 'AddValueResult';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IAddress = {
  __typename?: 'Address';
  address_name?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  complete_vat_number?: Maybe<Scalars['String']>;
  country: ICountry;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_main?: Maybe<Scalars['Boolean']>;
  is_nav?: Maybe<Scalars['Boolean']>;
  is_website?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  vat_country_code?: Maybe<Scalars['String']>;
  vat_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type IAddressInput = {
  city: Scalars['String'];
  country_id: Scalars['Int'];
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  is_main?: InputMaybe<Scalars['Boolean']>;
  is_nav?: InputMaybe<Scalars['Boolean']>;
  is_website?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  vat_country_code?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type IAllocationCountryInput = {
  country_id: Scalars['ID'];
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type IAllocationSector = {
  __typename?: 'AllocationSector';
  id: Scalars['ID'];
  sector_id: Scalars['ID'];
  stock_id: Scalars['ID'];
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type IAllocationSectorInput = {
  sector_id: Scalars['ID'];
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type IAuthUser = {
  __typename?: 'AuthUser';
  token: Scalars['String'];
  user: IUser;
};

export type IAwardInput = {
  date: Scalars['String'];
  type_id: Scalars['ID'];
};

export type IAwardType = {
  __typename?: 'AwardType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum ICacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type ICalendarEvent = {
  __typename?: 'CalendarEvent';
  company: ICompany;
  creator: IContact;
  description?: Maybe<Scalars['String']>;
  end_date: Scalars['String'];
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  start_date: Scalars['String'];
  title: Scalars['String'];
  type: IMeetingType;
};

export type IClientOptions = {
  __typename?: 'ClientOptions';
  companies: Array<Maybe<ICompany>>;
  contacts: Array<Maybe<IContact>>;
};

export type IComment = {
  __typename?: 'Comment';
  author: IUser;
  date: Scalars['String'];
  id: Scalars['ID'];
  membership: IMembership;
  text: Scalars['String'];
};

export type ICompaniesPage = {
  __typename?: 'CompaniesPage';
  companies: Array<Maybe<ICompany>>;
  total: Scalars['Int'];
};

export type ICompany = {
  __typename?: 'Company';
  company_type: ICompanyType;
  id: Scalars['ID'];
  info?: Maybe<Scalars['String']>;
  is_main_member: Scalars['Boolean'];
  main_address?: Maybe<IAddress>;
  main_contacts: Array<Maybe<IContact>>;
  market_activity: IMarketActivity;
  market_second_specialty?: Maybe<Scalars['String']>;
  member_index: Scalars['Boolean'];
  membership: IMembership;
  name: Scalars['String'];
  unique_stock_code?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type ICompanyFilterInput = {
  city?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  company_type_id?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['String']>;
  country_id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  market_activity_id?: InputMaybe<Scalars['Int']>;
  membership_id?: InputMaybe<Scalars['Int']>;
  membership_type_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
};

export type ICompanyType = {
  __typename?: 'CompanyType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IContact = {
  __typename?: 'Contact';
  address?: Maybe<IAddress>;
  assistant?: Maybe<IContact>;
  company: ICompany;
  contactMeetings?: Maybe<Array<Maybe<IMeeting>>>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  informal_name?: Maybe<Scalars['String']>;
  is_main: Scalars['Boolean'];
  last_name: Scalars['String'];
  linkedin?: Maybe<Scalars['String']>;
  location_of_contact?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  office365_id?: Maybe<Scalars['String']>;
  phone_direct?: Maybe<Scalars['String']>;
  phone_mobile?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  titleInternal: ITitleInternal;
  title_external?: Maybe<Scalars['String']>;
};

export type IContactCreateInput = {
  company_id: Scalars['Int'];
  email: Scalars['String'];
  fax?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  informal_name?: InputMaybe<Scalars['String']>;
  interest_ids: Array<InputMaybe<Scalars['Int']>>;
  last_name: Scalars['String'];
  linkedin?: InputMaybe<Scalars['String']>;
  location_of_contact?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone_direct?: InputMaybe<Scalars['String']>;
  phone_mobile?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  title_external?: InputMaybe<Scalars['String']>;
  title_internal_id: Scalars['Int'];
};

export type IContactFilterInput = {
  address?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type IContactInput = {
  company_id: Scalars['Int'];
  email: Scalars['String'];
  fax?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  informal_name?: InputMaybe<Scalars['String']>;
  last_name: Scalars['String'];
  linkedin?: InputMaybe<Scalars['String']>;
  location_of_contact?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone_direct?: InputMaybe<Scalars['String']>;
  phone_mobile?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  title_external?: InputMaybe<Scalars['String']>;
  title_internal_id: Scalars['Int'];
};

export type IContactInterests = {
  __typename?: 'ContactInterests';
  contact_id: Scalars['ID'];
  interest_id: Scalars['ID'];
};

export type IContactsPage = {
  __typename?: 'ContactsPage';
  contacts: Array<Maybe<IContact>>;
  total: Scalars['Int'];
};

export type ICountry = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  region?: Maybe<IRegion>;
};

export type ICreateUserInput = {
  confirm_password: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  password: Scalars['String'];
  user_role_ids: Array<InputMaybe<Scalars['Int']>>;
  username: Scalars['String'];
};

export type ICurrency = {
  __typename?: 'Currency';
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ICventContact = {
  __typename?: 'CventContact';
  company_name?: Maybe<Scalars['String']>;
  contact_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice?: Maybe<IInvoice>;
  is_approved?: Maybe<Scalars['Boolean']>;
  is_linked?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  pk_event_location: Scalars['Int'];
  role?: Maybe<ICventRole>;
  title?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

export type ICventEvent = {
  __typename?: 'CventEvent';
  created_by?: Maybe<Scalars['String']>;
  date_edit?: Maybe<Scalars['String']>;
  date_insert?: Maybe<Scalars['String']>;
  event_stub?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  is_paid_event?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pk_email_networking?: Maybe<Scalars['Int']>;
  pk_email_payment_reminder?: Maybe<Scalars['Int']>;
  pk_email_registration?: Maybe<Scalars['Int']>;
  pk_product_registration?: Maybe<Scalars['Int']>;
  update_by?: Maybe<Scalars['String']>;
  url_landing_page?: Maybe<Scalars['String']>;
};

export type ICventLocation = {
  __typename?: 'CventLocation';
  event_id: Scalars['ID'];
  id: Scalars['ID'];
  is_online?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  networking_enabled?: Maybe<Scalars['Boolean']>;
  pk_email_networking?: Maybe<Scalars['Int']>;
  pk_email_payment_reminder?: Maybe<Scalars['Int']>;
  pk_email_registration?: Maybe<Scalars['Int']>;
  pk_product_registration?: Maybe<Scalars['Int']>;
  url_landing_page?: Maybe<Scalars['String']>;
};

export type ICventRole = {
  __typename?: 'CventRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  name_short?: Maybe<Scalars['String']>;
};

export type IDashboardDoughnut = {
  __typename?: 'DashboardDoughnut';
  count: Scalars['Int'];
  label: Scalars['String'];
  membership_type: Scalars['String'];
};

export type IDashboardInvoices = {
  __typename?: 'DashboardInvoices';
  date: Scalars['String'];
  issued_invoices: Scalars['Int'];
  outstanding: Scalars['Int'];
  paid_invoices: Scalars['Int'];
  total_issued_invoices_count: Scalars['Int'];
  total_paid_invoices_count: Scalars['Int'];
};

export type IDashboardMembershipInfoForLastThreeYears = {
  __typename?: 'DashboardMembershipInfoForLastThreeYears';
  endedLegend: Scalars['String'];
  ended_memberships_count: Scalars['Int'];
  quarters_date: Scalars['String'];
  renewedLegend: Scalars['String'];
  renewed_memberships_count: Scalars['Int'];
  startedLegend: Scalars['String'];
  started_memberships_count: Scalars['Int'];
};

export type IDeleteHistoryStocksDataInput = {
  endDate: Scalars['String'];
};

export type IDividendGross = {
  __typename?: 'DividendGross';
  id: Scalars['ID'];
  start_date: Scalars['String'];
  stock_id: Scalars['ID'];
  value?: Maybe<Scalars['Float']>;
};

export type IDividendInput = {
  start_date: Scalars['String'];
  value: Scalars['Float'];
};

export type IDocument = {
  __typename?: 'Document';
  company: ICompany;
  country?: Maybe<ICountry>;
  description?: Maybe<Scalars['String']>;
  destination_url?: Maybe<Scalars['String']>;
  display_name: Scalars['String'];
  downloads?: Maybe<Scalars['Int']>;
  file_name: Scalars['String'];
  id: Scalars['ID'];
  protected_until?: Maybe<Scalars['String']>;
  site_sections?: Maybe<Array<Maybe<ISiteSection>>>;
  visible_from?: Maybe<Scalars['String']>;
};

export type IDocumentFilterInput = {
  company_id?: InputMaybe<Scalars['Int']>;
  country_id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  visible_from?: InputMaybe<Scalars['String']>;
};

export type IDocumentInput = {
  company_id: Scalars['Int'];
  country_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name: Scalars['String'];
  file?: InputMaybe<Scalars['Upload']>;
  file_name: Scalars['String'];
  protected_until?: InputMaybe<Scalars['String']>;
  site_sections?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  visible_from?: InputMaybe<Scalars['String']>;
};

export type IDocumentsPage = {
  __typename?: 'DocumentsPage';
  documents: Array<Maybe<IDocument>>;
  total: Scalars['Int'];
};

export type IEmailInput = {
  email_banner?: InputMaybe<Scalars['String']>;
  email_body?: InputMaybe<Scalars['String']>;
  email_subject?: InputMaybe<Scalars['String']>;
};

export type IEtf = {
  __typename?: 'Etf';
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  is_deleted: Scalars['Boolean'];
  launch_date: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
};

export type IEtfInput = {
  identifier: Scalars['String'];
  launch_date: Scalars['String'];
  name: Scalars['String'];
  provider: Scalars['String'];
};

export type IEtfValue = {
  __typename?: 'EtfValue';
  aum: Scalars['Float'];
  date: Scalars['String'];
  etf: IEtf;
  id: Scalars['ID'];
  index_total_return_one_year: Scalars['Float'];
  index_total_return_three_year?: Maybe<Scalars['Float']>;
  total_return_one_year: Scalars['Float'];
  total_return_three_year?: Maybe<Scalars['Float']>;
};

export type IEtfValueInput = {
  aum: Scalars['Float'];
  date: Scalars['String'];
  index_total_return_one_year: Scalars['Float'];
  index_total_return_three_year?: InputMaybe<Scalars['Float']>;
  total_return_one_year: Scalars['Float'];
  total_return_three_year?: InputMaybe<Scalars['Float']>;
};

export type IFtseConfiguration = {
  __typename?: 'FtseConfiguration';
  id: Scalars['ID'];
  property: Scalars['String'];
  value: Scalars['String'];
};

export type IFtseFile = {
  __typename?: 'FtseFile';
  attempt?: Maybe<Scalars['Int']>;
  file_location: Scalars['String'];
  id: Scalars['ID'];
  last_get?: Maybe<Scalars['String']>;
  last_import?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type?: Maybe<IFtseType>;
};

export type IFtseFx = {
  __typename?: 'FtseFx';
  currency: ICurrency;
  date: Scalars['String'];
  id: Scalars['ID'];
  rate: Scalars['Float'];
};

export type IFtseType = {
  __typename?: 'FtseType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IHistoryAllocationCountry = {
  __typename?: 'HistoryAllocationCountry';
  country: ICountry;
  id: Scalars['ID'];
  stock_id: Scalars['ID'];
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type IHistoryAward = {
  __typename?: 'HistoryAward';
  date: Scalars['String'];
  id: Scalars['ID'];
  stock_id: Scalars['ID'];
  type: IAwardType;
};

export type IHistoryConstituent = {
  __typename?: 'HistoryConstituent';
  date: Scalars['String'];
  file_name?: Maybe<Scalars['String']>;
  history_index?: Maybe<IHistoryIndex>;
  id: Scalars['ID'];
  index: IIndex;
  rank?: Maybe<Scalars['Int']>;
  stock: IStock;
  stock_id: Scalars['ID'];
  weight_perc: Scalars['Float'];
  weighting?: Maybe<Scalars['Float']>;
};

export type IHistoryIndex = {
  __typename?: 'HistoryIndex';
  date: Scalars['String'];
  dividend_net_yield?: Maybe<Scalars['Float']>;
  dividend_yield?: Maybe<Scalars['Float']>;
  file_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index_id: Scalars['ID'];
  mkt_cap_aud?: Maybe<Scalars['Float']>;
  mkt_cap_eur?: Maybe<Scalars['Float']>;
  mkt_cap_gbp?: Maybe<Scalars['Float']>;
  mkt_cap_hkd?: Maybe<Scalars['Float']>;
  mkt_cap_jpy?: Maybe<Scalars['Float']>;
  mkt_cap_local?: Maybe<Scalars['Float']>;
  mkt_cap_usd?: Maybe<Scalars['Float']>;
  price_close_aud?: Maybe<Scalars['Float']>;
  price_close_epra_local?: Maybe<Scalars['Float']>;
  price_close_eur?: Maybe<Scalars['Float']>;
  price_close_gbp?: Maybe<Scalars['Float']>;
  price_close_hkd?: Maybe<Scalars['Float']>;
  price_close_jpy?: Maybe<Scalars['Float']>;
  price_close_local?: Maybe<Scalars['Float']>;
  price_close_usd?: Maybe<Scalars['Float']>;
  price_net_aud?: Maybe<Scalars['Float']>;
  price_net_eur?: Maybe<Scalars['Float']>;
  price_net_gbp?: Maybe<Scalars['Float']>;
  price_net_hkd?: Maybe<Scalars['Float']>;
  price_net_jpy?: Maybe<Scalars['Float']>;
  price_net_local?: Maybe<Scalars['Float']>;
  price_net_usd?: Maybe<Scalars['Float']>;
  price_return_aud?: Maybe<Scalars['Float']>;
  price_return_epra_local?: Maybe<Scalars['Float']>;
  price_return_eur?: Maybe<Scalars['Float']>;
  price_return_gbp?: Maybe<Scalars['Float']>;
  price_return_hkd?: Maybe<Scalars['Float']>;
  price_return_jpy?: Maybe<Scalars['Float']>;
  price_return_local?: Maybe<Scalars['Float']>;
  price_return_usd?: Maybe<Scalars['Float']>;
};

export type IHistoryIndexInput = {
  date_day: Scalars['String'];
  index_code: Scalars['String'];
  mkt_cap_aud?: InputMaybe<Scalars['Float']>;
  mkt_cap_eur?: InputMaybe<Scalars['Float']>;
  mkt_cap_gbp?: InputMaybe<Scalars['Float']>;
  mkt_cap_jpy?: InputMaybe<Scalars['Float']>;
  mkt_cap_local?: InputMaybe<Scalars['Float']>;
  mkt_cap_usd?: InputMaybe<Scalars['Float']>;
  price_close_aud?: InputMaybe<Scalars['Float']>;
  price_close_eur?: InputMaybe<Scalars['Float']>;
  price_close_gbp?: InputMaybe<Scalars['Float']>;
  price_close_jpy?: InputMaybe<Scalars['Float']>;
  price_close_usd?: InputMaybe<Scalars['Float']>;
  price_net_aud?: InputMaybe<Scalars['Float']>;
  price_net_eur?: InputMaybe<Scalars['Float']>;
  price_net_gbp?: InputMaybe<Scalars['Float']>;
  price_net_jpy?: InputMaybe<Scalars['Float']>;
  price_net_usd?: InputMaybe<Scalars['Float']>;
  price_return_aud?: InputMaybe<Scalars['Float']>;
  price_return_eur?: InputMaybe<Scalars['Float']>;
  price_return_gbp?: InputMaybe<Scalars['Float']>;
  price_return_jpy?: InputMaybe<Scalars['Float']>;
  price_return_usd?: InputMaybe<Scalars['Float']>;
};

export type IHistoryIndicesByIdAndPeriodInput = {
  end_date: Scalars['String'];
  index_id: Scalars['Int'];
  start_date: Scalars['String'];
};

export type IHistoryKpi = {
  __typename?: 'HistoryKpi';
  average?: Maybe<Scalars['Float']>;
  cost_ratio_excl?: Maybe<Scalars['Float']>;
  cost_ratio_incl?: Maybe<Scalars['Float']>;
  date: Scalars['String'];
  eps?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  nav?: Maybe<Scalars['Float']>;
  ndv?: Maybe<Scalars['Float']>;
  niy?: Maybe<Scalars['Float']>;
  nnnav?: Maybe<Scalars['Float']>;
  nra?: Maybe<Scalars['Float']>;
  nta?: Maybe<Scalars['Float']>;
  stock_id: Scalars['ID'];
  vacancy?: Maybe<Scalars['Float']>;
};

export type IHistoryLtv = {
  __typename?: 'HistoryLtv';
  id: Scalars['ID'];
  start_date: Scalars['String'];
  stock_id: Scalars['ID'];
  value?: Maybe<Scalars['Float']>;
};

export type IHistoryRecalc = {
  __typename?: 'HistoryRecalc';
  column_to_recalc: Scalars['String'];
  end_date: Scalars['String'];
  id: Scalars['ID'];
  is_rollbacked: Scalars['Boolean'];
  new_value?: Maybe<Scalars['String']>;
  old_value?: Maybe<Scalars['String']>;
  operator: IRecalcOperator;
  start_date: Scalars['String'];
  stock_id: Scalars['ID'];
  value_to_calc_with: Scalars['Float'];
};

export type IHistoryRecalcInput = {
  column_to_recalc: Scalars['String'];
  end_date: Scalars['String'];
  operator_id: Scalars['Int'];
  start_date: Scalars['String'];
  value_to_calc_with: Scalars['Float'];
};

export type IHistoryStock = {
  __typename?: 'HistoryStock';
  average?: Maybe<Scalars['Float']>;
  close_price?: Maybe<Scalars['Float']>;
  close_price_change?: Maybe<Scalars['Float']>;
  country_index_wght_perc?: Maybe<Scalars['Float']>;
  date: Scalars['String'];
  div_gross?: Maybe<Scalars['Float']>;
  div_net?: Maybe<Scalars['Float']>;
  engl_mkt_cap?: Maybe<Scalars['Float']>;
  epra_shares?: Maybe<Scalars['Float']>;
  five_year_total_return?: Maybe<Scalars['Float']>;
  free_float_market_cap?: Maybe<Scalars['Float']>;
  full_market_cap?: Maybe<Scalars['Float']>;
  gross_div_yield?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  nav_epra?: Maybe<Scalars['Float']>;
  nav_ifrs?: Maybe<Scalars['Float']>;
  ndv?: Maybe<Scalars['Float']>;
  nra?: Maybe<Scalars['Float']>;
  nta?: Maybe<Scalars['Float']>;
  one_year_price_return?: Maybe<Scalars['Float']>;
  one_year_total_return?: Maybe<Scalars['Float']>;
  price_discount?: Maybe<Scalars['Float']>;
  stock_id: Scalars['ID'];
  ten_year_total_return?: Maybe<Scalars['Float']>;
  three_year_total_return?: Maybe<Scalars['Float']>;
};

export type IHistoryStockInput = {
  close_price?: InputMaybe<Scalars['Float']>;
  date_day: Scalars['String'];
  div_net?: InputMaybe<Scalars['Float']>;
  engl_mkt_cap?: InputMaybe<Scalars['Float']>;
  engl_mkt_cap_after_inv_wght?: InputMaybe<Scalars['Float']>;
  epra_shares?: InputMaybe<Scalars['Float']>;
  gross_div_yield?: InputMaybe<Scalars['Float']>;
  unique_stock_code: Scalars['String'];
};

export type IIndex = {
  __typename?: 'Index';
  code: Scalars['String'];
  country?: Maybe<ICountry>;
  currency: ICurrency;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  is_deleted: Scalars['Boolean'];
  is_online: Scalars['Boolean'];
  name: Scalars['String'];
  net_code?: Maybe<Scalars['String']>;
};

export type IIndexInput = {
  code: Scalars['String'];
  country?: InputMaybe<Scalars['Int']>;
  currency: Scalars['Int'];
  identifier: Scalars['String'];
  is_online: Scalars['Boolean'];
  name: Scalars['String'];
  net_code?: InputMaybe<Scalars['String']>;
};

export type IIndexSerie = {
  __typename?: 'IndexSerie';
  id: Scalars['ID'];
  indices: Array<Maybe<IIndex>>;
  name: Scalars['String'];
};

export type IIndexSerieInput = {
  index_ids: Array<InputMaybe<Scalars['Int']>>;
  name: Scalars['String'];
};

export type IInterest = {
  __typename?: 'Interest';
  id: Scalars['ID'];
  interest_group: IInterestGroup;
  name: Scalars['String'];
};

export type IInterestGroup = {
  __typename?: 'InterestGroup';
  id: Scalars['ID'];
  interests: Array<Maybe<IInterest>>;
  name: Scalars['String'];
};

export type IInvestmentFocus = {
  __typename?: 'InvestmentFocus';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IInvoice = {
  __typename?: 'Invoice';
  created_date?: Maybe<Scalars['String']>;
  date_paid?: Maybe<Scalars['String']>;
  debit_invoice_nr?: Maybe<Scalars['String']>;
  details: IInvoiceDetails;
  discount?: Maybe<Scalars['Float']>;
  due_date?: Maybe<Scalars['String']>;
  email_sent_date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_credit: Scalars['Boolean'];
  membership?: Maybe<IMembership>;
  notes?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  paymentDetails: IPaymentDetails;
  po_nr?: Maybe<Scalars['String']>;
  product: IProduct;
  remarks?: Maybe<Scalars['String']>;
  status: IInvoiceStatus;
  total: Scalars['Float'];
  vat?: Maybe<Scalars['Float']>;
};

export type IInvoiceDetails = {
  __typename?: 'InvoiceDetails';
  address_name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_address_vat?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_first_name?: Maybe<Scalars['String']>;
  contact_last_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  title_external?: Maybe<Scalars['String']>;
  vat_countrycode?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type IInvoiceDetailsInput = {
  address_name?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company_address_vat?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_first_name?: InputMaybe<Scalars['String']>;
  contact_last_name?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  title_external?: InputMaybe<Scalars['String']>;
  vat_countrycode?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type IInvoiceFilterInput = {
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_name?: InputMaybe<Scalars['String']>;
  dueAndUnpaid?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type IInvoiceInput = {
  cvent_contact_id?: InputMaybe<Scalars['Int']>;
  details: IInvoiceDetailsInput;
  discount: Scalars['Float'];
  email_extra?: InputMaybe<Scalars['String']>;
  membership_id: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  payment_details_id: Scalars['Int'];
  po_nr?: InputMaybe<Scalars['String']>;
  product_id: Scalars['Int'];
  remarks?: InputMaybe<Scalars['String']>;
  total: Scalars['Float'];
  vat: Scalars['Float'];
};

export type IInvoiceStatus = {
  __typename?: 'InvoiceStatus';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IInvoicesPage = {
  __typename?: 'InvoicesPage';
  invoices: Array<Maybe<IInvoice>>;
  total: Scalars['Int'];
};

export type IIsApproved = {
  is_approved?: InputMaybe<Scalars['Boolean']>;
};

export type IKpiInput = {
  average?: InputMaybe<Scalars['Float']>;
  cost_ratio_excl?: InputMaybe<Scalars['Float']>;
  cost_ratio_incl?: InputMaybe<Scalars['Float']>;
  date: Scalars['String'];
  eps?: InputMaybe<Scalars['Float']>;
  nav?: InputMaybe<Scalars['Float']>;
  ndv?: InputMaybe<Scalars['Float']>;
  niy?: InputMaybe<Scalars['Float']>;
  nnnav?: InputMaybe<Scalars['Float']>;
  nra?: InputMaybe<Scalars['Float']>;
  nta?: InputMaybe<Scalars['Float']>;
  vacancy?: InputMaybe<Scalars['Float']>;
};

export type ILinkContact = {
  email: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
};

export type ILtvInput = {
  start_date: Scalars['String'];
  value: Scalars['Float'];
};

export type IMarketActivity = {
  __typename?: 'MarketActivity';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IMeeting = {
  __typename?: 'Meeting';
  contacts?: Maybe<Array<Maybe<IContact>>>;
  end_time?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  meeting_details?: Maybe<Scalars['String']>;
  meeting_type?: Maybe<IMeetingsMeetingType>;
  name?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type IMeetingContact = {
  __typename?: 'MeetingContact';
  company: ICompany;
  contacts: IContact;
  id: Scalars['ID'];
  meeting: IMeeting;
};

export type IMeetingFilterInput = {
  date_after?: InputMaybe<Scalars['String']>;
  date_before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  meeting_type_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type IMeetingType = {
  __typename?: 'MeetingType';
  color_code: Scalars['String'];
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type IMeetingsMeetingType = {
  __typename?: 'MeetingsMeetingType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IMeetingsPage = {
  __typename?: 'MeetingsPage';
  meetings: Array<Maybe<IMeeting>>;
  total: Scalars['Int'];
};

export type IMembership = {
  __typename?: 'Membership';
  comments_count: Scalars['Int'];
  discount?: Maybe<Scalars['Float']>;
  end_date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_bad_debtor: Scalars['Boolean'];
  last_invoice?: Maybe<IInvoice>;
  name: Scalars['String'];
  product: IProduct;
  renewable_date?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  total: Scalars['Float'];
};

export type IMembershipFilterInput = {
  date_after?: InputMaybe<Scalars['String']>;
  date_before?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  membership_type_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
};

export type IMembershipInput = {
  discount?: InputMaybe<Scalars['Float']>;
  end_date?: InputMaybe<Scalars['String']>;
  is_bad_debtor?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  product_id: Scalars['Int'];
  renewable_date?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  total: Scalars['Float'];
};

export type IMembershipType = {
  __typename?: 'MembershipType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IMembershipTypeOptions = {
  __typename?: 'MembershipTypeOptions';
  membership_types: Array<Maybe<IMembershipType>>;
  taken_option_ids: Array<Maybe<Scalars['Int']>>;
};

export type IMembershipsPage = {
  __typename?: 'MembershipsPage';
  memberships: Array<Maybe<IMembership>>;
  total: Scalars['Int'];
};

export type IMsbReport = {
  __typename?: 'MsbReport';
  clear_cache: Scalars['Boolean'];
  generation_end?: Maybe<Scalars['String']>;
  generation_start?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  report_date: Scalars['String'];
};

export type IMutation = {
  __typename?: 'Mutation';
  addAddress: IAddress;
  addComment: INewCommentResult;
  addCompany: IMutationResult;
  addCompanyToMembership: ICompany;
  addEtf: IEtf;
  addEtfValue?: Maybe<IEtfValue>;
  addEvent: ICalendarEvent;
  addInterestToGroup: Array<Maybe<IAddInterestResult>>;
  addRoleToUser: Scalars['Boolean'];
  addToRole: Scalars['Boolean'];
  addValue: Array<Maybe<IAddValueResult>>;
  confirmInvoice: IInvoice;
  createAllocationCountry: IHistoryAllocationCountry;
  createAllocationSector: IAllocationSector;
  createAward: IHistoryAward;
  createContact: IContact;
  createCreditNote: IInvoice;
  createCventContact: ICventContact;
  createDividend: IDividendGross;
  createDocument: IDocument;
  createFtseFile: IFtseFile;
  createHistoryIndices: Array<IHistoryIndex>;
  createHistoryRecalc: IHistoryRecalc;
  createHistoryStocks: Array<IHistoryStock>;
  createIndex: IIndex;
  createIndexSerie: IIndexSerie;
  createInvoice: IInvoice;
  createKpi: IHistoryKpi;
  createLtv: IHistoryLtv;
  createMeeting: IMeeting;
  createMeetingType: IMeetingsMeetingType;
  createMembership: IMembership;
  createNav: INav;
  createPaymentDetails: IPaymentDetails;
  createProduct: IProduct;
  createRecipientList: IRecipientList;
  createRole: Scalars['Boolean'];
  createScheduler: IScheduler;
  createSiteSection: ISiteSection;
  createStock: IStock;
  createTemplate: ITemplate;
  createUser: IUser;
  deleteAddress: Scalars['Boolean'];
  deleteAllocationCountry: Scalars['Boolean'];
  deleteAllocationSector: Scalars['Boolean'];
  deleteAward: Scalars['Boolean'];
  deleteComment: IMembership;
  deleteCompany: Scalars['Boolean'];
  deleteContact: Scalars['Boolean'];
  deleteCventContact: Scalars['Boolean'];
  deleteDividend: Scalars['Boolean'];
  deleteDocument: Scalars['Boolean'];
  deleteDocumentFromSiteSection: Scalars['Boolean'];
  deleteETF: Scalars['Boolean'];
  deleteEvent: Scalars['Boolean'];
  deleteFtseFile: Scalars['Boolean'];
  deleteHSData?: Maybe<Scalars['Boolean']>;
  deleteIndex: Scalars['Boolean'];
  deleteIndexSerie: Scalars['Boolean'];
  deleteInterest: Scalars['Boolean'];
  deleteInvoice: Scalars['Boolean'];
  deleteKpi?: Maybe<Scalars['Boolean']>;
  deleteLtv: Scalars['Boolean'];
  deleteMeeting: Scalars['Boolean'];
  deleteMeetingType: Scalars['Boolean'];
  deleteMembership: Scalars['Boolean'];
  deleteNav: Scalars['Boolean'];
  deleteProduct: Scalars['Boolean'];
  deleteRecipientList: Scalars['Boolean'];
  deleteRecipientListFromScheduler: IScheduler;
  deleteScheduler: Scalars['Boolean'];
  deleteSiteSection: Scalars['Boolean'];
  deleteTemplate: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  deleteValue: Scalars['Boolean'];
  excludeRecipient: IRecipientList;
  linkContact: ICventContact;
  payInvoice: IInvoice;
  recalcRollback: IHistoryRecalc;
  removeRoleFromUser: Scalars['Boolean'];
  scheduleReport?: Maybe<IMsbReport>;
  schedulerUpdateSubscription: Scalars['Boolean'];
  sendInvoiceForApproval: Scalars['Boolean'];
  sendInvoiceToCustomer: Scalars['Boolean'];
  sendTestEmail?: Maybe<Scalars['Boolean']>;
  setInvoiceToContact: IContact;
  signin: IAuthUser;
  signup: Scalars['Boolean'];
  toggleIsApproved: ICventContact;
  unLinkContact: ICventContact;
  updateAddress: IAddress;
  updateAllocationCountry: IHistoryAllocationCountry;
  updateAllocationSector: IAllocationSector;
  updateAward: IHistoryAward;
  updateCompany: ICompany;
  updateCompanyMainContact: Scalars['Boolean'];
  updateCompanyMainMemberForMembership: Scalars['Boolean'];
  updateCompanyMembership: ICompany;
  updateContactAddress: IContact;
  updateContactAssistant: IContact;
  updateContactDetails: IContact;
  updateContactInterests: Array<Maybe<Scalars['String']>>;
  updateCventContact: ICventContact;
  updateDescription: IDocument;
  updateDividend: IDividendGross;
  updateDocument: IDocument;
  updateEtf: IEtf;
  updateEtfValue: IEtfValue;
  updateEvent: ICalendarEvent;
  updateFtse: IFtseFile;
  updateFtseConfiguration: IFtseConfiguration;
  updateHistoryRecalc: IHistoryRecalc;
  updateIndex: IIndex;
  updateIndexSerie: IIndexSerie;
  updateInvoice: IInvoice;
  updateKpi: IHistoryKpi;
  updateLtv: IHistoryLtv;
  updateMeeting: IMeeting;
  updateMeetingType: IMeetingsMeetingType;
  updateMembership: IMembership;
  updateNav: INav;
  updatePassword: Scalars['Boolean'];
  updateProductEmailInfo: IProduct;
  updateProductGeneralInfo: IProduct;
  updateRecipientList: IRecipientList;
  updateScheduler: IScheduler;
  updateSiteSection: ISiteSection;
  updateStock: IStock;
  updateTemplate: ITemplate;
  updateUserDetails: IUser;
  uploadCventContacts: IUploadCventContactsPayload;
};


export type IMutationAddAddressArgs = {
  company_id: Scalars['Int'];
  input: IAddressInput;
};


export type IMutationAddCommentArgs = {
  membership_id: Scalars['Int'];
  text: Scalars['String'];
};


export type IMutationAddCompanyArgs = {
  input: IAddCompanyInput;
};


export type IMutationAddCompanyToMembershipArgs = {
  id: Scalars['Int'];
  membership_id: Scalars['Int'];
};


export type IMutationAddEtfArgs = {
  input: IEtfInput;
};


export type IMutationAddEtfValueArgs = {
  etf_id: Scalars['ID'];
  input: IEtfValueInput;
};


export type IMutationAddEventArgs = {
  input: IAddNewEventInput;
};


export type IMutationAddInterestToGroupArgs = {
  input: INewInterestInput;
};


export type IMutationAddRoleToUserArgs = {
  role_id: Scalars['Int'];
  user_ids: Array<InputMaybe<Scalars['Int']>>;
};


export type IMutationAddToRoleArgs = {
  input: IUserRoleInput;
};


export type IMutationAddValueArgs = {
  input: INewValueInput;
};


export type IMutationConfirmInvoiceArgs = {
  id: Scalars['Int'];
};


export type IMutationCreateAllocationCountryArgs = {
  input: IAllocationCountryInput;
  stock_id: Scalars['ID'];
};


export type IMutationCreateAllocationSectorArgs = {
  input: IAllocationSectorInput;
  stock_id: Scalars['ID'];
};


export type IMutationCreateAwardArgs = {
  input: IAwardInput;
  stock_id: Scalars['ID'];
};


export type IMutationCreateContactArgs = {
  input: IContactCreateInput;
};


export type IMutationCreateCreditNoteArgs = {
  id: Scalars['Int'];
};


export type IMutationCreateCventContactArgs = {
  input?: InputMaybe<IAddCventContact>;
};


export type IMutationCreateDividendArgs = {
  input: IDividendInput;
  stock_id: Scalars['ID'];
};


export type IMutationCreateDocumentArgs = {
  input: IDocumentInput;
};


export type IMutationCreateFtseFileArgs = {
  input: IFtseFileInput;
};


export type IMutationCreateHistoryIndicesArgs = {
  input: Array<IHistoryIndexInput>;
};


export type IMutationCreateHistoryRecalcArgs = {
  input: IHistoryRecalcInput;
  stock_id: Scalars['ID'];
};


export type IMutationCreateHistoryStocksArgs = {
  input: Array<IHistoryStockInput>;
};


export type IMutationCreateIndexArgs = {
  input: IIndexInput;
};


export type IMutationCreateIndexSerieArgs = {
  input: IIndexSerieInput;
};


export type IMutationCreateInvoiceArgs = {
  input: IInvoiceInput;
};


export type IMutationCreateKpiArgs = {
  input: IKpiInput;
  stock_id: Scalars['ID'];
};


export type IMutationCreateLtvArgs = {
  input: ILtvInput;
  stock_id: Scalars['ID'];
};


export type IMutationCreateMeetingArgs = {
  input: IAddMeetingInput;
};


export type IMutationCreateMeetingTypeArgs = {
  name: Scalars['String'];
};


export type IMutationCreateMembershipArgs = {
  input: IMembershipInput;
};


export type IMutationCreateNavArgs = {
  input: INavInput;
  stock_id: Scalars['ID'];
};


export type IMutationCreatePaymentDetailsArgs = {
  input: INewPaymentDetailsInput;
};


export type IMutationCreateProductArgs = {
  input: IProductInput;
};


export type IMutationCreateRecipientListArgs = {
  input: IRecipientListInput;
};


export type IMutationCreateRoleArgs = {
  role_name: Scalars['String'];
};


export type IMutationCreateSchedulerArgs = {
  input: ISchedulerInput;
};


export type IMutationCreateSiteSectionArgs = {
  name: Scalars['String'];
};


export type IMutationCreateStockArgs = {
  input: IStockInput;
};


export type IMutationCreateTemplateArgs = {
  input: ITemplateInput;
};


export type IMutationCreateUserArgs = {
  input: ICreateUserInput;
};


export type IMutationDeleteAddressArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteAllocationCountryArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteAllocationSectorArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteAwardArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteCommentArgs = {
  id: Scalars['Int'];
  membership_id: Scalars['Int'];
};


export type IMutationDeleteCompanyArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteContactArgs = {
  can_delete_last?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};


export type IMutationDeleteCventContactArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteDividendArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteDocumentArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteDocumentFromSiteSectionArgs = {
  document_id: Scalars['ID'];
  site_section_id: Scalars['ID'];
};


export type IMutationDeleteEtfArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteEventArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteFtseFileArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteHsDataArgs = {
  id: Scalars['ID'];
  input: IDeleteHistoryStocksDataInput;
};


export type IMutationDeleteIndexArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteIndexSerieArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteInterestArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteInvoiceArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteKpiArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteLtvArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteMeetingArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteMeetingTypeArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteMembershipArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteNavArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteProductArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteRecipientListArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteRecipientListFromSchedulerArgs = {
  recipient_list_id: Scalars['ID'];
  scheduler_id: Scalars['ID'];
};


export type IMutationDeleteSchedulerArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteSiteSectionArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteTemplateArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteUserArgs = {
  id: Scalars['Int'];
};


export type IMutationDeleteValueArgs = {
  value_id: Scalars['Int'];
  value_list_name: Scalars['String'];
};


export type IMutationExcludeRecipientArgs = {
  contact_id: Scalars['Int'];
  recipient_list_id: Scalars['Int'];
};


export type IMutationLinkContactArgs = {
  id: Scalars['ID'];
  input: ILinkContact;
};


export type IMutationPayInvoiceArgs = {
  date_paid?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type IMutationRecalcRollbackArgs = {
  id: Scalars['ID'];
};


export type IMutationRemoveRoleFromUserArgs = {
  input: IUserRoleInput;
};


export type IMutationScheduleReportArgs = {
  input: IScheduleInput;
};


export type IMutationSchedulerUpdateSubscriptionArgs = {
  id: Scalars['Int'];
};


export type IMutationSendInvoiceForApprovalArgs = {
  id: Scalars['Int'];
  pdf_content: Scalars['String'];
};


export type IMutationSendInvoiceToCustomerArgs = {
  cc_emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['Int'];
  pdf_content: Scalars['String'];
};


export type IMutationSendTestEmailArgs = {
  recipient: Scalars['String'];
  sender_id: Scalars['String'];
  template_id: Scalars['Int'];
};


export type IMutationSetInvoiceToContactArgs = {
  id: Scalars['Int'];
  is_main: Scalars['Boolean'];
};


export type IMutationSigninArgs = {
  input: ISigninInput;
};


export type IMutationSignupArgs = {
  input: ISignupInput;
};


export type IMutationToggleIsApprovedArgs = {
  id: Scalars['ID'];
  input: IIsApproved;
};


export type IMutationUnLinkContactArgs = {
  id: Scalars['ID'];
};


export type IMutationUpdateAddressArgs = {
  id: Scalars['Int'];
  input: IAddressInput;
};


export type IMutationUpdateAllocationCountryArgs = {
  id: Scalars['ID'];
  input: IAllocationCountryInput;
};


export type IMutationUpdateAllocationSectorArgs = {
  id: Scalars['ID'];
  input: IAllocationSectorInput;
};


export type IMutationUpdateAwardArgs = {
  id: Scalars['ID'];
  input: IAwardInput;
};


export type IMutationUpdateCompanyArgs = {
  id: Scalars['Int'];
  input: INewCompanyInput;
};


export type IMutationUpdateCompanyMainContactArgs = {
  contact_id: Scalars['Int'];
  id: Scalars['Int'];
  is_main: Scalars['Boolean'];
};


export type IMutationUpdateCompanyMainMemberForMembershipArgs = {
  id: Scalars['Int'];
  is_main_member: Scalars['Boolean'];
  membership_id: Scalars['Int'];
};


export type IMutationUpdateCompanyMembershipArgs = {
  id: Scalars['Int'];
  membershipId: Scalars['Int'];
};


export type IMutationUpdateContactAddressArgs = {
  address_id?: InputMaybe<Scalars['Int']>;
  company_id: Scalars['Int'];
  id: Scalars['Int'];
};


export type IMutationUpdateContactAssistantArgs = {
  assistantId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type IMutationUpdateContactDetailsArgs = {
  id: Scalars['Int'];
  input?: InputMaybe<IContactInput>;
};


export type IMutationUpdateContactInterestsArgs = {
  contact_id: Scalars['Int'];
  interest_ids: Array<InputMaybe<Scalars['Int']>>;
};


export type IMutationUpdateCventContactArgs = {
  id: Scalars['ID'];
  input: IAddCventContact;
};


export type IMutationUpdateDescriptionArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type IMutationUpdateDividendArgs = {
  id: Scalars['ID'];
  input: IDividendInput;
};


export type IMutationUpdateDocumentArgs = {
  id: Scalars['ID'];
  input: IDocumentInput;
};


export type IMutationUpdateEtfArgs = {
  id: Scalars['ID'];
  input: IEtfInput;
};


export type IMutationUpdateEtfValueArgs = {
  id: Scalars['ID'];
  input: IEtfValueInput;
};


export type IMutationUpdateEventArgs = {
  id: Scalars['Int'];
  input: IAddNewEventInput;
};


export type IMutationUpdateFtseArgs = {
  id: Scalars['ID'];
  input: IFtseFileInput;
};


export type IMutationUpdateFtseConfigurationArgs = {
  id: Scalars['ID'];
  input: IFtseConfigurationInput;
};


export type IMutationUpdateHistoryRecalcArgs = {
  id: Scalars['ID'];
  input: IHistoryRecalcInput;
  stock_id: Scalars['ID'];
};


export type IMutationUpdateIndexArgs = {
  id: Scalars['ID'];
  input: IIndexInput;
};


export type IMutationUpdateIndexSerieArgs = {
  id: Scalars['ID'];
  input: IIndexSerieInput;
};


export type IMutationUpdateInvoiceArgs = {
  id: Scalars['Int'];
  input: IInvoiceInput;
};


export type IMutationUpdateKpiArgs = {
  id: Scalars['ID'];
  input: IKpiInput;
};


export type IMutationUpdateLtvArgs = {
  id: Scalars['ID'];
  input: ILtvInput;
};


export type IMutationUpdateMeetingArgs = {
  id: Scalars['ID'];
  input: IAddMeetingInput;
};


export type IMutationUpdateMeetingTypeArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type IMutationUpdateMembershipArgs = {
  id: Scalars['Int'];
  input: IMembershipInput;
};


export type IMutationUpdateNavArgs = {
  id: Scalars['ID'];
  input: INavInput;
};


export type IMutationUpdatePasswordArgs = {
  id: Scalars['Int'];
  newPass: Scalars['String'];
};


export type IMutationUpdateProductEmailInfoArgs = {
  id: Scalars['Int'];
  input: IEmailInput;
};


export type IMutationUpdateProductGeneralInfoArgs = {
  id: Scalars['Int'];
  input: IProductInput;
};


export type IMutationUpdateRecipientListArgs = {
  input: IRecipientListInput;
};


export type IMutationUpdateSchedulerArgs = {
  id: Scalars['Int'];
  input: ISchedulerInput;
};


export type IMutationUpdateSiteSectionArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type IMutationUpdateStockArgs = {
  id: Scalars['ID'];
  input: IStockInput;
};


export type IMutationUpdateTemplateArgs = {
  id: Scalars['Int'];
  input: ITemplateInput;
};


export type IMutationUpdateUserDetailsArgs = {
  id: Scalars['Int'];
  input: IUserInput;
};


export type IMutationUploadCventContactsArgs = {
  input?: InputMaybe<Array<InputMaybe<ICventFileInput>>>;
  location: Scalars['String'];
};

export type IMutationResult = {
  __typename?: 'MutationResult';
  company?: Maybe<ICompany>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Scalars['Boolean'];
};

export type INav = {
  __typename?: 'Nav';
  average?: Maybe<Scalars['Float']>;
  created_date: Scalars['String'];
  id: Scalars['ID'];
  nav?: Maybe<Scalars['Float']>;
  nav_epra?: Maybe<Scalars['Float']>;
  nav_epra_history?: Maybe<Scalars['Float']>;
  ndv?: Maybe<Scalars['Float']>;
  nra?: Maybe<Scalars['Float']>;
  nta?: Maybe<Scalars['Float']>;
  start_date: Scalars['String'];
  stock_id: Scalars['ID'];
  ta?: Maybe<Scalars['Float']>;
  tl?: Maybe<Scalars['Float']>;
};

export type INavInput = {
  average?: InputMaybe<Scalars['Float']>;
  created_date: Scalars['String'];
  nav?: InputMaybe<Scalars['Float']>;
  nav_epra?: InputMaybe<Scalars['Float']>;
  nav_epra_history?: InputMaybe<Scalars['Float']>;
  ndv?: InputMaybe<Scalars['Float']>;
  nra?: InputMaybe<Scalars['Float']>;
  nta?: InputMaybe<Scalars['Float']>;
  start_date: Scalars['String'];
  ta?: InputMaybe<Scalars['Float']>;
  tl?: InputMaybe<Scalars['Float']>;
};

export type INewCommentResult = {
  __typename?: 'NewCommentResult';
  comment: IComment;
  membership: IMembership;
};

export type INewCompanyInput = {
  company_type_id: Scalars['Int'];
  info?: InputMaybe<Scalars['String']>;
  market_activity_id: Scalars['Int'];
  market_second_specialty?: InputMaybe<Scalars['String']>;
  member_index?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  unique_stock_code?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type INewInterestInput = {
  category_id: Scalars['ID'];
  new_values: Array<InputMaybe<Scalars['String']>>;
};

export type INewPaymentDetailsInput = {
  bank_address: Scalars['String'];
  bank_affiliate: Scalars['String'];
  bank_bic: Scalars['String'];
  bank_iban: Scalars['String'];
  bank_name: Scalars['String'];
  contact_address: Scalars['String'];
  contact_address_name: Scalars['String'];
  contact_fax: Scalars['String'];
  contact_phone: Scalars['String'];
  contact_vat: Scalars['String'];
};

export type INewValueInput = {
  new_values: Array<InputMaybe<Scalars['String']>>;
  value_list_name: Scalars['String'];
};

export type IPaymentDetails = {
  __typename?: 'PaymentDetails';
  bank_address: Scalars['String'];
  bank_affiliate: Scalars['String'];
  bank_bic: Scalars['String'];
  bank_iban: Scalars['String'];
  bank_name: Scalars['String'];
  contact_address: Scalars['String'];
  contact_address_name: Scalars['String'];
  contact_fax: Scalars['String'];
  contact_phone: Scalars['String'];
  contact_vat: Scalars['String'];
  id: Scalars['ID'];
};

export type IProduct = {
  __typename?: 'Product';
  bottom_notes?: Maybe<Scalars['String']>;
  email_banner?: Maybe<Scalars['String']>;
  email_body?: Maybe<Scalars['String']>;
  email_subject?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  membership_type?: Maybe<IMembershipType>;
  name: Scalars['String'];
  price: Scalars['Float'];
  product_code: IProductCode;
  vat?: Maybe<Scalars['Float']>;
};

export type IProductCode = {
  __typename?: 'ProductCode';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IProductInput = {
  bottom_notes?: InputMaybe<Scalars['String']>;
  email_banner?: InputMaybe<Scalars['String']>;
  email_body?: InputMaybe<Scalars['String']>;
  email_subject?: InputMaybe<Scalars['String']>;
  membership_type_id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  price: Scalars['Float'];
  product_code_id: Scalars['Int'];
  vat?: InputMaybe<Scalars['Float']>;
};

export type IQuery = {
  __typename?: 'Query';
  addresses: Array<Maybe<IAddress>>;
  allMeetingsForContact?: Maybe<Array<Maybe<IMeeting>>>;
  allSectors: Array<Maybe<ISector>>;
  allocationSectors: Array<Maybe<IAllocationSector>>;
  assistantContactsFromSameCompany: Array<Maybe<IContact>>;
  calendarTypes: Array<Maybe<IMeetingType>>;
  comments: Array<Maybe<IComment>>;
  companies: Array<Maybe<ICompany>>;
  companiesFiltered: ICompaniesPage;
  company?: Maybe<ICompany>;
  companyAddresses: Array<Maybe<IAddress>>;
  companyContacts: Array<Maybe<IContact>>;
  companyTypes: Array<Maybe<ICompanyType>>;
  contact?: Maybe<IContact>;
  contactByEmailAndFullName: IContact;
  contactInterests: Array<Maybe<IContactInterests>>;
  contacts: Array<Maybe<IContact>>;
  contactsByInterests: Array<Maybe<IContact>>;
  contactsFiltered: IContactsPage;
  countries: Array<Maybe<ICountry>>;
  currencies: Array<Maybe<ICurrency>>;
  dashboardDoughnutQuery: Array<Maybe<IDashboardDoughnut>>;
  dashboardInvoicesInfo: Array<Maybe<IDashboardInvoices>>;
  dashboardMembershipsInfoForTheLastThreeYears: Array<Maybe<IDashboardMembershipInfoForLastThreeYears>>;
  documents: Array<Maybe<IDocument>>;
  documentsFiltered: IDocumentsPage;
  events: Array<Maybe<ICalendarEvent>>;
  excludedContacts: Array<Maybe<IContact>>;
  filteredStocks: Array<Maybe<IStock>>;
  getAllCventContacts?: Maybe<Array<Maybe<ICventContact>>>;
  getAllCventContactsForLocation?: Maybe<Array<Maybe<ICventContact>>>;
  getAllCventEvents?: Maybe<Array<Maybe<ICventEvent>>>;
  getAllCventLocations?: Maybe<Array<Maybe<ICventLocation>>>;
  getAllCventRoles?: Maybe<Array<Maybe<ICventRole>>>;
  getAllLocationsForEvent?: Maybe<Array<Maybe<ICventLocation>>>;
  getAllScheduled: Array<Maybe<IScheduler>>;
  getAllSenders: Array<Maybe<ISender>>;
  getAwardTypes: Array<Maybe<IAwardType>>;
  getDividendsGross: Array<Maybe<IDividendGross>>;
  getEtf: IEtf;
  getEtfValues: Array<Maybe<IEtfValue>>;
  getEtfs: Array<Maybe<IEtf>>;
  getEtfsWithValues: Array<Maybe<IEtfValue>>;
  getFtseConfigurations: Array<Maybe<IFtseConfiguration>>;
  getFtseFiles: Array<Maybe<IFtseFile>>;
  getFtseTypes: Array<Maybe<IFtseType>>;
  getFxData: Array<Maybe<IFtseFx>>;
  getHistoryAllocationCountries: Array<Maybe<IHistoryAllocationCountry>>;
  getHistoryAwards: Array<Maybe<IHistoryAward>>;
  getHistoryConstituents: Array<Maybe<IHistoryConstituent>>;
  getHistoryConstituentsByIndex: Array<Maybe<IHistoryConstituent>>;
  getHistoryLtvs: Array<Maybe<IHistoryLtv>>;
  getHistoryRecalcs: Array<Maybe<IHistoryRecalc>>;
  getLatestFxData: Array<Maybe<IFtseFx>>;
  getMatchedDbContactsByEmail?: Maybe<Array<IContact>>;
  getMeetingTypes: Array<Maybe<IMeetingsMeetingType>>;
  getNavs: Array<Maybe<INav>>;
  getRecalcOperators: Array<Maybe<IRecalcOperator>>;
  getSendGridEvents: Array<Maybe<ISendGridEvent>>;
  getSendGridMessages: Array<Maybe<ISendGridMessage>>;
  getSendGridStatistics: Array<Maybe<IStat>>;
  getSiteSections: Array<Maybe<ISiteSection>>;
  historyIndicesByIdAndPeriod: Array<IHistoryIndex>;
  historyKpis: Array<Maybe<IHistoryKpi>>;
  historyStocks: Array<Maybe<IHistoryStock>>;
  indexSeries: Array<Maybe<IIndexSerie>>;
  indices: Array<Maybe<IIndex>>;
  interestGroups: Array<Maybe<IInterestGroup>>;
  interests: Array<Maybe<IInterest>>;
  investmentFocuses: Array<Maybe<IInvestmentFocus>>;
  invoiceClientOptions?: Maybe<IClientOptions>;
  invoiceStatuses: Array<Maybe<IInvoiceStatus>>;
  invoices: Array<Maybe<IInvoice>>;
  invoicesFiltered: IInvoicesPage;
  invoicesForMembership: Array<Maybe<IInvoice>>;
  marketActivities: Array<Maybe<IMarketActivity>>;
  meeting?: Maybe<IMeeting>;
  meetings: Array<Maybe<IMeeting>>;
  meetingsFiltered: IMeetingsPage;
  meetingsForContact: Array<Maybe<IMeeting>>;
  meetingsMeetingType: Array<Maybe<IMeetingsMeetingType>>;
  membership?: Maybe<IMembership>;
  membershipComments: Array<Maybe<IComment>>;
  membershipCompanies?: Maybe<Array<Maybe<ICompany>>>;
  membershipContacts: Array<Maybe<IContact>>;
  membershipProducts: Array<Maybe<IProduct>>;
  membershipTypeOptions: IMembershipTypeOptions;
  membershipTypes: Array<Maybe<IMembershipType>>;
  memberships: Array<Maybe<IMembership>>;
  membershipsFiltered: IMembershipsPage;
  msbReports: Array<Maybe<IMsbReport>>;
  paymentDetails: IPaymentDetails;
  product?: Maybe<IProduct>;
  productCodes: Array<Maybe<IProductCode>>;
  products: Array<Maybe<IProduct>>;
  recipientListContacts: Array<Maybe<IContact>>;
  recipientLists: Array<Maybe<IRecipientList>>;
  recipients: Array<Maybe<IContact>>;
  regions: Array<Maybe<IRegion>>;
  roles: Array<Maybe<IRole>>;
  stock: IStock;
  stocks: Array<Maybe<IStock>>;
  stocksFiltered: IStocksPage;
  templates: Array<Maybe<ITemplate>>;
  titlesInternal: Array<Maybe<ITitleInternal>>;
  user?: Maybe<IUser>;
  users: Array<Maybe<IUser>>;
};


export type IQueryAllMeetingsForContactArgs = {
  contact_id: Scalars['Int'];
};


export type IQueryAllocationSectorsArgs = {
  stock_id: Scalars['Int'];
};


export type IQueryAssistantContactsFromSameCompanyArgs = {
  company_id: Scalars['Int'];
  id: Scalars['Int'];
};


export type IQueryCompaniesFilteredArgs = {
  filter?: InputMaybe<ICompanyFilterInput>;
};


export type IQueryCompanyArgs = {
  id: Scalars['Int'];
};


export type IQueryCompanyAddressesArgs = {
  company_id: Scalars['Int'];
};


export type IQueryCompanyContactsArgs = {
  company_id: Scalars['Int'];
};


export type IQueryContactArgs = {
  id: Scalars['Int'];
};


export type IQueryContactByEmailAndFullNameArgs = {
  email: Scalars['String'];
  fullName: Scalars['String'];
};


export type IQueryContactInterestsArgs = {
  contact_id: Scalars['Int'];
};


export type IQueryContactsByInterestsArgs = {
  interestIds: Array<Scalars['Int']>;
};


export type IQueryContactsFilteredArgs = {
  filter?: InputMaybe<IContactFilterInput>;
};


export type IQueryDocumentsFilteredArgs = {
  filter?: InputMaybe<IDocumentFilterInput>;
};


export type IQueryExcludedContactsArgs = {
  id: Scalars['Int'];
};


export type IQueryFilteredStocksArgs = {
  date: Scalars['String'];
  stock_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type IQueryGetAllCventContactsForLocationArgs = {
  id: Scalars['ID'];
};


export type IQueryGetAllLocationsForEventArgs = {
  event_id: Scalars['ID'];
};


export type IQueryGetDividendsGrossArgs = {
  stock_id: Scalars['Int'];
};


export type IQueryGetEtfArgs = {
  id: Scalars['ID'];
};


export type IQueryGetEtfValuesArgs = {
  etf_id: Scalars['Int'];
};


export type IQueryGetEtfsWithValuesArgs = {
  date?: InputMaybe<Scalars['String']>;
};


export type IQueryGetHistoryAllocationCountriesArgs = {
  stock_id: Scalars['Int'];
};


export type IQueryGetHistoryAwardsArgs = {
  stock_id: Scalars['Int'];
};


export type IQueryGetHistoryConstituentsArgs = {
  date?: InputMaybe<Scalars['String']>;
  stock_id: Scalars['Int'];
};


export type IQueryGetHistoryConstituentsByIndexArgs = {
  date?: InputMaybe<Scalars['String']>;
  index_id: Scalars['Int'];
};


export type IQueryGetHistoryLtvsArgs = {
  stock_id: Scalars['Int'];
};


export type IQueryGetHistoryRecalcsArgs = {
  stock_id: Scalars['Int'];
};


export type IQueryGetLatestFxDataArgs = {
  date?: InputMaybe<Scalars['String']>;
};


export type IQueryGetMatchedDbContactsByEmailArgs = {
  id: Scalars['ID'];
  input: ILinkContact;
};


export type IQueryGetNavsArgs = {
  stock_id: Scalars['Int'];
};


export type IQueryGetSendGridEventsArgs = {
  sg_message_id: Scalars['String'];
};


export type IQueryGetSendGridMessagesArgs = {
  scheduler_id: Scalars['Int'];
};


export type IQueryHistoryIndicesByIdAndPeriodArgs = {
  input: IHistoryIndicesByIdAndPeriodInput;
};


export type IQueryHistoryKpisArgs = {
  stock_id: Scalars['Int'];
};


export type IQueryHistoryStocksArgs = {
  stock_id: Scalars['Int'];
};


export type IQueryInvoiceClientOptionsArgs = {
  membership_id: Scalars['Int'];
};


export type IQueryInvoicesFilteredArgs = {
  filter?: InputMaybe<IInvoiceFilterInput>;
};


export type IQueryInvoicesForMembershipArgs = {
  membership_id: Scalars['Int'];
};


export type IQueryMeetingArgs = {
  id: Scalars['Int'];
};


export type IQueryMeetingsFilteredArgs = {
  filter?: InputMaybe<IMeetingFilterInput>;
};


export type IQueryMeetingsForContactArgs = {
  contact_id: Scalars['Int'];
};


export type IQueryMembershipArgs = {
  id: Scalars['Int'];
};


export type IQueryMembershipCommentsArgs = {
  membership_id: Scalars['Int'];
};


export type IQueryMembershipCompaniesArgs = {
  membership_id: Scalars['Int'];
};


export type IQueryMembershipContactsArgs = {
  id: Scalars['Int'];
};


export type IQueryMembershipsFilteredArgs = {
  filter?: InputMaybe<IMembershipFilterInput>;
};


export type IQueryPaymentDetailsArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type IQueryProductArgs = {
  id: Scalars['Int'];
};


export type IQueryRecipientListContactsArgs = {
  companyTypeIds: Array<InputMaybe<Scalars['Int']>>;
  contactTitleIds: Array<InputMaybe<Scalars['Int']>>;
  countryIds: Array<InputMaybe<Scalars['Int']>>;
  interestIds: Array<InputMaybe<Scalars['Int']>>;
  membershipTypeIds: Array<InputMaybe<Scalars['Int']>>;
  recipientListId?: InputMaybe<Scalars['Int']>;
};


export type IQueryRecipientsArgs = {
  id: Scalars['Int'];
};


export type IQueryStockArgs = {
  id: Scalars['Int'];
};


export type IQueryStocksFilteredArgs = {
  filter?: InputMaybe<IStockFilterInput>;
};


export type IQueryUserArgs = {
  id: Scalars['Int'];
};

export type IRecalcOperator = {
  __typename?: 'RecalcOperator';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type IRecipientList = {
  __typename?: 'RecipientList';
  company_types: Array<Maybe<ICompanyType>>;
  contact_titles: Array<Maybe<ITitleInternal>>;
  countries: Array<Maybe<ICountry>>;
  criteria: Scalars['String'];
  excluded_contact_ids?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  included_contact_ids?: Maybe<Scalars['String']>;
  interests: Array<Maybe<IInterest>>;
  membership_types: Array<Maybe<IMembershipType>>;
  name: Scalars['String'];
};

export type IRecipientListInput = {
  company_type_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contact_title_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  country_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  excluded_contact_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  included_contact_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  interest_ids: Array<InputMaybe<Scalars['Int']>>;
  membership_type_ids: Array<InputMaybe<Scalars['Int']>>;
  name: Scalars['String'];
};

export type IRegion = {
  __typename?: 'Region';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IRole = {
  __typename?: 'Role';
  id: Scalars['ID'];
  name: Scalars['String'];
  users: Array<Maybe<IUser>>;
};

export enum IRoles {
  Admin = 'admin',
  EsgOperator = 'esg_operator',
  IndexOperator = 'index_operator',
  InvoiceEditor = 'invoice_editor',
  MarketingOperator = 'marketing_operator',
  Operator = 'operator'
}

export type IScheduleInput = {
  report_date: Scalars['String'];
};

export type IScheduler = {
  __typename?: 'Scheduler';
  created_date: Scalars['String'];
  id: Scalars['ID'];
  is_success?: Maybe<Scalars['Boolean']>;
  mails_sent?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  recipient_lists: Array<IRecipientList>;
  scheduled_date: Scalars['String'];
  sender: ISender;
  template: ITemplate;
};

export type ISchedulerInput = {
  name: Scalars['String'];
  recipient_lists: Array<Scalars['Int']>;
  scheduled_date: Scalars['String'];
  sender_id: Scalars['String'];
  template_id: Scalars['Int'];
};

export type ISector = {
  __typename?: 'Sector';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ISendGridEvent = {
  __typename?: 'SendGridEvent';
  id: Scalars['ID'];
  name: Scalars['String'];
  sg_event_id: Scalars['String'];
  sg_message_id: Scalars['String'];
  timestamp: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type ISendGridMessage = {
  __typename?: 'SendGridMessage';
  clicks_count: Scalars['Int'];
  email: Scalars['String'];
  id: Scalars['ID'];
  opens_count: Scalars['Int'];
  scheduler: IScheduler;
  sg_message_id: Scalars['String'];
  status: Scalars['String'];
};

export type ISender = {
  __typename?: 'Sender';
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type ISigninInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type ISignupInput = {
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type ISiteSection = {
  __typename?: 'SiteSection';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IStat = {
  __typename?: 'Stat';
  blocks: Scalars['Int'];
  bounces: Scalars['Int'];
  delivered: Scalars['Int'];
  month: Scalars['String'];
  read: Scalars['Int'];
  sent: Scalars['Int'];
  spam_reports: Scalars['Int'];
};

export type IStock = {
  __typename?: 'Stock';
  bloomberg_ticker?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  company: ICompany;
  country?: Maybe<ICountry>;
  currency?: Maybe<ICurrency>;
  cusip?: Maybe<Scalars['String']>;
  exchange_code?: Maybe<Scalars['String']>;
  historyStock?: Maybe<IHistoryStock>;
  icb_industry_code?: Maybe<Scalars['Int']>;
  icb_sector_code?: Maybe<Scalars['Int']>;
  icb_subsector_code?: Maybe<Scalars['Int']>;
  icb_supersector_code?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  investment_focus?: Maybe<IInvestmentFocus>;
  is_reit: Scalars['Boolean'];
  isin_code?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reuters_code?: Maybe<Scalars['String']>;
  sector?: Maybe<ISector>;
  sedol?: Maybe<Scalars['String']>;
  snl_code?: Maybe<Scalars['String']>;
  start_date: Scalars['String'];
  subsector?: Maybe<ISector>;
};


export type IStockHistoryStockArgs = {
  date?: InputMaybe<Scalars['String']>;
};

export type IStockFilterInput = {
  country_id?: InputMaybe<Scalars['Int']>;
  currency_id?: InputMaybe<Scalars['Int']>;
  exchange_code?: InputMaybe<Scalars['String']>;
  isin_code?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  sector_id?: InputMaybe<Scalars['Int']>;
  trading_date?: InputMaybe<Scalars['String']>;
};

export type IStockInput = {
  bloomberg_ticker?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  company_id: Scalars['Int'];
  country_id?: InputMaybe<Scalars['Int']>;
  currency_id?: InputMaybe<Scalars['Int']>;
  cusip?: InputMaybe<Scalars['String']>;
  exchange_code?: InputMaybe<Scalars['String']>;
  icb_industry_code?: InputMaybe<Scalars['Int']>;
  icb_sector_code?: InputMaybe<Scalars['Int']>;
  icb_subsector_code?: InputMaybe<Scalars['Int']>;
  icb_supersector_code?: InputMaybe<Scalars['Int']>;
  investment_focus_id?: InputMaybe<Scalars['Int']>;
  is_reit: Scalars['Boolean'];
  isin_code?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  reuters_code?: InputMaybe<Scalars['String']>;
  sector_id?: InputMaybe<Scalars['Int']>;
  sedol?: InputMaybe<Scalars['String']>;
  snl_code?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  subsector_id?: InputMaybe<Scalars['Int']>;
};

export type IStocksPage = {
  __typename?: 'StocksPage';
  stocks: Array<Maybe<IStock>>;
  total: Scalars['Int'];
};

export type ISubscription = {
  __typename?: 'Subscription';
  allocationCountryCreated: IHistoryAllocationCountry;
  allocationCountryDeleted: IHistoryAllocationCountry;
  allocationCountryUpdated: IHistoryAllocationCountry;
  allocationSectorCreated: IAllocationSector;
  allocationSectorDeleted: IAllocationSector;
  allocationSectorUpdated: IAllocationSector;
  awardCreated: IHistoryAward;
  awardDeleted: IHistoryAward;
  awardUpdated: IHistoryAward;
  commentAdded: IMembership;
  commentDeleted: IMembership;
  companyCreated: ICompany;
  companyDeleted: ICompany;
  companyUpdated: ICompany;
  contactCreated: IContact;
  contactDeleted: IContact;
  contactUpdated: IContact;
  dividendCreated: IDividendGross;
  dividendDeleted: IDividendGross;
  dividendUpdated: IDividendGross;
  documentCreated: IDocument;
  documentDeleted: IDocument;
  documentUpdated: IDocument;
  etfCreated: IEtf;
  etfDeleted: IEtf;
  etfUpdated: IEtf;
  etfValueCreated: IEtfValue;
  etfValueUpdated: IEtfValue;
  eventCreated: ICalendarEvent;
  eventDeleted: ICalendarEvent;
  eventUpdated: ICalendarEvent;
  ftseConfigurationUpdated: IFtseConfiguration;
  ftseFileCreated: IFtseFile;
  ftseFileDeleted: IFtseFile;
  ftseFileUpdated: IFtseFile;
  historyRecalcCreated: IHistoryRecalc;
  historyRecalcLogCreated: IHistoryRecalc;
  historyRecalcUpdated: IHistoryRecalc;
  indexCreated: IIndex;
  indexDeleted: IIndex;
  indexSerieCreated: IIndexSerie;
  indexSerieDeleted: IIndexSerie;
  indexSerieUpdated: IIndexSerie;
  indexUpdated: IIndex;
  interestDeleted: IInterest;
  invoiceCreated: IInvoice;
  invoiceDeleted: IInvoice;
  invoiceUpdated: IInvoice;
  kpiCreated: IHistoryKpi;
  kpiDeleted: IHistoryKpi;
  kpiUpdated: IHistoryKpi;
  ltvCreated: IHistoryLtv;
  ltvDeleted: IHistoryLtv;
  ltvUpdated: IHistoryLtv;
  meetingCreated: IMeeting;
  meetingDeleted: IMeeting;
  meetingTypeCreated: IMeetingsMeetingType;
  meetingTypeDeleted: IMeetingsMeetingType;
  meetingTypeUpdated: IMeetingsMeetingType;
  meetingUpdated: IMeeting;
  membershipCreated: IMembership;
  membershipDeleted: IMembership;
  membershipUpdated: IMembership;
  navCreated: INav;
  navDeleted: INav;
  navUpdated: INav;
  productCreated: IProduct;
  productDeleted: IProduct;
  productUpdated: IProduct;
  recipientListCreated: IRecipientList;
  recipientListDeleted: IRecipientList;
  recipientListUpdated: IRecipientList;
  schedulerCreated: IScheduler;
  schedulerDeleted: IScheduler;
  schedulerUpdated: IScheduler;
  siteSectionCreated: ISiteSection;
  siteSectionDeleted: ISiteSection;
  siteSectionUpdated: ISiteSection;
  stockCreated: IStock;
  stockUpdated: IStock;
  templateCreated: ITemplate;
  templateDeleted: ITemplate;
  templateUpdated: ITemplate;
  userCreated: IUser;
  userDeleted: IUser;
  userRoleRemoved: IUser;
  userUpdated: IUser;
};


export type ISubscriptionAllocationCountryCreatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionAllocationCountryDeletedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionAllocationCountryUpdatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionAllocationSectorCreatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionAllocationSectorDeletedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionAllocationSectorUpdatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionAwardCreatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionAwardDeletedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionAwardUpdatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionDividendCreatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionDividendDeletedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionDividendUpdatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionEtfValueCreatedArgs = {
  etf_id: Scalars['ID'];
};


export type ISubscriptionEtfValueUpdatedArgs = {
  etf_id: Scalars['ID'];
};


export type ISubscriptionHistoryRecalcCreatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionHistoryRecalcUpdatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionKpiCreatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionKpiDeletedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionKpiUpdatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionLtvCreatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionLtvDeletedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionLtvUpdatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionNavCreatedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionNavDeletedArgs = {
  stock_id: Scalars['ID'];
};


export type ISubscriptionNavUpdatedArgs = {
  stock_id: Scalars['ID'];
};

export type ITemplate = {
  __typename?: 'Template';
  content: Scalars['String'];
  id: Scalars['ID'];
  subject: Scalars['String'];
  title: Scalars['String'];
};

export type ITemplateInput = {
  content: Scalars['String'];
  subject: Scalars['String'];
  title: Scalars['String'];
};

export type ITitleInternal = {
  __typename?: 'TitleInternal';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IUploadCventContactsPayload = {
  __typename?: 'UploadCventContactsPayload';
  event: ICventEvent;
  location?: Maybe<ICventLocation>;
};

export type IUser = {
  __typename?: 'User';
  first_name: Scalars['String'];
  id: Scalars['ID'];
  last_name: Scalars['String'];
  password: Scalars['String'];
  roles: Array<Maybe<Scalars['String']>>;
  username: Scalars['String'];
};

export type IUserInput = {
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  user_role_ids: Array<InputMaybe<Scalars['Int']>>;
  username: Scalars['String'];
};

export type IUserRoleInput = {
  role_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

export type ICventFileInput = {
  company_name: Scalars['String'];
  email: Scalars['String'];
  event_name?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  role_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type IFtseConfigurationInput = {
  value: Scalars['String'];
};

export type IFtseFileInput = {
  file_type_id: Scalars['Int'];
  location_on_server: Scalars['String'];
  name: Scalars['String'];
};

export type IAddressPropsFragment = { __typename?: 'Address', id: string, name: string, street: string, city: string, vat_number?: string | null, phone?: string | null, email?: string | null, is_main?: boolean | null, is_nav?: boolean | null, is_website?: boolean | null, fax?: string | null, zip?: string | null, complete_vat_number?: string | null, vat_country_code?: string | null, country: { __typename?: 'Country', id: string, name: string, region?: { __typename?: 'Region', id: string, name: string } | null } };

export type ICompanyAddressesQueryVariables = Exact<{
  company_id: Scalars['Int'];
}>;


export type ICompanyAddressesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Address', address_name?: string | null, id: string, name: string, street: string, city: string, vat_number?: string | null, phone?: string | null, email?: string | null, is_main?: boolean | null, is_nav?: boolean | null, is_website?: boolean | null, fax?: string | null, zip?: string | null, complete_vat_number?: string | null, vat_country_code?: string | null, country: { __typename?: 'Country', id: string, name: string, region?: { __typename?: 'Region', id: string, name: string } | null } } | null> };

export type IAddAddressMutationVariables = Exact<{
  company_id: Scalars['Int'];
  input: IAddressInput;
}>;


export type IAddAddressMutation = { __typename?: 'Mutation', result: { __typename?: 'Address', id: string, name: string, street: string, city: string, vat_number?: string | null, phone?: string | null, email?: string | null, is_main?: boolean | null, is_nav?: boolean | null, is_website?: boolean | null, fax?: string | null, zip?: string | null, complete_vat_number?: string | null, vat_country_code?: string | null, country: { __typename?: 'Country', id: string, name: string, region?: { __typename?: 'Region', id: string, name: string } | null } } };

export type IUpdateAddressMutationVariables = Exact<{
  id: Scalars['Int'];
  input: IAddressInput;
}>;


export type IUpdateAddressMutation = { __typename?: 'Mutation', result: { __typename?: 'Address', id: string, name: string, street: string, city: string, vat_number?: string | null, phone?: string | null, email?: string | null, is_main?: boolean | null, is_nav?: boolean | null, is_website?: boolean | null, fax?: string | null, zip?: string | null, complete_vat_number?: string | null, vat_country_code?: string | null, country: { __typename?: 'Country', id: string, name: string, region?: { __typename?: 'Region', id: string, name: string } | null } } };

export type IDeleteAddressMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteAddressMutation = { __typename?: 'Mutation', result: boolean };

export type IAddValueMutationVariables = Exact<{
  input: INewValueInput;
}>;


export type IAddValueMutation = { __typename?: 'Mutation', result: Array<{ __typename?: 'AddValueResult', id: string, name: string } | null> };

export type IDeleteValueMutationVariables = Exact<{
  value_list_name: Scalars['String'];
  value_id: Scalars['Int'];
}>;


export type IDeleteValueMutation = { __typename?: 'Mutation', result: boolean };

export type IAllocationSectorDetailsFragment = { __typename?: 'AllocationSector', id: string, stock_id: string, sector_id: string, year: number, value: number };

export type IGetAllocationSectorsQueryVariables = Exact<{
  stock_id: Scalars['Int'];
}>;


export type IGetAllocationSectorsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'AllocationSector', id: string, stock_id: string, sector_id: string, year: number, value: number } | null> };

export type ICreateAllocationSectorMutationVariables = Exact<{
  stock_id: Scalars['ID'];
  input: IAllocationSectorInput;
}>;


export type ICreateAllocationSectorMutation = { __typename?: 'Mutation', result: { __typename?: 'AllocationSector', id: string, stock_id: string, sector_id: string, year: number, value: number } };

export type IUpdateAllocationSectorMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IAllocationSectorInput;
}>;


export type IUpdateAllocationSectorMutation = { __typename?: 'Mutation', result: { __typename?: 'AllocationSector', id: string, stock_id: string, sector_id: string, year: number, value: number } };

export type IDeleteAllocationSectorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteAllocationSectorMutation = { __typename?: 'Mutation', result: boolean };

export type IAllocationSectorCreatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IAllocationSectorCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'AllocationSector', id: string, stock_id: string, sector_id: string, year: number, value: number } };

export type IAllocationSectorUpdatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IAllocationSectorUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'AllocationSector', id: string, stock_id: string, sector_id: string, year: number, value: number } };

export type IAllocationSectorDeletedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IAllocationSectorDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'AllocationSector', id: string, stock_id: string, sector_id: string, year: number, value: number } };

export type IEventMeetingDetailsFragment = { __typename?: 'CalendarEvent', id: string, title: string, location?: string | null, description?: string | null, start_date: string, end_date: string, creator: { __typename?: 'Contact', id: string, fullName: string }, company: { __typename?: 'Company', id: string, name: string }, type: { __typename?: 'MeetingType', id: string, type: string } };

export type IEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type IEventsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'CalendarEvent', id: string, title: string, location?: string | null, description?: string | null, start_date: string, end_date: string, creator: { __typename?: 'Contact', id: string, fullName: string }, company: { __typename?: 'Company', id: string, name: string }, type: { __typename?: 'MeetingType', id: string, type: string } } | null> };

export type ICalendarTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ICalendarTypesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'MeetingType', id: string, type: string, color_code: string } | null> };

export type IAddEventMutationVariables = Exact<{
  input: IAddNewEventInput;
}>;


export type IAddEventMutation = { __typename?: 'Mutation', result: { __typename?: 'CalendarEvent', id: string, title: string, location?: string | null, description?: string | null, start_date: string, end_date: string, creator: { __typename?: 'Contact', id: string, fullName: string }, company: { __typename?: 'Company', id: string, name: string }, type: { __typename?: 'MeetingType', id: string, type: string } } };

export type IDeleteEventMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteEventMutation = { __typename?: 'Mutation', result: boolean };

export type IUpdateEventMutationVariables = Exact<{
  id: Scalars['Int'];
  input: IAddNewEventInput;
}>;


export type IUpdateEventMutation = { __typename?: 'Mutation', result: { __typename?: 'CalendarEvent', id: string, title: string, location?: string | null, description?: string | null, start_date: string, end_date: string, creator: { __typename?: 'Contact', id: string, fullName: string }, company: { __typename?: 'Company', id: string, name: string }, type: { __typename?: 'MeetingType', id: string, type: string } } };

export type IEventCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IEventCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'CalendarEvent', id: string, title: string, location?: string | null, description?: string | null, start_date: string, end_date: string, creator: { __typename?: 'Contact', id: string, fullName: string }, company: { __typename?: 'Company', id: string, name: string }, type: { __typename?: 'MeetingType', id: string, type: string } } };

export type IEventDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IEventDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'CalendarEvent', id: string } };

export type IEventUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IEventUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'CalendarEvent', id: string, title: string, location?: string | null, description?: string | null, start_date: string, end_date: string, creator: { __typename?: 'Contact', id: string, fullName: string }, company: { __typename?: 'Company', id: string, name: string }, type: { __typename?: 'MeetingType', id: string, type: string } } };

export type IHistoryStocksDetailsFragment = { __typename?: 'HistoryStock', id: string, stock_id: string, date: string, close_price?: number | null, engl_mkt_cap?: number | null, epra_shares?: number | null, nav_epra?: number | null, nav_ifrs?: number | null, price_discount?: number | null, gross_div_yield?: number | null, div_gross?: number | null, div_net?: number | null, free_float_market_cap?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null };

export type IHistoryIndexDetailsFragment = { __typename?: 'HistoryIndex', id: string, index_id: string, date: string, mkt_cap_eur?: number | null, mkt_cap_usd?: number | null, mkt_cap_gbp?: number | null, mkt_cap_jpy?: number | null, mkt_cap_aud?: number | null, price_close_eur?: number | null, price_close_usd?: number | null, price_close_gbp?: number | null, price_close_jpy?: number | null, price_close_aud?: number | null, price_return_eur?: number | null, price_return_usd?: number | null, price_return_gbp?: number | null, price_return_jpy?: number | null, price_return_aud?: number | null, price_net_eur?: number | null, price_net_usd?: number | null, price_net_gbp?: number | null, price_net_jpy?: number | null, price_net_aud?: number | null };

export type IHistoryIndexExtendedDetailsFragment = { __typename?: 'HistoryIndex', id: string, index_id: string, date: string, file_name?: string | null, dividend_yield?: number | null, mkt_cap_eur?: number | null, mkt_cap_usd?: number | null, mkt_cap_gbp?: number | null, mkt_cap_jpy?: number | null, mkt_cap_aud?: number | null, mkt_cap_hkd?: number | null, mkt_cap_local?: number | null, price_close_eur?: number | null, price_close_usd?: number | null, price_close_gbp?: number | null, price_close_jpy?: number | null, price_close_aud?: number | null, price_close_local?: number | null, price_close_hkd?: number | null, price_return_eur?: number | null, price_return_usd?: number | null, price_return_gbp?: number | null, price_return_jpy?: number | null, price_return_aud?: number | null, price_return_hkd?: number | null, price_return_local?: number | null, price_net_eur?: number | null, price_net_usd?: number | null, price_net_gbp?: number | null, price_net_jpy?: number | null, price_net_aud?: number | null, price_net_hkd?: number | null, price_net_local?: number | null, dividend_net_yield?: number | null, price_return_epra_local?: number | null, price_close_epra_local?: number | null };

export type IGetClosePricesQueryVariables = Exact<{
  stock_id: Scalars['Int'];
}>;


export type IGetClosePricesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'HistoryStock', id: string, stock_id: string, date: string, close_price?: number | null, engl_mkt_cap?: number | null, epra_shares?: number | null, nav_epra?: number | null, nav_ifrs?: number | null, price_discount?: number | null, gross_div_yield?: number | null, div_gross?: number | null, div_net?: number | null, free_float_market_cap?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } | null> };

export type IHistoryIndicesByIdAndPeriodQueryVariables = Exact<{
  input: IHistoryIndicesByIdAndPeriodInput;
}>;


export type IHistoryIndicesByIdAndPeriodQuery = { __typename?: 'Query', result: Array<{ __typename?: 'HistoryIndex', id: string, index_id: string, date: string, file_name?: string | null, dividend_yield?: number | null, mkt_cap_eur?: number | null, mkt_cap_usd?: number | null, mkt_cap_gbp?: number | null, mkt_cap_jpy?: number | null, mkt_cap_aud?: number | null, mkt_cap_hkd?: number | null, mkt_cap_local?: number | null, price_close_eur?: number | null, price_close_usd?: number | null, price_close_gbp?: number | null, price_close_jpy?: number | null, price_close_aud?: number | null, price_close_local?: number | null, price_close_hkd?: number | null, price_return_eur?: number | null, price_return_usd?: number | null, price_return_gbp?: number | null, price_return_jpy?: number | null, price_return_aud?: number | null, price_return_hkd?: number | null, price_return_local?: number | null, price_net_eur?: number | null, price_net_usd?: number | null, price_net_gbp?: number | null, price_net_jpy?: number | null, price_net_aud?: number | null, price_net_hkd?: number | null, price_net_local?: number | null, dividend_net_yield?: number | null, price_return_epra_local?: number | null, price_close_epra_local?: number | null }> };

export type ICreateHistoryStocksMutationVariables = Exact<{
  input: Array<IHistoryStockInput> | IHistoryStockInput;
}>;


export type ICreateHistoryStocksMutation = { __typename?: 'Mutation', result: Array<{ __typename?: 'HistoryStock', id: string, stock_id: string, date: string, close_price?: number | null, engl_mkt_cap?: number | null, epra_shares?: number | null, nav_epra?: number | null, nav_ifrs?: number | null, price_discount?: number | null, gross_div_yield?: number | null, div_gross?: number | null, div_net?: number | null, free_float_market_cap?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null }> };

export type ICreateHistoryIndicesMutationVariables = Exact<{
  input: Array<IHistoryIndexInput> | IHistoryIndexInput;
}>;


export type ICreateHistoryIndicesMutation = { __typename?: 'Mutation', result: Array<{ __typename?: 'HistoryIndex', id: string, index_id: string, date: string, mkt_cap_eur?: number | null, mkt_cap_usd?: number | null, mkt_cap_gbp?: number | null, mkt_cap_jpy?: number | null, mkt_cap_aud?: number | null, price_close_eur?: number | null, price_close_usd?: number | null, price_close_gbp?: number | null, price_close_jpy?: number | null, price_close_aud?: number | null, price_return_eur?: number | null, price_return_usd?: number | null, price_return_gbp?: number | null, price_return_jpy?: number | null, price_return_aud?: number | null, price_net_eur?: number | null, price_net_usd?: number | null, price_net_gbp?: number | null, price_net_jpy?: number | null, price_net_aud?: number | null }> };

export type ICommentDetailsFragment = { __typename?: 'Comment', id: string, text: string, date: string, author: { __typename?: 'User', id: string, first_name: string, last_name: string } };

export type IMembershipCommentsQueryVariables = Exact<{
  membership_id: Scalars['Int'];
}>;


export type IMembershipCommentsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Comment', id: string, text: string, date: string, author: { __typename?: 'User', id: string, first_name: string, last_name: string } } | null> };

export type IAddCommentMutationVariables = Exact<{
  membership_id: Scalars['Int'];
  text: Scalars['String'];
}>;


export type IAddCommentMutation = { __typename?: 'Mutation', result: { __typename?: 'NewCommentResult', comment: { __typename?: 'Comment', id: string, text: string, date: string, author: { __typename?: 'User', id: string, first_name: string, last_name: string } }, membership: { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null } } };

export type IDeleteCommentMutationVariables = Exact<{
  id: Scalars['Int'];
  membership_id: Scalars['Int'];
}>;


export type IDeleteCommentMutation = { __typename?: 'Mutation', result: { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null } };

export type ICommentAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ICommentAddedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null } };

export type ICommentDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ICommentDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null } };

export type ICompanyDetailsFragment = { __typename?: 'Company', id: string, name: string, market_second_specialty?: string | null, website?: string | null, unique_stock_code?: string | null, info?: string | null, member_index: boolean, is_main_member: boolean, company_type: { __typename?: 'CompanyType', id: string, name: string }, market_activity: { __typename?: 'MarketActivity', id: string, name: string }, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } }, main_contacts: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, main_address?: { __typename?: 'Address', complete_vat_number?: string | null, id: string, name: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null };

export type ICompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type ICompaniesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Company', id: string, name: string, market_second_specialty?: string | null, website?: string | null, unique_stock_code?: string | null, info?: string | null, member_index: boolean, is_main_member: boolean, company_type: { __typename?: 'CompanyType', id: string, name: string }, market_activity: { __typename?: 'MarketActivity', id: string, name: string }, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } }, main_contacts: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, main_address?: { __typename?: 'Address', complete_vat_number?: string | null, id: string, name: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null } | null> };

export type ICompaniesNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type ICompaniesNamesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Company', id: string, name: string } | null> };

export type ICompanyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ICompanyQuery = { __typename?: 'Query', result?: { __typename?: 'Company', id: string, name: string, market_second_specialty?: string | null, website?: string | null, unique_stock_code?: string | null, info?: string | null, member_index: boolean, is_main_member: boolean, company_type: { __typename?: 'CompanyType', id: string, name: string }, market_activity: { __typename?: 'MarketActivity', id: string, name: string }, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } }, main_contacts: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, main_address?: { __typename?: 'Address', complete_vat_number?: string | null, id: string, name: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null } | null };

export type ICompaniesFilteredQueryVariables = Exact<{
  filter?: InputMaybe<ICompanyFilterInput>;
}>;


export type ICompaniesFilteredQuery = { __typename?: 'Query', result: { __typename?: 'CompaniesPage', total: number, companies: Array<{ __typename?: 'Company', id: string, name: string, market_second_specialty?: string | null, website?: string | null, unique_stock_code?: string | null, info?: string | null, member_index: boolean, is_main_member: boolean, company_type: { __typename?: 'CompanyType', id: string, name: string }, market_activity: { __typename?: 'MarketActivity', id: string, name: string }, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } }, main_contacts: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, main_address?: { __typename?: 'Address', complete_vat_number?: string | null, id: string, name: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null } | null> } };

export type IAddCompanyMutationVariables = Exact<{
  input: IAddCompanyInput;
}>;


export type IAddCompanyMutation = { __typename?: 'Mutation', result: { __typename?: 'MutationResult', success: boolean, errors?: Array<string | null> | null, company?: { __typename?: 'Company', id: string, name: string, market_second_specialty?: string | null, website?: string | null, unique_stock_code?: string | null, info?: string | null, member_index: boolean, is_main_member: boolean, company_type: { __typename?: 'CompanyType', id: string, name: string }, market_activity: { __typename?: 'MarketActivity', id: string, name: string }, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } }, main_contacts: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, main_address?: { __typename?: 'Address', complete_vat_number?: string | null, id: string, name: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null } | null } };

export type IUpdateCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
  input: INewCompanyInput;
}>;


export type IUpdateCompanyMutation = { __typename?: 'Mutation', result: { __typename?: 'Company', id: string, name: string, market_second_specialty?: string | null, website?: string | null, unique_stock_code?: string | null, info?: string | null, member_index: boolean, is_main_member: boolean, company_type: { __typename?: 'CompanyType', id: string, name: string }, market_activity: { __typename?: 'MarketActivity', id: string, name: string }, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } }, main_contacts: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, main_address?: { __typename?: 'Address', complete_vat_number?: string | null, id: string, name: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null } };

export type IUpdateCompanyMembershipMutationVariables = Exact<{
  id: Scalars['Int'];
  membershipId: Scalars['Int'];
}>;


export type IUpdateCompanyMembershipMutation = { __typename?: 'Mutation', result: { __typename?: 'Company', id: string, name: string, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } } } };

export type IDeleteCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteCompanyMutation = { __typename?: 'Mutation', result: boolean };

export type IAddCompanyToMembershipMutationVariables = Exact<{
  id: Scalars['Int'];
  membership_id: Scalars['Int'];
}>;


export type IAddCompanyToMembershipMutation = { __typename?: 'Mutation', result: { __typename?: 'Company', id: string, name: string, market_second_specialty?: string | null, website?: string | null, unique_stock_code?: string | null, info?: string | null, member_index: boolean, is_main_member: boolean, company_type: { __typename?: 'CompanyType', id: string, name: string }, market_activity: { __typename?: 'MarketActivity', id: string, name: string }, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } }, main_contacts: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, main_address?: { __typename?: 'Address', complete_vat_number?: string | null, id: string, name: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null } };

export type IUpdateCompanyMainMemberForMembershipMutationVariables = Exact<{
  id: Scalars['Int'];
  membership_id: Scalars['Int'];
  is_main_member: Scalars['Boolean'];
}>;


export type IUpdateCompanyMainMemberForMembershipMutation = { __typename?: 'Mutation', result: boolean };

export type IUpdateCompanyMainContactMutationVariables = Exact<{
  id: Scalars['Int'];
  contact_id: Scalars['Int'];
  is_main: Scalars['Boolean'];
}>;


export type IUpdateCompanyMainContactMutation = { __typename?: 'Mutation', result: boolean };

export type ICompanyCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ICompanyCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Company', id: string, name: string, market_second_specialty?: string | null, website?: string | null, unique_stock_code?: string | null, info?: string | null, member_index: boolean, is_main_member: boolean, company_type: { __typename?: 'CompanyType', id: string, name: string }, market_activity: { __typename?: 'MarketActivity', id: string, name: string }, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } }, main_contacts: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, main_address?: { __typename?: 'Address', complete_vat_number?: string | null, id: string, name: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null } };

export type ICompanyDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ICompanyDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Company', id: string, name: string, market_second_specialty?: string | null, website?: string | null, unique_stock_code?: string | null, info?: string | null, member_index: boolean, is_main_member: boolean, company_type: { __typename?: 'CompanyType', id: string, name: string }, market_activity: { __typename?: 'MarketActivity', id: string, name: string }, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } }, main_contacts: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, main_address?: { __typename?: 'Address', complete_vat_number?: string | null, id: string, name: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null } };

export type ICompanyUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ICompanyUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Company', id: string, name: string, market_second_specialty?: string | null, website?: string | null, unique_stock_code?: string | null, info?: string | null, member_index: boolean, is_main_member: boolean, company_type: { __typename?: 'CompanyType', id: string, name: string }, market_activity: { __typename?: 'MarketActivity', id: string, name: string }, membership: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null, product: { __typename?: 'Product', id: string, name: string, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } }, main_contacts: Array<{ __typename?: 'Contact', id: string, fullName: string } | null>, main_address?: { __typename?: 'Address', complete_vat_number?: string | null, id: string, name: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null } };

export type ICompanyTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ICompanyTypesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'CompanyType', id: string, name: string } | null> };

export type IContactDetailsFragment = { __typename?: 'Contact', id: string, email?: string | null, fullName: string, first_name: string, last_name: string, is_main: boolean, title_external?: string | null, prefix?: string | null, linkedin?: string | null, address?: { __typename?: 'Address', id: string, zip?: string | null, name: string, street: string, city: string, country: { __typename?: 'Country', name: string, region?: { __typename?: 'Region', name: string } | null } } | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } };

export type IContactDetailsInvoicePreviewFragment = { __typename?: 'Contact', id: string, title_external?: string | null, prefix?: string | null, suffix?: string | null };

export type IContactFullScopeFragment = { __typename?: 'Contact', id: string, prefix?: string | null, first_name: string, middle_name?: string | null, last_name: string, suffix?: string | null, fullName: string, informal_name?: string | null, title_external?: string | null, notes?: string | null, phone_direct?: string | null, phone_mobile?: string | null, fax?: string | null, email?: string | null, location_of_contact?: string | null, linkedin?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string }, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, name: string, phone?: string | null, address_name?: string | null, fax?: string | null, street: string, email?: string | null, city: string, zip?: string | null, country: { __typename?: 'Country', id: string, name: string } } | null, assistant?: { __typename?: 'Contact', id: string, fullName: string, email?: string | null, phone_direct?: string | null, phone_mobile?: string | null } | null, contactMeetings?: Array<{ __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } | null> | null };

export type IRecipientsFragment = { __typename?: 'Contact', id: string, first_name: string, last_name: string, fullName: string, email?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } };

export type ICompanyContactsQueryVariables = Exact<{
  company_id: Scalars['Int'];
}>;


export type ICompanyContactsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Contact', phone_direct?: string | null, id: string, email?: string | null, fullName: string, first_name: string, last_name: string, is_main: boolean, title_external?: string | null, prefix?: string | null, linkedin?: string | null, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, zip?: string | null, name: string, street: string, city: string, country: { __typename?: 'Country', name: string, region?: { __typename?: 'Region', name: string } | null } } | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } | null> };

export type IContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type IContactsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Contact', phone_direct?: string | null, id: string, email?: string | null, fullName: string, first_name: string, last_name: string, is_main: boolean, title_external?: string | null, prefix?: string | null, linkedin?: string | null, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, zip?: string | null, name: string, street: string, city: string, country: { __typename?: 'Country', name: string, region?: { __typename?: 'Region', name: string } | null } } | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } | null> };

export type IContactsFilteredQueryVariables = Exact<{
  filter?: InputMaybe<IContactFilterInput>;
}>;


export type IContactsFilteredQuery = { __typename?: 'Query', result: { __typename?: 'ContactsPage', total: number, contacts: Array<{ __typename?: 'Contact', phone_direct?: string | null, phone_mobile?: string | null, id: string, email?: string | null, fullName: string, first_name: string, last_name: string, is_main: boolean, title_external?: string | null, prefix?: string | null, linkedin?: string | null, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, zip?: string | null, name: string, street: string, city: string, country: { __typename?: 'Country', name: string, region?: { __typename?: 'Region', name: string } | null } } | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } | null> } };

export type IContactByEmailAndFullNameQueryVariables = Exact<{
  fullName: Scalars['String'];
  email: Scalars['String'];
}>;


export type IContactByEmailAndFullNameQuery = { __typename?: 'Query', result: { __typename?: 'Contact', id: string, title_external?: string | null, prefix?: string | null, suffix?: string | null } };

export type IContactQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IContactQuery = { __typename?: 'Query', result?: { __typename?: 'Contact', id: string, email?: string | null, fullName: string, first_name: string, last_name: string, is_main: boolean, title_external?: string | null, prefix?: string | null, linkedin?: string | null, company: { __typename?: 'Company', id: string, name: string, membership: { __typename?: 'Membership', id: string, name: string }, main_address?: { __typename?: 'Address', complete_vat_number?: string | null } | null }, contactMeetings?: Array<{ __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } | null> | null, address?: { __typename?: 'Address', id: string, zip?: string | null, name: string, street: string, city: string, country: { __typename?: 'Country', name: string, region?: { __typename?: 'Region', name: string } | null } } | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } | null };

export type IContactDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IContactDetailsQuery = { __typename?: 'Query', result?: { __typename?: 'Contact', id: string, prefix?: string | null, first_name: string, middle_name?: string | null, last_name: string, suffix?: string | null, fullName: string, informal_name?: string | null, title_external?: string | null, notes?: string | null, phone_direct?: string | null, phone_mobile?: string | null, fax?: string | null, email?: string | null, location_of_contact?: string | null, linkedin?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string }, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, name: string, phone?: string | null, address_name?: string | null, fax?: string | null, street: string, email?: string | null, city: string, zip?: string | null, country: { __typename?: 'Country', id: string, name: string } } | null, assistant?: { __typename?: 'Contact', id: string, fullName: string, email?: string | null, phone_direct?: string | null, phone_mobile?: string | null } | null, contactMeetings?: Array<{ __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } | null> | null } | null };

export type IContactBasicDataQueryVariables = Exact<{ [key: string]: never; }>;


export type IContactBasicDataQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> };

export type IAssistantContactsFromSameCompanyQueryVariables = Exact<{
  id: Scalars['Int'];
  company_id: Scalars['Int'];
}>;


export type IAssistantContactsFromSameCompanyQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Contact', id: string, fullName: string, email?: string | null, phone_direct?: string | null, phone_mobile?: string | null } | null> };

export type IContactInterestsQueryVariables = Exact<{
  contact_id: Scalars['Int'];
}>;


export type IContactInterestsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'ContactInterests', interest_id: string } | null> };

export type IContactsByInterestsQueryVariables = Exact<{
  interestIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type IContactsByInterestsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Contact', id: string, first_name: string, last_name: string, fullName: string, email?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } | null> };

export type IRecipientListContactsQueryVariables = Exact<{
  contactTitleIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  companyTypeIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  membershipTypeIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  interestIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  countryIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  recipientListId?: InputMaybe<Scalars['Int']>;
}>;


export type IRecipientListContactsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Contact', id: string, first_name: string, last_name: string, fullName: string, email?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } | null> };

export type IDeleteContactMutationVariables = Exact<{
  id: Scalars['Int'];
  can_delete_last?: InputMaybe<Scalars['Boolean']>;
}>;


export type IDeleteContactMutation = { __typename?: 'Mutation', result: boolean };

export type ICreateContactMutationVariables = Exact<{
  input: IContactCreateInput;
}>;


export type ICreateContactMutation = { __typename?: 'Mutation', result: { __typename?: 'Contact', phone_direct?: string | null, id: string, email?: string | null, fullName: string, first_name: string, last_name: string, is_main: boolean, title_external?: string | null, prefix?: string | null, linkedin?: string | null, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, zip?: string | null, name: string, street: string, city: string, country: { __typename?: 'Country', name: string, region?: { __typename?: 'Region', name: string } | null } } | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } };

export type IUpdateContactDetailsMutationVariables = Exact<{
  id: Scalars['Int'];
  input: IContactInput;
}>;


export type IUpdateContactDetailsMutation = { __typename?: 'Mutation', result: { __typename?: 'Contact', id: string, prefix?: string | null, first_name: string, middle_name?: string | null, last_name: string, suffix?: string | null, fullName: string, informal_name?: string | null, title_external?: string | null, notes?: string | null, phone_direct?: string | null, phone_mobile?: string | null, fax?: string | null, email?: string | null, location_of_contact?: string | null, linkedin?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string }, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, name: string, phone?: string | null, address_name?: string | null, fax?: string | null, street: string, email?: string | null, city: string, zip?: string | null, country: { __typename?: 'Country', id: string, name: string } } | null, assistant?: { __typename?: 'Contact', id: string, fullName: string, email?: string | null, phone_direct?: string | null, phone_mobile?: string | null } | null, contactMeetings?: Array<{ __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } | null> | null } };

export type IUpdateContactAddressMutationVariables = Exact<{
  id: Scalars['Int'];
  company_id: Scalars['Int'];
  address_id?: InputMaybe<Scalars['Int']>;
}>;


export type IUpdateContactAddressMutation = { __typename?: 'Mutation', result: { __typename?: 'Contact', id: string, prefix?: string | null, first_name: string, middle_name?: string | null, last_name: string, suffix?: string | null, fullName: string, informal_name?: string | null, title_external?: string | null, notes?: string | null, phone_direct?: string | null, phone_mobile?: string | null, fax?: string | null, email?: string | null, location_of_contact?: string | null, linkedin?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string }, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, name: string, phone?: string | null, address_name?: string | null, fax?: string | null, street: string, email?: string | null, city: string, zip?: string | null, country: { __typename?: 'Country', id: string, name: string } } | null, assistant?: { __typename?: 'Contact', id: string, fullName: string, email?: string | null, phone_direct?: string | null, phone_mobile?: string | null } | null, contactMeetings?: Array<{ __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } | null> | null } };

export type IUpdateContactAssistantMutationVariables = Exact<{
  id: Scalars['Int'];
  assistantId?: InputMaybe<Scalars['Int']>;
}>;


export type IUpdateContactAssistantMutation = { __typename?: 'Mutation', result: { __typename?: 'Contact', id: string, prefix?: string | null, first_name: string, middle_name?: string | null, last_name: string, suffix?: string | null, fullName: string, informal_name?: string | null, title_external?: string | null, notes?: string | null, phone_direct?: string | null, phone_mobile?: string | null, fax?: string | null, email?: string | null, location_of_contact?: string | null, linkedin?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string }, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, name: string, phone?: string | null, address_name?: string | null, fax?: string | null, street: string, email?: string | null, city: string, zip?: string | null, country: { __typename?: 'Country', id: string, name: string } } | null, assistant?: { __typename?: 'Contact', id: string, fullName: string, email?: string | null, phone_direct?: string | null, phone_mobile?: string | null } | null, contactMeetings?: Array<{ __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } | null> | null } };

export type ISetInvoiceToContactMutationVariables = Exact<{
  id: Scalars['Int'];
  is_main: Scalars['Boolean'];
}>;


export type ISetInvoiceToContactMutation = { __typename?: 'Mutation', result: { __typename?: 'Contact', id: string, is_main: boolean, fullName: string, email?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string }, address?: { __typename?: 'Address', id: string, street: string } | null, company: { __typename?: 'Company', id: string, name: string } } };

export type IUpdateContactInterestsMutationVariables = Exact<{
  id: Scalars['Int'];
  interest_ids: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type IUpdateContactInterestsMutation = { __typename?: 'Mutation', result: Array<string | null> };

export type IContactDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IContactDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Contact', id: string } };

export type IContactCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IContactCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Contact', phone_direct?: string | null, id: string, email?: string | null, fullName: string, first_name: string, last_name: string, is_main: boolean, title_external?: string | null, prefix?: string | null, linkedin?: string | null, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, zip?: string | null, name: string, street: string, city: string, country: { __typename?: 'Country', name: string, region?: { __typename?: 'Region', name: string } | null } } | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } };

export type IContactUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IContactUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Contact', phone_direct?: string | null, id: string, email?: string | null, fullName: string, first_name: string, last_name: string, is_main: boolean, title_external?: string | null, prefix?: string | null, linkedin?: string | null, company: { __typename?: 'Company', id: string, name: string }, address?: { __typename?: 'Address', id: string, zip?: string | null, name: string, street: string, city: string, country: { __typename?: 'Country', name: string, region?: { __typename?: 'Region', name: string } | null } } | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } };

export type ICountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ICountriesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Country', id: string, name: string, code?: string | null, region?: { __typename?: 'Region', id: string } | null } | null> };

export type ICountryNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type ICountryNamesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Country', id: string, name: string } | null> };

export type ICurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type ICurrenciesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Currency', id: string, name: string, code: string } | null> };

export type ICventEventDetailsFragment = { __typename?: 'CventEvent', id: string, name?: string | null, created_by?: string | null, update_by?: string | null, date_insert?: string | null, date_edit?: string | null, url_landing_page?: string | null, event_stub?: string | null, is_active: boolean, pk_email_payment_reminder?: number | null, pk_email_registration?: number | null, pk_product_registration?: number | null, pk_email_networking?: number | null, is_paid_event?: boolean | null };

export type ICventContactDetailsFragment = { __typename?: 'CventContact', id: string, date_created?: string | null, first_name?: string | null, last_name?: string | null, company_name?: string | null, email?: string | null, is_approved?: boolean | null, fullName?: string | null, contact_id?: number | null, is_linked?: boolean | null, role?: { __typename?: 'CventRole', id: string, name: string, name_short?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, number?: string | null, date_paid?: string | null, email_sent_date?: string | null } | null };

export type IDbContactDetailsFragment = { __typename?: 'Contact', id: string, email?: string | null, fullName: string };

export type ICventLocationDetailsFragment = { __typename?: 'CventLocation', id: string, name?: string | null };

export type ICventRolesDetailsFragment = { __typename?: 'CventRole', id: string, name: string, name_short?: string | null };

export type IGetAllCventEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllCventEventsQuery = { __typename?: 'Query', result?: Array<{ __typename?: 'CventEvent', id: string, name?: string | null, created_by?: string | null, update_by?: string | null, date_insert?: string | null, date_edit?: string | null, url_landing_page?: string | null, event_stub?: string | null, is_active: boolean, pk_email_payment_reminder?: number | null, pk_email_registration?: number | null, pk_product_registration?: number | null, pk_email_networking?: number | null, is_paid_event?: boolean | null } | null> | null };

export type IGetAllCventRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllCventRolesQuery = { __typename?: 'Query', result?: Array<{ __typename?: 'CventRole', id: string, name: string, name_short?: string | null } | null> | null };

export type IGetAllCventContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllCventContactsQuery = { __typename?: 'Query', result?: Array<{ __typename?: 'CventContact', id: string, date_created?: string | null, first_name?: string | null, last_name?: string | null, company_name?: string | null, email?: string | null, is_approved?: boolean | null, fullName?: string | null, contact_id?: number | null, is_linked?: boolean | null, role?: { __typename?: 'CventRole', id: string, name: string, name_short?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, number?: string | null, date_paid?: string | null, email_sent_date?: string | null } | null } | null> | null };

export type IGetAllCventContactsForLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetAllCventContactsForLocationQuery = { __typename?: 'Query', result?: Array<{ __typename?: 'CventContact', id: string, date_created?: string | null, first_name?: string | null, last_name?: string | null, company_name?: string | null, email?: string | null, is_approved?: boolean | null, fullName?: string | null, contact_id?: number | null, is_linked?: boolean | null, role?: { __typename?: 'CventRole', id: string, name: string, name_short?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, number?: string | null, date_paid?: string | null, email_sent_date?: string | null } | null } | null> | null };

export type IGetAllLocationsForEventQueryVariables = Exact<{
  event_id: Scalars['ID'];
}>;


export type IGetAllLocationsForEventQuery = { __typename?: 'Query', result?: Array<{ __typename?: 'CventLocation', id: string, name?: string | null } | null> | null };

export type IGetMatchedDbContactsByEmailQueryVariables = Exact<{
  id: Scalars['ID'];
  input: ILinkContact;
}>;


export type IGetMatchedDbContactsByEmailQuery = { __typename?: 'Query', result?: Array<{ __typename?: 'Contact', id: string, email?: string | null, fullName: string }> | null };

export type ICreateCventContactMutationVariables = Exact<{
  input: IAddCventContact;
}>;


export type ICreateCventContactMutation = { __typename?: 'Mutation', result: { __typename?: 'CventContact', id: string, date_created?: string | null, first_name?: string | null, last_name?: string | null, company_name?: string | null, email?: string | null, is_approved?: boolean | null, fullName?: string | null, contact_id?: number | null, is_linked?: boolean | null, role?: { __typename?: 'CventRole', id: string, name: string, name_short?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, number?: string | null, date_paid?: string | null, email_sent_date?: string | null } | null } };

export type IUpdateCventContactMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IAddCventContact;
}>;


export type IUpdateCventContactMutation = { __typename?: 'Mutation', result: { __typename?: 'CventContact', id: string, date_created?: string | null, first_name?: string | null, last_name?: string | null, company_name?: string | null, email?: string | null, is_approved?: boolean | null, fullName?: string | null, contact_id?: number | null, is_linked?: boolean | null, role?: { __typename?: 'CventRole', id: string, name: string, name_short?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, number?: string | null, date_paid?: string | null, email_sent_date?: string | null } | null } };

export type IDeleteCventContactMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteCventContactMutation = { __typename?: 'Mutation', result: boolean };

export type ILinkContactMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ILinkContact;
}>;


export type ILinkContactMutation = { __typename?: 'Mutation', result: { __typename?: 'CventContact', id: string, date_created?: string | null, first_name?: string | null, last_name?: string | null, company_name?: string | null, email?: string | null, is_approved?: boolean | null, fullName?: string | null, contact_id?: number | null, is_linked?: boolean | null, role?: { __typename?: 'CventRole', id: string, name: string, name_short?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, number?: string | null, date_paid?: string | null, email_sent_date?: string | null } | null } };

export type IUnLinkContactMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IUnLinkContactMutation = { __typename?: 'Mutation', result: { __typename?: 'CventContact', id: string, date_created?: string | null, first_name?: string | null, last_name?: string | null, company_name?: string | null, email?: string | null, is_approved?: boolean | null, fullName?: string | null, contact_id?: number | null, is_linked?: boolean | null, role?: { __typename?: 'CventRole', id: string, name: string, name_short?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, number?: string | null, date_paid?: string | null, email_sent_date?: string | null } | null } };

export type IToggleIsApprovedMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IIsApproved;
}>;


export type IToggleIsApprovedMutation = { __typename?: 'Mutation', result: { __typename?: 'CventContact', id: string, date_created?: string | null, first_name?: string | null, last_name?: string | null, company_name?: string | null, email?: string | null, is_approved?: boolean | null, fullName?: string | null, contact_id?: number | null, is_linked?: boolean | null, role?: { __typename?: 'CventRole', id: string, name: string, name_short?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, number?: string | null, date_paid?: string | null, email_sent_date?: string | null } | null } };

export type IUploadCventContactsMutationVariables = Exact<{
  location: Scalars['String'];
  input?: InputMaybe<Array<InputMaybe<ICventFileInput>> | InputMaybe<ICventFileInput>>;
}>;


export type IUploadCventContactsMutation = { __typename?: 'Mutation', result: { __typename?: 'UploadCventContactsPayload', event: { __typename?: 'CventEvent', id: string, name?: string | null, created_by?: string | null, update_by?: string | null, date_insert?: string | null, date_edit?: string | null, url_landing_page?: string | null, event_stub?: string | null, is_active: boolean, pk_email_payment_reminder?: number | null, pk_email_registration?: number | null, pk_product_registration?: number | null, pk_email_networking?: number | null, is_paid_event?: boolean | null }, location?: { __typename?: 'CventLocation', id: string, name?: string | null } | null } };

export type IDashboardDoughnutQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type IDashboardDoughnutQueryQuery = { __typename?: 'Query', result: Array<{ __typename?: 'DashboardDoughnut', count: number, membership_type: string, label: string } | null> };

export type IDashboardMembershipsInfoForTheLastThreeYearsQueryVariables = Exact<{ [key: string]: never; }>;


export type IDashboardMembershipsInfoForTheLastThreeYearsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'DashboardMembershipInfoForLastThreeYears', quarters_date: string, started_memberships_count: number, renewed_memberships_count: number, ended_memberships_count: number, startedLegend: string, renewedLegend: string, endedLegend: string } | null> };

export type IDashboardInvoicesInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type IDashboardInvoicesInfoQuery = { __typename?: 'Query', result: Array<{ __typename?: 'DashboardInvoices', date: string, issued_invoices: number, paid_invoices: number, outstanding: number, total_issued_invoices_count: number, total_paid_invoices_count: number } | null> };

export type IDividendDetailsFragment = { __typename?: 'DividendGross', id: string, start_date: string, stock_id: string, value?: number | null };

export type IGetDividendsGrossQueryVariables = Exact<{
  stock_id: Scalars['Int'];
}>;


export type IGetDividendsGrossQuery = { __typename?: 'Query', result: Array<{ __typename?: 'DividendGross', id: string, start_date: string, stock_id: string, value?: number | null } | null> };

export type ICreateDividendMutationVariables = Exact<{
  stock_id: Scalars['ID'];
  input: IDividendInput;
}>;


export type ICreateDividendMutation = { __typename?: 'Mutation', result: { __typename?: 'DividendGross', id: string, start_date: string, stock_id: string, value?: number | null } };

export type IUpdateDividendMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IDividendInput;
}>;


export type IUpdateDividendMutation = { __typename?: 'Mutation', result: { __typename?: 'DividendGross', id: string, start_date: string, stock_id: string, value?: number | null } };

export type IDeleteDividendMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteDividendMutation = { __typename?: 'Mutation', result: boolean };

export type IDividendCreatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IDividendCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'DividendGross', id: string, start_date: string, stock_id: string, value?: number | null } };

export type IDividendUpdatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IDividendUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'DividendGross', id: string, start_date: string, stock_id: string, value?: number | null } };

export type IDividendDeletedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IDividendDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'DividendGross', id: string, start_date: string, stock_id: string, value?: number | null } };

export type IDocumentDetailsFragment = { __typename?: 'Document', id: string, display_name: string, file_name: string, visible_from?: string | null, protected_until?: string | null, description?: string | null, destination_url?: string | null, downloads?: number | null, company: { __typename?: 'Company', id: string, name: string }, country?: { __typename?: 'Country', id: string, name: string } | null, site_sections?: Array<{ __typename?: 'SiteSection', id: string, name: string } | null> | null };

export type IDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type IDocumentsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Document', id: string, display_name: string, file_name: string, visible_from?: string | null, protected_until?: string | null, description?: string | null, destination_url?: string | null, downloads?: number | null, company: { __typename?: 'Company', id: string, name: string }, country?: { __typename?: 'Country', id: string, name: string } | null, site_sections?: Array<{ __typename?: 'SiteSection', id: string, name: string } | null> | null } | null> };

export type IDocumentsFilteredQueryVariables = Exact<{
  filter?: InputMaybe<IDocumentFilterInput>;
}>;


export type IDocumentsFilteredQuery = { __typename?: 'Query', result: { __typename?: 'DocumentsPage', total: number, documents: Array<{ __typename?: 'Document', id: string, display_name: string, file_name: string, visible_from?: string | null, protected_until?: string | null, description?: string | null, destination_url?: string | null, downloads?: number | null, company: { __typename?: 'Company', id: string, name: string }, country?: { __typename?: 'Country', id: string, name: string } | null, site_sections?: Array<{ __typename?: 'SiteSection', id: string, name: string } | null> | null } | null> } };

export type ICreateDocumentMutationVariables = Exact<{
  input: IDocumentInput;
}>;


export type ICreateDocumentMutation = { __typename?: 'Mutation', result: { __typename?: 'Document', id: string, display_name: string, file_name: string, visible_from?: string | null, protected_until?: string | null, description?: string | null, destination_url?: string | null, downloads?: number | null, company: { __typename?: 'Company', id: string, name: string }, country?: { __typename?: 'Country', id: string, name: string } | null, site_sections?: Array<{ __typename?: 'SiteSection', id: string, name: string } | null> | null } };

export type IUpdateDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IDocumentInput;
}>;


export type IUpdateDocumentMutation = { __typename?: 'Mutation', result: { __typename?: 'Document', id: string, display_name: string, file_name: string, visible_from?: string | null, protected_until?: string | null, description?: string | null, destination_url?: string | null, downloads?: number | null, company: { __typename?: 'Company', id: string, name: string }, country?: { __typename?: 'Country', id: string, name: string } | null, site_sections?: Array<{ __typename?: 'SiteSection', id: string, name: string } | null> | null } };

export type IDeleteDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteDocumentMutation = { __typename?: 'Mutation', result: boolean };

export type IDeleteDocumentFromSiteSectionMutationVariables = Exact<{
  document_id: Scalars['ID'];
  site_section_id: Scalars['ID'];
}>;


export type IDeleteDocumentFromSiteSectionMutation = { __typename?: 'Mutation', result: boolean };

export type IUpdateDescriptionMutationVariables = Exact<{
  id: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type IUpdateDescriptionMutation = { __typename?: 'Mutation', result: { __typename?: 'Document', id: string, display_name: string, file_name: string, visible_from?: string | null, protected_until?: string | null, description?: string | null, destination_url?: string | null, downloads?: number | null, company: { __typename?: 'Company', id: string, name: string }, country?: { __typename?: 'Country', id: string, name: string } | null, site_sections?: Array<{ __typename?: 'SiteSection', id: string, name: string } | null> | null } };

export type IDocumentDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IDocumentDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Document', id: string, display_name: string, file_name: string, visible_from?: string | null, protected_until?: string | null, description?: string | null, destination_url?: string | null, downloads?: number | null, company: { __typename?: 'Company', id: string, name: string }, country?: { __typename?: 'Country', id: string, name: string } | null, site_sections?: Array<{ __typename?: 'SiteSection', id: string, name: string } | null> | null } };

export type IDocumentUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IDocumentUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Document', id: string, display_name: string, file_name: string, visible_from?: string | null, protected_until?: string | null, description?: string | null, destination_url?: string | null, downloads?: number | null, company: { __typename?: 'Company', id: string, name: string }, country?: { __typename?: 'Country', id: string, name: string } | null, site_sections?: Array<{ __typename?: 'SiteSection', id: string, name: string } | null> | null } };

export type IDocumentCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IDocumentCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Document', id: string, display_name: string, file_name: string, visible_from?: string | null, protected_until?: string | null, description?: string | null, destination_url?: string | null, downloads?: number | null, company: { __typename?: 'Company', id: string, name: string }, country?: { __typename?: 'Country', id: string, name: string } | null, site_sections?: Array<{ __typename?: 'SiteSection', id: string, name: string } | null> | null } };

export type IEtfDetailsFragment = { __typename?: 'Etf', id: string, launch_date: string, name?: string | null, provider?: string | null, identifier?: string | null, is_deleted: boolean };

export type IEtfValueDetailsFragment = { __typename?: 'EtfValue', id: string, date: string, aum: number, total_return_one_year: number, index_total_return_one_year: number, total_return_three_year?: number | null, index_total_return_three_year?: number | null, etf: { __typename?: 'Etf', id: string, name?: string | null, provider?: string | null, identifier?: string | null, launch_date: string } };

export type IGetEtfsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetEtfsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Etf', id: string, launch_date: string, name?: string | null, provider?: string | null, identifier?: string | null, is_deleted: boolean } | null> };

export type IGetEtfValuesQueryVariables = Exact<{
  etf_id: Scalars['Int'];
}>;


export type IGetEtfValuesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'EtfValue', id: string, date: string, aum: number, total_return_one_year: number, index_total_return_one_year: number, total_return_three_year?: number | null, index_total_return_three_year?: number | null, etf: { __typename?: 'Etf', id: string, name?: string | null, provider?: string | null, identifier?: string | null, launch_date: string } } | null> };

export type IGetEtfQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetEtfQuery = { __typename?: 'Query', result: { __typename?: 'Etf', id: string, launch_date: string, name?: string | null, provider?: string | null, identifier?: string | null, is_deleted: boolean } };

export type IAddEtfMutationVariables = Exact<{
  input: IEtfInput;
}>;


export type IAddEtfMutation = { __typename?: 'Mutation', result: { __typename?: 'Etf', id: string, launch_date: string, name?: string | null, provider?: string | null, identifier?: string | null, is_deleted: boolean } };

export type IUpdateEtfMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IEtfInput;
}>;


export type IUpdateEtfMutation = { __typename?: 'Mutation', result: { __typename?: 'Etf', id: string, launch_date: string, name?: string | null, provider?: string | null, identifier?: string | null, is_deleted: boolean } };

export type IDeleteEtfMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteEtfMutation = { __typename?: 'Mutation', result: boolean };

export type IAddEtfValueMutationVariables = Exact<{
  etf_id: Scalars['ID'];
  input: IEtfValueInput;
}>;


export type IAddEtfValueMutation = { __typename?: 'Mutation', result?: { __typename?: 'EtfValue', id: string, date: string, aum: number, total_return_one_year: number, index_total_return_one_year: number, total_return_three_year?: number | null, index_total_return_three_year?: number | null, etf: { __typename?: 'Etf', id: string, name?: string | null, provider?: string | null, identifier?: string | null, launch_date: string } } | null };

export type IUpdateEtfValueMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IEtfValueInput;
}>;


export type IUpdateEtfValueMutation = { __typename?: 'Mutation', result: { __typename?: 'EtfValue', id: string, date: string, aum: number, total_return_one_year: number, index_total_return_one_year: number, total_return_three_year?: number | null, index_total_return_three_year?: number | null, etf: { __typename?: 'Etf', id: string, name?: string | null, provider?: string | null, identifier?: string | null, launch_date: string } } };

export type IEtfCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IEtfCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Etf', id: string, launch_date: string, name?: string | null, provider?: string | null, identifier?: string | null, is_deleted: boolean } };

export type IEtfUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IEtfUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Etf', id: string, launch_date: string, name?: string | null, provider?: string | null, identifier?: string | null, is_deleted: boolean } };

export type IEtfDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IEtfDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Etf', id: string, launch_date: string, name?: string | null, provider?: string | null, identifier?: string | null, is_deleted: boolean } };

export type IEtfValueCreatedSubscriptionVariables = Exact<{
  etf_id: Scalars['ID'];
}>;


export type IEtfValueCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'EtfValue', id: string, date: string, aum: number, total_return_one_year: number, index_total_return_one_year: number, total_return_three_year?: number | null, index_total_return_three_year?: number | null, etf: { __typename?: 'Etf', id: string, name?: string | null, provider?: string | null, identifier?: string | null, launch_date: string } } };

export type IEtfValueUpdatedSubscriptionVariables = Exact<{
  etf_id: Scalars['ID'];
}>;


export type IEtfValueUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'EtfValue', id: string, date: string, aum: number, total_return_one_year: number, index_total_return_one_year: number, total_return_three_year?: number | null, index_total_return_three_year?: number | null, etf: { __typename?: 'Etf', id: string, name?: string | null, provider?: string | null, identifier?: string | null, launch_date: string } } };

export type IGetEtfsWithValuesQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']>;
}>;


export type IGetEtfsWithValuesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'EtfValue', id: string, date: string, aum: number, total_return_one_year: number, index_total_return_one_year: number, total_return_three_year?: number | null, index_total_return_three_year?: number | null, etf: { __typename?: 'Etf', id: string, name?: string | null, provider?: string | null, identifier?: string | null, launch_date: string } } | null> };

export type IFtseDetailsFragment = { __typename?: 'FtseFile', id: string, name: string, file_location: string, last_import?: string | null, last_get?: string | null, attempt?: number | null, type?: { __typename?: 'FtseType', id: string, name: string } | null };

export type IFtseConfigurationDetailsFragment = { __typename?: 'FtseConfiguration', id: string, property: string, value: string };

export type IGetFtseFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetFtseFilesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'FtseFile', id: string, name: string, file_location: string, last_import?: string | null, last_get?: string | null, attempt?: number | null, type?: { __typename?: 'FtseType', id: string, name: string } | null } | null> };

export type IGetFtseTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetFtseTypesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'FtseType', id: string, name: string } | null> };

export type IGetFtseConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetFtseConfigurationsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'FtseConfiguration', id: string, property: string, value: string } | null> };

export type IDeleteFtseFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteFtseFileMutation = { __typename?: 'Mutation', result: boolean };

export type ICreateFtseFileMutationVariables = Exact<{
  input: IFtseFileInput;
}>;


export type ICreateFtseFileMutation = { __typename?: 'Mutation', result: { __typename?: 'FtseFile', id: string, name: string, file_location: string, last_import?: string | null, last_get?: string | null, attempt?: number | null, type?: { __typename?: 'FtseType', id: string, name: string } | null } };

export type IUpdateFtseMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IFtseFileInput;
}>;


export type IUpdateFtseMutation = { __typename?: 'Mutation', result: { __typename?: 'FtseFile', id: string, name: string, file_location: string, last_import?: string | null, last_get?: string | null, attempt?: number | null, type?: { __typename?: 'FtseType', id: string, name: string } | null } };

export type IUpdateFtseConfigurationMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IFtseConfigurationInput;
}>;


export type IUpdateFtseConfigurationMutation = { __typename?: 'Mutation', result: { __typename?: 'FtseConfiguration', id: string, property: string, value: string } };

export type IFtseFileCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IFtseFileCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'FtseFile', id: string, name: string, file_location: string, last_import?: string | null, last_get?: string | null, attempt?: number | null, type?: { __typename?: 'FtseType', id: string, name: string } | null } };

export type IFtseFileUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IFtseFileUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'FtseFile', id: string, name: string, file_location: string, last_import?: string | null, last_get?: string | null, attempt?: number | null, type?: { __typename?: 'FtseType', id: string, name: string } | null } };

export type IFtseConfigurationUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IFtseConfigurationUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'FtseConfiguration', id: string, property: string, value: string } };

export type IFtseFileDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IFtseFileDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'FtseFile', id: string, name: string, file_location: string, last_import?: string | null, last_get?: string | null, attempt?: number | null, type?: { __typename?: 'FtseType', id: string, name: string } | null } };

export type IFtseFxDetailsFragment = { __typename?: 'FtseFx', id: string, rate: number, date: string, currency: { __typename?: 'Currency', id: string, code: string } };

export type IGetFxDataQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetFxDataQuery = { __typename?: 'Query', result: Array<{ __typename?: 'FtseFx', id: string, rate: number, date: string, currency: { __typename?: 'Currency', id: string, code: string } } | null> };

export type IGetLatestFxDataQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']>;
}>;


export type IGetLatestFxDataQuery = { __typename?: 'Query', result: Array<{ __typename?: 'FtseFx', id: string, rate: number, date: string, currency: { __typename?: 'Currency', id: string, code: string } } | null> };

export type IHistoryAllocationCountryDetailsFragment = { __typename?: 'HistoryAllocationCountry', id: string, stock_id: string, value: number, year: number, country: { __typename?: 'Country', id: string, name: string } };

export type IGetHistoryAllocationCountriesQueryVariables = Exact<{
  stock_id: Scalars['Int'];
}>;


export type IGetHistoryAllocationCountriesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'HistoryAllocationCountry', id: string, stock_id: string, value: number, year: number, country: { __typename?: 'Country', id: string, name: string } } | null> };

export type ICreateAllocationCountryMutationVariables = Exact<{
  stock_id: Scalars['ID'];
  input: IAllocationCountryInput;
}>;


export type ICreateAllocationCountryMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryAllocationCountry', id: string, stock_id: string, value: number, year: number, country: { __typename?: 'Country', id: string, name: string } } };

export type IUpdateAllocationCountryMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IAllocationCountryInput;
}>;


export type IUpdateAllocationCountryMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryAllocationCountry', id: string, stock_id: string, value: number, year: number, country: { __typename?: 'Country', id: string, name: string } } };

export type IDeleteAllocationCountryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteAllocationCountryMutation = { __typename?: 'Mutation', result: boolean };

export type IAllocationCountryCreatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IAllocationCountryCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryAllocationCountry', id: string, stock_id: string, value: number, year: number, country: { __typename?: 'Country', id: string, name: string } } };

export type IAllocationCountryUpdatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IAllocationCountryUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryAllocationCountry', id: string, stock_id: string, value: number, year: number, country: { __typename?: 'Country', id: string, name: string } } };

export type IAllocationCountryDeletedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IAllocationCountryDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryAllocationCountry', id: string, stock_id: string, value: number, year: number, country: { __typename?: 'Country', id: string, name: string } } };

export type IHistoryAwardDetailsFragment = { __typename?: 'HistoryAward', id: string, stock_id: string, date: string, type: { __typename?: 'AwardType', id: string, name: string } };

export type IGetHistoryAwardsQueryVariables = Exact<{
  stock_id: Scalars['Int'];
}>;


export type IGetHistoryAwardsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'HistoryAward', id: string, stock_id: string, date: string, type: { __typename?: 'AwardType', id: string, name: string } } | null> };

export type IGetAwardTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAwardTypesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'AwardType', id: string, name: string } | null> };

export type ICreateAwardMutationVariables = Exact<{
  stock_id: Scalars['ID'];
  input: IAwardInput;
}>;


export type ICreateAwardMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryAward', id: string, stock_id: string, date: string, type: { __typename?: 'AwardType', id: string, name: string } } };

export type IUpdateAwardMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IAwardInput;
}>;


export type IUpdateAwardMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryAward', id: string, stock_id: string, date: string, type: { __typename?: 'AwardType', id: string, name: string } } };

export type IDeleteAwardMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteAwardMutation = { __typename?: 'Mutation', result: boolean };

export type IAwardCreatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IAwardCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryAward', id: string, stock_id: string, date: string, type: { __typename?: 'AwardType', id: string, name: string } } };

export type IAwardUpdatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IAwardUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryAward', id: string, stock_id: string, date: string, type: { __typename?: 'AwardType', id: string, name: string } } };

export type IAwardDeletedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IAwardDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryAward', id: string, stock_id: string, date: string, type: { __typename?: 'AwardType', id: string, name: string } } };

export type IHistoryConstituentDetailsFragment = { __typename?: 'HistoryConstituent', id: string, weight_perc: number, weighting?: number | null, date: string, index: { __typename?: 'Index', id: string, name: string }, history_index?: { __typename?: 'HistoryIndex', id: string, dividend_yield?: number | null } | null, stock: { __typename?: 'Stock', id: string, name: string, historyStock?: { __typename?: 'HistoryStock', id: string, free_float_market_cap?: number | null, engl_mkt_cap?: number | null } | null } };

export type IGetHistoryConstituentsQueryVariables = Exact<{
  stock_id: Scalars['Int'];
  date?: InputMaybe<Scalars['String']>;
}>;


export type IGetHistoryConstituentsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'HistoryConstituent', id: string, weight_perc: number, date: string, rank?: number | null, index: { __typename?: 'Index', id: string, name: string }, history_index?: { __typename?: 'HistoryIndex', id: string, dividend_yield?: number | null } | null } | null> };

export type IGetHistoryConstituentsByIndexQueryVariables = Exact<{
  index_id: Scalars['Int'];
  date?: InputMaybe<Scalars['String']>;
}>;


export type IGetHistoryConstituentsByIndexQuery = { __typename?: 'Query', result: Array<{ __typename?: 'HistoryConstituent', id: string, weight_perc: number, weighting?: number | null, date: string, index: { __typename?: 'Index', id: string, name: string }, history_index?: { __typename?: 'HistoryIndex', id: string, dividend_yield?: number | null } | null, stock: { __typename?: 'Stock', id: string, name: string, historyStock?: { __typename?: 'HistoryStock', id: string, free_float_market_cap?: number | null, engl_mkt_cap?: number | null } | null } } | null> };

export type IHistoryKpiDetailsFragment = { __typename?: 'HistoryKpi', id: string, stock_id: string, date: string, eps?: number | null, nav?: number | null, nnnav?: number | null, niy?: number | null, vacancy?: number | null, cost_ratio_incl?: number | null, cost_ratio_excl?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null };

export type IGetHistoryKpisQueryVariables = Exact<{
  stock_id: Scalars['Int'];
}>;


export type IGetHistoryKpisQuery = { __typename?: 'Query', result: Array<{ __typename?: 'HistoryKpi', id: string, stock_id: string, date: string, eps?: number | null, nav?: number | null, nnnav?: number | null, niy?: number | null, vacancy?: number | null, cost_ratio_incl?: number | null, cost_ratio_excl?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } | null> };

export type ICreateKpiMutationVariables = Exact<{
  stock_id: Scalars['ID'];
  input: IKpiInput;
}>;


export type ICreateKpiMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryKpi', id: string, stock_id: string, date: string, eps?: number | null, nav?: number | null, nnnav?: number | null, niy?: number | null, vacancy?: number | null, cost_ratio_incl?: number | null, cost_ratio_excl?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } };

export type IUpdateKpiMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IKpiInput;
}>;


export type IUpdateKpiMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryKpi', id: string, stock_id: string, date: string, eps?: number | null, nav?: number | null, nnnav?: number | null, niy?: number | null, vacancy?: number | null, cost_ratio_incl?: number | null, cost_ratio_excl?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } };

export type IDeleteKpiMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteKpiMutation = { __typename?: 'Mutation', return?: boolean | null };

export type IKpiCreatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IKpiCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryKpi', id: string, stock_id: string, date: string, eps?: number | null, nav?: number | null, nnnav?: number | null, niy?: number | null, vacancy?: number | null, cost_ratio_incl?: number | null, cost_ratio_excl?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } };

export type IKpiUpdatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IKpiUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryKpi', id: string, stock_id: string, date: string, eps?: number | null, nav?: number | null, nnnav?: number | null, niy?: number | null, vacancy?: number | null, cost_ratio_incl?: number | null, cost_ratio_excl?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } };

export type IKpiDeletedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IKpiDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryKpi', id: string, stock_id: string, date: string, eps?: number | null, nav?: number | null, nnnav?: number | null, niy?: number | null, vacancy?: number | null, cost_ratio_incl?: number | null, cost_ratio_excl?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } };

export type IHistoryLtvDetailsFragment = { __typename?: 'HistoryLtv', id: string, stock_id: string, value?: number | null, start_date: string };

export type IGetHistoryLtvsQueryVariables = Exact<{
  stock_id: Scalars['Int'];
}>;


export type IGetHistoryLtvsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'HistoryLtv', id: string, stock_id: string, value?: number | null, start_date: string } | null> };

export type ICreateLtvMutationVariables = Exact<{
  stock_id: Scalars['ID'];
  input: ILtvInput;
}>;


export type ICreateLtvMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryLtv', id: string, stock_id: string, value?: number | null, start_date: string } };

export type IUpdateLtvMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ILtvInput;
}>;


export type IUpdateLtvMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryLtv', id: string, stock_id: string, value?: number | null, start_date: string } };

export type IDeleteLtvMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteLtvMutation = { __typename?: 'Mutation', result: boolean };

export type ILtvCreatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type ILtvCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryLtv', id: string, stock_id: string, value?: number | null, start_date: string } };

export type ILtvUpdatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type ILtvUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryLtv', id: string, stock_id: string, value?: number | null, start_date: string } };

export type ILtvDeletedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type ILtvDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryLtv', id: string, stock_id: string, value?: number | null, start_date: string } };

export type IHistoryRecalcDetailsFragment = { __typename?: 'HistoryRecalc', id: string, value_to_calc_with: number, column_to_recalc: string, start_date: string, end_date: string, is_rollbacked: boolean, operator: { __typename?: 'RecalcOperator', id: string, value: string } };

export type IGetHistoryRecalcsQueryVariables = Exact<{
  stock_id: Scalars['Int'];
}>;


export type IGetHistoryRecalcsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'HistoryRecalc', id: string, value_to_calc_with: number, column_to_recalc: string, start_date: string, end_date: string, is_rollbacked: boolean, operator: { __typename?: 'RecalcOperator', id: string, value: string } } | null> };

export type IGetRecalcOperatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetRecalcOperatorsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'RecalcOperator', id: string, value: string } | null> };

export type ICreateHistoryRecalcMutationVariables = Exact<{
  stock_id: Scalars['ID'];
  input: IHistoryRecalcInput;
}>;


export type ICreateHistoryRecalcMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryRecalc', id: string, value_to_calc_with: number, column_to_recalc: string, start_date: string, end_date: string, is_rollbacked: boolean, operator: { __typename?: 'RecalcOperator', id: string, value: string } } };

export type IRecalcRollbackMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IRecalcRollbackMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryRecalc', id: string, value_to_calc_with: number, column_to_recalc: string, start_date: string, end_date: string, is_rollbacked: boolean, operator: { __typename?: 'RecalcOperator', id: string, value: string } } };

export type IUpdateHistoryRecalcMutationVariables = Exact<{
  id: Scalars['ID'];
  stock_id: Scalars['ID'];
  input: IHistoryRecalcInput;
}>;


export type IUpdateHistoryRecalcMutation = { __typename?: 'Mutation', result: { __typename?: 'HistoryRecalc', id: string, value_to_calc_with: number, column_to_recalc: string, start_date: string, end_date: string, is_rollbacked: boolean, operator: { __typename?: 'RecalcOperator', id: string, value: string } } };

export type IHistoryRecalcCreatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IHistoryRecalcCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryRecalc', id: string, value_to_calc_with: number, column_to_recalc: string, start_date: string, end_date: string, is_rollbacked: boolean, operator: { __typename?: 'RecalcOperator', id: string, value: string } } };

export type IHistoryRecalcUpdatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type IHistoryRecalcUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'HistoryRecalc', id: string, value_to_calc_with: number, column_to_recalc: string, start_date: string, end_date: string, is_rollbacked: boolean, operator: { __typename?: 'RecalcOperator', id: string, value: string } } };

export type IIndexSeriesDetailsFragment = { __typename?: 'IndexSerie', id: string, name: string, indices: Array<{ __typename?: 'Index', id: string, name: string } | null> };

export type IIndexSeriesQueryVariables = Exact<{ [key: string]: never; }>;


export type IIndexSeriesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'IndexSerie', id: string, name: string, indices: Array<{ __typename?: 'Index', id: string, name: string } | null> } | null> };

export type IDeleteIndexSerieMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteIndexSerieMutation = { __typename?: 'Mutation', result: boolean };

export type ICreateIndexSerieMutationVariables = Exact<{
  input: IIndexSerieInput;
}>;


export type ICreateIndexSerieMutation = { __typename?: 'Mutation', result: { __typename?: 'IndexSerie', id: string, name: string, indices: Array<{ __typename?: 'Index', id: string, name: string } | null> } };

export type IUpdateIndexSerieMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IIndexSerieInput;
}>;


export type IUpdateIndexSerieMutation = { __typename?: 'Mutation', result: { __typename?: 'IndexSerie', id: string, name: string, indices: Array<{ __typename?: 'Index', id: string, name: string } | null> } };

export type IIndexSerieDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IIndexSerieDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'IndexSerie', id: string, name: string } };

export type IIndexSerieCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IIndexSerieCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'IndexSerie', id: string, name: string, indices: Array<{ __typename?: 'Index', id: string, name: string } | null> } };

export type IIndexSerieUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IIndexSerieUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'IndexSerie', id: string, name: string, indices: Array<{ __typename?: 'Index', id: string, name: string } | null> } };

export type IIndiceDetailsFragment = { __typename?: 'Index', id: string, name: string, code: string, net_code?: string | null, identifier?: string | null, is_online: boolean, country?: { __typename?: 'Country', id: string, name: string } | null, currency: { __typename?: 'Currency', id: string, code: string } };

export type IIndicesQueryVariables = Exact<{ [key: string]: never; }>;


export type IIndicesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Index', id: string, name: string, code: string, net_code?: string | null, identifier?: string | null, is_online: boolean, country?: { __typename?: 'Country', id: string, name: string } | null, currency: { __typename?: 'Currency', id: string, code: string } } | null> };

export type ICreateIndexMutationVariables = Exact<{
  input: IIndexInput;
}>;


export type ICreateIndexMutation = { __typename?: 'Mutation', result: { __typename?: 'Index', id: string, name: string, code: string, net_code?: string | null, identifier?: string | null, is_online: boolean, country?: { __typename?: 'Country', id: string, name: string } | null, currency: { __typename?: 'Currency', id: string, code: string } } };

export type IDeleteIndexMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteIndexMutation = { __typename?: 'Mutation', result: boolean };

export type IUpdateIndexMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IIndexInput;
}>;


export type IUpdateIndexMutation = { __typename?: 'Mutation', result: { __typename?: 'Index', id: string, name: string, code: string, net_code?: string | null, identifier?: string | null, is_online: boolean, country?: { __typename?: 'Country', id: string, name: string } | null, currency: { __typename?: 'Currency', id: string, code: string } } };

export type IIndexCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IIndexCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Index', id: string, name: string, code: string, net_code?: string | null, identifier?: string | null, is_online: boolean, country?: { __typename?: 'Country', id: string, name: string } | null, currency: { __typename?: 'Currency', id: string, code: string } } };

export type IIndexDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IIndexDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Index', id: string, name: string, code: string, net_code?: string | null, identifier?: string | null, is_online: boolean, country?: { __typename?: 'Country', id: string, name: string } | null, currency: { __typename?: 'Currency', id: string, code: string } } };

export type IIndexUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IIndexUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Index', id: string, name: string, code: string, net_code?: string | null, identifier?: string | null, is_online: boolean, country?: { __typename?: 'Country', id: string, name: string } | null, currency: { __typename?: 'Currency', id: string, code: string } } };

export type IGetInterestGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetInterestGroupsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'InterestGroup', id: string, name: string, interests: Array<{ __typename?: 'Interest', name: string, id: string } | null> } | null> };

export type IAddInterestToGroupMutationVariables = Exact<{
  input: INewInterestInput;
}>;


export type IAddInterestToGroupMutation = { __typename?: 'Mutation', result: Array<{ __typename?: 'AddInterestResult', id: string, name: string } | null> };

export type IDeleteInterestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteInterestMutation = { __typename?: 'Mutation', result: boolean };

export type IInterestDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IInterestDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Interest', id: string, interest_group: { __typename?: 'InterestGroup', id: string } } };

export type IGetInterestsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetInterestsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Interest', id: string, name: string, interest_group: { __typename?: 'InterestGroup', id: string } } | null> };

export type IInvestmentFocusesQueryVariables = Exact<{ [key: string]: never; }>;


export type IInvestmentFocusesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'InvestmentFocus', id: string, name: string } | null> };

export type IInvoiceDtoFullFragment = { __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } };

export type IPaymentDetailsFragment = { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string };

export type IInvoiceDetailsFragment = { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null };

export type IInvoicesForMembershipQueryVariables = Exact<{
  membership_id: Scalars['Int'];
}>;


export type IInvoicesForMembershipQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } } | null> };

export type IInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type IInvoicesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } } | null> };

export type IInvoicesFilteredQueryVariables = Exact<{
  filter?: InputMaybe<IInvoiceFilterInput>;
}>;


export type IInvoicesFilteredQuery = { __typename?: 'Query', result: { __typename?: 'InvoicesPage', total: number, invoices: Array<{ __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } } | null> } };

export type IInvoiceClientOptionsQueryVariables = Exact<{
  membership_id: Scalars['Int'];
}>;


export type IInvoiceClientOptionsQuery = { __typename?: 'Query', result?: { __typename?: 'ClientOptions', companies: Array<{ __typename?: 'Company', id: string, name: string, main_address?: { __typename?: 'Address', id: string, complete_vat_number?: string | null } | null } | null>, contacts: Array<{ __typename?: 'Contact', id: string, fullName: string, first_name: string, last_name: string, email?: string | null, title_external?: string | null, prefix?: string | null, address?: { __typename?: 'Address', id: string, name: string, street: string, city: string, zip?: string | null, country: { __typename?: 'Country', id: string, name: string, region?: { __typename?: 'Region', id: string, name: string } | null } } | null, company: { __typename?: 'Company', id: string, name: string, main_address?: { __typename?: 'Address', id: string, complete_vat_number?: string | null } | null } } | null> } | null };

export type IPaymentDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type IPaymentDetailsQuery = { __typename?: 'Query', result: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } };

export type IAddPaymentDetailsMutationVariables = Exact<{
  input: INewPaymentDetailsInput;
}>;


export type IAddPaymentDetailsMutation = { __typename?: 'Mutation', result: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } };

export type IDeleteInvoiceMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteInvoiceMutation = { __typename?: 'Mutation', result: boolean };

export type IPayInvoiceMutationVariables = Exact<{
  id: Scalars['Int'];
  date_paid?: InputMaybe<Scalars['String']>;
}>;


export type IPayInvoiceMutation = { __typename?: 'Mutation', result: { __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } } };

export type ICreateInvoiceMutationVariables = Exact<{
  input: IInvoiceInput;
}>;


export type ICreateInvoiceMutation = { __typename?: 'Mutation', result: { __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } } };

export type IUpdateInvoiceMutationVariables = Exact<{
  id: Scalars['Int'];
  input: IInvoiceInput;
}>;


export type IUpdateInvoiceMutation = { __typename?: 'Mutation', result: { __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } } };

export type ICreateCreditNoteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ICreateCreditNoteMutation = { __typename?: 'Mutation', result: { __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } } };

export type IConfirmInvoiceMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IConfirmInvoiceMutation = { __typename?: 'Mutation', result: { __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } } };

export type IInvoiceDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IInvoiceDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Invoice', id: string } };

export type IInvoiceUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IInvoiceUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } } };

export type IInvoiceCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IInvoiceCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Invoice', id: string, number?: string | null, created_date?: string | null, date_paid?: string | null, due_date?: string | null, total: number, vat?: number | null, discount?: number | null, is_credit: boolean, email_sent_date?: string | null, debit_invoice_nr?: string | null, notes?: string | null, po_nr?: string | null, remarks?: string | null, membership?: { __typename?: 'Membership', id: string, name: string, start_date?: string | null, end_date?: string | null } | null, status: { __typename?: 'InvoiceStatus', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, price: number, bottom_notes?: string | null, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null, product_code: { __typename?: 'ProductCode', id: string, name: string } }, details: { __typename?: 'InvoiceDetails', fullName?: string | null, company_name?: string | null, company_address_vat?: string | null, contact_first_name?: string | null, contact_last_name?: string | null, contact_email?: string | null, address_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null, region?: string | null, prefix?: string | null, title_external?: string | null, vat_countrycode?: string | null }, paymentDetails: { __typename?: 'PaymentDetails', id: string, contact_address_name: string, contact_address: string, contact_phone: string, contact_fax: string, contact_vat: string, bank_name: string, bank_affiliate: string, bank_address: string, bank_bic: string, bank_iban: string } } };

export type ISinginMutationVariables = Exact<{
  input: ISigninInput;
}>;


export type ISinginMutation = { __typename?: 'Mutation', result: { __typename?: 'AuthUser', token: string, user: { __typename?: 'User', id: string, username: string, roles: Array<string | null>, first_name: string, last_name: string, password: string } } };

export type ISendInvoiceForApprovalMutationVariables = Exact<{
  id: Scalars['Int'];
  pdf_content: Scalars['String'];
}>;


export type ISendInvoiceForApprovalMutation = { __typename?: 'Mutation', result: boolean };

export type ISendInvoiceToCustomerMutationVariables = Exact<{
  id: Scalars['Int'];
  pdf_content: Scalars['String'];
  cc_emails?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ISendInvoiceToCustomerMutation = { __typename?: 'Mutation', result: boolean };

export type IMarketActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type IMarketActivitiesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'MarketActivity', id: string, name: string } | null> };

export type IMeetingContactDetailsFragment = { __typename?: 'MeetingContact', id: string, meeting: { __typename?: 'Meeting', id: string, name?: string | null }, contacts: { __typename?: 'Contact', id: string, fullName: string }, company: { __typename?: 'Company', id: string, name: string } };

export type IMeetingsMeetingTypeDetailsFragment = { __typename?: 'MeetingsMeetingType', id: string, name: string };

export type IMeetingsMeetingTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type IMeetingsMeetingTypeQuery = { __typename?: 'Query', result: Array<{ __typename?: 'MeetingsMeetingType', id: string, name: string } | null> };

export type IGetMeetingTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetMeetingTypesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'MeetingsMeetingType', id: string, name: string } | null> };

export type ICreateMeetingTypeMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type ICreateMeetingTypeMutation = { __typename?: 'Mutation', result: { __typename?: 'MeetingsMeetingType', id: string, name: string } };

export type IUpdateMeetingTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type IUpdateMeetingTypeMutation = { __typename?: 'Mutation', result: { __typename?: 'MeetingsMeetingType', id: string, name: string } };

export type IDeleteMeetingTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteMeetingTypeMutation = { __typename?: 'Mutation', result: boolean };

export type IMeetingDetailsFragment = { __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null };

export type IMeetingsQueryVariables = Exact<{ [key: string]: never; }>;


export type IMeetingsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } | null> };

export type IMeetingQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IMeetingQuery = { __typename?: 'Query', result?: { __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } | null };

export type IAllMeetingsForContactQueryVariables = Exact<{
  contact_id: Scalars['Int'];
}>;


export type IAllMeetingsForContactQuery = { __typename?: 'Query', result?: Array<{ __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } | null> | null };

export type IMeetingsFilteredQueryVariables = Exact<{
  filter?: InputMaybe<IMeetingFilterInput>;
}>;


export type IMeetingsFilteredQuery = { __typename?: 'Query', result: { __typename?: 'MeetingsPage', total: number, meetings: Array<{ __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } | null> } };

export type ICreateMeetingMutationVariables = Exact<{
  input: IAddMeetingInput;
}>;


export type ICreateMeetingMutation = { __typename?: 'Mutation', result: { __typename?: 'Meeting', id: string, name?: string | null } };

export type IUpdateMeetingMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IAddMeetingInput;
}>;


export type IUpdateMeetingMutation = { __typename?: 'Mutation', result: { __typename?: 'Meeting', id: string, name?: string | null } };

export type IDeleteMeetingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteMeetingMutation = { __typename?: 'Mutation', result: boolean };

export type IMeetingCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IMeetingCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } };

export type IMeetingUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IMeetingUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } };

export type IMeetingDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IMeetingDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Meeting', id: string, name?: string | null, subject?: string | null, meeting_details?: string | null, location?: string | null, start_time?: string | null, end_time?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, fullName: string } | null> | null, meeting_type?: { __typename?: 'MeetingsMeetingType', id: string, name: string } | null } };

export type IMembershipTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type IMembershipTypesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'MembershipType', id: string, name: string } | null> };

export type IMembershipDetailsFragment = { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } };

export type IMembershipOverviewFragment = { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null };

export type IMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type IMembershipsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null } | null> };

export type IMembershipsFilteredQueryVariables = Exact<{
  filter?: InputMaybe<IMembershipFilterInput>;
}>;


export type IMembershipsFilteredQuery = { __typename?: 'Query', result: { __typename?: 'MembershipsPage', total: number, memberships: Array<{ __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null } | null> } };

export type IMembershipQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IMembershipQuery = { __typename?: 'Query', result?: { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } } | null };

export type IMembershipCompaniesQueryVariables = Exact<{
  membership_id: Scalars['Int'];
}>;


export type IMembershipCompaniesQuery = { __typename?: 'Query', result?: Array<{ __typename?: 'Company', id: string, name: string, is_main_member: boolean, main_address?: { __typename?: 'Address', id: string, street: string, city: string, country: { __typename?: 'Country', id: string, name: string } } | null } | null> | null };

export type IMembershipTypeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type IMembershipTypeOptionsQuery = { __typename?: 'Query', result: { __typename?: 'MembershipTypeOptions', taken_option_ids: Array<number | null>, membership_types: Array<{ __typename?: 'MembershipType', id: string, name: string } | null> } };

export type IMembershipContactsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IMembershipContactsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Contact', id: string, is_main: boolean, fullName: string, email?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string }, address?: { __typename?: 'Address', id: string, street: string } | null, company: { __typename?: 'Company', id: string, name: string } } | null> };

export type ICreateMembershipMutationVariables = Exact<{
  input: IMembershipInput;
}>;


export type ICreateMembershipMutation = { __typename?: 'Mutation', result: { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null } };

export type IUpdateMembershipMutationVariables = Exact<{
  id: Scalars['Int'];
  input: IMembershipInput;
}>;


export type IUpdateMembershipMutation = { __typename?: 'Mutation', result: { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null } };

export type IDeleteMembershipMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteMembershipMutation = { __typename?: 'Mutation', result: boolean };

export type IMembershipCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IMembershipCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null } };

export type IMembershipUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IMembershipUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Membership', id: string, name: string, is_bad_debtor: boolean, discount?: number | null, total: number, start_date?: string | null, end_date?: string | null, renewable_date?: string | null, comments_count: number, product: { __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null }, last_invoice?: { __typename?: 'Invoice', id: string, number?: string | null, email_sent_date?: string | null, date_paid?: string | null, total: number } | null } };

export type IMembershipDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IMembershipDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Membership', id: string } };

export type IMsbReportOverviewFragment = { __typename?: 'MsbReport', id: string, report_date: string, generation_start?: string | null, generation_end?: string | null, clear_cache: boolean };

export type IMsbReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type IMsbReportsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'MsbReport', id: string, report_date: string, generation_start?: string | null, generation_end?: string | null, clear_cache: boolean } | null> };

export type IScheduleReportMutationVariables = Exact<{
  input: IScheduleInput;
}>;


export type IScheduleReportMutation = { __typename?: 'Mutation', result?: { __typename?: 'MsbReport', id: string, report_date: string, generation_start?: string | null, generation_end?: string | null, clear_cache: boolean } | null };

export type INavDetailsFragment = { __typename?: 'Nav', id: string, created_date: string, start_date: string, stock_id: string, ta?: number | null, tl?: number | null, nav?: number | null, nav_epra?: number | null, nav_epra_history?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null };

export type IGetNavsQueryVariables = Exact<{
  stock_id: Scalars['Int'];
}>;


export type IGetNavsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Nav', id: string, created_date: string, start_date: string, stock_id: string, ta?: number | null, tl?: number | null, nav?: number | null, nav_epra?: number | null, nav_epra_history?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } | null> };

export type ICreateNavMutationVariables = Exact<{
  stock_id: Scalars['ID'];
  input: INavInput;
}>;


export type ICreateNavMutation = { __typename?: 'Mutation', result: { __typename?: 'Nav', id: string, created_date: string, start_date: string, stock_id: string, ta?: number | null, tl?: number | null, nav?: number | null, nav_epra?: number | null, nav_epra_history?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } };

export type IUpdateNavMutationVariables = Exact<{
  id: Scalars['ID'];
  input: INavInput;
}>;


export type IUpdateNavMutation = { __typename?: 'Mutation', result: { __typename?: 'Nav', id: string, created_date: string, start_date: string, stock_id: string, ta?: number | null, tl?: number | null, nav?: number | null, nav_epra?: number | null, nav_epra_history?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } };

export type IDeleteNavMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteNavMutation = { __typename?: 'Mutation', result: boolean };

export type INavCreatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type INavCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Nav', id: string, created_date: string, start_date: string, stock_id: string, ta?: number | null, tl?: number | null, nav?: number | null, nav_epra?: number | null, nav_epra_history?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } };

export type INavUpdatedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type INavUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Nav', id: string, created_date: string, start_date: string, stock_id: string, ta?: number | null, tl?: number | null, nav?: number | null, nav_epra?: number | null, nav_epra_history?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } };

export type INavDeletedSubscriptionVariables = Exact<{
  stock_id: Scalars['ID'];
}>;


export type INavDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Nav', id: string, created_date: string, start_date: string, stock_id: string, ta?: number | null, tl?: number | null, nav?: number | null, nav_epra?: number | null, nav_epra_history?: number | null, nra?: number | null, nta?: number | null, ndv?: number | null, average?: number | null } };

export type IProductCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type IProductCodesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'ProductCode', id: string, name: string } | null> };

export type IProductDetailsFullFragment = { __typename?: 'Product', id: string, name: string, price: number, vat?: number | null, bottom_notes?: string | null, email_subject?: string | null, email_body?: string | null, email_banner?: string | null, product_code: { __typename?: 'ProductCode', id: string, name: string }, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null };

export type IProductDetailsFragment = { __typename?: 'Product', id: string, name: string, price: number, vat?: number | null, bottom_notes?: string | null, product_code: { __typename?: 'ProductCode', id: string, name: string }, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null };

export type IProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type IProductsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Product', id: string, name: string, price: number, vat?: number | null, bottom_notes?: string | null, product_code: { __typename?: 'ProductCode', id: string, name: string }, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } | null> };

export type IProductQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IProductQuery = { __typename?: 'Query', result?: { __typename?: 'Product', id: string, name: string, price: number, vat?: number | null, bottom_notes?: string | null, email_subject?: string | null, email_body?: string | null, email_banner?: string | null, product_code: { __typename?: 'ProductCode', id: string, name: string }, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } | null };

export type IMembershipProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type IMembershipProductsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Product', id: string, price: number, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } | null> };

export type IDeleteProductMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteProductMutation = { __typename?: 'Mutation', result: boolean };

export type ICreateProductMutationVariables = Exact<{
  input: IProductInput;
}>;


export type ICreateProductMutation = { __typename?: 'Mutation', result: { __typename?: 'Product', id: string, name: string, price: number, vat?: number | null, bottom_notes?: string | null, product_code: { __typename?: 'ProductCode', id: string, name: string }, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } };

export type IUpdateProductGeneralInfoMutationVariables = Exact<{
  id: Scalars['Int'];
  input: IProductInput;
}>;


export type IUpdateProductGeneralInfoMutation = { __typename?: 'Mutation', result: { __typename?: 'Product', id: string, name: string, price: number, vat?: number | null, bottom_notes?: string | null, email_subject?: string | null, email_body?: string | null, email_banner?: string | null, product_code: { __typename?: 'ProductCode', id: string, name: string }, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } };

export type IUpdateProductEmailInfoMutationVariables = Exact<{
  id: Scalars['Int'];
  input: IEmailInput;
}>;


export type IUpdateProductEmailInfoMutation = { __typename?: 'Mutation', result: { __typename?: 'Product', id: string, name: string, price: number, vat?: number | null, bottom_notes?: string | null, email_subject?: string | null, email_body?: string | null, email_banner?: string | null, product_code: { __typename?: 'ProductCode', id: string, name: string }, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } };

export type IProductCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IProductCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Product', id: string, name: string, price: number, vat?: number | null, bottom_notes?: string | null, product_code: { __typename?: 'ProductCode', id: string, name: string }, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } };

export type IProductUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IProductUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Product', id: string, name: string, price: number, vat?: number | null, bottom_notes?: string | null, product_code: { __typename?: 'ProductCode', id: string, name: string }, membership_type?: { __typename?: 'MembershipType', id: string, name: string } | null } };

export type IProductDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IProductDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Product', id: string } };

export type IRecipientListPropsFragment = { __typename?: 'RecipientList', id: string, name: string, excluded_contact_ids?: string | null, included_contact_ids?: string | null, contact_titles: Array<{ __typename?: 'TitleInternal', id: string, name: string } | null>, company_types: Array<{ __typename?: 'CompanyType', id: string, name: string } | null>, membership_types: Array<{ __typename?: 'MembershipType', id: string, name: string } | null>, interests: Array<{ __typename?: 'Interest', id: string, name: string } | null>, countries: Array<{ __typename?: 'Country', id: string, name: string } | null> };

export type IRecipientListsQueryVariables = Exact<{ [key: string]: never; }>;


export type IRecipientListsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'RecipientList', id: string, name: string, excluded_contact_ids?: string | null, included_contact_ids?: string | null, contact_titles: Array<{ __typename?: 'TitleInternal', id: string, name: string } | null>, company_types: Array<{ __typename?: 'CompanyType', id: string, name: string } | null>, membership_types: Array<{ __typename?: 'MembershipType', id: string, name: string } | null>, interests: Array<{ __typename?: 'Interest', id: string, name: string } | null>, countries: Array<{ __typename?: 'Country', id: string, name: string } | null> } | null> };

export type IExcludedContactsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IExcludedContactsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Contact', id: string, first_name: string, last_name: string, email?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } | null> };

export type IRecipientsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IRecipientsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Contact', id: string, first_name: string, last_name: string, email?: string | null, titleInternal: { __typename?: 'TitleInternal', id: string, name: string } } | null> };

export type IDeleteRecipientListMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteRecipientListMutation = { __typename?: 'Mutation', result: boolean };

export type IExcludeRecipientMutationVariables = Exact<{
  recipient_list_id: Scalars['Int'];
  contact_id: Scalars['Int'];
}>;


export type IExcludeRecipientMutation = { __typename?: 'Mutation', result: { __typename?: 'RecipientList', id: string, name: string, excluded_contact_ids?: string | null, included_contact_ids?: string | null, contact_titles: Array<{ __typename?: 'TitleInternal', id: string, name: string } | null>, company_types: Array<{ __typename?: 'CompanyType', id: string, name: string } | null>, membership_types: Array<{ __typename?: 'MembershipType', id: string, name: string } | null>, interests: Array<{ __typename?: 'Interest', id: string, name: string } | null>, countries: Array<{ __typename?: 'Country', id: string, name: string } | null> } };

export type ICreateRecipientListMutationVariables = Exact<{
  input: IRecipientListInput;
}>;


export type ICreateRecipientListMutation = { __typename?: 'Mutation', result: { __typename?: 'RecipientList', id: string, name: string, excluded_contact_ids?: string | null, included_contact_ids?: string | null, contact_titles: Array<{ __typename?: 'TitleInternal', id: string, name: string } | null>, company_types: Array<{ __typename?: 'CompanyType', id: string, name: string } | null>, membership_types: Array<{ __typename?: 'MembershipType', id: string, name: string } | null>, interests: Array<{ __typename?: 'Interest', id: string, name: string } | null>, countries: Array<{ __typename?: 'Country', id: string, name: string } | null> } };

export type IUpdateRecipientListMutationVariables = Exact<{
  input: IRecipientListInput;
}>;


export type IUpdateRecipientListMutation = { __typename?: 'Mutation', result: { __typename?: 'RecipientList', id: string, name: string, excluded_contact_ids?: string | null, included_contact_ids?: string | null, contact_titles: Array<{ __typename?: 'TitleInternal', id: string, name: string } | null>, company_types: Array<{ __typename?: 'CompanyType', id: string, name: string } | null>, membership_types: Array<{ __typename?: 'MembershipType', id: string, name: string } | null>, interests: Array<{ __typename?: 'Interest', id: string, name: string } | null>, countries: Array<{ __typename?: 'Country', id: string, name: string } | null> } };

export type IRecipientListDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IRecipientListDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'RecipientList', id: string } };

export type IRecipientListCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IRecipientListCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'RecipientList', id: string, name: string, excluded_contact_ids?: string | null, included_contact_ids?: string | null, contact_titles: Array<{ __typename?: 'TitleInternal', id: string, name: string } | null>, company_types: Array<{ __typename?: 'CompanyType', id: string, name: string } | null>, membership_types: Array<{ __typename?: 'MembershipType', id: string, name: string } | null>, interests: Array<{ __typename?: 'Interest', id: string, name: string } | null>, countries: Array<{ __typename?: 'Country', id: string, name: string } | null> } };

export type IRecipientListUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IRecipientListUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'RecipientList', id: string, name: string, excluded_contact_ids?: string | null, included_contact_ids?: string | null, contact_titles: Array<{ __typename?: 'TitleInternal', id: string, name: string } | null>, company_types: Array<{ __typename?: 'CompanyType', id: string, name: string } | null>, membership_types: Array<{ __typename?: 'MembershipType', id: string, name: string } | null>, interests: Array<{ __typename?: 'Interest', id: string, name: string } | null>, countries: Array<{ __typename?: 'Country', id: string, name: string } | null> } };

export type IRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type IRegionsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Region', id: string, name: string } | null> };

export type IGetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetRolesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Role', id: string, name: string, users: Array<{ __typename?: 'User', id: string, username: string, first_name: string, last_name: string } | null> } | null> };

export type IRemoveRoleFromUserMutationVariables = Exact<{
  input: IUserRoleInput;
}>;


export type IRemoveRoleFromUserMutation = { __typename?: 'Mutation', result: boolean };

export type ISchedulerDetailsFragment = { __typename?: 'Scheduler', id: string, name: string, is_success?: boolean | null, scheduled_date: string, created_date: string, mails_sent?: number | null, sender: { __typename?: 'Sender', id: string, email: string }, recipient_lists: Array<{ __typename?: 'RecipientList', id: string, name: string }>, template: { __typename?: 'Template', id: string, title: string } };

export type IGetAllScheduledQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllScheduledQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Scheduler', id: string, name: string, is_success?: boolean | null, scheduled_date: string, created_date: string, mails_sent?: number | null, sender: { __typename?: 'Sender', id: string, email: string }, recipient_lists: Array<{ __typename?: 'RecipientList', id: string, name: string }>, template: { __typename?: 'Template', id: string, title: string } } | null> };

export type ICreateSchedulerMutationVariables = Exact<{
  input: ISchedulerInput;
}>;


export type ICreateSchedulerMutation = { __typename?: 'Mutation', result: { __typename?: 'Scheduler', id: string, name: string, is_success?: boolean | null, scheduled_date: string, created_date: string, mails_sent?: number | null, sender: { __typename?: 'Sender', id: string, email: string }, recipient_lists: Array<{ __typename?: 'RecipientList', id: string, name: string }>, template: { __typename?: 'Template', id: string, title: string } } };

export type IUpdateSchedulerMutationVariables = Exact<{
  id: Scalars['Int'];
  input: ISchedulerInput;
}>;


export type IUpdateSchedulerMutation = { __typename?: 'Mutation', result: { __typename?: 'Scheduler', id: string, name: string, is_success?: boolean | null, scheduled_date: string, created_date: string, mails_sent?: number | null, sender: { __typename?: 'Sender', id: string, email: string }, recipient_lists: Array<{ __typename?: 'RecipientList', id: string, name: string }>, template: { __typename?: 'Template', id: string, title: string } } };

export type IDeleteSchedulerMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteSchedulerMutation = { __typename?: 'Mutation', result: boolean };

export type IDeleteRecipientListFromSchedulerMutationVariables = Exact<{
  scheduler_id: Scalars['ID'];
  recipient_list_id: Scalars['ID'];
}>;


export type IDeleteRecipientListFromSchedulerMutation = { __typename?: 'Mutation', result: { __typename?: 'Scheduler', id: string, name: string, is_success?: boolean | null, scheduled_date: string, created_date: string, mails_sent?: number | null, sender: { __typename?: 'Sender', id: string, email: string }, recipient_lists: Array<{ __typename?: 'RecipientList', id: string, name: string }>, template: { __typename?: 'Template', id: string, title: string } } };

export type ISendTestEmailMutationVariables = Exact<{
  template_id: Scalars['Int'];
  sender_id: Scalars['String'];
  recipient: Scalars['String'];
}>;


export type ISendTestEmailMutation = { __typename?: 'Mutation', result?: boolean | null };

export type ISchedulerDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ISchedulerDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Scheduler', id: string } };

export type ISchedulerCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ISchedulerCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Scheduler', id: string, name: string, is_success?: boolean | null, scheduled_date: string, created_date: string, mails_sent?: number | null, sender: { __typename?: 'Sender', id: string, email: string }, recipient_lists: Array<{ __typename?: 'RecipientList', id: string, name: string }>, template: { __typename?: 'Template', id: string, title: string } } };

export type ISchedulerUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ISchedulerUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Scheduler', id: string, name: string, is_success?: boolean | null, scheduled_date: string, created_date: string, mails_sent?: number | null, sender: { __typename?: 'Sender', id: string, email: string }, recipient_lists: Array<{ __typename?: 'RecipientList', id: string, name: string }>, template: { __typename?: 'Template', id: string, title: string } } };

export type ISectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ISectorsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Sector', id: string, name: string } | null> };

export type IGetAllSendersQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetAllSendersQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Sender', id: string, email: string } | null> };

export type IGetSendGridStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetSendGridStatisticsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Stat', month: string, sent: number, delivered: number, read: number, blocks: number, bounces: number, spam_reports: number } | null> };

export type IGetSendGridMessagesQueryVariables = Exact<{
  scheduler_id: Scalars['Int'];
}>;


export type IGetSendGridMessagesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'SendGridMessage', id: string, sg_message_id: string, opens_count: number, clicks_count: number, email: string, status: string } | null> };

export type IGetSendGridDataForExcelQueryVariables = Exact<{
  scheduler_id: Scalars['Int'];
}>;


export type IGetSendGridDataForExcelQuery = { __typename?: 'Query', result: Array<{ __typename?: 'SendGridMessage', id: string, opens_count: number, clicks_count: number, email: string, status: string, scheduler: { __typename?: 'Scheduler', id: string, name: string } } | null> };

export type IGetSendGridEventsQueryVariables = Exact<{
  sg_message_id: Scalars['String'];
}>;


export type IGetSendGridEventsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'SendGridEvent', id: string, name: string, timestamp: string, url?: string | null } | null> };

export type ISiteSectionDetailsFragment = { __typename?: 'SiteSection', id: string, name: string };

export type IGetSiteSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetSiteSectionsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'SiteSection', id: string, name: string } | null> };

export type ICreateSiteSectionMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type ICreateSiteSectionMutation = { __typename?: 'Mutation', result: { __typename?: 'SiteSection', id: string, name: string } };

export type IDeleteSiteSectionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IDeleteSiteSectionMutation = { __typename?: 'Mutation', result: boolean };

export type IUpdateSiteSectionMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type IUpdateSiteSectionMutation = { __typename?: 'Mutation', result: { __typename?: 'SiteSection', id: string, name: string } };

export type ISiteSectionCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ISiteSectionCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'SiteSection', id: string, name: string } };

export type ISiteSectionDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ISiteSectionDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'SiteSection', id: string, name: string } };

export type ISiteSectionUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ISiteSectionUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'SiteSection', id: string, name: string } };

export type IStockOverviewMiniFragment = { __typename?: 'Stock', id: string, name: string, isin_code?: string | null, bloomberg_ticker?: string | null, exchange_code?: string | null, code?: string | null, country?: { __typename?: 'Country', id: string, name: string, code?: string | null } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null };

export type IStockOverviewFragment = { __typename?: 'Stock', id: string, name: string, isin_code?: string | null, bloomberg_ticker?: string | null, exchange_code?: string | null, code?: string | null, historyStock?: { __typename?: 'HistoryStock', id: string, close_price?: number | null, engl_mkt_cap?: number | null, epra_shares?: number | null, nav_epra?: number | null, nav_ifrs?: number | null, price_discount?: number | null } | null, country?: { __typename?: 'Country', id: string, name: string, code?: string | null } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null };

export type IStockDetailsFragment = { __typename?: 'Stock', id: string, name: string, code?: string | null, cusip?: string | null, bloomberg_ticker?: string | null, isin_code?: string | null, exchange_code?: string | null, reuters_code?: string | null, snl_code?: string | null, icb_industry_code?: number | null, icb_supersector_code?: number | null, icb_sector_code?: number | null, icb_subsector_code?: number | null, sedol?: string | null, start_date: string, is_reit: boolean, currency?: { __typename?: 'Currency', id: string, code: string } | null, country?: { __typename?: 'Country', id: string, code?: string | null } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null, company: { __typename?: 'Company', id: string, name: string }, investment_focus?: { __typename?: 'InvestmentFocus', id: string, name: string } | null };

export type IStocksQueryVariables = Exact<{ [key: string]: never; }>;


export type IStocksQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Stock', id: string, name: string, isin_code?: string | null, bloomberg_ticker?: string | null, exchange_code?: string | null, code?: string | null, historyStock?: { __typename?: 'HistoryStock', id: string, close_price?: number | null, engl_mkt_cap?: number | null, epra_shares?: number | null, nav_epra?: number | null, nav_ifrs?: number | null, price_discount?: number | null } | null, country?: { __typename?: 'Country', id: string, name: string, code?: string | null } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null } | null> };

export type IStockQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IStockQuery = { __typename?: 'Query', result: { __typename?: 'Stock', id: string, name: string, code?: string | null, cusip?: string | null, bloomberg_ticker?: string | null, isin_code?: string | null, exchange_code?: string | null, reuters_code?: string | null, snl_code?: string | null, icb_industry_code?: number | null, icb_supersector_code?: number | null, icb_sector_code?: number | null, icb_subsector_code?: number | null, sedol?: string | null, start_date: string, is_reit: boolean, currency?: { __typename?: 'Currency', id: string, code: string } | null, country?: { __typename?: 'Country', id: string, code?: string | null } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null, company: { __typename?: 'Company', id: string, name: string }, investment_focus?: { __typename?: 'InvestmentFocus', id: string, name: string } | null } };

export type IFilteredStocksQueryVariables = Exact<{
  date: Scalars['String'];
  stock_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type IFilteredStocksQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Stock', id: string, name: string, isin_code?: string | null, bloomberg_ticker?: string | null, exchange_code?: string | null, code?: string | null, historyStock?: { __typename?: 'HistoryStock', id: string, close_price?: number | null, engl_mkt_cap?: number | null, epra_shares?: number | null, nav_epra?: number | null, nav_ifrs?: number | null, price_discount?: number | null } | null, country?: { __typename?: 'Country', id: string, name: string, code?: string | null } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null } | null> };

export type IStocksFilteredQueryVariables = Exact<{
  filter?: InputMaybe<IStockFilterInput>;
}>;


export type IStocksFilteredQuery = { __typename?: 'Query', result: { __typename?: 'StocksPage', total: number, stocks: Array<{ __typename?: 'Stock', id: string, name: string, isin_code?: string | null, bloomberg_ticker?: string | null, exchange_code?: string | null, code?: string | null, historyStock?: { __typename?: 'HistoryStock', id: string, close_price?: number | null, engl_mkt_cap?: number | null, epra_shares?: number | null, nav_epra?: number | null, nav_ifrs?: number | null, price_discount?: number | null } | null, country?: { __typename?: 'Country', id: string, name: string, code?: string | null } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null } | null> } };

export type ICreateStockMutationVariables = Exact<{
  input: IStockInput;
}>;


export type ICreateStockMutation = { __typename?: 'Mutation', result: { __typename?: 'Stock', id: string, name: string, isin_code?: string | null, bloomberg_ticker?: string | null, exchange_code?: string | null, code?: string | null, historyStock?: { __typename?: 'HistoryStock', id: string, close_price?: number | null, engl_mkt_cap?: number | null, epra_shares?: number | null, nav_epra?: number | null, nav_ifrs?: number | null, price_discount?: number | null } | null, country?: { __typename?: 'Country', id: string, name: string, code?: string | null } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null } };

export type IUpdateStockMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IStockInput;
}>;


export type IUpdateStockMutation = { __typename?: 'Mutation', result: { __typename?: 'Stock', id: string, name: string, isin_code?: string | null, bloomberg_ticker?: string | null, exchange_code?: string | null, code?: string | null, historyStock?: { __typename?: 'HistoryStock', id: string, close_price?: number | null, engl_mkt_cap?: number | null, epra_shares?: number | null, nav_epra?: number | null, nav_ifrs?: number | null, price_discount?: number | null } | null, country?: { __typename?: 'Country', id: string, name: string, code?: string | null } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null } };

export type IDeleteHsDataMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IDeleteHistoryStocksDataInput;
}>;


export type IDeleteHsDataMutation = { __typename?: 'Mutation', result?: boolean | null };

export type IStockCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IStockCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Stock', id: string, name: string, isin_code?: string | null, bloomberg_ticker?: string | null, exchange_code?: string | null, code?: string | null, historyStock?: { __typename?: 'HistoryStock', id: string, close_price?: number | null, engl_mkt_cap?: number | null, epra_shares?: number | null, nav_epra?: number | null, nav_ifrs?: number | null, price_discount?: number | null } | null, country?: { __typename?: 'Country', id: string, name: string, code?: string | null } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null } };

export type IStockUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IStockUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Stock', id: string, name: string, isin_code?: string | null, bloomberg_ticker?: string | null, exchange_code?: string | null, code?: string | null, country?: { __typename?: 'Country', id: string, name: string, code?: string | null } | null, currency?: { __typename?: 'Currency', id: string, code: string } | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, subsector?: { __typename?: 'Sector', id: string, name: string } | null } };

export type ITemplateDetailsFragment = { __typename?: 'Template', id: string, title: string, subject: string, content: string };

export type ITemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ITemplatesQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Template', id: string, title: string, subject: string, content: string } | null> };

export type IDeleteTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteTemplateMutation = { __typename?: 'Mutation', result: boolean };

export type ICreateTemplateMutationVariables = Exact<{
  input: ITemplateInput;
}>;


export type ICreateTemplateMutation = { __typename?: 'Mutation', result: { __typename?: 'Template', id: string, title: string, subject: string, content: string } };

export type IUpdateTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  input: ITemplateInput;
}>;


export type IUpdateTemplateMutation = { __typename?: 'Mutation', result: { __typename?: 'Template', id: string, title: string, subject: string, content: string } };

export type ITemplateDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ITemplateDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Template', id: string } };

export type ITemplateCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ITemplateCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Template', id: string, title: string, subject: string, content: string } };

export type ITemplateUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ITemplateUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'Template', id: string, title: string, subject: string, content: string } };

export type ITitlesInternalQueryVariables = Exact<{ [key: string]: never; }>;


export type ITitlesInternalQuery = { __typename?: 'Query', result: Array<{ __typename?: 'TitleInternal', id: string, name: string } | null> };

export type IAddRoleToUserMutationVariables = Exact<{
  role_id: Scalars['Int'];
  user_ids: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type IAddRoleToUserMutation = { __typename?: 'Mutation', result: boolean };

export type IUserDetailsFragment = { __typename?: 'User', id: string, username: string, first_name: string, last_name: string, roles: Array<string | null>, password: string };

export type IGetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetUsersQuery = { __typename?: 'Query', result: Array<{ __typename?: 'User', id: string, username: string, first_name: string, last_name: string, roles: Array<string | null> } | null> };

export type IGetUserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IGetUserQuery = { __typename?: 'Query', result?: { __typename?: 'User', id: string, username: string, first_name: string, last_name: string, roles: Array<string | null>, password: string } | null };

export type ICreateUserMutationVariables = Exact<{
  input: ICreateUserInput;
}>;


export type ICreateUserMutation = { __typename?: 'Mutation', result: { __typename?: 'User', id: string, username: string, first_name: string, last_name: string, roles: Array<string | null>, password: string } };

export type IUpdatePasswordMutationVariables = Exact<{
  id: Scalars['Int'];
  newPass: Scalars['String'];
}>;


export type IUpdatePasswordMutation = { __typename?: 'Mutation', result: boolean };

export type IUpdateUserDetailsMutationVariables = Exact<{
  id: Scalars['Int'];
  input: IUserInput;
}>;


export type IUpdateUserDetailsMutation = { __typename?: 'Mutation', result: { __typename?: 'User', id: string, username: string, first_name: string, last_name: string, roles: Array<string | null>, password: string } };

export type IDeleteUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteUserMutation = { __typename?: 'Mutation', result: boolean };

export type IUserCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IUserCreatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'User', id: string, username: string, first_name: string, last_name: string, roles: Array<string | null>, password: string } };

export type IUserUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IUserUpdatedSubscription = { __typename?: 'Subscription', result: { __typename?: 'User', id: string, username: string, first_name: string, last_name: string, roles: Array<string | null>, password: string } };

export type IUserDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IUserDeletedSubscription = { __typename?: 'Subscription', result: { __typename?: 'User', id: string } };

export type IUserRoleRemovedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IUserRoleRemovedSubscription = { __typename?: 'Subscription', result: { __typename?: 'User', id: string, username: string, first_name: string, last_name: string, roles: Array<string | null>, password: string } };

export const AddressPropsFragmentDoc = gql`
    fragment AddressProps on Address {
  id
  name
  street
  city
  country {
    id
    name
    region {
      id
      name
    }
  }
  vat_number
  phone
  email
  is_main
  is_nav
  is_website
  fax
  zip
  complete_vat_number
  vat_country_code
}
    `;
export const AllocationSectorDetailsFragmentDoc = gql`
    fragment AllocationSectorDetails on AllocationSector {
  id
  stock_id
  sector_id
  year
  value
}
    `;
export const EventMeetingDetailsFragmentDoc = gql`
    fragment eventMeetingDetails on CalendarEvent {
  id
  title
  location
  description
  creator {
    id
    fullName
  }
  company {
    id
    name
  }
  type {
    id
    type
  }
  start_date
  end_date
}
    `;
export const HistoryStocksDetailsFragmentDoc = gql`
    fragment HistoryStocksDetails on HistoryStock {
  id
  stock_id
  date
  close_price
  engl_mkt_cap
  epra_shares
  nav_epra
  nav_ifrs
  price_discount
  gross_div_yield
  div_gross
  div_net
  free_float_market_cap
  nra
  nta
  ndv
  average
}
    `;
export const HistoryIndexDetailsFragmentDoc = gql`
    fragment HistoryIndexDetails on HistoryIndex {
  id
  index_id
  date
  mkt_cap_eur
  mkt_cap_usd
  mkt_cap_gbp
  mkt_cap_jpy
  mkt_cap_aud
  price_close_eur
  price_close_usd
  price_close_gbp
  price_close_jpy
  price_close_aud
  price_return_eur
  price_return_usd
  price_return_gbp
  price_return_jpy
  price_return_aud
  price_net_eur
  price_net_usd
  price_net_gbp
  price_net_jpy
  price_net_aud
}
    `;
export const HistoryIndexExtendedDetailsFragmentDoc = gql`
    fragment HistoryIndexExtendedDetails on HistoryIndex {
  id
  index_id
  date
  file_name
  dividend_yield
  mkt_cap_eur
  mkt_cap_usd
  mkt_cap_gbp
  mkt_cap_jpy
  mkt_cap_aud
  mkt_cap_hkd
  mkt_cap_local
  price_close_eur
  price_close_usd
  price_close_gbp
  price_close_jpy
  price_close_aud
  price_close_local
  price_close_hkd
  price_return_eur
  price_return_usd
  price_return_gbp
  price_return_jpy
  price_return_aud
  price_return_hkd
  price_return_local
  price_net_eur
  price_net_usd
  price_net_gbp
  price_net_jpy
  price_net_aud
  price_net_hkd
  price_net_local
  dividend_net_yield
  price_return_epra_local
  price_close_epra_local
}
    `;
export const CommentDetailsFragmentDoc = gql`
    fragment CommentDetails on Comment {
  id
  text
  date
  author {
    id
    first_name
    last_name
  }
}
    `;
export const CompanyDetailsFragmentDoc = gql`
    fragment CompanyDetails on Company {
  id
  name
  company_type {
    id
    name
  }
  market_activity {
    id
    name
  }
  membership {
    id
    name
    start_date
    end_date
    product {
      id
      name
      membership_type {
        id
        name
      }
    }
  }
  main_contacts {
    id
    fullName
  }
  market_second_specialty
  website
  unique_stock_code
  info
  member_index
  is_main_member
  main_address {
    complete_vat_number
    id
    name
    street
    city
    country {
      id
      name
    }
  }
}
    `;
export const ContactDetailsFragmentDoc = gql`
    fragment ContactDetails on Contact {
  id
  email
  fullName
  first_name
  last_name
  is_main
  title_external
  prefix
  address {
    id
    zip
    name
    street
    city
    country {
      name
      region {
        name
      }
    }
  }
  titleInternal {
    id
    name
  }
  linkedin
}
    `;
export const ContactDetailsInvoicePreviewFragmentDoc = gql`
    fragment ContactDetailsInvoicePreview on Contact {
  id
  title_external
  prefix
  suffix
}
    `;
export const ContactFullScopeFragmentDoc = gql`
    fragment ContactFullScope on Contact {
  id
  prefix
  first_name
  middle_name
  last_name
  suffix
  fullName
  informal_name
  titleInternal {
    id
    name
  }
  title_external
  company {
    id
    name
  }
  notes
  phone_direct
  phone_mobile
  fax
  email
  location_of_contact
  address {
    id
    name
    phone
    address_name
    fax
    street
    email
    country {
      id
      name
    }
    city
    zip
  }
  assistant {
    id
    fullName
    email
    phone_direct
    phone_mobile
  }
  contactMeetings {
    id
    name
    subject
    contacts {
      id
      fullName
    }
    meeting_type {
      id
      name
    }
    meeting_details
    location
    start_time
    end_time
  }
  linkedin
}
    `;
export const RecipientsFragmentDoc = gql`
    fragment Recipients on Contact {
  id
  first_name
  last_name
  fullName
  email
  titleInternal {
    id
    name
  }
}
    `;
export const CventEventDetailsFragmentDoc = gql`
    fragment CventEventDetails on CventEvent {
  id
  name
  created_by
  update_by
  date_insert
  date_edit
  url_landing_page
  event_stub
  is_active
  pk_email_payment_reminder
  pk_email_registration
  pk_product_registration
  pk_email_networking
  is_paid_event
}
    `;
export const CventContactDetailsFragmentDoc = gql`
    fragment CventContactDetails on CventContact {
  id
  date_created
  role {
    id
    name
    name_short
  }
  first_name
  last_name
  company_name
  email
  is_approved
  invoice {
    id
    number
    date_paid
    email_sent_date
  }
  fullName
  contact_id
  is_linked
}
    `;
export const DbContactDetailsFragmentDoc = gql`
    fragment DbContactDetails on Contact {
  id
  email
  fullName
}
    `;
export const CventLocationDetailsFragmentDoc = gql`
    fragment CventLocationDetails on CventLocation {
  id
  name
}
    `;
export const CventRolesDetailsFragmentDoc = gql`
    fragment CventRolesDetails on CventRole {
  id
  name
  name_short
}
    `;
export const DividendDetailsFragmentDoc = gql`
    fragment DividendDetails on DividendGross {
  id
  start_date
  stock_id
  value
}
    `;
export const DocumentDetailsFragmentDoc = gql`
    fragment DocumentDetails on Document {
  id
  display_name
  file_name
  visible_from
  protected_until
  company {
    id
    name
  }
  country {
    id
    name
  }
  description
  destination_url
  site_sections {
    id
    name
  }
  downloads
}
    `;
export const EtfDetailsFragmentDoc = gql`
    fragment EtfDetails on Etf {
  id
  launch_date
  name
  provider
  identifier
  is_deleted
}
    `;
export const EtfValueDetailsFragmentDoc = gql`
    fragment EtfValueDetails on EtfValue {
  id
  etf {
    id
    name
    provider
    identifier
    launch_date
  }
  date
  aum
  total_return_one_year
  index_total_return_one_year
  total_return_three_year
  index_total_return_three_year
}
    `;
export const FtseDetailsFragmentDoc = gql`
    fragment FtseDetails on FtseFile {
  id
  name
  type {
    id
    name
  }
  file_location
  last_import
  last_get
  attempt
}
    `;
export const FtseConfigurationDetailsFragmentDoc = gql`
    fragment FtseConfigurationDetails on FtseConfiguration {
  id
  property
  value
}
    `;
export const FtseFxDetailsFragmentDoc = gql`
    fragment FtseFxDetails on FtseFx {
  id
  rate
  date
  currency {
    id
    code
  }
}
    `;
export const HistoryAllocationCountryDetailsFragmentDoc = gql`
    fragment HistoryAllocationCountryDetails on HistoryAllocationCountry {
  id
  stock_id
  value
  year
  country {
    id
    name
  }
}
    `;
export const HistoryAwardDetailsFragmentDoc = gql`
    fragment HistoryAwardDetails on HistoryAward {
  id
  stock_id
  date
  type {
    id
    name
  }
}
    `;
export const HistoryConstituentDetailsFragmentDoc = gql`
    fragment HistoryConstituentDetails on HistoryConstituent {
  id
  weight_perc
  weighting
  date
  index {
    id
    name
  }
  history_index {
    id
    dividend_yield
  }
  stock {
    id
    name
    historyStock {
      id
      free_float_market_cap
      engl_mkt_cap
    }
  }
}
    `;
export const HistoryKpiDetailsFragmentDoc = gql`
    fragment HistoryKpiDetails on HistoryKpi {
  id
  stock_id
  date
  eps
  nav
  nnnav
  niy
  vacancy
  cost_ratio_incl
  cost_ratio_excl
  nra
  nta
  ndv
  average
}
    `;
export const HistoryLtvDetailsFragmentDoc = gql`
    fragment HistoryLtvDetails on HistoryLtv {
  id
  stock_id
  value
  start_date
}
    `;
export const HistoryRecalcDetailsFragmentDoc = gql`
    fragment HistoryRecalcDetails on HistoryRecalc {
  id
  value_to_calc_with
  column_to_recalc
  start_date
  end_date
  operator {
    id
    value
  }
  is_rollbacked
}
    `;
export const IndexSeriesDetailsFragmentDoc = gql`
    fragment indexSeriesDetails on IndexSerie {
  id
  name
  indices {
    id
    name
  }
}
    `;
export const IndiceDetailsFragmentDoc = gql`
    fragment IndiceDetails on Index {
  id
  name
  code
  net_code
  country {
    id
    name
  }
  currency {
    id
    code
  }
  identifier
  is_online
}
    `;
export const InvoiceDetailsFragmentDoc = gql`
    fragment InvoiceDetails on InvoiceDetails {
  fullName
  company_name
  company_address_vat
  contact_first_name
  contact_last_name
  contact_email
  address_name
  street
  city
  zip
  country
  region
  prefix
  title_external
  vat_countrycode
}
    `;
export const PaymentDetailsFragmentDoc = gql`
    fragment PaymentDetails on PaymentDetails {
  id
  contact_address_name
  contact_address
  contact_phone
  contact_fax
  contact_vat
  bank_name
  bank_affiliate
  bank_address
  bank_bic
  bank_iban
}
    `;
export const InvoiceDtoFullFragmentDoc = gql`
    fragment InvoiceDtoFull on Invoice {
  id
  number
  created_date
  date_paid
  due_date
  total
  vat
  discount
  is_credit
  email_sent_date
  debit_invoice_nr
  debit_invoice_nr
  membership {
    id
    name
    start_date
    end_date
  }
  status {
    id
    name
  }
  product {
    id
    name
    price
    membership_type {
      id
      name
    }
    bottom_notes
    product_code {
      id
      name
    }
  }
  details {
    ...InvoiceDetails
  }
  paymentDetails {
    ...PaymentDetails
  }
  notes
  po_nr
  remarks
}
    ${InvoiceDetailsFragmentDoc}
${PaymentDetailsFragmentDoc}`;
export const MeetingContactDetailsFragmentDoc = gql`
    fragment MeetingContactDetails on MeetingContact {
  id
  meeting {
    id
    name
  }
  contacts {
    id
    fullName
  }
  company {
    id
    name
  }
}
    `;
export const MeetingsMeetingTypeDetailsFragmentDoc = gql`
    fragment MeetingsMeetingTypeDetails on MeetingsMeetingType {
  id
  name
}
    `;
export const MeetingDetailsFragmentDoc = gql`
    fragment MeetingDetails on Meeting {
  id
  name
  subject
  contacts {
    id
    fullName
  }
  meeting_type {
    id
    name
  }
  meeting_details
  location
  start_time
  end_time
}
    `;
export const MembershipDetailsFragmentDoc = gql`
    fragment MembershipDetails on Membership {
  id
  name
  product {
    id
    price
    membership_type {
      id
      name
    }
  }
  is_bad_debtor
  discount
  total
  start_date
  end_date
  renewable_date
  comments_count
}
    `;
export const MembershipOverviewFragmentDoc = gql`
    fragment MembershipOverview on Membership {
  id
  name
  product {
    id
    price
    membership_type {
      id
      name
    }
  }
  is_bad_debtor
  discount
  total
  start_date
  end_date
  renewable_date
  comments_count
  last_invoice {
    id
    number
    email_sent_date
    date_paid
    total
  }
}
    `;
export const MsbReportOverviewFragmentDoc = gql`
    fragment MsbReportOverview on MsbReport {
  id
  report_date
  generation_start
  generation_end
  clear_cache
}
    `;
export const NavDetailsFragmentDoc = gql`
    fragment NavDetails on Nav {
  id
  created_date
  start_date
  stock_id
  ta
  tl
  nav
  nav_epra
  nav_epra_history
  nra
  nta
  ndv
  average
}
    `;
export const ProductDetailsFullFragmentDoc = gql`
    fragment ProductDetailsFull on Product {
  id
  name
  product_code {
    id
    name
  }
  price
  vat
  membership_type {
    id
    name
  }
  bottom_notes
  email_subject
  email_body
  email_banner
}
    `;
export const ProductDetailsFragmentDoc = gql`
    fragment ProductDetails on Product {
  id
  name
  product_code {
    id
    name
  }
  price
  vat
  membership_type {
    id
    name
  }
  bottom_notes
}
    `;
export const RecipientListPropsFragmentDoc = gql`
    fragment RecipientListProps on RecipientList {
  id
  name
  contact_titles {
    id
    name
  }
  company_types {
    id
    name
  }
  membership_types {
    id
    name
  }
  interests {
    id
    name
  }
  countries {
    id
    name
  }
  excluded_contact_ids
  included_contact_ids
}
    `;
export const SchedulerDetailsFragmentDoc = gql`
    fragment SchedulerDetails on Scheduler {
  id
  name
  is_success
  scheduled_date
  created_date
  sender {
    id
    email
  }
  recipient_lists {
    id
    name
  }
  template {
    id
    title
  }
  mails_sent
}
    `;
export const SiteSectionDetailsFragmentDoc = gql`
    fragment SiteSectionDetails on SiteSection {
  id
  name
}
    `;
export const StockOverviewMiniFragmentDoc = gql`
    fragment StockOverviewMini on Stock {
  id
  name
  country {
    id
    name
    code
  }
  isin_code
  bloomberg_ticker
  exchange_code
  currency {
    id
    code
  }
  code
  sector {
    id
    name
  }
  subsector {
    id
    name
  }
}
    `;
export const StockOverviewFragmentDoc = gql`
    fragment StockOverview on Stock {
  ...StockOverviewMini
  historyStock {
    id
    close_price
    engl_mkt_cap
    epra_shares
    nav_epra
    nav_ifrs
    price_discount
  }
}
    ${StockOverviewMiniFragmentDoc}`;
export const StockDetailsFragmentDoc = gql`
    fragment StockDetails on Stock {
  id
  name
  code
  currency {
    id
    code
  }
  cusip
  bloomberg_ticker
  isin_code
  exchange_code
  reuters_code
  snl_code
  icb_industry_code
  icb_supersector_code
  icb_sector_code
  icb_subsector_code
  country {
    id
    code
  }
  sector {
    id
    name
  }
  subsector {
    id
    name
  }
  sedol
  company {
    id
    name
  }
  start_date
  is_reit
  investment_focus {
    id
    name
  }
}
    `;
export const TemplateDetailsFragmentDoc = gql`
    fragment TemplateDetails on Template {
  id
  title
  subject
  content
}
    `;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on User {
  id
  username
  first_name
  last_name
  roles
  password
}
    `;
export const CompanyAddressesDocument = gql`
    query companyAddresses($company_id: Int!) {
  result: companyAddresses(company_id: $company_id) {
    ...AddressProps
    address_name
  }
}
    ${AddressPropsFragmentDoc}`;

/**
 * __useCompanyAddressesQuery__
 *
 * To run a query within a React component, call `useCompanyAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAddressesQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useCompanyAddressesQuery(baseOptions: Apollo.QueryHookOptions<ICompanyAddressesQuery, ICompanyAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICompanyAddressesQuery, ICompanyAddressesQueryVariables>(CompanyAddressesDocument, options);
      }
export function useCompanyAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICompanyAddressesQuery, ICompanyAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICompanyAddressesQuery, ICompanyAddressesQueryVariables>(CompanyAddressesDocument, options);
        }
export type CompanyAddressesQueryHookResult = ReturnType<typeof useCompanyAddressesQuery>;
export type CompanyAddressesLazyQueryHookResult = ReturnType<typeof useCompanyAddressesLazyQuery>;
export type CompanyAddressesQueryResult = Apollo.QueryResult<ICompanyAddressesQuery, ICompanyAddressesQueryVariables>;
export const AddAddressDocument = gql`
    mutation addAddress($company_id: Int!, $input: AddressInput!) {
  result: addAddress(company_id: $company_id, input: $input) {
    ...AddressProps
  }
}
    ${AddressPropsFragmentDoc}`;
export type IAddAddressMutationFn = Apollo.MutationFunction<IAddAddressMutation, IAddAddressMutationVariables>;

/**
 * __useAddAddressMutation__
 *
 * To run a mutation, you first call `useAddAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAddressMutation, { data, loading, error }] = useAddAddressMutation({
 *   variables: {
 *      company_id: // value for 'company_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAddressMutation(baseOptions?: Apollo.MutationHookOptions<IAddAddressMutation, IAddAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddAddressMutation, IAddAddressMutationVariables>(AddAddressDocument, options);
      }
export type AddAddressMutationHookResult = ReturnType<typeof useAddAddressMutation>;
export type AddAddressMutationResult = Apollo.MutationResult<IAddAddressMutation>;
export type AddAddressMutationOptions = Apollo.BaseMutationOptions<IAddAddressMutation, IAddAddressMutationVariables>;
export const UpdateAddressDocument = gql`
    mutation updateAddress($id: Int!, $input: AddressInput!) {
  result: updateAddress(id: $id, input: $input) {
    ...AddressProps
  }
}
    ${AddressPropsFragmentDoc}`;
export type IUpdateAddressMutationFn = Apollo.MutationFunction<IUpdateAddressMutation, IUpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAddressMutation, IUpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAddressMutation, IUpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<IUpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<IUpdateAddressMutation, IUpdateAddressMutationVariables>;
export const DeleteAddressDocument = gql`
    mutation deleteAddress($id: Int!) {
  result: deleteAddress(id: $id)
}
    `;
export type IDeleteAddressMutationFn = Apollo.MutationFunction<IDeleteAddressMutation, IDeleteAddressMutationVariables>;

/**
 * __useDeleteAddressMutation__
 *
 * To run a mutation, you first call `useDeleteAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressMutation, { data, loading, error }] = useDeleteAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAddressMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteAddressMutation, IDeleteAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteAddressMutation, IDeleteAddressMutationVariables>(DeleteAddressDocument, options);
      }
export type DeleteAddressMutationHookResult = ReturnType<typeof useDeleteAddressMutation>;
export type DeleteAddressMutationResult = Apollo.MutationResult<IDeleteAddressMutation>;
export type DeleteAddressMutationOptions = Apollo.BaseMutationOptions<IDeleteAddressMutation, IDeleteAddressMutationVariables>;
export const AddValueDocument = gql`
    mutation addValue($input: NewValueInput!) {
  result: addValue(input: $input) {
    id
    name
  }
}
    `;
export type IAddValueMutationFn = Apollo.MutationFunction<IAddValueMutation, IAddValueMutationVariables>;

/**
 * __useAddValueMutation__
 *
 * To run a mutation, you first call `useAddValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addValueMutation, { data, loading, error }] = useAddValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddValueMutation(baseOptions?: Apollo.MutationHookOptions<IAddValueMutation, IAddValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddValueMutation, IAddValueMutationVariables>(AddValueDocument, options);
      }
export type AddValueMutationHookResult = ReturnType<typeof useAddValueMutation>;
export type AddValueMutationResult = Apollo.MutationResult<IAddValueMutation>;
export type AddValueMutationOptions = Apollo.BaseMutationOptions<IAddValueMutation, IAddValueMutationVariables>;
export const DeleteValueDocument = gql`
    mutation deleteValue($value_list_name: String!, $value_id: Int!) {
  result: deleteValue(value_list_name: $value_list_name, value_id: $value_id)
}
    `;
export type IDeleteValueMutationFn = Apollo.MutationFunction<IDeleteValueMutation, IDeleteValueMutationVariables>;

/**
 * __useDeleteValueMutation__
 *
 * To run a mutation, you first call `useDeleteValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteValueMutation, { data, loading, error }] = useDeleteValueMutation({
 *   variables: {
 *      value_list_name: // value for 'value_list_name'
 *      value_id: // value for 'value_id'
 *   },
 * });
 */
export function useDeleteValueMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteValueMutation, IDeleteValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteValueMutation, IDeleteValueMutationVariables>(DeleteValueDocument, options);
      }
export type DeleteValueMutationHookResult = ReturnType<typeof useDeleteValueMutation>;
export type DeleteValueMutationResult = Apollo.MutationResult<IDeleteValueMutation>;
export type DeleteValueMutationOptions = Apollo.BaseMutationOptions<IDeleteValueMutation, IDeleteValueMutationVariables>;
export const GetAllocationSectorsDocument = gql`
    query getAllocationSectors($stock_id: Int!) {
  result: allocationSectors(stock_id: $stock_id) {
    ...AllocationSectorDetails
  }
}
    ${AllocationSectorDetailsFragmentDoc}`;

/**
 * __useGetAllocationSectorsQuery__
 *
 * To run a query within a React component, call `useGetAllocationSectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllocationSectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllocationSectorsQuery({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useGetAllocationSectorsQuery(baseOptions: Apollo.QueryHookOptions<IGetAllocationSectorsQuery, IGetAllocationSectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllocationSectorsQuery, IGetAllocationSectorsQueryVariables>(GetAllocationSectorsDocument, options);
      }
export function useGetAllocationSectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllocationSectorsQuery, IGetAllocationSectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllocationSectorsQuery, IGetAllocationSectorsQueryVariables>(GetAllocationSectorsDocument, options);
        }
export type GetAllocationSectorsQueryHookResult = ReturnType<typeof useGetAllocationSectorsQuery>;
export type GetAllocationSectorsLazyQueryHookResult = ReturnType<typeof useGetAllocationSectorsLazyQuery>;
export type GetAllocationSectorsQueryResult = Apollo.QueryResult<IGetAllocationSectorsQuery, IGetAllocationSectorsQueryVariables>;
export const CreateAllocationSectorDocument = gql`
    mutation createAllocationSector($stock_id: ID!, $input: AllocationSectorInput!) {
  result: createAllocationSector(stock_id: $stock_id, input: $input) {
    ...AllocationSectorDetails
  }
}
    ${AllocationSectorDetailsFragmentDoc}`;
export type ICreateAllocationSectorMutationFn = Apollo.MutationFunction<ICreateAllocationSectorMutation, ICreateAllocationSectorMutationVariables>;

/**
 * __useCreateAllocationSectorMutation__
 *
 * To run a mutation, you first call `useCreateAllocationSectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllocationSectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllocationSectorMutation, { data, loading, error }] = useCreateAllocationSectorMutation({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAllocationSectorMutation(baseOptions?: Apollo.MutationHookOptions<ICreateAllocationSectorMutation, ICreateAllocationSectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateAllocationSectorMutation, ICreateAllocationSectorMutationVariables>(CreateAllocationSectorDocument, options);
      }
export type CreateAllocationSectorMutationHookResult = ReturnType<typeof useCreateAllocationSectorMutation>;
export type CreateAllocationSectorMutationResult = Apollo.MutationResult<ICreateAllocationSectorMutation>;
export type CreateAllocationSectorMutationOptions = Apollo.BaseMutationOptions<ICreateAllocationSectorMutation, ICreateAllocationSectorMutationVariables>;
export const UpdateAllocationSectorDocument = gql`
    mutation updateAllocationSector($id: ID!, $input: AllocationSectorInput!) {
  result: updateAllocationSector(id: $id, input: $input) {
    ...AllocationSectorDetails
  }
}
    ${AllocationSectorDetailsFragmentDoc}`;
export type IUpdateAllocationSectorMutationFn = Apollo.MutationFunction<IUpdateAllocationSectorMutation, IUpdateAllocationSectorMutationVariables>;

/**
 * __useUpdateAllocationSectorMutation__
 *
 * To run a mutation, you first call `useUpdateAllocationSectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllocationSectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllocationSectorMutation, { data, loading, error }] = useUpdateAllocationSectorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllocationSectorMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAllocationSectorMutation, IUpdateAllocationSectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAllocationSectorMutation, IUpdateAllocationSectorMutationVariables>(UpdateAllocationSectorDocument, options);
      }
export type UpdateAllocationSectorMutationHookResult = ReturnType<typeof useUpdateAllocationSectorMutation>;
export type UpdateAllocationSectorMutationResult = Apollo.MutationResult<IUpdateAllocationSectorMutation>;
export type UpdateAllocationSectorMutationOptions = Apollo.BaseMutationOptions<IUpdateAllocationSectorMutation, IUpdateAllocationSectorMutationVariables>;
export const DeleteAllocationSectorDocument = gql`
    mutation deleteAllocationSector($id: ID!) {
  result: deleteAllocationSector(id: $id)
}
    `;
export type IDeleteAllocationSectorMutationFn = Apollo.MutationFunction<IDeleteAllocationSectorMutation, IDeleteAllocationSectorMutationVariables>;

/**
 * __useDeleteAllocationSectorMutation__
 *
 * To run a mutation, you first call `useDeleteAllocationSectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllocationSectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllocationSectorMutation, { data, loading, error }] = useDeleteAllocationSectorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAllocationSectorMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteAllocationSectorMutation, IDeleteAllocationSectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteAllocationSectorMutation, IDeleteAllocationSectorMutationVariables>(DeleteAllocationSectorDocument, options);
      }
export type DeleteAllocationSectorMutationHookResult = ReturnType<typeof useDeleteAllocationSectorMutation>;
export type DeleteAllocationSectorMutationResult = Apollo.MutationResult<IDeleteAllocationSectorMutation>;
export type DeleteAllocationSectorMutationOptions = Apollo.BaseMutationOptions<IDeleteAllocationSectorMutation, IDeleteAllocationSectorMutationVariables>;
export const AllocationSectorCreatedDocument = gql`
    subscription allocationSectorCreated($stock_id: ID!) {
  result: allocationSectorCreated(stock_id: $stock_id) {
    ...AllocationSectorDetails
  }
}
    ${AllocationSectorDetailsFragmentDoc}`;

/**
 * __useAllocationSectorCreatedSubscription__
 *
 * To run a query within a React component, call `useAllocationSectorCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAllocationSectorCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocationSectorCreatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useAllocationSectorCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IAllocationSectorCreatedSubscription, IAllocationSectorCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IAllocationSectorCreatedSubscription, IAllocationSectorCreatedSubscriptionVariables>(AllocationSectorCreatedDocument, options);
      }
export type AllocationSectorCreatedSubscriptionHookResult = ReturnType<typeof useAllocationSectorCreatedSubscription>;
export type AllocationSectorCreatedSubscriptionResult = Apollo.SubscriptionResult<IAllocationSectorCreatedSubscription>;
export const AllocationSectorUpdatedDocument = gql`
    subscription allocationSectorUpdated($stock_id: ID!) {
  result: allocationSectorUpdated(stock_id: $stock_id) {
    ...AllocationSectorDetails
  }
}
    ${AllocationSectorDetailsFragmentDoc}`;

/**
 * __useAllocationSectorUpdatedSubscription__
 *
 * To run a query within a React component, call `useAllocationSectorUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAllocationSectorUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocationSectorUpdatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useAllocationSectorUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IAllocationSectorUpdatedSubscription, IAllocationSectorUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IAllocationSectorUpdatedSubscription, IAllocationSectorUpdatedSubscriptionVariables>(AllocationSectorUpdatedDocument, options);
      }
export type AllocationSectorUpdatedSubscriptionHookResult = ReturnType<typeof useAllocationSectorUpdatedSubscription>;
export type AllocationSectorUpdatedSubscriptionResult = Apollo.SubscriptionResult<IAllocationSectorUpdatedSubscription>;
export const AllocationSectorDeletedDocument = gql`
    subscription allocationSectorDeleted($stock_id: ID!) {
  result: allocationSectorDeleted(stock_id: $stock_id) {
    ...AllocationSectorDetails
  }
}
    ${AllocationSectorDetailsFragmentDoc}`;

/**
 * __useAllocationSectorDeletedSubscription__
 *
 * To run a query within a React component, call `useAllocationSectorDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAllocationSectorDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocationSectorDeletedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useAllocationSectorDeletedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IAllocationSectorDeletedSubscription, IAllocationSectorDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IAllocationSectorDeletedSubscription, IAllocationSectorDeletedSubscriptionVariables>(AllocationSectorDeletedDocument, options);
      }
export type AllocationSectorDeletedSubscriptionHookResult = ReturnType<typeof useAllocationSectorDeletedSubscription>;
export type AllocationSectorDeletedSubscriptionResult = Apollo.SubscriptionResult<IAllocationSectorDeletedSubscription>;
export const EventsDocument = gql`
    query events {
  result: events {
    ...eventMeetingDetails
  }
}
    ${EventMeetingDetailsFragmentDoc}`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventsQuery(baseOptions?: Apollo.QueryHookOptions<IEventsQuery, IEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IEventsQuery, IEventsQueryVariables>(EventsDocument, options);
      }
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IEventsQuery, IEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IEventsQuery, IEventsQueryVariables>(EventsDocument, options);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsQueryResult = Apollo.QueryResult<IEventsQuery, IEventsQueryVariables>;
export const CalendarTypesDocument = gql`
    query calendarTypes {
  result: calendarTypes {
    id
    type
    color_code
  }
}
    `;

/**
 * __useCalendarTypesQuery__
 *
 * To run a query within a React component, call `useCalendarTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarTypesQuery(baseOptions?: Apollo.QueryHookOptions<ICalendarTypesQuery, ICalendarTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICalendarTypesQuery, ICalendarTypesQueryVariables>(CalendarTypesDocument, options);
      }
export function useCalendarTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICalendarTypesQuery, ICalendarTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICalendarTypesQuery, ICalendarTypesQueryVariables>(CalendarTypesDocument, options);
        }
export type CalendarTypesQueryHookResult = ReturnType<typeof useCalendarTypesQuery>;
export type CalendarTypesLazyQueryHookResult = ReturnType<typeof useCalendarTypesLazyQuery>;
export type CalendarTypesQueryResult = Apollo.QueryResult<ICalendarTypesQuery, ICalendarTypesQueryVariables>;
export const AddEventDocument = gql`
    mutation addEvent($input: AddNewEventInput!) {
  result: addEvent(input: $input) {
    ...eventMeetingDetails
  }
}
    ${EventMeetingDetailsFragmentDoc}`;
export type IAddEventMutationFn = Apollo.MutationFunction<IAddEventMutation, IAddEventMutationVariables>;

/**
 * __useAddEventMutation__
 *
 * To run a mutation, you first call `useAddEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventMutation, { data, loading, error }] = useAddEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEventMutation(baseOptions?: Apollo.MutationHookOptions<IAddEventMutation, IAddEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddEventMutation, IAddEventMutationVariables>(AddEventDocument, options);
      }
export type AddEventMutationHookResult = ReturnType<typeof useAddEventMutation>;
export type AddEventMutationResult = Apollo.MutationResult<IAddEventMutation>;
export type AddEventMutationOptions = Apollo.BaseMutationOptions<IAddEventMutation, IAddEventMutationVariables>;
export const DeleteEventDocument = gql`
    mutation deleteEvent($id: Int!) {
  result: deleteEvent(id: $id)
}
    `;
export type IDeleteEventMutationFn = Apollo.MutationFunction<IDeleteEventMutation, IDeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteEventMutation, IDeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteEventMutation, IDeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<IDeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<IDeleteEventMutation, IDeleteEventMutationVariables>;
export const UpdateEventDocument = gql`
    mutation updateEvent($id: Int!, $input: AddNewEventInput!) {
  result: updateEvent(id: $id, input: $input) {
    ...eventMeetingDetails
  }
}
    ${EventMeetingDetailsFragmentDoc}`;
export type IUpdateEventMutationFn = Apollo.MutationFunction<IUpdateEventMutation, IUpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateEventMutation, IUpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateEventMutation, IUpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<IUpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<IUpdateEventMutation, IUpdateEventMutationVariables>;
export const EventCreatedDocument = gql`
    subscription eventCreated {
  result: eventCreated {
    id
    title
    location
    description
    creator {
      id
      fullName
    }
    company {
      id
      name
    }
    type {
      id
      type
    }
    start_date
    end_date
  }
}
    `;

/**
 * __useEventCreatedSubscription__
 *
 * To run a query within a React component, call `useEventCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEventCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IEventCreatedSubscription, IEventCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IEventCreatedSubscription, IEventCreatedSubscriptionVariables>(EventCreatedDocument, options);
      }
export type EventCreatedSubscriptionHookResult = ReturnType<typeof useEventCreatedSubscription>;
export type EventCreatedSubscriptionResult = Apollo.SubscriptionResult<IEventCreatedSubscription>;
export const EventDeletedDocument = gql`
    subscription eventDeleted {
  result: eventDeleted {
    id
  }
}
    `;

/**
 * __useEventDeletedSubscription__
 *
 * To run a query within a React component, call `useEventDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEventDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IEventDeletedSubscription, IEventDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IEventDeletedSubscription, IEventDeletedSubscriptionVariables>(EventDeletedDocument, options);
      }
export type EventDeletedSubscriptionHookResult = ReturnType<typeof useEventDeletedSubscription>;
export type EventDeletedSubscriptionResult = Apollo.SubscriptionResult<IEventDeletedSubscription>;
export const EventUpdatedDocument = gql`
    subscription eventUpdated {
  result: eventUpdated {
    ...eventMeetingDetails
  }
}
    ${EventMeetingDetailsFragmentDoc}`;

/**
 * __useEventUpdatedSubscription__
 *
 * To run a query within a React component, call `useEventUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEventUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IEventUpdatedSubscription, IEventUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IEventUpdatedSubscription, IEventUpdatedSubscriptionVariables>(EventUpdatedDocument, options);
      }
export type EventUpdatedSubscriptionHookResult = ReturnType<typeof useEventUpdatedSubscription>;
export type EventUpdatedSubscriptionResult = Apollo.SubscriptionResult<IEventUpdatedSubscription>;
export const GetClosePricesDocument = gql`
    query getClosePrices($stock_id: Int!) {
  result: historyStocks(stock_id: $stock_id) {
    ...HistoryStocksDetails
  }
}
    ${HistoryStocksDetailsFragmentDoc}`;

/**
 * __useGetClosePricesQuery__
 *
 * To run a query within a React component, call `useGetClosePricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClosePricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClosePricesQuery({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useGetClosePricesQuery(baseOptions: Apollo.QueryHookOptions<IGetClosePricesQuery, IGetClosePricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetClosePricesQuery, IGetClosePricesQueryVariables>(GetClosePricesDocument, options);
      }
export function useGetClosePricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetClosePricesQuery, IGetClosePricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetClosePricesQuery, IGetClosePricesQueryVariables>(GetClosePricesDocument, options);
        }
export type GetClosePricesQueryHookResult = ReturnType<typeof useGetClosePricesQuery>;
export type GetClosePricesLazyQueryHookResult = ReturnType<typeof useGetClosePricesLazyQuery>;
export type GetClosePricesQueryResult = Apollo.QueryResult<IGetClosePricesQuery, IGetClosePricesQueryVariables>;
export const HistoryIndicesByIdAndPeriodDocument = gql`
    query historyIndicesByIdAndPeriod($input: HistoryIndicesByIdAndPeriodInput!) {
  result: historyIndicesByIdAndPeriod(input: $input) {
    ...HistoryIndexExtendedDetails
  }
}
    ${HistoryIndexExtendedDetailsFragmentDoc}`;

/**
 * __useHistoryIndicesByIdAndPeriodQuery__
 *
 * To run a query within a React component, call `useHistoryIndicesByIdAndPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryIndicesByIdAndPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryIndicesByIdAndPeriodQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHistoryIndicesByIdAndPeriodQuery(baseOptions: Apollo.QueryHookOptions<IHistoryIndicesByIdAndPeriodQuery, IHistoryIndicesByIdAndPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IHistoryIndicesByIdAndPeriodQuery, IHistoryIndicesByIdAndPeriodQueryVariables>(HistoryIndicesByIdAndPeriodDocument, options);
      }
export function useHistoryIndicesByIdAndPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IHistoryIndicesByIdAndPeriodQuery, IHistoryIndicesByIdAndPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IHistoryIndicesByIdAndPeriodQuery, IHistoryIndicesByIdAndPeriodQueryVariables>(HistoryIndicesByIdAndPeriodDocument, options);
        }
export type HistoryIndicesByIdAndPeriodQueryHookResult = ReturnType<typeof useHistoryIndicesByIdAndPeriodQuery>;
export type HistoryIndicesByIdAndPeriodLazyQueryHookResult = ReturnType<typeof useHistoryIndicesByIdAndPeriodLazyQuery>;
export type HistoryIndicesByIdAndPeriodQueryResult = Apollo.QueryResult<IHistoryIndicesByIdAndPeriodQuery, IHistoryIndicesByIdAndPeriodQueryVariables>;
export const CreateHistoryStocksDocument = gql`
    mutation createHistoryStocks($input: [HistoryStockInput!]!) {
  result: createHistoryStocks(input: $input) {
    ...HistoryStocksDetails
  }
}
    ${HistoryStocksDetailsFragmentDoc}`;
export type ICreateHistoryStocksMutationFn = Apollo.MutationFunction<ICreateHistoryStocksMutation, ICreateHistoryStocksMutationVariables>;

/**
 * __useCreateHistoryStocksMutation__
 *
 * To run a mutation, you first call `useCreateHistoryStocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHistoryStocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHistoryStocksMutation, { data, loading, error }] = useCreateHistoryStocksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHistoryStocksMutation(baseOptions?: Apollo.MutationHookOptions<ICreateHistoryStocksMutation, ICreateHistoryStocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateHistoryStocksMutation, ICreateHistoryStocksMutationVariables>(CreateHistoryStocksDocument, options);
      }
export type CreateHistoryStocksMutationHookResult = ReturnType<typeof useCreateHistoryStocksMutation>;
export type CreateHistoryStocksMutationResult = Apollo.MutationResult<ICreateHistoryStocksMutation>;
export type CreateHistoryStocksMutationOptions = Apollo.BaseMutationOptions<ICreateHistoryStocksMutation, ICreateHistoryStocksMutationVariables>;
export const CreateHistoryIndicesDocument = gql`
    mutation createHistoryIndices($input: [HistoryIndexInput!]!) {
  result: createHistoryIndices(input: $input) {
    ...HistoryIndexDetails
  }
}
    ${HistoryIndexDetailsFragmentDoc}`;
export type ICreateHistoryIndicesMutationFn = Apollo.MutationFunction<ICreateHistoryIndicesMutation, ICreateHistoryIndicesMutationVariables>;

/**
 * __useCreateHistoryIndicesMutation__
 *
 * To run a mutation, you first call `useCreateHistoryIndicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHistoryIndicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHistoryIndicesMutation, { data, loading, error }] = useCreateHistoryIndicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHistoryIndicesMutation(baseOptions?: Apollo.MutationHookOptions<ICreateHistoryIndicesMutation, ICreateHistoryIndicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateHistoryIndicesMutation, ICreateHistoryIndicesMutationVariables>(CreateHistoryIndicesDocument, options);
      }
export type CreateHistoryIndicesMutationHookResult = ReturnType<typeof useCreateHistoryIndicesMutation>;
export type CreateHistoryIndicesMutationResult = Apollo.MutationResult<ICreateHistoryIndicesMutation>;
export type CreateHistoryIndicesMutationOptions = Apollo.BaseMutationOptions<ICreateHistoryIndicesMutation, ICreateHistoryIndicesMutationVariables>;
export const MembershipCommentsDocument = gql`
    query membershipComments($membership_id: Int!) {
  result: membershipComments(membership_id: $membership_id) {
    ...CommentDetails
  }
}
    ${CommentDetailsFragmentDoc}`;

/**
 * __useMembershipCommentsQuery__
 *
 * To run a query within a React component, call `useMembershipCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipCommentsQuery({
 *   variables: {
 *      membership_id: // value for 'membership_id'
 *   },
 * });
 */
export function useMembershipCommentsQuery(baseOptions: Apollo.QueryHookOptions<IMembershipCommentsQuery, IMembershipCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMembershipCommentsQuery, IMembershipCommentsQueryVariables>(MembershipCommentsDocument, options);
      }
export function useMembershipCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMembershipCommentsQuery, IMembershipCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMembershipCommentsQuery, IMembershipCommentsQueryVariables>(MembershipCommentsDocument, options);
        }
export type MembershipCommentsQueryHookResult = ReturnType<typeof useMembershipCommentsQuery>;
export type MembershipCommentsLazyQueryHookResult = ReturnType<typeof useMembershipCommentsLazyQuery>;
export type MembershipCommentsQueryResult = Apollo.QueryResult<IMembershipCommentsQuery, IMembershipCommentsQueryVariables>;
export const AddCommentDocument = gql`
    mutation addComment($membership_id: Int!, $text: String!) {
  result: addComment(membership_id: $membership_id, text: $text) {
    comment {
      ...CommentDetails
    }
    membership {
      ...MembershipOverview
    }
  }
}
    ${CommentDetailsFragmentDoc}
${MembershipOverviewFragmentDoc}`;
export type IAddCommentMutationFn = Apollo.MutationFunction<IAddCommentMutation, IAddCommentMutationVariables>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      membership_id: // value for 'membership_id'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<IAddCommentMutation, IAddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddCommentMutation, IAddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<IAddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<IAddCommentMutation, IAddCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($id: Int!, $membership_id: Int!) {
  result: deleteComment(id: $id, membership_id: $membership_id) {
    ...MembershipOverview
  }
}
    ${MembershipOverviewFragmentDoc}`;
export type IDeleteCommentMutationFn = Apollo.MutationFunction<IDeleteCommentMutation, IDeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      membership_id: // value for 'membership_id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteCommentMutation, IDeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteCommentMutation, IDeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<IDeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<IDeleteCommentMutation, IDeleteCommentMutationVariables>;
export const CommentAddedDocument = gql`
    subscription CommentAdded {
  result: commentAdded {
    ...MembershipOverview
  }
}
    ${MembershipOverviewFragmentDoc}`;

/**
 * __useCommentAddedSubscription__
 *
 * To run a query within a React component, call `useCommentAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentAddedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCommentAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ICommentAddedSubscription, ICommentAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ICommentAddedSubscription, ICommentAddedSubscriptionVariables>(CommentAddedDocument, options);
      }
export type CommentAddedSubscriptionHookResult = ReturnType<typeof useCommentAddedSubscription>;
export type CommentAddedSubscriptionResult = Apollo.SubscriptionResult<ICommentAddedSubscription>;
export const CommentDeletedDocument = gql`
    subscription CommentDeleted {
  result: commentDeleted {
    ...MembershipOverview
  }
}
    ${MembershipOverviewFragmentDoc}`;

/**
 * __useCommentDeletedSubscription__
 *
 * To run a query within a React component, call `useCommentDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCommentDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ICommentDeletedSubscription, ICommentDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ICommentDeletedSubscription, ICommentDeletedSubscriptionVariables>(CommentDeletedDocument, options);
      }
export type CommentDeletedSubscriptionHookResult = ReturnType<typeof useCommentDeletedSubscription>;
export type CommentDeletedSubscriptionResult = Apollo.SubscriptionResult<ICommentDeletedSubscription>;
export const CompaniesDocument = gql`
    query companies {
  result: companies {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<ICompaniesQuery, ICompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICompaniesQuery, ICompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICompaniesQuery, ICompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICompaniesQuery, ICompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<ICompaniesQuery, ICompaniesQueryVariables>;
export const CompaniesNamesDocument = gql`
    query companiesNames {
  result: companies {
    id
    name
  }
}
    `;

/**
 * __useCompaniesNamesQuery__
 *
 * To run a query within a React component, call `useCompaniesNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompaniesNamesQuery(baseOptions?: Apollo.QueryHookOptions<ICompaniesNamesQuery, ICompaniesNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICompaniesNamesQuery, ICompaniesNamesQueryVariables>(CompaniesNamesDocument, options);
      }
export function useCompaniesNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICompaniesNamesQuery, ICompaniesNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICompaniesNamesQuery, ICompaniesNamesQueryVariables>(CompaniesNamesDocument, options);
        }
export type CompaniesNamesQueryHookResult = ReturnType<typeof useCompaniesNamesQuery>;
export type CompaniesNamesLazyQueryHookResult = ReturnType<typeof useCompaniesNamesLazyQuery>;
export type CompaniesNamesQueryResult = Apollo.QueryResult<ICompaniesNamesQuery, ICompaniesNamesQueryVariables>;
export const CompanyDocument = gql`
    query company($id: Int!) {
  result: company(id: $id) {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<ICompanyQuery, ICompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICompanyQuery, ICompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICompanyQuery, ICompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICompanyQuery, ICompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = Apollo.QueryResult<ICompanyQuery, ICompanyQueryVariables>;
export const CompaniesFilteredDocument = gql`
    query companiesFiltered($filter: CompanyFilterInput) {
  result: companiesFiltered(filter: $filter) {
    total
    companies {
      ...CompanyDetails
    }
  }
}
    ${CompanyDetailsFragmentDoc}`;

/**
 * __useCompaniesFilteredQuery__
 *
 * To run a query within a React component, call `useCompaniesFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesFilteredQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCompaniesFilteredQuery(baseOptions?: Apollo.QueryHookOptions<ICompaniesFilteredQuery, ICompaniesFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICompaniesFilteredQuery, ICompaniesFilteredQueryVariables>(CompaniesFilteredDocument, options);
      }
export function useCompaniesFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICompaniesFilteredQuery, ICompaniesFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICompaniesFilteredQuery, ICompaniesFilteredQueryVariables>(CompaniesFilteredDocument, options);
        }
export type CompaniesFilteredQueryHookResult = ReturnType<typeof useCompaniesFilteredQuery>;
export type CompaniesFilteredLazyQueryHookResult = ReturnType<typeof useCompaniesFilteredLazyQuery>;
export type CompaniesFilteredQueryResult = Apollo.QueryResult<ICompaniesFilteredQuery, ICompaniesFilteredQueryVariables>;
export const AddCompanyDocument = gql`
    mutation addCompany($input: AddCompanyInput!) {
  result: addCompany(input: $input) {
    success
    errors
    company {
      ...CompanyDetails
    }
  }
}
    ${CompanyDetailsFragmentDoc}`;
export type IAddCompanyMutationFn = Apollo.MutationFunction<IAddCompanyMutation, IAddCompanyMutationVariables>;

/**
 * __useAddCompanyMutation__
 *
 * To run a mutation, you first call `useAddCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyMutation, { data, loading, error }] = useAddCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyMutation(baseOptions?: Apollo.MutationHookOptions<IAddCompanyMutation, IAddCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddCompanyMutation, IAddCompanyMutationVariables>(AddCompanyDocument, options);
      }
export type AddCompanyMutationHookResult = ReturnType<typeof useAddCompanyMutation>;
export type AddCompanyMutationResult = Apollo.MutationResult<IAddCompanyMutation>;
export type AddCompanyMutationOptions = Apollo.BaseMutationOptions<IAddCompanyMutation, IAddCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($id: Int!, $input: NewCompanyInput!) {
  result: updateCompany(id: $id, input: $input) {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;
export type IUpdateCompanyMutationFn = Apollo.MutationFunction<IUpdateCompanyMutation, IUpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCompanyMutation, IUpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCompanyMutation, IUpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<IUpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<IUpdateCompanyMutation, IUpdateCompanyMutationVariables>;
export const UpdateCompanyMembershipDocument = gql`
    mutation updateCompanyMembership($id: Int!, $membershipId: Int!) {
  result: updateCompanyMembership(id: $id, membershipId: $membershipId) {
    id
    name
    membership {
      id
      name
      start_date
      end_date
      product {
        id
        name
        membership_type {
          id
          name
        }
      }
    }
  }
}
    `;
export type IUpdateCompanyMembershipMutationFn = Apollo.MutationFunction<IUpdateCompanyMembershipMutation, IUpdateCompanyMembershipMutationVariables>;

/**
 * __useUpdateCompanyMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMembershipMutation, { data, loading, error }] = useUpdateCompanyMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useUpdateCompanyMembershipMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCompanyMembershipMutation, IUpdateCompanyMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCompanyMembershipMutation, IUpdateCompanyMembershipMutationVariables>(UpdateCompanyMembershipDocument, options);
      }
export type UpdateCompanyMembershipMutationHookResult = ReturnType<typeof useUpdateCompanyMembershipMutation>;
export type UpdateCompanyMembershipMutationResult = Apollo.MutationResult<IUpdateCompanyMembershipMutation>;
export type UpdateCompanyMembershipMutationOptions = Apollo.BaseMutationOptions<IUpdateCompanyMembershipMutation, IUpdateCompanyMembershipMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation deleteCompany($id: Int!) {
  result: deleteCompany(id: $id)
}
    `;
export type IDeleteCompanyMutationFn = Apollo.MutationFunction<IDeleteCompanyMutation, IDeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteCompanyMutation, IDeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteCompanyMutation, IDeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<IDeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<IDeleteCompanyMutation, IDeleteCompanyMutationVariables>;
export const AddCompanyToMembershipDocument = gql`
    mutation addCompanyToMembership($id: Int!, $membership_id: Int!) {
  result: addCompanyToMembership(id: $id, membership_id: $membership_id) {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;
export type IAddCompanyToMembershipMutationFn = Apollo.MutationFunction<IAddCompanyToMembershipMutation, IAddCompanyToMembershipMutationVariables>;

/**
 * __useAddCompanyToMembershipMutation__
 *
 * To run a mutation, you first call `useAddCompanyToMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyToMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyToMembershipMutation, { data, loading, error }] = useAddCompanyToMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      membership_id: // value for 'membership_id'
 *   },
 * });
 */
export function useAddCompanyToMembershipMutation(baseOptions?: Apollo.MutationHookOptions<IAddCompanyToMembershipMutation, IAddCompanyToMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddCompanyToMembershipMutation, IAddCompanyToMembershipMutationVariables>(AddCompanyToMembershipDocument, options);
      }
export type AddCompanyToMembershipMutationHookResult = ReturnType<typeof useAddCompanyToMembershipMutation>;
export type AddCompanyToMembershipMutationResult = Apollo.MutationResult<IAddCompanyToMembershipMutation>;
export type AddCompanyToMembershipMutationOptions = Apollo.BaseMutationOptions<IAddCompanyToMembershipMutation, IAddCompanyToMembershipMutationVariables>;
export const UpdateCompanyMainMemberForMembershipDocument = gql`
    mutation updateCompanyMainMemberForMembership($id: Int!, $membership_id: Int!, $is_main_member: Boolean!) {
  result: updateCompanyMainMemberForMembership(
    id: $id
    membership_id: $membership_id
    is_main_member: $is_main_member
  )
}
    `;
export type IUpdateCompanyMainMemberForMembershipMutationFn = Apollo.MutationFunction<IUpdateCompanyMainMemberForMembershipMutation, IUpdateCompanyMainMemberForMembershipMutationVariables>;

/**
 * __useUpdateCompanyMainMemberForMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMainMemberForMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMainMemberForMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMainMemberForMembershipMutation, { data, loading, error }] = useUpdateCompanyMainMemberForMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      membership_id: // value for 'membership_id'
 *      is_main_member: // value for 'is_main_member'
 *   },
 * });
 */
export function useUpdateCompanyMainMemberForMembershipMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCompanyMainMemberForMembershipMutation, IUpdateCompanyMainMemberForMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCompanyMainMemberForMembershipMutation, IUpdateCompanyMainMemberForMembershipMutationVariables>(UpdateCompanyMainMemberForMembershipDocument, options);
      }
export type UpdateCompanyMainMemberForMembershipMutationHookResult = ReturnType<typeof useUpdateCompanyMainMemberForMembershipMutation>;
export type UpdateCompanyMainMemberForMembershipMutationResult = Apollo.MutationResult<IUpdateCompanyMainMemberForMembershipMutation>;
export type UpdateCompanyMainMemberForMembershipMutationOptions = Apollo.BaseMutationOptions<IUpdateCompanyMainMemberForMembershipMutation, IUpdateCompanyMainMemberForMembershipMutationVariables>;
export const UpdateCompanyMainContactDocument = gql`
    mutation updateCompanyMainContact($id: Int!, $contact_id: Int!, $is_main: Boolean!) {
  result: updateCompanyMainContact(
    id: $id
    contact_id: $contact_id
    is_main: $is_main
  )
}
    `;
export type IUpdateCompanyMainContactMutationFn = Apollo.MutationFunction<IUpdateCompanyMainContactMutation, IUpdateCompanyMainContactMutationVariables>;

/**
 * __useUpdateCompanyMainContactMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMainContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMainContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMainContactMutation, { data, loading, error }] = useUpdateCompanyMainContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contact_id: // value for 'contact_id'
 *      is_main: // value for 'is_main'
 *   },
 * });
 */
export function useUpdateCompanyMainContactMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCompanyMainContactMutation, IUpdateCompanyMainContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCompanyMainContactMutation, IUpdateCompanyMainContactMutationVariables>(UpdateCompanyMainContactDocument, options);
      }
export type UpdateCompanyMainContactMutationHookResult = ReturnType<typeof useUpdateCompanyMainContactMutation>;
export type UpdateCompanyMainContactMutationResult = Apollo.MutationResult<IUpdateCompanyMainContactMutation>;
export type UpdateCompanyMainContactMutationOptions = Apollo.BaseMutationOptions<IUpdateCompanyMainContactMutation, IUpdateCompanyMainContactMutationVariables>;
export const CompanyCreatedDocument = gql`
    subscription CompanyCreated {
  result: companyCreated {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;

/**
 * __useCompanyCreatedSubscription__
 *
 * To run a query within a React component, call `useCompanyCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCompanyCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCompanyCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ICompanyCreatedSubscription, ICompanyCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ICompanyCreatedSubscription, ICompanyCreatedSubscriptionVariables>(CompanyCreatedDocument, options);
      }
export type CompanyCreatedSubscriptionHookResult = ReturnType<typeof useCompanyCreatedSubscription>;
export type CompanyCreatedSubscriptionResult = Apollo.SubscriptionResult<ICompanyCreatedSubscription>;
export const CompanyDeletedDocument = gql`
    subscription CompanyDeleted {
  result: companyDeleted {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;

/**
 * __useCompanyDeletedSubscription__
 *
 * To run a query within a React component, call `useCompanyDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCompanyDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ICompanyDeletedSubscription, ICompanyDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ICompanyDeletedSubscription, ICompanyDeletedSubscriptionVariables>(CompanyDeletedDocument, options);
      }
export type CompanyDeletedSubscriptionHookResult = ReturnType<typeof useCompanyDeletedSubscription>;
export type CompanyDeletedSubscriptionResult = Apollo.SubscriptionResult<ICompanyDeletedSubscription>;
export const CompanyUpdatedDocument = gql`
    subscription CompanyUpdated {
  result: companyUpdated {
    ...CompanyDetails
  }
}
    ${CompanyDetailsFragmentDoc}`;

/**
 * __useCompanyUpdatedSubscription__
 *
 * To run a query within a React component, call `useCompanyUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCompanyUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCompanyUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ICompanyUpdatedSubscription, ICompanyUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ICompanyUpdatedSubscription, ICompanyUpdatedSubscriptionVariables>(CompanyUpdatedDocument, options);
      }
export type CompanyUpdatedSubscriptionHookResult = ReturnType<typeof useCompanyUpdatedSubscription>;
export type CompanyUpdatedSubscriptionResult = Apollo.SubscriptionResult<ICompanyUpdatedSubscription>;
export const CompanyTypesDocument = gql`
    query companyTypes {
  result: companyTypes {
    id
    name
  }
}
    `;

/**
 * __useCompanyTypesQuery__
 *
 * To run a query within a React component, call `useCompanyTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyTypesQuery(baseOptions?: Apollo.QueryHookOptions<ICompanyTypesQuery, ICompanyTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICompanyTypesQuery, ICompanyTypesQueryVariables>(CompanyTypesDocument, options);
      }
export function useCompanyTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICompanyTypesQuery, ICompanyTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICompanyTypesQuery, ICompanyTypesQueryVariables>(CompanyTypesDocument, options);
        }
export type CompanyTypesQueryHookResult = ReturnType<typeof useCompanyTypesQuery>;
export type CompanyTypesLazyQueryHookResult = ReturnType<typeof useCompanyTypesLazyQuery>;
export type CompanyTypesQueryResult = Apollo.QueryResult<ICompanyTypesQuery, ICompanyTypesQueryVariables>;
export const CompanyContactsDocument = gql`
    query companyContacts($company_id: Int!) {
  result: companyContacts(company_id: $company_id) {
    ...ContactDetails
    phone_direct
    company {
      id
      name
    }
  }
}
    ${ContactDetailsFragmentDoc}`;

/**
 * __useCompanyContactsQuery__
 *
 * To run a query within a React component, call `useCompanyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyContactsQuery({
 *   variables: {
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useCompanyContactsQuery(baseOptions: Apollo.QueryHookOptions<ICompanyContactsQuery, ICompanyContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICompanyContactsQuery, ICompanyContactsQueryVariables>(CompanyContactsDocument, options);
      }
export function useCompanyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICompanyContactsQuery, ICompanyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICompanyContactsQuery, ICompanyContactsQueryVariables>(CompanyContactsDocument, options);
        }
export type CompanyContactsQueryHookResult = ReturnType<typeof useCompanyContactsQuery>;
export type CompanyContactsLazyQueryHookResult = ReturnType<typeof useCompanyContactsLazyQuery>;
export type CompanyContactsQueryResult = Apollo.QueryResult<ICompanyContactsQuery, ICompanyContactsQueryVariables>;
export const ContactsDocument = gql`
    query contacts {
  result: contacts {
    ...ContactDetails
    phone_direct
    company {
      id
      name
    }
  }
}
    ${ContactDetailsFragmentDoc}`;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactsQuery(baseOptions?: Apollo.QueryHookOptions<IContactsQuery, IContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContactsQuery, IContactsQueryVariables>(ContactsDocument, options);
      }
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContactsQuery, IContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContactsQuery, IContactsQueryVariables>(ContactsDocument, options);
        }
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsQueryResult = Apollo.QueryResult<IContactsQuery, IContactsQueryVariables>;
export const ContactsFilteredDocument = gql`
    query contactsFiltered($filter: ContactFilterInput) {
  result: contactsFiltered(filter: $filter) {
    total
    contacts {
      ...ContactDetails
      phone_direct
      phone_mobile
      company {
        id
        name
      }
    }
  }
}
    ${ContactDetailsFragmentDoc}`;

/**
 * __useContactsFilteredQuery__
 *
 * To run a query within a React component, call `useContactsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsFilteredQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useContactsFilteredQuery(baseOptions?: Apollo.QueryHookOptions<IContactsFilteredQuery, IContactsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContactsFilteredQuery, IContactsFilteredQueryVariables>(ContactsFilteredDocument, options);
      }
export function useContactsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContactsFilteredQuery, IContactsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContactsFilteredQuery, IContactsFilteredQueryVariables>(ContactsFilteredDocument, options);
        }
export type ContactsFilteredQueryHookResult = ReturnType<typeof useContactsFilteredQuery>;
export type ContactsFilteredLazyQueryHookResult = ReturnType<typeof useContactsFilteredLazyQuery>;
export type ContactsFilteredQueryResult = Apollo.QueryResult<IContactsFilteredQuery, IContactsFilteredQueryVariables>;
export const ContactByEmailAndFullNameDocument = gql`
    query contactByEmailAndFullName($fullName: String!, $email: String!) {
  result: contactByEmailAndFullName(fullName: $fullName, email: $email) {
    ...ContactDetailsInvoicePreview
  }
}
    ${ContactDetailsInvoicePreviewFragmentDoc}`;

/**
 * __useContactByEmailAndFullNameQuery__
 *
 * To run a query within a React component, call `useContactByEmailAndFullNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactByEmailAndFullNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactByEmailAndFullNameQuery({
 *   variables: {
 *      fullName: // value for 'fullName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useContactByEmailAndFullNameQuery(baseOptions: Apollo.QueryHookOptions<IContactByEmailAndFullNameQuery, IContactByEmailAndFullNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContactByEmailAndFullNameQuery, IContactByEmailAndFullNameQueryVariables>(ContactByEmailAndFullNameDocument, options);
      }
export function useContactByEmailAndFullNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContactByEmailAndFullNameQuery, IContactByEmailAndFullNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContactByEmailAndFullNameQuery, IContactByEmailAndFullNameQueryVariables>(ContactByEmailAndFullNameDocument, options);
        }
export type ContactByEmailAndFullNameQueryHookResult = ReturnType<typeof useContactByEmailAndFullNameQuery>;
export type ContactByEmailAndFullNameLazyQueryHookResult = ReturnType<typeof useContactByEmailAndFullNameLazyQuery>;
export type ContactByEmailAndFullNameQueryResult = Apollo.QueryResult<IContactByEmailAndFullNameQuery, IContactByEmailAndFullNameQueryVariables>;
export const ContactDocument = gql`
    query contact($id: Int!) {
  result: contact(id: $id) {
    ...ContactDetails
    company {
      id
      name
      membership {
        id
        name
      }
      main_address {
        complete_vat_number
      }
    }
    contactMeetings {
      id
      name
      subject
      contacts {
        id
        fullName
      }
      meeting_type {
        id
        name
      }
      meeting_details
      location
      start_time
      end_time
    }
  }
}
    ${ContactDetailsFragmentDoc}`;

/**
 * __useContactQuery__
 *
 * To run a query within a React component, call `useContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactQuery(baseOptions: Apollo.QueryHookOptions<IContactQuery, IContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContactQuery, IContactQueryVariables>(ContactDocument, options);
      }
export function useContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContactQuery, IContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContactQuery, IContactQueryVariables>(ContactDocument, options);
        }
export type ContactQueryHookResult = ReturnType<typeof useContactQuery>;
export type ContactLazyQueryHookResult = ReturnType<typeof useContactLazyQuery>;
export type ContactQueryResult = Apollo.QueryResult<IContactQuery, IContactQueryVariables>;
export const ContactDetailsDocument = gql`
    query contactDetails($id: Int!) {
  result: contact(id: $id) {
    ...ContactFullScope
  }
}
    ${ContactFullScopeFragmentDoc}`;

/**
 * __useContactDetailsQuery__
 *
 * To run a query within a React component, call `useContactDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactDetailsQuery(baseOptions: Apollo.QueryHookOptions<IContactDetailsQuery, IContactDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContactDetailsQuery, IContactDetailsQueryVariables>(ContactDetailsDocument, options);
      }
export function useContactDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContactDetailsQuery, IContactDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContactDetailsQuery, IContactDetailsQueryVariables>(ContactDetailsDocument, options);
        }
export type ContactDetailsQueryHookResult = ReturnType<typeof useContactDetailsQuery>;
export type ContactDetailsLazyQueryHookResult = ReturnType<typeof useContactDetailsLazyQuery>;
export type ContactDetailsQueryResult = Apollo.QueryResult<IContactDetailsQuery, IContactDetailsQueryVariables>;
export const ContactBasicDataDocument = gql`
    query contactBasicData {
  result: contacts {
    id
    fullName
  }
}
    `;

/**
 * __useContactBasicDataQuery__
 *
 * To run a query within a React component, call `useContactBasicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactBasicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactBasicDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactBasicDataQuery(baseOptions?: Apollo.QueryHookOptions<IContactBasicDataQuery, IContactBasicDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContactBasicDataQuery, IContactBasicDataQueryVariables>(ContactBasicDataDocument, options);
      }
export function useContactBasicDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContactBasicDataQuery, IContactBasicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContactBasicDataQuery, IContactBasicDataQueryVariables>(ContactBasicDataDocument, options);
        }
export type ContactBasicDataQueryHookResult = ReturnType<typeof useContactBasicDataQuery>;
export type ContactBasicDataLazyQueryHookResult = ReturnType<typeof useContactBasicDataLazyQuery>;
export type ContactBasicDataQueryResult = Apollo.QueryResult<IContactBasicDataQuery, IContactBasicDataQueryVariables>;
export const AssistantContactsFromSameCompanyDocument = gql`
    query assistantContactsFromSameCompany($id: Int!, $company_id: Int!) {
  result: assistantContactsFromSameCompany(id: $id, company_id: $company_id) {
    id
    fullName
    email
    phone_direct
    phone_mobile
  }
}
    `;

/**
 * __useAssistantContactsFromSameCompanyQuery__
 *
 * To run a query within a React component, call `useAssistantContactsFromSameCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssistantContactsFromSameCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssistantContactsFromSameCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      company_id: // value for 'company_id'
 *   },
 * });
 */
export function useAssistantContactsFromSameCompanyQuery(baseOptions: Apollo.QueryHookOptions<IAssistantContactsFromSameCompanyQuery, IAssistantContactsFromSameCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAssistantContactsFromSameCompanyQuery, IAssistantContactsFromSameCompanyQueryVariables>(AssistantContactsFromSameCompanyDocument, options);
      }
export function useAssistantContactsFromSameCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAssistantContactsFromSameCompanyQuery, IAssistantContactsFromSameCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAssistantContactsFromSameCompanyQuery, IAssistantContactsFromSameCompanyQueryVariables>(AssistantContactsFromSameCompanyDocument, options);
        }
export type AssistantContactsFromSameCompanyQueryHookResult = ReturnType<typeof useAssistantContactsFromSameCompanyQuery>;
export type AssistantContactsFromSameCompanyLazyQueryHookResult = ReturnType<typeof useAssistantContactsFromSameCompanyLazyQuery>;
export type AssistantContactsFromSameCompanyQueryResult = Apollo.QueryResult<IAssistantContactsFromSameCompanyQuery, IAssistantContactsFromSameCompanyQueryVariables>;
export const ContactInterestsDocument = gql`
    query contactInterests($contact_id: Int!) {
  result: contactInterests(contact_id: $contact_id) {
    interest_id
  }
}
    `;

/**
 * __useContactInterestsQuery__
 *
 * To run a query within a React component, call `useContactInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactInterestsQuery({
 *   variables: {
 *      contact_id: // value for 'contact_id'
 *   },
 * });
 */
export function useContactInterestsQuery(baseOptions: Apollo.QueryHookOptions<IContactInterestsQuery, IContactInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContactInterestsQuery, IContactInterestsQueryVariables>(ContactInterestsDocument, options);
      }
export function useContactInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContactInterestsQuery, IContactInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContactInterestsQuery, IContactInterestsQueryVariables>(ContactInterestsDocument, options);
        }
export type ContactInterestsQueryHookResult = ReturnType<typeof useContactInterestsQuery>;
export type ContactInterestsLazyQueryHookResult = ReturnType<typeof useContactInterestsLazyQuery>;
export type ContactInterestsQueryResult = Apollo.QueryResult<IContactInterestsQuery, IContactInterestsQueryVariables>;
export const ContactsByInterestsDocument = gql`
    query contactsByInterests($interestIds: [Int!]!) {
  result: contactsByInterests(interestIds: $interestIds) {
    ...Recipients
  }
}
    ${RecipientsFragmentDoc}`;

/**
 * __useContactsByInterestsQuery__
 *
 * To run a query within a React component, call `useContactsByInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsByInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsByInterestsQuery({
 *   variables: {
 *      interestIds: // value for 'interestIds'
 *   },
 * });
 */
export function useContactsByInterestsQuery(baseOptions: Apollo.QueryHookOptions<IContactsByInterestsQuery, IContactsByInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContactsByInterestsQuery, IContactsByInterestsQueryVariables>(ContactsByInterestsDocument, options);
      }
export function useContactsByInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContactsByInterestsQuery, IContactsByInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContactsByInterestsQuery, IContactsByInterestsQueryVariables>(ContactsByInterestsDocument, options);
        }
export type ContactsByInterestsQueryHookResult = ReturnType<typeof useContactsByInterestsQuery>;
export type ContactsByInterestsLazyQueryHookResult = ReturnType<typeof useContactsByInterestsLazyQuery>;
export type ContactsByInterestsQueryResult = Apollo.QueryResult<IContactsByInterestsQuery, IContactsByInterestsQueryVariables>;
export const RecipientListContactsDocument = gql`
    query recipientListContacts($contactTitleIds: [Int]!, $companyTypeIds: [Int]!, $membershipTypeIds: [Int]!, $interestIds: [Int]!, $countryIds: [Int]!, $recipientListId: Int) {
  result: recipientListContacts(
    contactTitleIds: $contactTitleIds
    companyTypeIds: $companyTypeIds
    membershipTypeIds: $membershipTypeIds
    interestIds: $interestIds
    countryIds: $countryIds
    recipientListId: $recipientListId
  ) {
    ...Recipients
  }
}
    ${RecipientsFragmentDoc}`;

/**
 * __useRecipientListContactsQuery__
 *
 * To run a query within a React component, call `useRecipientListContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientListContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientListContactsQuery({
 *   variables: {
 *      contactTitleIds: // value for 'contactTitleIds'
 *      companyTypeIds: // value for 'companyTypeIds'
 *      membershipTypeIds: // value for 'membershipTypeIds'
 *      interestIds: // value for 'interestIds'
 *      countryIds: // value for 'countryIds'
 *      recipientListId: // value for 'recipientListId'
 *   },
 * });
 */
export function useRecipientListContactsQuery(baseOptions: Apollo.QueryHookOptions<IRecipientListContactsQuery, IRecipientListContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRecipientListContactsQuery, IRecipientListContactsQueryVariables>(RecipientListContactsDocument, options);
      }
export function useRecipientListContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRecipientListContactsQuery, IRecipientListContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRecipientListContactsQuery, IRecipientListContactsQueryVariables>(RecipientListContactsDocument, options);
        }
export type RecipientListContactsQueryHookResult = ReturnType<typeof useRecipientListContactsQuery>;
export type RecipientListContactsLazyQueryHookResult = ReturnType<typeof useRecipientListContactsLazyQuery>;
export type RecipientListContactsQueryResult = Apollo.QueryResult<IRecipientListContactsQuery, IRecipientListContactsQueryVariables>;
export const DeleteContactDocument = gql`
    mutation deleteContact($id: Int!, $can_delete_last: Boolean) {
  result: deleteContact(id: $id, can_delete_last: $can_delete_last)
}
    `;
export type IDeleteContactMutationFn = Apollo.MutationFunction<IDeleteContactMutation, IDeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      can_delete_last: // value for 'can_delete_last'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteContactMutation, IDeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteContactMutation, IDeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<IDeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<IDeleteContactMutation, IDeleteContactMutationVariables>;
export const CreateContactDocument = gql`
    mutation createContact($input: ContactCreateInput!) {
  result: createContact(input: $input) {
    ...ContactDetails
    phone_direct
    company {
      id
      name
    }
  }
}
    ${ContactDetailsFragmentDoc}`;
export type ICreateContactMutationFn = Apollo.MutationFunction<ICreateContactMutation, ICreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<ICreateContactMutation, ICreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateContactMutation, ICreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<ICreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<ICreateContactMutation, ICreateContactMutationVariables>;
export const UpdateContactDetailsDocument = gql`
    mutation updateContactDetails($id: Int!, $input: ContactInput!) {
  result: updateContactDetails(id: $id, input: $input) {
    ...ContactFullScope
  }
}
    ${ContactFullScopeFragmentDoc}`;
export type IUpdateContactDetailsMutationFn = Apollo.MutationFunction<IUpdateContactDetailsMutation, IUpdateContactDetailsMutationVariables>;

/**
 * __useUpdateContactDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateContactDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactDetailsMutation, { data, loading, error }] = useUpdateContactDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactDetailsMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateContactDetailsMutation, IUpdateContactDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateContactDetailsMutation, IUpdateContactDetailsMutationVariables>(UpdateContactDetailsDocument, options);
      }
export type UpdateContactDetailsMutationHookResult = ReturnType<typeof useUpdateContactDetailsMutation>;
export type UpdateContactDetailsMutationResult = Apollo.MutationResult<IUpdateContactDetailsMutation>;
export type UpdateContactDetailsMutationOptions = Apollo.BaseMutationOptions<IUpdateContactDetailsMutation, IUpdateContactDetailsMutationVariables>;
export const UpdateContactAddressDocument = gql`
    mutation updateContactAddress($id: Int!, $company_id: Int!, $address_id: Int) {
  result: updateContactAddress(
    id: $id
    company_id: $company_id
    address_id: $address_id
  ) {
    ...ContactFullScope
  }
}
    ${ContactFullScopeFragmentDoc}`;
export type IUpdateContactAddressMutationFn = Apollo.MutationFunction<IUpdateContactAddressMutation, IUpdateContactAddressMutationVariables>;

/**
 * __useUpdateContactAddressMutation__
 *
 * To run a mutation, you first call `useUpdateContactAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactAddressMutation, { data, loading, error }] = useUpdateContactAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      company_id: // value for 'company_id'
 *      address_id: // value for 'address_id'
 *   },
 * });
 */
export function useUpdateContactAddressMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateContactAddressMutation, IUpdateContactAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateContactAddressMutation, IUpdateContactAddressMutationVariables>(UpdateContactAddressDocument, options);
      }
export type UpdateContactAddressMutationHookResult = ReturnType<typeof useUpdateContactAddressMutation>;
export type UpdateContactAddressMutationResult = Apollo.MutationResult<IUpdateContactAddressMutation>;
export type UpdateContactAddressMutationOptions = Apollo.BaseMutationOptions<IUpdateContactAddressMutation, IUpdateContactAddressMutationVariables>;
export const UpdateContactAssistantDocument = gql`
    mutation updateContactAssistant($id: Int!, $assistantId: Int) {
  result: updateContactAssistant(id: $id, assistantId: $assistantId) {
    ...ContactFullScope
  }
}
    ${ContactFullScopeFragmentDoc}`;
export type IUpdateContactAssistantMutationFn = Apollo.MutationFunction<IUpdateContactAssistantMutation, IUpdateContactAssistantMutationVariables>;

/**
 * __useUpdateContactAssistantMutation__
 *
 * To run a mutation, you first call `useUpdateContactAssistantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactAssistantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactAssistantMutation, { data, loading, error }] = useUpdateContactAssistantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assistantId: // value for 'assistantId'
 *   },
 * });
 */
export function useUpdateContactAssistantMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateContactAssistantMutation, IUpdateContactAssistantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateContactAssistantMutation, IUpdateContactAssistantMutationVariables>(UpdateContactAssistantDocument, options);
      }
export type UpdateContactAssistantMutationHookResult = ReturnType<typeof useUpdateContactAssistantMutation>;
export type UpdateContactAssistantMutationResult = Apollo.MutationResult<IUpdateContactAssistantMutation>;
export type UpdateContactAssistantMutationOptions = Apollo.BaseMutationOptions<IUpdateContactAssistantMutation, IUpdateContactAssistantMutationVariables>;
export const SetInvoiceToContactDocument = gql`
    mutation setInvoiceToContact($id: Int!, $is_main: Boolean!) {
  result: setInvoiceToContact(id: $id, is_main: $is_main) {
    id
    is_main
    fullName
    email
    titleInternal {
      id
      name
    }
    address {
      id
      street
    }
    company {
      id
      name
    }
  }
}
    `;
export type ISetInvoiceToContactMutationFn = Apollo.MutationFunction<ISetInvoiceToContactMutation, ISetInvoiceToContactMutationVariables>;

/**
 * __useSetInvoiceToContactMutation__
 *
 * To run a mutation, you first call `useSetInvoiceToContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInvoiceToContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInvoiceToContactMutation, { data, loading, error }] = useSetInvoiceToContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_main: // value for 'is_main'
 *   },
 * });
 */
export function useSetInvoiceToContactMutation(baseOptions?: Apollo.MutationHookOptions<ISetInvoiceToContactMutation, ISetInvoiceToContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISetInvoiceToContactMutation, ISetInvoiceToContactMutationVariables>(SetInvoiceToContactDocument, options);
      }
export type SetInvoiceToContactMutationHookResult = ReturnType<typeof useSetInvoiceToContactMutation>;
export type SetInvoiceToContactMutationResult = Apollo.MutationResult<ISetInvoiceToContactMutation>;
export type SetInvoiceToContactMutationOptions = Apollo.BaseMutationOptions<ISetInvoiceToContactMutation, ISetInvoiceToContactMutationVariables>;
export const UpdateContactInterestsDocument = gql`
    mutation updateContactInterests($id: Int!, $interest_ids: [Int]!) {
  result: updateContactInterests(contact_id: $id, interest_ids: $interest_ids)
}
    `;
export type IUpdateContactInterestsMutationFn = Apollo.MutationFunction<IUpdateContactInterestsMutation, IUpdateContactInterestsMutationVariables>;

/**
 * __useUpdateContactInterestsMutation__
 *
 * To run a mutation, you first call `useUpdateContactInterestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactInterestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactInterestsMutation, { data, loading, error }] = useUpdateContactInterestsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      interest_ids: // value for 'interest_ids'
 *   },
 * });
 */
export function useUpdateContactInterestsMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateContactInterestsMutation, IUpdateContactInterestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateContactInterestsMutation, IUpdateContactInterestsMutationVariables>(UpdateContactInterestsDocument, options);
      }
export type UpdateContactInterestsMutationHookResult = ReturnType<typeof useUpdateContactInterestsMutation>;
export type UpdateContactInterestsMutationResult = Apollo.MutationResult<IUpdateContactInterestsMutation>;
export type UpdateContactInterestsMutationOptions = Apollo.BaseMutationOptions<IUpdateContactInterestsMutation, IUpdateContactInterestsMutationVariables>;
export const ContactDeletedDocument = gql`
    subscription ContactDeleted {
  result: contactDeleted {
    id
  }
}
    `;

/**
 * __useContactDeletedSubscription__
 *
 * To run a query within a React component, call `useContactDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContactDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useContactDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IContactDeletedSubscription, IContactDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IContactDeletedSubscription, IContactDeletedSubscriptionVariables>(ContactDeletedDocument, options);
      }
export type ContactDeletedSubscriptionHookResult = ReturnType<typeof useContactDeletedSubscription>;
export type ContactDeletedSubscriptionResult = Apollo.SubscriptionResult<IContactDeletedSubscription>;
export const ContactCreatedDocument = gql`
    subscription ContactCreated {
  result: contactCreated {
    ...ContactDetails
    phone_direct
    company {
      id
      name
    }
  }
}
    ${ContactDetailsFragmentDoc}`;

/**
 * __useContactCreatedSubscription__
 *
 * To run a query within a React component, call `useContactCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContactCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useContactCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IContactCreatedSubscription, IContactCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IContactCreatedSubscription, IContactCreatedSubscriptionVariables>(ContactCreatedDocument, options);
      }
export type ContactCreatedSubscriptionHookResult = ReturnType<typeof useContactCreatedSubscription>;
export type ContactCreatedSubscriptionResult = Apollo.SubscriptionResult<IContactCreatedSubscription>;
export const ContactUpdatedDocument = gql`
    subscription ContactUpdated {
  result: contactUpdated {
    ...ContactDetails
    phone_direct
    company {
      id
      name
    }
  }
}
    ${ContactDetailsFragmentDoc}`;

/**
 * __useContactUpdatedSubscription__
 *
 * To run a query within a React component, call `useContactUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContactUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useContactUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IContactUpdatedSubscription, IContactUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IContactUpdatedSubscription, IContactUpdatedSubscriptionVariables>(ContactUpdatedDocument, options);
      }
export type ContactUpdatedSubscriptionHookResult = ReturnType<typeof useContactUpdatedSubscription>;
export type ContactUpdatedSubscriptionResult = Apollo.SubscriptionResult<IContactUpdatedSubscription>;
export const CountriesDocument = gql`
    query countries {
  result: countries {
    id
    name
    code
    region {
      id
    }
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<ICountriesQuery, ICountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICountriesQuery, ICountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICountriesQuery, ICountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICountriesQuery, ICountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<ICountriesQuery, ICountriesQueryVariables>;
export const CountryNamesDocument = gql`
    query countryNames {
  result: countries {
    id
    name
  }
}
    `;

/**
 * __useCountryNamesQuery__
 *
 * To run a query within a React component, call `useCountryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountryNamesQuery(baseOptions?: Apollo.QueryHookOptions<ICountryNamesQuery, ICountryNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICountryNamesQuery, ICountryNamesQueryVariables>(CountryNamesDocument, options);
      }
export function useCountryNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICountryNamesQuery, ICountryNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICountryNamesQuery, ICountryNamesQueryVariables>(CountryNamesDocument, options);
        }
export type CountryNamesQueryHookResult = ReturnType<typeof useCountryNamesQuery>;
export type CountryNamesLazyQueryHookResult = ReturnType<typeof useCountryNamesLazyQuery>;
export type CountryNamesQueryResult = Apollo.QueryResult<ICountryNamesQuery, ICountryNamesQueryVariables>;
export const CurrenciesDocument = gql`
    query currencies {
  result: currencies {
    id
    name
    code
  }
}
    `;

/**
 * __useCurrenciesQuery__
 *
 * To run a query within a React component, call `useCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<ICurrenciesQuery, ICurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICurrenciesQuery, ICurrenciesQueryVariables>(CurrenciesDocument, options);
      }
export function useCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICurrenciesQuery, ICurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICurrenciesQuery, ICurrenciesQueryVariables>(CurrenciesDocument, options);
        }
export type CurrenciesQueryHookResult = ReturnType<typeof useCurrenciesQuery>;
export type CurrenciesLazyQueryHookResult = ReturnType<typeof useCurrenciesLazyQuery>;
export type CurrenciesQueryResult = Apollo.QueryResult<ICurrenciesQuery, ICurrenciesQueryVariables>;
export const GetAllCventEventsDocument = gql`
    query getAllCventEvents {
  result: getAllCventEvents {
    ...CventEventDetails
  }
}
    ${CventEventDetailsFragmentDoc}`;

/**
 * __useGetAllCventEventsQuery__
 *
 * To run a query within a React component, call `useGetAllCventEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCventEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCventEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCventEventsQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllCventEventsQuery, IGetAllCventEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllCventEventsQuery, IGetAllCventEventsQueryVariables>(GetAllCventEventsDocument, options);
      }
export function useGetAllCventEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllCventEventsQuery, IGetAllCventEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllCventEventsQuery, IGetAllCventEventsQueryVariables>(GetAllCventEventsDocument, options);
        }
export type GetAllCventEventsQueryHookResult = ReturnType<typeof useGetAllCventEventsQuery>;
export type GetAllCventEventsLazyQueryHookResult = ReturnType<typeof useGetAllCventEventsLazyQuery>;
export type GetAllCventEventsQueryResult = Apollo.QueryResult<IGetAllCventEventsQuery, IGetAllCventEventsQueryVariables>;
export const GetAllCventRolesDocument = gql`
    query getAllCventRoles {
  result: getAllCventRoles {
    ...CventRolesDetails
  }
}
    ${CventRolesDetailsFragmentDoc}`;

/**
 * __useGetAllCventRolesQuery__
 *
 * To run a query within a React component, call `useGetAllCventRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCventRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCventRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCventRolesQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllCventRolesQuery, IGetAllCventRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllCventRolesQuery, IGetAllCventRolesQueryVariables>(GetAllCventRolesDocument, options);
      }
export function useGetAllCventRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllCventRolesQuery, IGetAllCventRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllCventRolesQuery, IGetAllCventRolesQueryVariables>(GetAllCventRolesDocument, options);
        }
export type GetAllCventRolesQueryHookResult = ReturnType<typeof useGetAllCventRolesQuery>;
export type GetAllCventRolesLazyQueryHookResult = ReturnType<typeof useGetAllCventRolesLazyQuery>;
export type GetAllCventRolesQueryResult = Apollo.QueryResult<IGetAllCventRolesQuery, IGetAllCventRolesQueryVariables>;
export const GetAllCventContactsDocument = gql`
    query getAllCventContacts {
  result: getAllCventContacts {
    ...CventContactDetails
  }
}
    ${CventContactDetailsFragmentDoc}`;

/**
 * __useGetAllCventContactsQuery__
 *
 * To run a query within a React component, call `useGetAllCventContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCventContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCventContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCventContactsQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllCventContactsQuery, IGetAllCventContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllCventContactsQuery, IGetAllCventContactsQueryVariables>(GetAllCventContactsDocument, options);
      }
export function useGetAllCventContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllCventContactsQuery, IGetAllCventContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllCventContactsQuery, IGetAllCventContactsQueryVariables>(GetAllCventContactsDocument, options);
        }
export type GetAllCventContactsQueryHookResult = ReturnType<typeof useGetAllCventContactsQuery>;
export type GetAllCventContactsLazyQueryHookResult = ReturnType<typeof useGetAllCventContactsLazyQuery>;
export type GetAllCventContactsQueryResult = Apollo.QueryResult<IGetAllCventContactsQuery, IGetAllCventContactsQueryVariables>;
export const GetAllCventContactsForLocationDocument = gql`
    query getAllCventContactsForLocation($id: ID!) {
  result: getAllCventContactsForLocation(id: $id) {
    ...CventContactDetails
  }
}
    ${CventContactDetailsFragmentDoc}`;

/**
 * __useGetAllCventContactsForLocationQuery__
 *
 * To run a query within a React component, call `useGetAllCventContactsForLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCventContactsForLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCventContactsForLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllCventContactsForLocationQuery(baseOptions: Apollo.QueryHookOptions<IGetAllCventContactsForLocationQuery, IGetAllCventContactsForLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllCventContactsForLocationQuery, IGetAllCventContactsForLocationQueryVariables>(GetAllCventContactsForLocationDocument, options);
      }
export function useGetAllCventContactsForLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllCventContactsForLocationQuery, IGetAllCventContactsForLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllCventContactsForLocationQuery, IGetAllCventContactsForLocationQueryVariables>(GetAllCventContactsForLocationDocument, options);
        }
export type GetAllCventContactsForLocationQueryHookResult = ReturnType<typeof useGetAllCventContactsForLocationQuery>;
export type GetAllCventContactsForLocationLazyQueryHookResult = ReturnType<typeof useGetAllCventContactsForLocationLazyQuery>;
export type GetAllCventContactsForLocationQueryResult = Apollo.QueryResult<IGetAllCventContactsForLocationQuery, IGetAllCventContactsForLocationQueryVariables>;
export const GetAllLocationsForEventDocument = gql`
    query getAllLocationsForEvent($event_id: ID!) {
  result: getAllLocationsForEvent(event_id: $event_id) {
    ...CventLocationDetails
  }
}
    ${CventLocationDetailsFragmentDoc}`;

/**
 * __useGetAllLocationsForEventQuery__
 *
 * To run a query within a React component, call `useGetAllLocationsForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationsForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationsForEventQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetAllLocationsForEventQuery(baseOptions: Apollo.QueryHookOptions<IGetAllLocationsForEventQuery, IGetAllLocationsForEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllLocationsForEventQuery, IGetAllLocationsForEventQueryVariables>(GetAllLocationsForEventDocument, options);
      }
export function useGetAllLocationsForEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllLocationsForEventQuery, IGetAllLocationsForEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllLocationsForEventQuery, IGetAllLocationsForEventQueryVariables>(GetAllLocationsForEventDocument, options);
        }
export type GetAllLocationsForEventQueryHookResult = ReturnType<typeof useGetAllLocationsForEventQuery>;
export type GetAllLocationsForEventLazyQueryHookResult = ReturnType<typeof useGetAllLocationsForEventLazyQuery>;
export type GetAllLocationsForEventQueryResult = Apollo.QueryResult<IGetAllLocationsForEventQuery, IGetAllLocationsForEventQueryVariables>;
export const GetMatchedDbContactsByEmailDocument = gql`
    query getMatchedDbContactsByEmail($id: ID!, $input: LinkContact!) {
  result: getMatchedDbContactsByEmail(id: $id, input: $input) {
    ...DbContactDetails
  }
}
    ${DbContactDetailsFragmentDoc}`;

/**
 * __useGetMatchedDbContactsByEmailQuery__
 *
 * To run a query within a React component, call `useGetMatchedDbContactsByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchedDbContactsByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchedDbContactsByEmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMatchedDbContactsByEmailQuery(baseOptions: Apollo.QueryHookOptions<IGetMatchedDbContactsByEmailQuery, IGetMatchedDbContactsByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetMatchedDbContactsByEmailQuery, IGetMatchedDbContactsByEmailQueryVariables>(GetMatchedDbContactsByEmailDocument, options);
      }
export function useGetMatchedDbContactsByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetMatchedDbContactsByEmailQuery, IGetMatchedDbContactsByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetMatchedDbContactsByEmailQuery, IGetMatchedDbContactsByEmailQueryVariables>(GetMatchedDbContactsByEmailDocument, options);
        }
export type GetMatchedDbContactsByEmailQueryHookResult = ReturnType<typeof useGetMatchedDbContactsByEmailQuery>;
export type GetMatchedDbContactsByEmailLazyQueryHookResult = ReturnType<typeof useGetMatchedDbContactsByEmailLazyQuery>;
export type GetMatchedDbContactsByEmailQueryResult = Apollo.QueryResult<IGetMatchedDbContactsByEmailQuery, IGetMatchedDbContactsByEmailQueryVariables>;
export const CreateCventContactDocument = gql`
    mutation createCventContact($input: AddCventContact!) {
  result: createCventContact(input: $input) {
    ...CventContactDetails
  }
}
    ${CventContactDetailsFragmentDoc}`;
export type ICreateCventContactMutationFn = Apollo.MutationFunction<ICreateCventContactMutation, ICreateCventContactMutationVariables>;

/**
 * __useCreateCventContactMutation__
 *
 * To run a mutation, you first call `useCreateCventContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCventContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCventContactMutation, { data, loading, error }] = useCreateCventContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCventContactMutation(baseOptions?: Apollo.MutationHookOptions<ICreateCventContactMutation, ICreateCventContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateCventContactMutation, ICreateCventContactMutationVariables>(CreateCventContactDocument, options);
      }
export type CreateCventContactMutationHookResult = ReturnType<typeof useCreateCventContactMutation>;
export type CreateCventContactMutationResult = Apollo.MutationResult<ICreateCventContactMutation>;
export type CreateCventContactMutationOptions = Apollo.BaseMutationOptions<ICreateCventContactMutation, ICreateCventContactMutationVariables>;
export const UpdateCventContactDocument = gql`
    mutation updateCventContact($id: ID!, $input: AddCventContact!) {
  result: updateCventContact(id: $id, input: $input) {
    ...CventContactDetails
  }
}
    ${CventContactDetailsFragmentDoc}`;
export type IUpdateCventContactMutationFn = Apollo.MutationFunction<IUpdateCventContactMutation, IUpdateCventContactMutationVariables>;

/**
 * __useUpdateCventContactMutation__
 *
 * To run a mutation, you first call `useUpdateCventContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCventContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCventContactMutation, { data, loading, error }] = useUpdateCventContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCventContactMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCventContactMutation, IUpdateCventContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCventContactMutation, IUpdateCventContactMutationVariables>(UpdateCventContactDocument, options);
      }
export type UpdateCventContactMutationHookResult = ReturnType<typeof useUpdateCventContactMutation>;
export type UpdateCventContactMutationResult = Apollo.MutationResult<IUpdateCventContactMutation>;
export type UpdateCventContactMutationOptions = Apollo.BaseMutationOptions<IUpdateCventContactMutation, IUpdateCventContactMutationVariables>;
export const DeleteCventContactDocument = gql`
    mutation deleteCventContact($id: Int!) {
  result: deleteCventContact(id: $id)
}
    `;
export type IDeleteCventContactMutationFn = Apollo.MutationFunction<IDeleteCventContactMutation, IDeleteCventContactMutationVariables>;

/**
 * __useDeleteCventContactMutation__
 *
 * To run a mutation, you first call `useDeleteCventContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCventContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCventContactMutation, { data, loading, error }] = useDeleteCventContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCventContactMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteCventContactMutation, IDeleteCventContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteCventContactMutation, IDeleteCventContactMutationVariables>(DeleteCventContactDocument, options);
      }
export type DeleteCventContactMutationHookResult = ReturnType<typeof useDeleteCventContactMutation>;
export type DeleteCventContactMutationResult = Apollo.MutationResult<IDeleteCventContactMutation>;
export type DeleteCventContactMutationOptions = Apollo.BaseMutationOptions<IDeleteCventContactMutation, IDeleteCventContactMutationVariables>;
export const LinkContactDocument = gql`
    mutation linkContact($id: ID!, $input: LinkContact!) {
  result: linkContact(id: $id, input: $input) {
    ...CventContactDetails
  }
}
    ${CventContactDetailsFragmentDoc}`;
export type ILinkContactMutationFn = Apollo.MutationFunction<ILinkContactMutation, ILinkContactMutationVariables>;

/**
 * __useLinkContactMutation__
 *
 * To run a mutation, you first call `useLinkContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkContactMutation, { data, loading, error }] = useLinkContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkContactMutation(baseOptions?: Apollo.MutationHookOptions<ILinkContactMutation, ILinkContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ILinkContactMutation, ILinkContactMutationVariables>(LinkContactDocument, options);
      }
export type LinkContactMutationHookResult = ReturnType<typeof useLinkContactMutation>;
export type LinkContactMutationResult = Apollo.MutationResult<ILinkContactMutation>;
export type LinkContactMutationOptions = Apollo.BaseMutationOptions<ILinkContactMutation, ILinkContactMutationVariables>;
export const UnLinkContactDocument = gql`
    mutation unLinkContact($id: ID!) {
  result: unLinkContact(id: $id) {
    ...CventContactDetails
  }
}
    ${CventContactDetailsFragmentDoc}`;
export type IUnLinkContactMutationFn = Apollo.MutationFunction<IUnLinkContactMutation, IUnLinkContactMutationVariables>;

/**
 * __useUnLinkContactMutation__
 *
 * To run a mutation, you first call `useUnLinkContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnLinkContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unLinkContactMutation, { data, loading, error }] = useUnLinkContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnLinkContactMutation(baseOptions?: Apollo.MutationHookOptions<IUnLinkContactMutation, IUnLinkContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUnLinkContactMutation, IUnLinkContactMutationVariables>(UnLinkContactDocument, options);
      }
export type UnLinkContactMutationHookResult = ReturnType<typeof useUnLinkContactMutation>;
export type UnLinkContactMutationResult = Apollo.MutationResult<IUnLinkContactMutation>;
export type UnLinkContactMutationOptions = Apollo.BaseMutationOptions<IUnLinkContactMutation, IUnLinkContactMutationVariables>;
export const ToggleIsApprovedDocument = gql`
    mutation toggleIsApproved($id: ID!, $input: IsApproved!) {
  result: toggleIsApproved(id: $id, input: $input) {
    ...CventContactDetails
  }
}
    ${CventContactDetailsFragmentDoc}`;
export type IToggleIsApprovedMutationFn = Apollo.MutationFunction<IToggleIsApprovedMutation, IToggleIsApprovedMutationVariables>;

/**
 * __useToggleIsApprovedMutation__
 *
 * To run a mutation, you first call `useToggleIsApprovedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIsApprovedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIsApprovedMutation, { data, loading, error }] = useToggleIsApprovedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleIsApprovedMutation(baseOptions?: Apollo.MutationHookOptions<IToggleIsApprovedMutation, IToggleIsApprovedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IToggleIsApprovedMutation, IToggleIsApprovedMutationVariables>(ToggleIsApprovedDocument, options);
      }
export type ToggleIsApprovedMutationHookResult = ReturnType<typeof useToggleIsApprovedMutation>;
export type ToggleIsApprovedMutationResult = Apollo.MutationResult<IToggleIsApprovedMutation>;
export type ToggleIsApprovedMutationOptions = Apollo.BaseMutationOptions<IToggleIsApprovedMutation, IToggleIsApprovedMutationVariables>;
export const UploadCventContactsDocument = gql`
    mutation uploadCventContacts($location: String!, $input: [cventFileInput]) {
  result: uploadCventContacts(location: $location, input: $input) {
    event {
      ...CventEventDetails
    }
    location {
      ...CventLocationDetails
    }
  }
}
    ${CventEventDetailsFragmentDoc}
${CventLocationDetailsFragmentDoc}`;
export type IUploadCventContactsMutationFn = Apollo.MutationFunction<IUploadCventContactsMutation, IUploadCventContactsMutationVariables>;

/**
 * __useUploadCventContactsMutation__
 *
 * To run a mutation, you first call `useUploadCventContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCventContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCventContactsMutation, { data, loading, error }] = useUploadCventContactsMutation({
 *   variables: {
 *      location: // value for 'location'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCventContactsMutation(baseOptions?: Apollo.MutationHookOptions<IUploadCventContactsMutation, IUploadCventContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUploadCventContactsMutation, IUploadCventContactsMutationVariables>(UploadCventContactsDocument, options);
      }
export type UploadCventContactsMutationHookResult = ReturnType<typeof useUploadCventContactsMutation>;
export type UploadCventContactsMutationResult = Apollo.MutationResult<IUploadCventContactsMutation>;
export type UploadCventContactsMutationOptions = Apollo.BaseMutationOptions<IUploadCventContactsMutation, IUploadCventContactsMutationVariables>;
export const DashboardDoughnutQueryDocument = gql`
    query dashboardDoughnutQuery {
  result: dashboardDoughnutQuery {
    count
    membership_type
    label
  }
}
    `;

/**
 * __useDashboardDoughnutQueryQuery__
 *
 * To run a query within a React component, call `useDashboardDoughnutQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardDoughnutQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardDoughnutQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardDoughnutQueryQuery(baseOptions?: Apollo.QueryHookOptions<IDashboardDoughnutQueryQuery, IDashboardDoughnutQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IDashboardDoughnutQueryQuery, IDashboardDoughnutQueryQueryVariables>(DashboardDoughnutQueryDocument, options);
      }
export function useDashboardDoughnutQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IDashboardDoughnutQueryQuery, IDashboardDoughnutQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IDashboardDoughnutQueryQuery, IDashboardDoughnutQueryQueryVariables>(DashboardDoughnutQueryDocument, options);
        }
export type DashboardDoughnutQueryQueryHookResult = ReturnType<typeof useDashboardDoughnutQueryQuery>;
export type DashboardDoughnutQueryLazyQueryHookResult = ReturnType<typeof useDashboardDoughnutQueryLazyQuery>;
export type DashboardDoughnutQueryQueryResult = Apollo.QueryResult<IDashboardDoughnutQueryQuery, IDashboardDoughnutQueryQueryVariables>;
export const DashboardMembershipsInfoForTheLastThreeYearsDocument = gql`
    query dashboardMembershipsInfoForTheLastThreeYears {
  result: dashboardMembershipsInfoForTheLastThreeYears {
    quarters_date
    started_memberships_count
    renewed_memberships_count
    ended_memberships_count
    startedLegend
    renewedLegend
    endedLegend
  }
}
    `;

/**
 * __useDashboardMembershipsInfoForTheLastThreeYearsQuery__
 *
 * To run a query within a React component, call `useDashboardMembershipsInfoForTheLastThreeYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardMembershipsInfoForTheLastThreeYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardMembershipsInfoForTheLastThreeYearsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardMembershipsInfoForTheLastThreeYearsQuery(baseOptions?: Apollo.QueryHookOptions<IDashboardMembershipsInfoForTheLastThreeYearsQuery, IDashboardMembershipsInfoForTheLastThreeYearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IDashboardMembershipsInfoForTheLastThreeYearsQuery, IDashboardMembershipsInfoForTheLastThreeYearsQueryVariables>(DashboardMembershipsInfoForTheLastThreeYearsDocument, options);
      }
export function useDashboardMembershipsInfoForTheLastThreeYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IDashboardMembershipsInfoForTheLastThreeYearsQuery, IDashboardMembershipsInfoForTheLastThreeYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IDashboardMembershipsInfoForTheLastThreeYearsQuery, IDashboardMembershipsInfoForTheLastThreeYearsQueryVariables>(DashboardMembershipsInfoForTheLastThreeYearsDocument, options);
        }
export type DashboardMembershipsInfoForTheLastThreeYearsQueryHookResult = ReturnType<typeof useDashboardMembershipsInfoForTheLastThreeYearsQuery>;
export type DashboardMembershipsInfoForTheLastThreeYearsLazyQueryHookResult = ReturnType<typeof useDashboardMembershipsInfoForTheLastThreeYearsLazyQuery>;
export type DashboardMembershipsInfoForTheLastThreeYearsQueryResult = Apollo.QueryResult<IDashboardMembershipsInfoForTheLastThreeYearsQuery, IDashboardMembershipsInfoForTheLastThreeYearsQueryVariables>;
export const DashboardInvoicesInfoDocument = gql`
    query dashboardInvoicesInfo {
  result: dashboardInvoicesInfo {
    date
    issued_invoices
    paid_invoices
    outstanding
    total_issued_invoices_count
    total_paid_invoices_count
  }
}
    `;

/**
 * __useDashboardInvoicesInfoQuery__
 *
 * To run a query within a React component, call `useDashboardInvoicesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardInvoicesInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardInvoicesInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardInvoicesInfoQuery(baseOptions?: Apollo.QueryHookOptions<IDashboardInvoicesInfoQuery, IDashboardInvoicesInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IDashboardInvoicesInfoQuery, IDashboardInvoicesInfoQueryVariables>(DashboardInvoicesInfoDocument, options);
      }
export function useDashboardInvoicesInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IDashboardInvoicesInfoQuery, IDashboardInvoicesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IDashboardInvoicesInfoQuery, IDashboardInvoicesInfoQueryVariables>(DashboardInvoicesInfoDocument, options);
        }
export type DashboardInvoicesInfoQueryHookResult = ReturnType<typeof useDashboardInvoicesInfoQuery>;
export type DashboardInvoicesInfoLazyQueryHookResult = ReturnType<typeof useDashboardInvoicesInfoLazyQuery>;
export type DashboardInvoicesInfoQueryResult = Apollo.QueryResult<IDashboardInvoicesInfoQuery, IDashboardInvoicesInfoQueryVariables>;
export const GetDividendsGrossDocument = gql`
    query getDividendsGross($stock_id: Int!) {
  result: getDividendsGross(stock_id: $stock_id) {
    ...DividendDetails
  }
}
    ${DividendDetailsFragmentDoc}`;

/**
 * __useGetDividendsGrossQuery__
 *
 * To run a query within a React component, call `useGetDividendsGrossQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDividendsGrossQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDividendsGrossQuery({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useGetDividendsGrossQuery(baseOptions: Apollo.QueryHookOptions<IGetDividendsGrossQuery, IGetDividendsGrossQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetDividendsGrossQuery, IGetDividendsGrossQueryVariables>(GetDividendsGrossDocument, options);
      }
export function useGetDividendsGrossLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetDividendsGrossQuery, IGetDividendsGrossQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetDividendsGrossQuery, IGetDividendsGrossQueryVariables>(GetDividendsGrossDocument, options);
        }
export type GetDividendsGrossQueryHookResult = ReturnType<typeof useGetDividendsGrossQuery>;
export type GetDividendsGrossLazyQueryHookResult = ReturnType<typeof useGetDividendsGrossLazyQuery>;
export type GetDividendsGrossQueryResult = Apollo.QueryResult<IGetDividendsGrossQuery, IGetDividendsGrossQueryVariables>;
export const CreateDividendDocument = gql`
    mutation createDividend($stock_id: ID!, $input: DividendInput!) {
  result: createDividend(stock_id: $stock_id, input: $input) {
    ...DividendDetails
  }
}
    ${DividendDetailsFragmentDoc}`;
export type ICreateDividendMutationFn = Apollo.MutationFunction<ICreateDividendMutation, ICreateDividendMutationVariables>;

/**
 * __useCreateDividendMutation__
 *
 * To run a mutation, you first call `useCreateDividendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDividendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDividendMutation, { data, loading, error }] = useCreateDividendMutation({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDividendMutation(baseOptions?: Apollo.MutationHookOptions<ICreateDividendMutation, ICreateDividendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateDividendMutation, ICreateDividendMutationVariables>(CreateDividendDocument, options);
      }
export type CreateDividendMutationHookResult = ReturnType<typeof useCreateDividendMutation>;
export type CreateDividendMutationResult = Apollo.MutationResult<ICreateDividendMutation>;
export type CreateDividendMutationOptions = Apollo.BaseMutationOptions<ICreateDividendMutation, ICreateDividendMutationVariables>;
export const UpdateDividendDocument = gql`
    mutation updateDividend($id: ID!, $input: DividendInput!) {
  result: updateDividend(id: $id, input: $input) {
    ...DividendDetails
  }
}
    ${DividendDetailsFragmentDoc}`;
export type IUpdateDividendMutationFn = Apollo.MutationFunction<IUpdateDividendMutation, IUpdateDividendMutationVariables>;

/**
 * __useUpdateDividendMutation__
 *
 * To run a mutation, you first call `useUpdateDividendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDividendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDividendMutation, { data, loading, error }] = useUpdateDividendMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDividendMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateDividendMutation, IUpdateDividendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateDividendMutation, IUpdateDividendMutationVariables>(UpdateDividendDocument, options);
      }
export type UpdateDividendMutationHookResult = ReturnType<typeof useUpdateDividendMutation>;
export type UpdateDividendMutationResult = Apollo.MutationResult<IUpdateDividendMutation>;
export type UpdateDividendMutationOptions = Apollo.BaseMutationOptions<IUpdateDividendMutation, IUpdateDividendMutationVariables>;
export const DeleteDividendDocument = gql`
    mutation deleteDividend($id: ID!) {
  result: deleteDividend(id: $id)
}
    `;
export type IDeleteDividendMutationFn = Apollo.MutationFunction<IDeleteDividendMutation, IDeleteDividendMutationVariables>;

/**
 * __useDeleteDividendMutation__
 *
 * To run a mutation, you first call `useDeleteDividendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDividendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDividendMutation, { data, loading, error }] = useDeleteDividendMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDividendMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteDividendMutation, IDeleteDividendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteDividendMutation, IDeleteDividendMutationVariables>(DeleteDividendDocument, options);
      }
export type DeleteDividendMutationHookResult = ReturnType<typeof useDeleteDividendMutation>;
export type DeleteDividendMutationResult = Apollo.MutationResult<IDeleteDividendMutation>;
export type DeleteDividendMutationOptions = Apollo.BaseMutationOptions<IDeleteDividendMutation, IDeleteDividendMutationVariables>;
export const DividendCreatedDocument = gql`
    subscription dividendCreated($stock_id: ID!) {
  result: dividendCreated(stock_id: $stock_id) {
    ...DividendDetails
  }
}
    ${DividendDetailsFragmentDoc}`;

/**
 * __useDividendCreatedSubscription__
 *
 * To run a query within a React component, call `useDividendCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDividendCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDividendCreatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useDividendCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IDividendCreatedSubscription, IDividendCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IDividendCreatedSubscription, IDividendCreatedSubscriptionVariables>(DividendCreatedDocument, options);
      }
export type DividendCreatedSubscriptionHookResult = ReturnType<typeof useDividendCreatedSubscription>;
export type DividendCreatedSubscriptionResult = Apollo.SubscriptionResult<IDividendCreatedSubscription>;
export const DividendUpdatedDocument = gql`
    subscription dividendUpdated($stock_id: ID!) {
  result: dividendUpdated(stock_id: $stock_id) {
    ...DividendDetails
  }
}
    ${DividendDetailsFragmentDoc}`;

/**
 * __useDividendUpdatedSubscription__
 *
 * To run a query within a React component, call `useDividendUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDividendUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDividendUpdatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useDividendUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IDividendUpdatedSubscription, IDividendUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IDividendUpdatedSubscription, IDividendUpdatedSubscriptionVariables>(DividendUpdatedDocument, options);
      }
export type DividendUpdatedSubscriptionHookResult = ReturnType<typeof useDividendUpdatedSubscription>;
export type DividendUpdatedSubscriptionResult = Apollo.SubscriptionResult<IDividendUpdatedSubscription>;
export const DividendDeletedDocument = gql`
    subscription dividendDeleted($stock_id: ID!) {
  result: dividendDeleted(stock_id: $stock_id) {
    ...DividendDetails
  }
}
    ${DividendDetailsFragmentDoc}`;

/**
 * __useDividendDeletedSubscription__
 *
 * To run a query within a React component, call `useDividendDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDividendDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDividendDeletedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useDividendDeletedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IDividendDeletedSubscription, IDividendDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IDividendDeletedSubscription, IDividendDeletedSubscriptionVariables>(DividendDeletedDocument, options);
      }
export type DividendDeletedSubscriptionHookResult = ReturnType<typeof useDividendDeletedSubscription>;
export type DividendDeletedSubscriptionResult = Apollo.SubscriptionResult<IDividendDeletedSubscription>;
export const DocumentsDocument = gql`
    query documents {
  result: documents {
    ...DocumentDetails
  }
}
    ${DocumentDetailsFragmentDoc}`;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<IDocumentsQuery, IDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IDocumentsQuery, IDocumentsQueryVariables>(DocumentsDocument, options);
      }
export function useDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IDocumentsQuery, IDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IDocumentsQuery, IDocumentsQueryVariables>(DocumentsDocument, options);
        }
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsQueryResult = Apollo.QueryResult<IDocumentsQuery, IDocumentsQueryVariables>;
export const DocumentsFilteredDocument = gql`
    query documentsFiltered($filter: DocumentFilterInput) {
  result: documentsFiltered(filter: $filter) {
    documents {
      ...DocumentDetails
    }
    total
  }
}
    ${DocumentDetailsFragmentDoc}`;

/**
 * __useDocumentsFilteredQuery__
 *
 * To run a query within a React component, call `useDocumentsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsFilteredQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDocumentsFilteredQuery(baseOptions?: Apollo.QueryHookOptions<IDocumentsFilteredQuery, IDocumentsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IDocumentsFilteredQuery, IDocumentsFilteredQueryVariables>(DocumentsFilteredDocument, options);
      }
export function useDocumentsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IDocumentsFilteredQuery, IDocumentsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IDocumentsFilteredQuery, IDocumentsFilteredQueryVariables>(DocumentsFilteredDocument, options);
        }
export type DocumentsFilteredQueryHookResult = ReturnType<typeof useDocumentsFilteredQuery>;
export type DocumentsFilteredLazyQueryHookResult = ReturnType<typeof useDocumentsFilteredLazyQuery>;
export type DocumentsFilteredQueryResult = Apollo.QueryResult<IDocumentsFilteredQuery, IDocumentsFilteredQueryVariables>;
export const CreateDocumentDocument = gql`
    mutation createDocument($input: DocumentInput!) {
  result: createDocument(input: $input) {
    ...DocumentDetails
  }
}
    ${DocumentDetailsFragmentDoc}`;
export type ICreateDocumentMutationFn = Apollo.MutationFunction<ICreateDocumentMutation, ICreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ICreateDocumentMutation, ICreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateDocumentMutation, ICreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<ICreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<ICreateDocumentMutation, ICreateDocumentMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation updateDocument($id: ID!, $input: DocumentInput!) {
  result: updateDocument(id: $id, input: $input) {
    ...DocumentDetails
  }
}
    ${DocumentDetailsFragmentDoc}`;
export type IUpdateDocumentMutationFn = Apollo.MutationFunction<IUpdateDocumentMutation, IUpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateDocumentMutation, IUpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateDocumentMutation, IUpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<IUpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<IUpdateDocumentMutation, IUpdateDocumentMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation deleteDocument($id: ID!) {
  result: deleteDocument(id: $id)
}
    `;
export type IDeleteDocumentMutationFn = Apollo.MutationFunction<IDeleteDocumentMutation, IDeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteDocumentMutation, IDeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteDocumentMutation, IDeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<IDeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<IDeleteDocumentMutation, IDeleteDocumentMutationVariables>;
export const DeleteDocumentFromSiteSectionDocument = gql`
    mutation deleteDocumentFromSiteSection($document_id: ID!, $site_section_id: ID!) {
  result: deleteDocumentFromSiteSection(
    document_id: $document_id
    site_section_id: $site_section_id
  )
}
    `;
export type IDeleteDocumentFromSiteSectionMutationFn = Apollo.MutationFunction<IDeleteDocumentFromSiteSectionMutation, IDeleteDocumentFromSiteSectionMutationVariables>;

/**
 * __useDeleteDocumentFromSiteSectionMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentFromSiteSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentFromSiteSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentFromSiteSectionMutation, { data, loading, error }] = useDeleteDocumentFromSiteSectionMutation({
 *   variables: {
 *      document_id: // value for 'document_id'
 *      site_section_id: // value for 'site_section_id'
 *   },
 * });
 */
export function useDeleteDocumentFromSiteSectionMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteDocumentFromSiteSectionMutation, IDeleteDocumentFromSiteSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteDocumentFromSiteSectionMutation, IDeleteDocumentFromSiteSectionMutationVariables>(DeleteDocumentFromSiteSectionDocument, options);
      }
export type DeleteDocumentFromSiteSectionMutationHookResult = ReturnType<typeof useDeleteDocumentFromSiteSectionMutation>;
export type DeleteDocumentFromSiteSectionMutationResult = Apollo.MutationResult<IDeleteDocumentFromSiteSectionMutation>;
export type DeleteDocumentFromSiteSectionMutationOptions = Apollo.BaseMutationOptions<IDeleteDocumentFromSiteSectionMutation, IDeleteDocumentFromSiteSectionMutationVariables>;
export const UpdateDescriptionDocument = gql`
    mutation updateDescription($id: ID!, $description: String) {
  result: updateDescription(id: $id, description: $description) {
    ...DocumentDetails
  }
}
    ${DocumentDetailsFragmentDoc}`;
export type IUpdateDescriptionMutationFn = Apollo.MutationFunction<IUpdateDescriptionMutation, IUpdateDescriptionMutationVariables>;

/**
 * __useUpdateDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDescriptionMutation, { data, loading, error }] = useUpdateDescriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateDescriptionMutation, IUpdateDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateDescriptionMutation, IUpdateDescriptionMutationVariables>(UpdateDescriptionDocument, options);
      }
export type UpdateDescriptionMutationHookResult = ReturnType<typeof useUpdateDescriptionMutation>;
export type UpdateDescriptionMutationResult = Apollo.MutationResult<IUpdateDescriptionMutation>;
export type UpdateDescriptionMutationOptions = Apollo.BaseMutationOptions<IUpdateDescriptionMutation, IUpdateDescriptionMutationVariables>;
export const DocumentDeletedDocument = gql`
    subscription documentDeleted {
  result: documentDeleted {
    ...DocumentDetails
  }
}
    ${DocumentDetailsFragmentDoc}`;

/**
 * __useDocumentDeletedSubscription__
 *
 * To run a query within a React component, call `useDocumentDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useDocumentDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IDocumentDeletedSubscription, IDocumentDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IDocumentDeletedSubscription, IDocumentDeletedSubscriptionVariables>(DocumentDeletedDocument, options);
      }
export type DocumentDeletedSubscriptionHookResult = ReturnType<typeof useDocumentDeletedSubscription>;
export type DocumentDeletedSubscriptionResult = Apollo.SubscriptionResult<IDocumentDeletedSubscription>;
export const DocumentUpdatedDocument = gql`
    subscription documentUpdated {
  result: documentUpdated {
    ...DocumentDetails
  }
}
    ${DocumentDetailsFragmentDoc}`;

/**
 * __useDocumentUpdatedSubscription__
 *
 * To run a query within a React component, call `useDocumentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDocumentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useDocumentUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IDocumentUpdatedSubscription, IDocumentUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IDocumentUpdatedSubscription, IDocumentUpdatedSubscriptionVariables>(DocumentUpdatedDocument, options);
      }
export type DocumentUpdatedSubscriptionHookResult = ReturnType<typeof useDocumentUpdatedSubscription>;
export type DocumentUpdatedSubscriptionResult = Apollo.SubscriptionResult<IDocumentUpdatedSubscription>;
export const DocumentCreatedDocument = gql`
    subscription documentCreated {
  result: documentCreated {
    ...DocumentDetails
  }
}
    ${DocumentDetailsFragmentDoc}`;

/**
 * __useDocumentCreatedSubscription__
 *
 * To run a query within a React component, call `useDocumentCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDocumentCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useDocumentCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IDocumentCreatedSubscription, IDocumentCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IDocumentCreatedSubscription, IDocumentCreatedSubscriptionVariables>(DocumentCreatedDocument, options);
      }
export type DocumentCreatedSubscriptionHookResult = ReturnType<typeof useDocumentCreatedSubscription>;
export type DocumentCreatedSubscriptionResult = Apollo.SubscriptionResult<IDocumentCreatedSubscription>;
export const GetEtfsDocument = gql`
    query getEtfs {
  result: getEtfs {
    ...EtfDetails
  }
}
    ${EtfDetailsFragmentDoc}`;

/**
 * __useGetEtfsQuery__
 *
 * To run a query within a React component, call `useGetEtfsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtfsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtfsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEtfsQuery(baseOptions?: Apollo.QueryHookOptions<IGetEtfsQuery, IGetEtfsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEtfsQuery, IGetEtfsQueryVariables>(GetEtfsDocument, options);
      }
export function useGetEtfsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEtfsQuery, IGetEtfsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEtfsQuery, IGetEtfsQueryVariables>(GetEtfsDocument, options);
        }
export type GetEtfsQueryHookResult = ReturnType<typeof useGetEtfsQuery>;
export type GetEtfsLazyQueryHookResult = ReturnType<typeof useGetEtfsLazyQuery>;
export type GetEtfsQueryResult = Apollo.QueryResult<IGetEtfsQuery, IGetEtfsQueryVariables>;
export const GetEtfValuesDocument = gql`
    query getEtfValues($etf_id: Int!) {
  result: getEtfValues(etf_id: $etf_id) {
    ...EtfValueDetails
  }
}
    ${EtfValueDetailsFragmentDoc}`;

/**
 * __useGetEtfValuesQuery__
 *
 * To run a query within a React component, call `useGetEtfValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtfValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtfValuesQuery({
 *   variables: {
 *      etf_id: // value for 'etf_id'
 *   },
 * });
 */
export function useGetEtfValuesQuery(baseOptions: Apollo.QueryHookOptions<IGetEtfValuesQuery, IGetEtfValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEtfValuesQuery, IGetEtfValuesQueryVariables>(GetEtfValuesDocument, options);
      }
export function useGetEtfValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEtfValuesQuery, IGetEtfValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEtfValuesQuery, IGetEtfValuesQueryVariables>(GetEtfValuesDocument, options);
        }
export type GetEtfValuesQueryHookResult = ReturnType<typeof useGetEtfValuesQuery>;
export type GetEtfValuesLazyQueryHookResult = ReturnType<typeof useGetEtfValuesLazyQuery>;
export type GetEtfValuesQueryResult = Apollo.QueryResult<IGetEtfValuesQuery, IGetEtfValuesQueryVariables>;
export const GetEtfDocument = gql`
    query getEtf($id: ID!) {
  result: getEtf(id: $id) {
    ...EtfDetails
  }
}
    ${EtfDetailsFragmentDoc}`;

/**
 * __useGetEtfQuery__
 *
 * To run a query within a React component, call `useGetEtfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtfQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEtfQuery(baseOptions: Apollo.QueryHookOptions<IGetEtfQuery, IGetEtfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEtfQuery, IGetEtfQueryVariables>(GetEtfDocument, options);
      }
export function useGetEtfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEtfQuery, IGetEtfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEtfQuery, IGetEtfQueryVariables>(GetEtfDocument, options);
        }
export type GetEtfQueryHookResult = ReturnType<typeof useGetEtfQuery>;
export type GetEtfLazyQueryHookResult = ReturnType<typeof useGetEtfLazyQuery>;
export type GetEtfQueryResult = Apollo.QueryResult<IGetEtfQuery, IGetEtfQueryVariables>;
export const AddEtfDocument = gql`
    mutation addEtf($input: EtfInput!) {
  result: addEtf(input: $input) {
    ...EtfDetails
  }
}
    ${EtfDetailsFragmentDoc}`;
export type IAddEtfMutationFn = Apollo.MutationFunction<IAddEtfMutation, IAddEtfMutationVariables>;

/**
 * __useAddEtfMutation__
 *
 * To run a mutation, you first call `useAddEtfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEtfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEtfMutation, { data, loading, error }] = useAddEtfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEtfMutation(baseOptions?: Apollo.MutationHookOptions<IAddEtfMutation, IAddEtfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddEtfMutation, IAddEtfMutationVariables>(AddEtfDocument, options);
      }
export type AddEtfMutationHookResult = ReturnType<typeof useAddEtfMutation>;
export type AddEtfMutationResult = Apollo.MutationResult<IAddEtfMutation>;
export type AddEtfMutationOptions = Apollo.BaseMutationOptions<IAddEtfMutation, IAddEtfMutationVariables>;
export const UpdateEtfDocument = gql`
    mutation updateEtf($id: ID!, $input: EtfInput!) {
  result: updateEtf(id: $id, input: $input) {
    ...EtfDetails
  }
}
    ${EtfDetailsFragmentDoc}`;
export type IUpdateEtfMutationFn = Apollo.MutationFunction<IUpdateEtfMutation, IUpdateEtfMutationVariables>;

/**
 * __useUpdateEtfMutation__
 *
 * To run a mutation, you first call `useUpdateEtfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEtfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEtfMutation, { data, loading, error }] = useUpdateEtfMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEtfMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateEtfMutation, IUpdateEtfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateEtfMutation, IUpdateEtfMutationVariables>(UpdateEtfDocument, options);
      }
export type UpdateEtfMutationHookResult = ReturnType<typeof useUpdateEtfMutation>;
export type UpdateEtfMutationResult = Apollo.MutationResult<IUpdateEtfMutation>;
export type UpdateEtfMutationOptions = Apollo.BaseMutationOptions<IUpdateEtfMutation, IUpdateEtfMutationVariables>;
export const DeleteEtfDocument = gql`
    mutation deleteETF($id: ID!) {
  result: deleteETF(id: $id)
}
    `;
export type IDeleteEtfMutationFn = Apollo.MutationFunction<IDeleteEtfMutation, IDeleteEtfMutationVariables>;

/**
 * __useDeleteEtfMutation__
 *
 * To run a mutation, you first call `useDeleteEtfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEtfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEtfMutation, { data, loading, error }] = useDeleteEtfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEtfMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteEtfMutation, IDeleteEtfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteEtfMutation, IDeleteEtfMutationVariables>(DeleteEtfDocument, options);
      }
export type DeleteEtfMutationHookResult = ReturnType<typeof useDeleteEtfMutation>;
export type DeleteEtfMutationResult = Apollo.MutationResult<IDeleteEtfMutation>;
export type DeleteEtfMutationOptions = Apollo.BaseMutationOptions<IDeleteEtfMutation, IDeleteEtfMutationVariables>;
export const AddEtfValueDocument = gql`
    mutation addEtfValue($etf_id: ID!, $input: EtfValueInput!) {
  result: addEtfValue(etf_id: $etf_id, input: $input) {
    ...EtfValueDetails
  }
}
    ${EtfValueDetailsFragmentDoc}`;
export type IAddEtfValueMutationFn = Apollo.MutationFunction<IAddEtfValueMutation, IAddEtfValueMutationVariables>;

/**
 * __useAddEtfValueMutation__
 *
 * To run a mutation, you first call `useAddEtfValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEtfValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEtfValueMutation, { data, loading, error }] = useAddEtfValueMutation({
 *   variables: {
 *      etf_id: // value for 'etf_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEtfValueMutation(baseOptions?: Apollo.MutationHookOptions<IAddEtfValueMutation, IAddEtfValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddEtfValueMutation, IAddEtfValueMutationVariables>(AddEtfValueDocument, options);
      }
export type AddEtfValueMutationHookResult = ReturnType<typeof useAddEtfValueMutation>;
export type AddEtfValueMutationResult = Apollo.MutationResult<IAddEtfValueMutation>;
export type AddEtfValueMutationOptions = Apollo.BaseMutationOptions<IAddEtfValueMutation, IAddEtfValueMutationVariables>;
export const UpdateEtfValueDocument = gql`
    mutation updateEtfValue($id: ID!, $input: EtfValueInput!) {
  result: updateEtfValue(id: $id, input: $input) {
    ...EtfValueDetails
  }
}
    ${EtfValueDetailsFragmentDoc}`;
export type IUpdateEtfValueMutationFn = Apollo.MutationFunction<IUpdateEtfValueMutation, IUpdateEtfValueMutationVariables>;

/**
 * __useUpdateEtfValueMutation__
 *
 * To run a mutation, you first call `useUpdateEtfValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEtfValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEtfValueMutation, { data, loading, error }] = useUpdateEtfValueMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEtfValueMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateEtfValueMutation, IUpdateEtfValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateEtfValueMutation, IUpdateEtfValueMutationVariables>(UpdateEtfValueDocument, options);
      }
export type UpdateEtfValueMutationHookResult = ReturnType<typeof useUpdateEtfValueMutation>;
export type UpdateEtfValueMutationResult = Apollo.MutationResult<IUpdateEtfValueMutation>;
export type UpdateEtfValueMutationOptions = Apollo.BaseMutationOptions<IUpdateEtfValueMutation, IUpdateEtfValueMutationVariables>;
export const EtfCreatedDocument = gql`
    subscription etfCreated {
  result: etfCreated {
    ...EtfDetails
  }
}
    ${EtfDetailsFragmentDoc}`;

/**
 * __useEtfCreatedSubscription__
 *
 * To run a query within a React component, call `useEtfCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEtfCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEtfCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEtfCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IEtfCreatedSubscription, IEtfCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IEtfCreatedSubscription, IEtfCreatedSubscriptionVariables>(EtfCreatedDocument, options);
      }
export type EtfCreatedSubscriptionHookResult = ReturnType<typeof useEtfCreatedSubscription>;
export type EtfCreatedSubscriptionResult = Apollo.SubscriptionResult<IEtfCreatedSubscription>;
export const EtfUpdatedDocument = gql`
    subscription etfUpdated {
  result: etfUpdated {
    ...EtfDetails
  }
}
    ${EtfDetailsFragmentDoc}`;

/**
 * __useEtfUpdatedSubscription__
 *
 * To run a query within a React component, call `useEtfUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEtfUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEtfUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEtfUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IEtfUpdatedSubscription, IEtfUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IEtfUpdatedSubscription, IEtfUpdatedSubscriptionVariables>(EtfUpdatedDocument, options);
      }
export type EtfUpdatedSubscriptionHookResult = ReturnType<typeof useEtfUpdatedSubscription>;
export type EtfUpdatedSubscriptionResult = Apollo.SubscriptionResult<IEtfUpdatedSubscription>;
export const EtfDeletedDocument = gql`
    subscription etfDeleted {
  result: etfDeleted {
    ...EtfDetails
  }
}
    ${EtfDetailsFragmentDoc}`;

/**
 * __useEtfDeletedSubscription__
 *
 * To run a query within a React component, call `useEtfDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEtfDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEtfDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEtfDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IEtfDeletedSubscription, IEtfDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IEtfDeletedSubscription, IEtfDeletedSubscriptionVariables>(EtfDeletedDocument, options);
      }
export type EtfDeletedSubscriptionHookResult = ReturnType<typeof useEtfDeletedSubscription>;
export type EtfDeletedSubscriptionResult = Apollo.SubscriptionResult<IEtfDeletedSubscription>;
export const EtfValueCreatedDocument = gql`
    subscription etfValueCreated($etf_id: ID!) {
  result: etfValueCreated(etf_id: $etf_id) {
    ...EtfValueDetails
  }
}
    ${EtfValueDetailsFragmentDoc}`;

/**
 * __useEtfValueCreatedSubscription__
 *
 * To run a query within a React component, call `useEtfValueCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEtfValueCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEtfValueCreatedSubscription({
 *   variables: {
 *      etf_id: // value for 'etf_id'
 *   },
 * });
 */
export function useEtfValueCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IEtfValueCreatedSubscription, IEtfValueCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IEtfValueCreatedSubscription, IEtfValueCreatedSubscriptionVariables>(EtfValueCreatedDocument, options);
      }
export type EtfValueCreatedSubscriptionHookResult = ReturnType<typeof useEtfValueCreatedSubscription>;
export type EtfValueCreatedSubscriptionResult = Apollo.SubscriptionResult<IEtfValueCreatedSubscription>;
export const EtfValueUpdatedDocument = gql`
    subscription etfValueUpdated($etf_id: ID!) {
  result: etfValueUpdated(etf_id: $etf_id) {
    ...EtfValueDetails
  }
}
    ${EtfValueDetailsFragmentDoc}`;

/**
 * __useEtfValueUpdatedSubscription__
 *
 * To run a query within a React component, call `useEtfValueUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEtfValueUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEtfValueUpdatedSubscription({
 *   variables: {
 *      etf_id: // value for 'etf_id'
 *   },
 * });
 */
export function useEtfValueUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IEtfValueUpdatedSubscription, IEtfValueUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IEtfValueUpdatedSubscription, IEtfValueUpdatedSubscriptionVariables>(EtfValueUpdatedDocument, options);
      }
export type EtfValueUpdatedSubscriptionHookResult = ReturnType<typeof useEtfValueUpdatedSubscription>;
export type EtfValueUpdatedSubscriptionResult = Apollo.SubscriptionResult<IEtfValueUpdatedSubscription>;
export const GetEtfsWithValuesDocument = gql`
    query getEtfsWithValues($date: String) {
  result: getEtfsWithValues(date: $date) {
    ...EtfValueDetails
  }
}
    ${EtfValueDetailsFragmentDoc}`;

/**
 * __useGetEtfsWithValuesQuery__
 *
 * To run a query within a React component, call `useGetEtfsWithValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtfsWithValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtfsWithValuesQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetEtfsWithValuesQuery(baseOptions?: Apollo.QueryHookOptions<IGetEtfsWithValuesQuery, IGetEtfsWithValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEtfsWithValuesQuery, IGetEtfsWithValuesQueryVariables>(GetEtfsWithValuesDocument, options);
      }
export function useGetEtfsWithValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEtfsWithValuesQuery, IGetEtfsWithValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEtfsWithValuesQuery, IGetEtfsWithValuesQueryVariables>(GetEtfsWithValuesDocument, options);
        }
export type GetEtfsWithValuesQueryHookResult = ReturnType<typeof useGetEtfsWithValuesQuery>;
export type GetEtfsWithValuesLazyQueryHookResult = ReturnType<typeof useGetEtfsWithValuesLazyQuery>;
export type GetEtfsWithValuesQueryResult = Apollo.QueryResult<IGetEtfsWithValuesQuery, IGetEtfsWithValuesQueryVariables>;
export const GetFtseFilesDocument = gql`
    query getFtseFiles {
  result: getFtseFiles {
    ...FtseDetails
  }
}
    ${FtseDetailsFragmentDoc}`;

/**
 * __useGetFtseFilesQuery__
 *
 * To run a query within a React component, call `useGetFtseFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFtseFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFtseFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFtseFilesQuery(baseOptions?: Apollo.QueryHookOptions<IGetFtseFilesQuery, IGetFtseFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFtseFilesQuery, IGetFtseFilesQueryVariables>(GetFtseFilesDocument, options);
      }
export function useGetFtseFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFtseFilesQuery, IGetFtseFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFtseFilesQuery, IGetFtseFilesQueryVariables>(GetFtseFilesDocument, options);
        }
export type GetFtseFilesQueryHookResult = ReturnType<typeof useGetFtseFilesQuery>;
export type GetFtseFilesLazyQueryHookResult = ReturnType<typeof useGetFtseFilesLazyQuery>;
export type GetFtseFilesQueryResult = Apollo.QueryResult<IGetFtseFilesQuery, IGetFtseFilesQueryVariables>;
export const GetFtseTypesDocument = gql`
    query getFtseTypes {
  result: getFtseTypes {
    id
    name
  }
}
    `;

/**
 * __useGetFtseTypesQuery__
 *
 * To run a query within a React component, call `useGetFtseTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFtseTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFtseTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFtseTypesQuery(baseOptions?: Apollo.QueryHookOptions<IGetFtseTypesQuery, IGetFtseTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFtseTypesQuery, IGetFtseTypesQueryVariables>(GetFtseTypesDocument, options);
      }
export function useGetFtseTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFtseTypesQuery, IGetFtseTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFtseTypesQuery, IGetFtseTypesQueryVariables>(GetFtseTypesDocument, options);
        }
export type GetFtseTypesQueryHookResult = ReturnType<typeof useGetFtseTypesQuery>;
export type GetFtseTypesLazyQueryHookResult = ReturnType<typeof useGetFtseTypesLazyQuery>;
export type GetFtseTypesQueryResult = Apollo.QueryResult<IGetFtseTypesQuery, IGetFtseTypesQueryVariables>;
export const GetFtseConfigurationsDocument = gql`
    query getFtseConfigurations {
  result: getFtseConfigurations {
    ...FtseConfigurationDetails
  }
}
    ${FtseConfigurationDetailsFragmentDoc}`;

/**
 * __useGetFtseConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetFtseConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFtseConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFtseConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFtseConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<IGetFtseConfigurationsQuery, IGetFtseConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFtseConfigurationsQuery, IGetFtseConfigurationsQueryVariables>(GetFtseConfigurationsDocument, options);
      }
export function useGetFtseConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFtseConfigurationsQuery, IGetFtseConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFtseConfigurationsQuery, IGetFtseConfigurationsQueryVariables>(GetFtseConfigurationsDocument, options);
        }
export type GetFtseConfigurationsQueryHookResult = ReturnType<typeof useGetFtseConfigurationsQuery>;
export type GetFtseConfigurationsLazyQueryHookResult = ReturnType<typeof useGetFtseConfigurationsLazyQuery>;
export type GetFtseConfigurationsQueryResult = Apollo.QueryResult<IGetFtseConfigurationsQuery, IGetFtseConfigurationsQueryVariables>;
export const DeleteFtseFileDocument = gql`
    mutation deleteFtseFile($id: ID!) {
  result: deleteFtseFile(id: $id)
}
    `;
export type IDeleteFtseFileMutationFn = Apollo.MutationFunction<IDeleteFtseFileMutation, IDeleteFtseFileMutationVariables>;

/**
 * __useDeleteFtseFileMutation__
 *
 * To run a mutation, you first call `useDeleteFtseFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFtseFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFtseFileMutation, { data, loading, error }] = useDeleteFtseFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFtseFileMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteFtseFileMutation, IDeleteFtseFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteFtseFileMutation, IDeleteFtseFileMutationVariables>(DeleteFtseFileDocument, options);
      }
export type DeleteFtseFileMutationHookResult = ReturnType<typeof useDeleteFtseFileMutation>;
export type DeleteFtseFileMutationResult = Apollo.MutationResult<IDeleteFtseFileMutation>;
export type DeleteFtseFileMutationOptions = Apollo.BaseMutationOptions<IDeleteFtseFileMutation, IDeleteFtseFileMutationVariables>;
export const CreateFtseFileDocument = gql`
    mutation createFtseFile($input: ftseFileInput!) {
  result: createFtseFile(input: $input) {
    ...FtseDetails
  }
}
    ${FtseDetailsFragmentDoc}`;
export type ICreateFtseFileMutationFn = Apollo.MutationFunction<ICreateFtseFileMutation, ICreateFtseFileMutationVariables>;

/**
 * __useCreateFtseFileMutation__
 *
 * To run a mutation, you first call `useCreateFtseFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFtseFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFtseFileMutation, { data, loading, error }] = useCreateFtseFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFtseFileMutation(baseOptions?: Apollo.MutationHookOptions<ICreateFtseFileMutation, ICreateFtseFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateFtseFileMutation, ICreateFtseFileMutationVariables>(CreateFtseFileDocument, options);
      }
export type CreateFtseFileMutationHookResult = ReturnType<typeof useCreateFtseFileMutation>;
export type CreateFtseFileMutationResult = Apollo.MutationResult<ICreateFtseFileMutation>;
export type CreateFtseFileMutationOptions = Apollo.BaseMutationOptions<ICreateFtseFileMutation, ICreateFtseFileMutationVariables>;
export const UpdateFtseDocument = gql`
    mutation updateFtse($id: ID!, $input: ftseFileInput!) {
  result: updateFtse(id: $id, input: $input) {
    ...FtseDetails
  }
}
    ${FtseDetailsFragmentDoc}`;
export type IUpdateFtseMutationFn = Apollo.MutationFunction<IUpdateFtseMutation, IUpdateFtseMutationVariables>;

/**
 * __useUpdateFtseMutation__
 *
 * To run a mutation, you first call `useUpdateFtseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFtseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFtseMutation, { data, loading, error }] = useUpdateFtseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFtseMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateFtseMutation, IUpdateFtseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateFtseMutation, IUpdateFtseMutationVariables>(UpdateFtseDocument, options);
      }
export type UpdateFtseMutationHookResult = ReturnType<typeof useUpdateFtseMutation>;
export type UpdateFtseMutationResult = Apollo.MutationResult<IUpdateFtseMutation>;
export type UpdateFtseMutationOptions = Apollo.BaseMutationOptions<IUpdateFtseMutation, IUpdateFtseMutationVariables>;
export const UpdateFtseConfigurationDocument = gql`
    mutation updateFtseConfiguration($id: ID!, $input: ftseConfigurationInput!) {
  result: updateFtseConfiguration(id: $id, input: $input) {
    ...FtseConfigurationDetails
  }
}
    ${FtseConfigurationDetailsFragmentDoc}`;
export type IUpdateFtseConfigurationMutationFn = Apollo.MutationFunction<IUpdateFtseConfigurationMutation, IUpdateFtseConfigurationMutationVariables>;

/**
 * __useUpdateFtseConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateFtseConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFtseConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFtseConfigurationMutation, { data, loading, error }] = useUpdateFtseConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFtseConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateFtseConfigurationMutation, IUpdateFtseConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateFtseConfigurationMutation, IUpdateFtseConfigurationMutationVariables>(UpdateFtseConfigurationDocument, options);
      }
export type UpdateFtseConfigurationMutationHookResult = ReturnType<typeof useUpdateFtseConfigurationMutation>;
export type UpdateFtseConfigurationMutationResult = Apollo.MutationResult<IUpdateFtseConfigurationMutation>;
export type UpdateFtseConfigurationMutationOptions = Apollo.BaseMutationOptions<IUpdateFtseConfigurationMutation, IUpdateFtseConfigurationMutationVariables>;
export const FtseFileCreatedDocument = gql`
    subscription ftseFileCreated {
  result: ftseFileCreated {
    ...FtseDetails
  }
}
    ${FtseDetailsFragmentDoc}`;

/**
 * __useFtseFileCreatedSubscription__
 *
 * To run a query within a React component, call `useFtseFileCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFtseFileCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFtseFileCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useFtseFileCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IFtseFileCreatedSubscription, IFtseFileCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IFtseFileCreatedSubscription, IFtseFileCreatedSubscriptionVariables>(FtseFileCreatedDocument, options);
      }
export type FtseFileCreatedSubscriptionHookResult = ReturnType<typeof useFtseFileCreatedSubscription>;
export type FtseFileCreatedSubscriptionResult = Apollo.SubscriptionResult<IFtseFileCreatedSubscription>;
export const FtseFileUpdatedDocument = gql`
    subscription ftseFileUpdated {
  result: ftseFileUpdated {
    ...FtseDetails
  }
}
    ${FtseDetailsFragmentDoc}`;

/**
 * __useFtseFileUpdatedSubscription__
 *
 * To run a query within a React component, call `useFtseFileUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFtseFileUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFtseFileUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useFtseFileUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IFtseFileUpdatedSubscription, IFtseFileUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IFtseFileUpdatedSubscription, IFtseFileUpdatedSubscriptionVariables>(FtseFileUpdatedDocument, options);
      }
export type FtseFileUpdatedSubscriptionHookResult = ReturnType<typeof useFtseFileUpdatedSubscription>;
export type FtseFileUpdatedSubscriptionResult = Apollo.SubscriptionResult<IFtseFileUpdatedSubscription>;
export const FtseConfigurationUpdatedDocument = gql`
    subscription ftseConfigurationUpdated {
  result: ftseConfigurationUpdated {
    ...FtseConfigurationDetails
  }
}
    ${FtseConfigurationDetailsFragmentDoc}`;

/**
 * __useFtseConfigurationUpdatedSubscription__
 *
 * To run a query within a React component, call `useFtseConfigurationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFtseConfigurationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFtseConfigurationUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useFtseConfigurationUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IFtseConfigurationUpdatedSubscription, IFtseConfigurationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IFtseConfigurationUpdatedSubscription, IFtseConfigurationUpdatedSubscriptionVariables>(FtseConfigurationUpdatedDocument, options);
      }
export type FtseConfigurationUpdatedSubscriptionHookResult = ReturnType<typeof useFtseConfigurationUpdatedSubscription>;
export type FtseConfigurationUpdatedSubscriptionResult = Apollo.SubscriptionResult<IFtseConfigurationUpdatedSubscription>;
export const FtseFileDeletedDocument = gql`
    subscription ftseFileDeleted {
  result: ftseFileDeleted {
    ...FtseDetails
  }
}
    ${FtseDetailsFragmentDoc}`;

/**
 * __useFtseFileDeletedSubscription__
 *
 * To run a query within a React component, call `useFtseFileDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFtseFileDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFtseFileDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useFtseFileDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IFtseFileDeletedSubscription, IFtseFileDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IFtseFileDeletedSubscription, IFtseFileDeletedSubscriptionVariables>(FtseFileDeletedDocument, options);
      }
export type FtseFileDeletedSubscriptionHookResult = ReturnType<typeof useFtseFileDeletedSubscription>;
export type FtseFileDeletedSubscriptionResult = Apollo.SubscriptionResult<IFtseFileDeletedSubscription>;
export const GetFxDataDocument = gql`
    query getFxData {
  result: getFxData {
    ...FtseFxDetails
  }
}
    ${FtseFxDetailsFragmentDoc}`;

/**
 * __useGetFxDataQuery__
 *
 * To run a query within a React component, call `useGetFxDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFxDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFxDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFxDataQuery(baseOptions?: Apollo.QueryHookOptions<IGetFxDataQuery, IGetFxDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetFxDataQuery, IGetFxDataQueryVariables>(GetFxDataDocument, options);
      }
export function useGetFxDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetFxDataQuery, IGetFxDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetFxDataQuery, IGetFxDataQueryVariables>(GetFxDataDocument, options);
        }
export type GetFxDataQueryHookResult = ReturnType<typeof useGetFxDataQuery>;
export type GetFxDataLazyQueryHookResult = ReturnType<typeof useGetFxDataLazyQuery>;
export type GetFxDataQueryResult = Apollo.QueryResult<IGetFxDataQuery, IGetFxDataQueryVariables>;
export const GetLatestFxDataDocument = gql`
    query getLatestFxData($date: String) {
  result: getLatestFxData(date: $date) {
    ...FtseFxDetails
  }
}
    ${FtseFxDetailsFragmentDoc}`;

/**
 * __useGetLatestFxDataQuery__
 *
 * To run a query within a React component, call `useGetLatestFxDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestFxDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestFxDataQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetLatestFxDataQuery(baseOptions?: Apollo.QueryHookOptions<IGetLatestFxDataQuery, IGetLatestFxDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetLatestFxDataQuery, IGetLatestFxDataQueryVariables>(GetLatestFxDataDocument, options);
      }
export function useGetLatestFxDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetLatestFxDataQuery, IGetLatestFxDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetLatestFxDataQuery, IGetLatestFxDataQueryVariables>(GetLatestFxDataDocument, options);
        }
export type GetLatestFxDataQueryHookResult = ReturnType<typeof useGetLatestFxDataQuery>;
export type GetLatestFxDataLazyQueryHookResult = ReturnType<typeof useGetLatestFxDataLazyQuery>;
export type GetLatestFxDataQueryResult = Apollo.QueryResult<IGetLatestFxDataQuery, IGetLatestFxDataQueryVariables>;
export const GetHistoryAllocationCountriesDocument = gql`
    query getHistoryAllocationCountries($stock_id: Int!) {
  result: getHistoryAllocationCountries(stock_id: $stock_id) {
    ...HistoryAllocationCountryDetails
  }
}
    ${HistoryAllocationCountryDetailsFragmentDoc}`;

/**
 * __useGetHistoryAllocationCountriesQuery__
 *
 * To run a query within a React component, call `useGetHistoryAllocationCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoryAllocationCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoryAllocationCountriesQuery({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useGetHistoryAllocationCountriesQuery(baseOptions: Apollo.QueryHookOptions<IGetHistoryAllocationCountriesQuery, IGetHistoryAllocationCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHistoryAllocationCountriesQuery, IGetHistoryAllocationCountriesQueryVariables>(GetHistoryAllocationCountriesDocument, options);
      }
export function useGetHistoryAllocationCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHistoryAllocationCountriesQuery, IGetHistoryAllocationCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHistoryAllocationCountriesQuery, IGetHistoryAllocationCountriesQueryVariables>(GetHistoryAllocationCountriesDocument, options);
        }
export type GetHistoryAllocationCountriesQueryHookResult = ReturnType<typeof useGetHistoryAllocationCountriesQuery>;
export type GetHistoryAllocationCountriesLazyQueryHookResult = ReturnType<typeof useGetHistoryAllocationCountriesLazyQuery>;
export type GetHistoryAllocationCountriesQueryResult = Apollo.QueryResult<IGetHistoryAllocationCountriesQuery, IGetHistoryAllocationCountriesQueryVariables>;
export const CreateAllocationCountryDocument = gql`
    mutation createAllocationCountry($stock_id: ID!, $input: AllocationCountryInput!) {
  result: createAllocationCountry(stock_id: $stock_id, input: $input) {
    ...HistoryAllocationCountryDetails
  }
}
    ${HistoryAllocationCountryDetailsFragmentDoc}`;
export type ICreateAllocationCountryMutationFn = Apollo.MutationFunction<ICreateAllocationCountryMutation, ICreateAllocationCountryMutationVariables>;

/**
 * __useCreateAllocationCountryMutation__
 *
 * To run a mutation, you first call `useCreateAllocationCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllocationCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllocationCountryMutation, { data, loading, error }] = useCreateAllocationCountryMutation({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAllocationCountryMutation(baseOptions?: Apollo.MutationHookOptions<ICreateAllocationCountryMutation, ICreateAllocationCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateAllocationCountryMutation, ICreateAllocationCountryMutationVariables>(CreateAllocationCountryDocument, options);
      }
export type CreateAllocationCountryMutationHookResult = ReturnType<typeof useCreateAllocationCountryMutation>;
export type CreateAllocationCountryMutationResult = Apollo.MutationResult<ICreateAllocationCountryMutation>;
export type CreateAllocationCountryMutationOptions = Apollo.BaseMutationOptions<ICreateAllocationCountryMutation, ICreateAllocationCountryMutationVariables>;
export const UpdateAllocationCountryDocument = gql`
    mutation updateAllocationCountry($id: ID!, $input: AllocationCountryInput!) {
  result: updateAllocationCountry(id: $id, input: $input) {
    ...HistoryAllocationCountryDetails
  }
}
    ${HistoryAllocationCountryDetailsFragmentDoc}`;
export type IUpdateAllocationCountryMutationFn = Apollo.MutationFunction<IUpdateAllocationCountryMutation, IUpdateAllocationCountryMutationVariables>;

/**
 * __useUpdateAllocationCountryMutation__
 *
 * To run a mutation, you first call `useUpdateAllocationCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllocationCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllocationCountryMutation, { data, loading, error }] = useUpdateAllocationCountryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllocationCountryMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAllocationCountryMutation, IUpdateAllocationCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAllocationCountryMutation, IUpdateAllocationCountryMutationVariables>(UpdateAllocationCountryDocument, options);
      }
export type UpdateAllocationCountryMutationHookResult = ReturnType<typeof useUpdateAllocationCountryMutation>;
export type UpdateAllocationCountryMutationResult = Apollo.MutationResult<IUpdateAllocationCountryMutation>;
export type UpdateAllocationCountryMutationOptions = Apollo.BaseMutationOptions<IUpdateAllocationCountryMutation, IUpdateAllocationCountryMutationVariables>;
export const DeleteAllocationCountryDocument = gql`
    mutation deleteAllocationCountry($id: ID!) {
  result: deleteAllocationCountry(id: $id)
}
    `;
export type IDeleteAllocationCountryMutationFn = Apollo.MutationFunction<IDeleteAllocationCountryMutation, IDeleteAllocationCountryMutationVariables>;

/**
 * __useDeleteAllocationCountryMutation__
 *
 * To run a mutation, you first call `useDeleteAllocationCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllocationCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllocationCountryMutation, { data, loading, error }] = useDeleteAllocationCountryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAllocationCountryMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteAllocationCountryMutation, IDeleteAllocationCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteAllocationCountryMutation, IDeleteAllocationCountryMutationVariables>(DeleteAllocationCountryDocument, options);
      }
export type DeleteAllocationCountryMutationHookResult = ReturnType<typeof useDeleteAllocationCountryMutation>;
export type DeleteAllocationCountryMutationResult = Apollo.MutationResult<IDeleteAllocationCountryMutation>;
export type DeleteAllocationCountryMutationOptions = Apollo.BaseMutationOptions<IDeleteAllocationCountryMutation, IDeleteAllocationCountryMutationVariables>;
export const AllocationCountryCreatedDocument = gql`
    subscription allocationCountryCreated($stock_id: ID!) {
  result: allocationCountryCreated(stock_id: $stock_id) {
    ...HistoryAllocationCountryDetails
  }
}
    ${HistoryAllocationCountryDetailsFragmentDoc}`;

/**
 * __useAllocationCountryCreatedSubscription__
 *
 * To run a query within a React component, call `useAllocationCountryCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAllocationCountryCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocationCountryCreatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useAllocationCountryCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IAllocationCountryCreatedSubscription, IAllocationCountryCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IAllocationCountryCreatedSubscription, IAllocationCountryCreatedSubscriptionVariables>(AllocationCountryCreatedDocument, options);
      }
export type AllocationCountryCreatedSubscriptionHookResult = ReturnType<typeof useAllocationCountryCreatedSubscription>;
export type AllocationCountryCreatedSubscriptionResult = Apollo.SubscriptionResult<IAllocationCountryCreatedSubscription>;
export const AllocationCountryUpdatedDocument = gql`
    subscription allocationCountryUpdated($stock_id: ID!) {
  result: allocationCountryUpdated(stock_id: $stock_id) {
    ...HistoryAllocationCountryDetails
  }
}
    ${HistoryAllocationCountryDetailsFragmentDoc}`;

/**
 * __useAllocationCountryUpdatedSubscription__
 *
 * To run a query within a React component, call `useAllocationCountryUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAllocationCountryUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocationCountryUpdatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useAllocationCountryUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IAllocationCountryUpdatedSubscription, IAllocationCountryUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IAllocationCountryUpdatedSubscription, IAllocationCountryUpdatedSubscriptionVariables>(AllocationCountryUpdatedDocument, options);
      }
export type AllocationCountryUpdatedSubscriptionHookResult = ReturnType<typeof useAllocationCountryUpdatedSubscription>;
export type AllocationCountryUpdatedSubscriptionResult = Apollo.SubscriptionResult<IAllocationCountryUpdatedSubscription>;
export const AllocationCountryDeletedDocument = gql`
    subscription allocationCountryDeleted($stock_id: ID!) {
  result: allocationCountryDeleted(stock_id: $stock_id) {
    ...HistoryAllocationCountryDetails
  }
}
    ${HistoryAllocationCountryDetailsFragmentDoc}`;

/**
 * __useAllocationCountryDeletedSubscription__
 *
 * To run a query within a React component, call `useAllocationCountryDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAllocationCountryDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocationCountryDeletedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useAllocationCountryDeletedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IAllocationCountryDeletedSubscription, IAllocationCountryDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IAllocationCountryDeletedSubscription, IAllocationCountryDeletedSubscriptionVariables>(AllocationCountryDeletedDocument, options);
      }
export type AllocationCountryDeletedSubscriptionHookResult = ReturnType<typeof useAllocationCountryDeletedSubscription>;
export type AllocationCountryDeletedSubscriptionResult = Apollo.SubscriptionResult<IAllocationCountryDeletedSubscription>;
export const GetHistoryAwardsDocument = gql`
    query getHistoryAwards($stock_id: Int!) {
  result: getHistoryAwards(stock_id: $stock_id) {
    ...HistoryAwardDetails
  }
}
    ${HistoryAwardDetailsFragmentDoc}`;

/**
 * __useGetHistoryAwardsQuery__
 *
 * To run a query within a React component, call `useGetHistoryAwardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoryAwardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoryAwardsQuery({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useGetHistoryAwardsQuery(baseOptions: Apollo.QueryHookOptions<IGetHistoryAwardsQuery, IGetHistoryAwardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHistoryAwardsQuery, IGetHistoryAwardsQueryVariables>(GetHistoryAwardsDocument, options);
      }
export function useGetHistoryAwardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHistoryAwardsQuery, IGetHistoryAwardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHistoryAwardsQuery, IGetHistoryAwardsQueryVariables>(GetHistoryAwardsDocument, options);
        }
export type GetHistoryAwardsQueryHookResult = ReturnType<typeof useGetHistoryAwardsQuery>;
export type GetHistoryAwardsLazyQueryHookResult = ReturnType<typeof useGetHistoryAwardsLazyQuery>;
export type GetHistoryAwardsQueryResult = Apollo.QueryResult<IGetHistoryAwardsQuery, IGetHistoryAwardsQueryVariables>;
export const GetAwardTypesDocument = gql`
    query getAwardTypes {
  result: getAwardTypes {
    id
    name
  }
}
    `;

/**
 * __useGetAwardTypesQuery__
 *
 * To run a query within a React component, call `useGetAwardTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAwardTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAwardTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAwardTypesQuery(baseOptions?: Apollo.QueryHookOptions<IGetAwardTypesQuery, IGetAwardTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAwardTypesQuery, IGetAwardTypesQueryVariables>(GetAwardTypesDocument, options);
      }
export function useGetAwardTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAwardTypesQuery, IGetAwardTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAwardTypesQuery, IGetAwardTypesQueryVariables>(GetAwardTypesDocument, options);
        }
export type GetAwardTypesQueryHookResult = ReturnType<typeof useGetAwardTypesQuery>;
export type GetAwardTypesLazyQueryHookResult = ReturnType<typeof useGetAwardTypesLazyQuery>;
export type GetAwardTypesQueryResult = Apollo.QueryResult<IGetAwardTypesQuery, IGetAwardTypesQueryVariables>;
export const CreateAwardDocument = gql`
    mutation createAward($stock_id: ID!, $input: AwardInput!) {
  result: createAward(stock_id: $stock_id, input: $input) {
    ...HistoryAwardDetails
  }
}
    ${HistoryAwardDetailsFragmentDoc}`;
export type ICreateAwardMutationFn = Apollo.MutationFunction<ICreateAwardMutation, ICreateAwardMutationVariables>;

/**
 * __useCreateAwardMutation__
 *
 * To run a mutation, you first call `useCreateAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAwardMutation, { data, loading, error }] = useCreateAwardMutation({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAwardMutation(baseOptions?: Apollo.MutationHookOptions<ICreateAwardMutation, ICreateAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateAwardMutation, ICreateAwardMutationVariables>(CreateAwardDocument, options);
      }
export type CreateAwardMutationHookResult = ReturnType<typeof useCreateAwardMutation>;
export type CreateAwardMutationResult = Apollo.MutationResult<ICreateAwardMutation>;
export type CreateAwardMutationOptions = Apollo.BaseMutationOptions<ICreateAwardMutation, ICreateAwardMutationVariables>;
export const UpdateAwardDocument = gql`
    mutation updateAward($id: ID!, $input: AwardInput!) {
  result: updateAward(id: $id, input: $input) {
    ...HistoryAwardDetails
  }
}
    ${HistoryAwardDetailsFragmentDoc}`;
export type IUpdateAwardMutationFn = Apollo.MutationFunction<IUpdateAwardMutation, IUpdateAwardMutationVariables>;

/**
 * __useUpdateAwardMutation__
 *
 * To run a mutation, you first call `useUpdateAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwardMutation, { data, loading, error }] = useUpdateAwardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAwardMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAwardMutation, IUpdateAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAwardMutation, IUpdateAwardMutationVariables>(UpdateAwardDocument, options);
      }
export type UpdateAwardMutationHookResult = ReturnType<typeof useUpdateAwardMutation>;
export type UpdateAwardMutationResult = Apollo.MutationResult<IUpdateAwardMutation>;
export type UpdateAwardMutationOptions = Apollo.BaseMutationOptions<IUpdateAwardMutation, IUpdateAwardMutationVariables>;
export const DeleteAwardDocument = gql`
    mutation deleteAward($id: ID!) {
  result: deleteAward(id: $id)
}
    `;
export type IDeleteAwardMutationFn = Apollo.MutationFunction<IDeleteAwardMutation, IDeleteAwardMutationVariables>;

/**
 * __useDeleteAwardMutation__
 *
 * To run a mutation, you first call `useDeleteAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAwardMutation, { data, loading, error }] = useDeleteAwardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAwardMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteAwardMutation, IDeleteAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteAwardMutation, IDeleteAwardMutationVariables>(DeleteAwardDocument, options);
      }
export type DeleteAwardMutationHookResult = ReturnType<typeof useDeleteAwardMutation>;
export type DeleteAwardMutationResult = Apollo.MutationResult<IDeleteAwardMutation>;
export type DeleteAwardMutationOptions = Apollo.BaseMutationOptions<IDeleteAwardMutation, IDeleteAwardMutationVariables>;
export const AwardCreatedDocument = gql`
    subscription awardCreated($stock_id: ID!) {
  result: awardCreated(stock_id: $stock_id) {
    ...HistoryAwardDetails
  }
}
    ${HistoryAwardDetailsFragmentDoc}`;

/**
 * __useAwardCreatedSubscription__
 *
 * To run a query within a React component, call `useAwardCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAwardCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardCreatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useAwardCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IAwardCreatedSubscription, IAwardCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IAwardCreatedSubscription, IAwardCreatedSubscriptionVariables>(AwardCreatedDocument, options);
      }
export type AwardCreatedSubscriptionHookResult = ReturnType<typeof useAwardCreatedSubscription>;
export type AwardCreatedSubscriptionResult = Apollo.SubscriptionResult<IAwardCreatedSubscription>;
export const AwardUpdatedDocument = gql`
    subscription awardUpdated($stock_id: ID!) {
  result: awardUpdated(stock_id: $stock_id) {
    ...HistoryAwardDetails
  }
}
    ${HistoryAwardDetailsFragmentDoc}`;

/**
 * __useAwardUpdatedSubscription__
 *
 * To run a query within a React component, call `useAwardUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAwardUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardUpdatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useAwardUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IAwardUpdatedSubscription, IAwardUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IAwardUpdatedSubscription, IAwardUpdatedSubscriptionVariables>(AwardUpdatedDocument, options);
      }
export type AwardUpdatedSubscriptionHookResult = ReturnType<typeof useAwardUpdatedSubscription>;
export type AwardUpdatedSubscriptionResult = Apollo.SubscriptionResult<IAwardUpdatedSubscription>;
export const AwardDeletedDocument = gql`
    subscription awardDeleted($stock_id: ID!) {
  result: awardDeleted(stock_id: $stock_id) {
    ...HistoryAwardDetails
  }
}
    ${HistoryAwardDetailsFragmentDoc}`;

/**
 * __useAwardDeletedSubscription__
 *
 * To run a query within a React component, call `useAwardDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAwardDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardDeletedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useAwardDeletedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IAwardDeletedSubscription, IAwardDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IAwardDeletedSubscription, IAwardDeletedSubscriptionVariables>(AwardDeletedDocument, options);
      }
export type AwardDeletedSubscriptionHookResult = ReturnType<typeof useAwardDeletedSubscription>;
export type AwardDeletedSubscriptionResult = Apollo.SubscriptionResult<IAwardDeletedSubscription>;
export const GetHistoryConstituentsDocument = gql`
    query getHistoryConstituents($stock_id: Int!, $date: String) {
  result: getHistoryConstituents(stock_id: $stock_id, date: $date) {
    id
    weight_perc
    date
    index {
      id
      name
    }
    history_index {
      id
      dividend_yield
    }
    rank
  }
}
    `;

/**
 * __useGetHistoryConstituentsQuery__
 *
 * To run a query within a React component, call `useGetHistoryConstituentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoryConstituentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoryConstituentsQuery({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetHistoryConstituentsQuery(baseOptions: Apollo.QueryHookOptions<IGetHistoryConstituentsQuery, IGetHistoryConstituentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHistoryConstituentsQuery, IGetHistoryConstituentsQueryVariables>(GetHistoryConstituentsDocument, options);
      }
export function useGetHistoryConstituentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHistoryConstituentsQuery, IGetHistoryConstituentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHistoryConstituentsQuery, IGetHistoryConstituentsQueryVariables>(GetHistoryConstituentsDocument, options);
        }
export type GetHistoryConstituentsQueryHookResult = ReturnType<typeof useGetHistoryConstituentsQuery>;
export type GetHistoryConstituentsLazyQueryHookResult = ReturnType<typeof useGetHistoryConstituentsLazyQuery>;
export type GetHistoryConstituentsQueryResult = Apollo.QueryResult<IGetHistoryConstituentsQuery, IGetHistoryConstituentsQueryVariables>;
export const GetHistoryConstituentsByIndexDocument = gql`
    query getHistoryConstituentsByIndex($index_id: Int!, $date: String) {
  result: getHistoryConstituentsByIndex(index_id: $index_id, date: $date) {
    ...HistoryConstituentDetails
  }
}
    ${HistoryConstituentDetailsFragmentDoc}`;

/**
 * __useGetHistoryConstituentsByIndexQuery__
 *
 * To run a query within a React component, call `useGetHistoryConstituentsByIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoryConstituentsByIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoryConstituentsByIndexQuery({
 *   variables: {
 *      index_id: // value for 'index_id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetHistoryConstituentsByIndexQuery(baseOptions: Apollo.QueryHookOptions<IGetHistoryConstituentsByIndexQuery, IGetHistoryConstituentsByIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHistoryConstituentsByIndexQuery, IGetHistoryConstituentsByIndexQueryVariables>(GetHistoryConstituentsByIndexDocument, options);
      }
export function useGetHistoryConstituentsByIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHistoryConstituentsByIndexQuery, IGetHistoryConstituentsByIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHistoryConstituentsByIndexQuery, IGetHistoryConstituentsByIndexQueryVariables>(GetHistoryConstituentsByIndexDocument, options);
        }
export type GetHistoryConstituentsByIndexQueryHookResult = ReturnType<typeof useGetHistoryConstituentsByIndexQuery>;
export type GetHistoryConstituentsByIndexLazyQueryHookResult = ReturnType<typeof useGetHistoryConstituentsByIndexLazyQuery>;
export type GetHistoryConstituentsByIndexQueryResult = Apollo.QueryResult<IGetHistoryConstituentsByIndexQuery, IGetHistoryConstituentsByIndexQueryVariables>;
export const GetHistoryKpisDocument = gql`
    query getHistoryKpis($stock_id: Int!) {
  result: historyKpis(stock_id: $stock_id) {
    ...HistoryKpiDetails
  }
}
    ${HistoryKpiDetailsFragmentDoc}`;

/**
 * __useGetHistoryKpisQuery__
 *
 * To run a query within a React component, call `useGetHistoryKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoryKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoryKpisQuery({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useGetHistoryKpisQuery(baseOptions: Apollo.QueryHookOptions<IGetHistoryKpisQuery, IGetHistoryKpisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHistoryKpisQuery, IGetHistoryKpisQueryVariables>(GetHistoryKpisDocument, options);
      }
export function useGetHistoryKpisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHistoryKpisQuery, IGetHistoryKpisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHistoryKpisQuery, IGetHistoryKpisQueryVariables>(GetHistoryKpisDocument, options);
        }
export type GetHistoryKpisQueryHookResult = ReturnType<typeof useGetHistoryKpisQuery>;
export type GetHistoryKpisLazyQueryHookResult = ReturnType<typeof useGetHistoryKpisLazyQuery>;
export type GetHistoryKpisQueryResult = Apollo.QueryResult<IGetHistoryKpisQuery, IGetHistoryKpisQueryVariables>;
export const CreateKpiDocument = gql`
    mutation createKpi($stock_id: ID!, $input: KpiInput!) {
  result: createKpi(stock_id: $stock_id, input: $input) {
    ...HistoryKpiDetails
  }
}
    ${HistoryKpiDetailsFragmentDoc}`;
export type ICreateKpiMutationFn = Apollo.MutationFunction<ICreateKpiMutation, ICreateKpiMutationVariables>;

/**
 * __useCreateKpiMutation__
 *
 * To run a mutation, you first call `useCreateKpiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKpiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKpiMutation, { data, loading, error }] = useCreateKpiMutation({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKpiMutation(baseOptions?: Apollo.MutationHookOptions<ICreateKpiMutation, ICreateKpiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateKpiMutation, ICreateKpiMutationVariables>(CreateKpiDocument, options);
      }
export type CreateKpiMutationHookResult = ReturnType<typeof useCreateKpiMutation>;
export type CreateKpiMutationResult = Apollo.MutationResult<ICreateKpiMutation>;
export type CreateKpiMutationOptions = Apollo.BaseMutationOptions<ICreateKpiMutation, ICreateKpiMutationVariables>;
export const UpdateKpiDocument = gql`
    mutation updateKpi($id: ID!, $input: KpiInput!) {
  result: updateKpi(id: $id, input: $input) {
    ...HistoryKpiDetails
  }
}
    ${HistoryKpiDetailsFragmentDoc}`;
export type IUpdateKpiMutationFn = Apollo.MutationFunction<IUpdateKpiMutation, IUpdateKpiMutationVariables>;

/**
 * __useUpdateKpiMutation__
 *
 * To run a mutation, you first call `useUpdateKpiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKpiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKpiMutation, { data, loading, error }] = useUpdateKpiMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKpiMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateKpiMutation, IUpdateKpiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateKpiMutation, IUpdateKpiMutationVariables>(UpdateKpiDocument, options);
      }
export type UpdateKpiMutationHookResult = ReturnType<typeof useUpdateKpiMutation>;
export type UpdateKpiMutationResult = Apollo.MutationResult<IUpdateKpiMutation>;
export type UpdateKpiMutationOptions = Apollo.BaseMutationOptions<IUpdateKpiMutation, IUpdateKpiMutationVariables>;
export const DeleteKpiDocument = gql`
    mutation deleteKpi($id: ID!) {
  return: deleteKpi(id: $id)
}
    `;
export type IDeleteKpiMutationFn = Apollo.MutationFunction<IDeleteKpiMutation, IDeleteKpiMutationVariables>;

/**
 * __useDeleteKpiMutation__
 *
 * To run a mutation, you first call `useDeleteKpiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKpiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKpiMutation, { data, loading, error }] = useDeleteKpiMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKpiMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteKpiMutation, IDeleteKpiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteKpiMutation, IDeleteKpiMutationVariables>(DeleteKpiDocument, options);
      }
export type DeleteKpiMutationHookResult = ReturnType<typeof useDeleteKpiMutation>;
export type DeleteKpiMutationResult = Apollo.MutationResult<IDeleteKpiMutation>;
export type DeleteKpiMutationOptions = Apollo.BaseMutationOptions<IDeleteKpiMutation, IDeleteKpiMutationVariables>;
export const KpiCreatedDocument = gql`
    subscription kpiCreated($stock_id: ID!) {
  result: kpiCreated(stock_id: $stock_id) {
    ...HistoryKpiDetails
  }
}
    ${HistoryKpiDetailsFragmentDoc}`;

/**
 * __useKpiCreatedSubscription__
 *
 * To run a query within a React component, call `useKpiCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useKpiCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiCreatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useKpiCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IKpiCreatedSubscription, IKpiCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IKpiCreatedSubscription, IKpiCreatedSubscriptionVariables>(KpiCreatedDocument, options);
      }
export type KpiCreatedSubscriptionHookResult = ReturnType<typeof useKpiCreatedSubscription>;
export type KpiCreatedSubscriptionResult = Apollo.SubscriptionResult<IKpiCreatedSubscription>;
export const KpiUpdatedDocument = gql`
    subscription kpiUpdated($stock_id: ID!) {
  result: kpiUpdated(stock_id: $stock_id) {
    ...HistoryKpiDetails
  }
}
    ${HistoryKpiDetailsFragmentDoc}`;

/**
 * __useKpiUpdatedSubscription__
 *
 * To run a query within a React component, call `useKpiUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useKpiUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiUpdatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useKpiUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IKpiUpdatedSubscription, IKpiUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IKpiUpdatedSubscription, IKpiUpdatedSubscriptionVariables>(KpiUpdatedDocument, options);
      }
export type KpiUpdatedSubscriptionHookResult = ReturnType<typeof useKpiUpdatedSubscription>;
export type KpiUpdatedSubscriptionResult = Apollo.SubscriptionResult<IKpiUpdatedSubscription>;
export const KpiDeletedDocument = gql`
    subscription kpiDeleted($stock_id: ID!) {
  result: kpiDeleted(stock_id: $stock_id) {
    ...HistoryKpiDetails
  }
}
    ${HistoryKpiDetailsFragmentDoc}`;

/**
 * __useKpiDeletedSubscription__
 *
 * To run a query within a React component, call `useKpiDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useKpiDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiDeletedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useKpiDeletedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IKpiDeletedSubscription, IKpiDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IKpiDeletedSubscription, IKpiDeletedSubscriptionVariables>(KpiDeletedDocument, options);
      }
export type KpiDeletedSubscriptionHookResult = ReturnType<typeof useKpiDeletedSubscription>;
export type KpiDeletedSubscriptionResult = Apollo.SubscriptionResult<IKpiDeletedSubscription>;
export const GetHistoryLtvsDocument = gql`
    query getHistoryLtvs($stock_id: Int!) {
  result: getHistoryLtvs(stock_id: $stock_id) {
    ...HistoryLtvDetails
  }
}
    ${HistoryLtvDetailsFragmentDoc}`;

/**
 * __useGetHistoryLtvsQuery__
 *
 * To run a query within a React component, call `useGetHistoryLtvsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoryLtvsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoryLtvsQuery({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useGetHistoryLtvsQuery(baseOptions: Apollo.QueryHookOptions<IGetHistoryLtvsQuery, IGetHistoryLtvsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHistoryLtvsQuery, IGetHistoryLtvsQueryVariables>(GetHistoryLtvsDocument, options);
      }
export function useGetHistoryLtvsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHistoryLtvsQuery, IGetHistoryLtvsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHistoryLtvsQuery, IGetHistoryLtvsQueryVariables>(GetHistoryLtvsDocument, options);
        }
export type GetHistoryLtvsQueryHookResult = ReturnType<typeof useGetHistoryLtvsQuery>;
export type GetHistoryLtvsLazyQueryHookResult = ReturnType<typeof useGetHistoryLtvsLazyQuery>;
export type GetHistoryLtvsQueryResult = Apollo.QueryResult<IGetHistoryLtvsQuery, IGetHistoryLtvsQueryVariables>;
export const CreateLtvDocument = gql`
    mutation createLtv($stock_id: ID!, $input: LtvInput!) {
  result: createLtv(stock_id: $stock_id, input: $input) {
    ...HistoryLtvDetails
  }
}
    ${HistoryLtvDetailsFragmentDoc}`;
export type ICreateLtvMutationFn = Apollo.MutationFunction<ICreateLtvMutation, ICreateLtvMutationVariables>;

/**
 * __useCreateLtvMutation__
 *
 * To run a mutation, you first call `useCreateLtvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLtvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLtvMutation, { data, loading, error }] = useCreateLtvMutation({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLtvMutation(baseOptions?: Apollo.MutationHookOptions<ICreateLtvMutation, ICreateLtvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateLtvMutation, ICreateLtvMutationVariables>(CreateLtvDocument, options);
      }
export type CreateLtvMutationHookResult = ReturnType<typeof useCreateLtvMutation>;
export type CreateLtvMutationResult = Apollo.MutationResult<ICreateLtvMutation>;
export type CreateLtvMutationOptions = Apollo.BaseMutationOptions<ICreateLtvMutation, ICreateLtvMutationVariables>;
export const UpdateLtvDocument = gql`
    mutation updateLtv($id: ID!, $input: LtvInput!) {
  result: updateLtv(id: $id, input: $input) {
    ...HistoryLtvDetails
  }
}
    ${HistoryLtvDetailsFragmentDoc}`;
export type IUpdateLtvMutationFn = Apollo.MutationFunction<IUpdateLtvMutation, IUpdateLtvMutationVariables>;

/**
 * __useUpdateLtvMutation__
 *
 * To run a mutation, you first call `useUpdateLtvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLtvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLtvMutation, { data, loading, error }] = useUpdateLtvMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLtvMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateLtvMutation, IUpdateLtvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateLtvMutation, IUpdateLtvMutationVariables>(UpdateLtvDocument, options);
      }
export type UpdateLtvMutationHookResult = ReturnType<typeof useUpdateLtvMutation>;
export type UpdateLtvMutationResult = Apollo.MutationResult<IUpdateLtvMutation>;
export type UpdateLtvMutationOptions = Apollo.BaseMutationOptions<IUpdateLtvMutation, IUpdateLtvMutationVariables>;
export const DeleteLtvDocument = gql`
    mutation deleteLtv($id: ID!) {
  result: deleteLtv(id: $id)
}
    `;
export type IDeleteLtvMutationFn = Apollo.MutationFunction<IDeleteLtvMutation, IDeleteLtvMutationVariables>;

/**
 * __useDeleteLtvMutation__
 *
 * To run a mutation, you first call `useDeleteLtvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLtvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLtvMutation, { data, loading, error }] = useDeleteLtvMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLtvMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteLtvMutation, IDeleteLtvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteLtvMutation, IDeleteLtvMutationVariables>(DeleteLtvDocument, options);
      }
export type DeleteLtvMutationHookResult = ReturnType<typeof useDeleteLtvMutation>;
export type DeleteLtvMutationResult = Apollo.MutationResult<IDeleteLtvMutation>;
export type DeleteLtvMutationOptions = Apollo.BaseMutationOptions<IDeleteLtvMutation, IDeleteLtvMutationVariables>;
export const LtvCreatedDocument = gql`
    subscription ltvCreated($stock_id: ID!) {
  result: ltvCreated(stock_id: $stock_id) {
    ...HistoryLtvDetails
  }
}
    ${HistoryLtvDetailsFragmentDoc}`;

/**
 * __useLtvCreatedSubscription__
 *
 * To run a query within a React component, call `useLtvCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLtvCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLtvCreatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useLtvCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ILtvCreatedSubscription, ILtvCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ILtvCreatedSubscription, ILtvCreatedSubscriptionVariables>(LtvCreatedDocument, options);
      }
export type LtvCreatedSubscriptionHookResult = ReturnType<typeof useLtvCreatedSubscription>;
export type LtvCreatedSubscriptionResult = Apollo.SubscriptionResult<ILtvCreatedSubscription>;
export const LtvUpdatedDocument = gql`
    subscription ltvUpdated($stock_id: ID!) {
  result: ltvUpdated(stock_id: $stock_id) {
    ...HistoryLtvDetails
  }
}
    ${HistoryLtvDetailsFragmentDoc}`;

/**
 * __useLtvUpdatedSubscription__
 *
 * To run a query within a React component, call `useLtvUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLtvUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLtvUpdatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useLtvUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ILtvUpdatedSubscription, ILtvUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ILtvUpdatedSubscription, ILtvUpdatedSubscriptionVariables>(LtvUpdatedDocument, options);
      }
export type LtvUpdatedSubscriptionHookResult = ReturnType<typeof useLtvUpdatedSubscription>;
export type LtvUpdatedSubscriptionResult = Apollo.SubscriptionResult<ILtvUpdatedSubscription>;
export const LtvDeletedDocument = gql`
    subscription ltvDeleted($stock_id: ID!) {
  result: ltvDeleted(stock_id: $stock_id) {
    ...HistoryLtvDetails
  }
}
    ${HistoryLtvDetailsFragmentDoc}`;

/**
 * __useLtvDeletedSubscription__
 *
 * To run a query within a React component, call `useLtvDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLtvDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLtvDeletedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useLtvDeletedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ILtvDeletedSubscription, ILtvDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ILtvDeletedSubscription, ILtvDeletedSubscriptionVariables>(LtvDeletedDocument, options);
      }
export type LtvDeletedSubscriptionHookResult = ReturnType<typeof useLtvDeletedSubscription>;
export type LtvDeletedSubscriptionResult = Apollo.SubscriptionResult<ILtvDeletedSubscription>;
export const GetHistoryRecalcsDocument = gql`
    query getHistoryRecalcs($stock_id: Int!) {
  result: getHistoryRecalcs(stock_id: $stock_id) {
    ...HistoryRecalcDetails
  }
}
    ${HistoryRecalcDetailsFragmentDoc}`;

/**
 * __useGetHistoryRecalcsQuery__
 *
 * To run a query within a React component, call `useGetHistoryRecalcsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoryRecalcsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoryRecalcsQuery({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useGetHistoryRecalcsQuery(baseOptions: Apollo.QueryHookOptions<IGetHistoryRecalcsQuery, IGetHistoryRecalcsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHistoryRecalcsQuery, IGetHistoryRecalcsQueryVariables>(GetHistoryRecalcsDocument, options);
      }
export function useGetHistoryRecalcsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHistoryRecalcsQuery, IGetHistoryRecalcsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHistoryRecalcsQuery, IGetHistoryRecalcsQueryVariables>(GetHistoryRecalcsDocument, options);
        }
export type GetHistoryRecalcsQueryHookResult = ReturnType<typeof useGetHistoryRecalcsQuery>;
export type GetHistoryRecalcsLazyQueryHookResult = ReturnType<typeof useGetHistoryRecalcsLazyQuery>;
export type GetHistoryRecalcsQueryResult = Apollo.QueryResult<IGetHistoryRecalcsQuery, IGetHistoryRecalcsQueryVariables>;
export const GetRecalcOperatorsDocument = gql`
    query getRecalcOperators {
  result: getRecalcOperators {
    id
    value
  }
}
    `;

/**
 * __useGetRecalcOperatorsQuery__
 *
 * To run a query within a React component, call `useGetRecalcOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecalcOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecalcOperatorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecalcOperatorsQuery(baseOptions?: Apollo.QueryHookOptions<IGetRecalcOperatorsQuery, IGetRecalcOperatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRecalcOperatorsQuery, IGetRecalcOperatorsQueryVariables>(GetRecalcOperatorsDocument, options);
      }
export function useGetRecalcOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRecalcOperatorsQuery, IGetRecalcOperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRecalcOperatorsQuery, IGetRecalcOperatorsQueryVariables>(GetRecalcOperatorsDocument, options);
        }
export type GetRecalcOperatorsQueryHookResult = ReturnType<typeof useGetRecalcOperatorsQuery>;
export type GetRecalcOperatorsLazyQueryHookResult = ReturnType<typeof useGetRecalcOperatorsLazyQuery>;
export type GetRecalcOperatorsQueryResult = Apollo.QueryResult<IGetRecalcOperatorsQuery, IGetRecalcOperatorsQueryVariables>;
export const CreateHistoryRecalcDocument = gql`
    mutation createHistoryRecalc($stock_id: ID!, $input: HistoryRecalcInput!) {
  result: createHistoryRecalc(stock_id: $stock_id, input: $input) {
    ...HistoryRecalcDetails
  }
}
    ${HistoryRecalcDetailsFragmentDoc}`;
export type ICreateHistoryRecalcMutationFn = Apollo.MutationFunction<ICreateHistoryRecalcMutation, ICreateHistoryRecalcMutationVariables>;

/**
 * __useCreateHistoryRecalcMutation__
 *
 * To run a mutation, you first call `useCreateHistoryRecalcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHistoryRecalcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHistoryRecalcMutation, { data, loading, error }] = useCreateHistoryRecalcMutation({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHistoryRecalcMutation(baseOptions?: Apollo.MutationHookOptions<ICreateHistoryRecalcMutation, ICreateHistoryRecalcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateHistoryRecalcMutation, ICreateHistoryRecalcMutationVariables>(CreateHistoryRecalcDocument, options);
      }
export type CreateHistoryRecalcMutationHookResult = ReturnType<typeof useCreateHistoryRecalcMutation>;
export type CreateHistoryRecalcMutationResult = Apollo.MutationResult<ICreateHistoryRecalcMutation>;
export type CreateHistoryRecalcMutationOptions = Apollo.BaseMutationOptions<ICreateHistoryRecalcMutation, ICreateHistoryRecalcMutationVariables>;
export const RecalcRollbackDocument = gql`
    mutation recalcRollback($id: ID!) {
  result: recalcRollback(id: $id) {
    ...HistoryRecalcDetails
  }
}
    ${HistoryRecalcDetailsFragmentDoc}`;
export type IRecalcRollbackMutationFn = Apollo.MutationFunction<IRecalcRollbackMutation, IRecalcRollbackMutationVariables>;

/**
 * __useRecalcRollbackMutation__
 *
 * To run a mutation, you first call `useRecalcRollbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalcRollbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalcRollbackMutation, { data, loading, error }] = useRecalcRollbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecalcRollbackMutation(baseOptions?: Apollo.MutationHookOptions<IRecalcRollbackMutation, IRecalcRollbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRecalcRollbackMutation, IRecalcRollbackMutationVariables>(RecalcRollbackDocument, options);
      }
export type RecalcRollbackMutationHookResult = ReturnType<typeof useRecalcRollbackMutation>;
export type RecalcRollbackMutationResult = Apollo.MutationResult<IRecalcRollbackMutation>;
export type RecalcRollbackMutationOptions = Apollo.BaseMutationOptions<IRecalcRollbackMutation, IRecalcRollbackMutationVariables>;
export const UpdateHistoryRecalcDocument = gql`
    mutation updateHistoryRecalc($id: ID!, $stock_id: ID!, $input: HistoryRecalcInput!) {
  result: updateHistoryRecalc(id: $id, stock_id: $stock_id, input: $input) {
    ...HistoryRecalcDetails
  }
}
    ${HistoryRecalcDetailsFragmentDoc}`;
export type IUpdateHistoryRecalcMutationFn = Apollo.MutationFunction<IUpdateHistoryRecalcMutation, IUpdateHistoryRecalcMutationVariables>;

/**
 * __useUpdateHistoryRecalcMutation__
 *
 * To run a mutation, you first call `useUpdateHistoryRecalcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHistoryRecalcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHistoryRecalcMutation, { data, loading, error }] = useUpdateHistoryRecalcMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stock_id: // value for 'stock_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHistoryRecalcMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateHistoryRecalcMutation, IUpdateHistoryRecalcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateHistoryRecalcMutation, IUpdateHistoryRecalcMutationVariables>(UpdateHistoryRecalcDocument, options);
      }
export type UpdateHistoryRecalcMutationHookResult = ReturnType<typeof useUpdateHistoryRecalcMutation>;
export type UpdateHistoryRecalcMutationResult = Apollo.MutationResult<IUpdateHistoryRecalcMutation>;
export type UpdateHistoryRecalcMutationOptions = Apollo.BaseMutationOptions<IUpdateHistoryRecalcMutation, IUpdateHistoryRecalcMutationVariables>;
export const HistoryRecalcCreatedDocument = gql`
    subscription historyRecalcCreated($stock_id: ID!) {
  result: historyRecalcCreated(stock_id: $stock_id) {
    ...HistoryRecalcDetails
  }
}
    ${HistoryRecalcDetailsFragmentDoc}`;

/**
 * __useHistoryRecalcCreatedSubscription__
 *
 * To run a query within a React component, call `useHistoryRecalcCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHistoryRecalcCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryRecalcCreatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useHistoryRecalcCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IHistoryRecalcCreatedSubscription, IHistoryRecalcCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IHistoryRecalcCreatedSubscription, IHistoryRecalcCreatedSubscriptionVariables>(HistoryRecalcCreatedDocument, options);
      }
export type HistoryRecalcCreatedSubscriptionHookResult = ReturnType<typeof useHistoryRecalcCreatedSubscription>;
export type HistoryRecalcCreatedSubscriptionResult = Apollo.SubscriptionResult<IHistoryRecalcCreatedSubscription>;
export const HistoryRecalcUpdatedDocument = gql`
    subscription historyRecalcUpdated($stock_id: ID!) {
  result: historyRecalcUpdated(stock_id: $stock_id) {
    ...HistoryRecalcDetails
  }
}
    ${HistoryRecalcDetailsFragmentDoc}`;

/**
 * __useHistoryRecalcUpdatedSubscription__
 *
 * To run a query within a React component, call `useHistoryRecalcUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHistoryRecalcUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryRecalcUpdatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useHistoryRecalcUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<IHistoryRecalcUpdatedSubscription, IHistoryRecalcUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IHistoryRecalcUpdatedSubscription, IHistoryRecalcUpdatedSubscriptionVariables>(HistoryRecalcUpdatedDocument, options);
      }
export type HistoryRecalcUpdatedSubscriptionHookResult = ReturnType<typeof useHistoryRecalcUpdatedSubscription>;
export type HistoryRecalcUpdatedSubscriptionResult = Apollo.SubscriptionResult<IHistoryRecalcUpdatedSubscription>;
export const IndexSeriesDocument = gql`
    query indexSeries {
  result: indexSeries {
    ...indexSeriesDetails
  }
}
    ${IndexSeriesDetailsFragmentDoc}`;

/**
 * __useIndexSeriesQuery__
 *
 * To run a query within a React component, call `useIndexSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexSeriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndexSeriesQuery(baseOptions?: Apollo.QueryHookOptions<IIndexSeriesQuery, IIndexSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IIndexSeriesQuery, IIndexSeriesQueryVariables>(IndexSeriesDocument, options);
      }
export function useIndexSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IIndexSeriesQuery, IIndexSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IIndexSeriesQuery, IIndexSeriesQueryVariables>(IndexSeriesDocument, options);
        }
export type IndexSeriesQueryHookResult = ReturnType<typeof useIndexSeriesQuery>;
export type IndexSeriesLazyQueryHookResult = ReturnType<typeof useIndexSeriesLazyQuery>;
export type IndexSeriesQueryResult = Apollo.QueryResult<IIndexSeriesQuery, IIndexSeriesQueryVariables>;
export const DeleteIndexSerieDocument = gql`
    mutation deleteIndexSerie($id: ID!) {
  result: deleteIndexSerie(id: $id)
}
    `;
export type IDeleteIndexSerieMutationFn = Apollo.MutationFunction<IDeleteIndexSerieMutation, IDeleteIndexSerieMutationVariables>;

/**
 * __useDeleteIndexSerieMutation__
 *
 * To run a mutation, you first call `useDeleteIndexSerieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndexSerieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndexSerieMutation, { data, loading, error }] = useDeleteIndexSerieMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndexSerieMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteIndexSerieMutation, IDeleteIndexSerieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteIndexSerieMutation, IDeleteIndexSerieMutationVariables>(DeleteIndexSerieDocument, options);
      }
export type DeleteIndexSerieMutationHookResult = ReturnType<typeof useDeleteIndexSerieMutation>;
export type DeleteIndexSerieMutationResult = Apollo.MutationResult<IDeleteIndexSerieMutation>;
export type DeleteIndexSerieMutationOptions = Apollo.BaseMutationOptions<IDeleteIndexSerieMutation, IDeleteIndexSerieMutationVariables>;
export const CreateIndexSerieDocument = gql`
    mutation createIndexSerie($input: IndexSerieInput!) {
  result: createIndexSerie(input: $input) {
    ...indexSeriesDetails
  }
}
    ${IndexSeriesDetailsFragmentDoc}`;
export type ICreateIndexSerieMutationFn = Apollo.MutationFunction<ICreateIndexSerieMutation, ICreateIndexSerieMutationVariables>;

/**
 * __useCreateIndexSerieMutation__
 *
 * To run a mutation, you first call `useCreateIndexSerieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndexSerieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndexSerieMutation, { data, loading, error }] = useCreateIndexSerieMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndexSerieMutation(baseOptions?: Apollo.MutationHookOptions<ICreateIndexSerieMutation, ICreateIndexSerieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateIndexSerieMutation, ICreateIndexSerieMutationVariables>(CreateIndexSerieDocument, options);
      }
export type CreateIndexSerieMutationHookResult = ReturnType<typeof useCreateIndexSerieMutation>;
export type CreateIndexSerieMutationResult = Apollo.MutationResult<ICreateIndexSerieMutation>;
export type CreateIndexSerieMutationOptions = Apollo.BaseMutationOptions<ICreateIndexSerieMutation, ICreateIndexSerieMutationVariables>;
export const UpdateIndexSerieDocument = gql`
    mutation updateIndexSerie($id: ID!, $input: IndexSerieInput!) {
  result: updateIndexSerie(id: $id, input: $input) {
    ...indexSeriesDetails
  }
}
    ${IndexSeriesDetailsFragmentDoc}`;
export type IUpdateIndexSerieMutationFn = Apollo.MutationFunction<IUpdateIndexSerieMutation, IUpdateIndexSerieMutationVariables>;

/**
 * __useUpdateIndexSerieMutation__
 *
 * To run a mutation, you first call `useUpdateIndexSerieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndexSerieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndexSerieMutation, { data, loading, error }] = useUpdateIndexSerieMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndexSerieMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateIndexSerieMutation, IUpdateIndexSerieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateIndexSerieMutation, IUpdateIndexSerieMutationVariables>(UpdateIndexSerieDocument, options);
      }
export type UpdateIndexSerieMutationHookResult = ReturnType<typeof useUpdateIndexSerieMutation>;
export type UpdateIndexSerieMutationResult = Apollo.MutationResult<IUpdateIndexSerieMutation>;
export type UpdateIndexSerieMutationOptions = Apollo.BaseMutationOptions<IUpdateIndexSerieMutation, IUpdateIndexSerieMutationVariables>;
export const IndexSerieDeletedDocument = gql`
    subscription indexSerieDeleted {
  result: indexSerieDeleted {
    id
    name
  }
}
    `;

/**
 * __useIndexSerieDeletedSubscription__
 *
 * To run a query within a React component, call `useIndexSerieDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIndexSerieDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexSerieDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIndexSerieDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IIndexSerieDeletedSubscription, IIndexSerieDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IIndexSerieDeletedSubscription, IIndexSerieDeletedSubscriptionVariables>(IndexSerieDeletedDocument, options);
      }
export type IndexSerieDeletedSubscriptionHookResult = ReturnType<typeof useIndexSerieDeletedSubscription>;
export type IndexSerieDeletedSubscriptionResult = Apollo.SubscriptionResult<IIndexSerieDeletedSubscription>;
export const IndexSerieCreatedDocument = gql`
    subscription indexSerieCreated {
  result: indexSerieCreated {
    ...indexSeriesDetails
  }
}
    ${IndexSeriesDetailsFragmentDoc}`;

/**
 * __useIndexSerieCreatedSubscription__
 *
 * To run a query within a React component, call `useIndexSerieCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIndexSerieCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexSerieCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIndexSerieCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IIndexSerieCreatedSubscription, IIndexSerieCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IIndexSerieCreatedSubscription, IIndexSerieCreatedSubscriptionVariables>(IndexSerieCreatedDocument, options);
      }
export type IndexSerieCreatedSubscriptionHookResult = ReturnType<typeof useIndexSerieCreatedSubscription>;
export type IndexSerieCreatedSubscriptionResult = Apollo.SubscriptionResult<IIndexSerieCreatedSubscription>;
export const IndexSerieUpdatedDocument = gql`
    subscription indexSerieUpdated {
  result: indexSerieUpdated {
    ...indexSeriesDetails
  }
}
    ${IndexSeriesDetailsFragmentDoc}`;

/**
 * __useIndexSerieUpdatedSubscription__
 *
 * To run a query within a React component, call `useIndexSerieUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIndexSerieUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexSerieUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIndexSerieUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IIndexSerieUpdatedSubscription, IIndexSerieUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IIndexSerieUpdatedSubscription, IIndexSerieUpdatedSubscriptionVariables>(IndexSerieUpdatedDocument, options);
      }
export type IndexSerieUpdatedSubscriptionHookResult = ReturnType<typeof useIndexSerieUpdatedSubscription>;
export type IndexSerieUpdatedSubscriptionResult = Apollo.SubscriptionResult<IIndexSerieUpdatedSubscription>;
export const IndicesDocument = gql`
    query indices {
  result: indices {
    ...IndiceDetails
  }
}
    ${IndiceDetailsFragmentDoc}`;

/**
 * __useIndicesQuery__
 *
 * To run a query within a React component, call `useIndicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndicesQuery(baseOptions?: Apollo.QueryHookOptions<IIndicesQuery, IIndicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IIndicesQuery, IIndicesQueryVariables>(IndicesDocument, options);
      }
export function useIndicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IIndicesQuery, IIndicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IIndicesQuery, IIndicesQueryVariables>(IndicesDocument, options);
        }
export type IndicesQueryHookResult = ReturnType<typeof useIndicesQuery>;
export type IndicesLazyQueryHookResult = ReturnType<typeof useIndicesLazyQuery>;
export type IndicesQueryResult = Apollo.QueryResult<IIndicesQuery, IIndicesQueryVariables>;
export const CreateIndexDocument = gql`
    mutation createIndex($input: IndexInput!) {
  result: createIndex(input: $input) {
    ...IndiceDetails
  }
}
    ${IndiceDetailsFragmentDoc}`;
export type ICreateIndexMutationFn = Apollo.MutationFunction<ICreateIndexMutation, ICreateIndexMutationVariables>;

/**
 * __useCreateIndexMutation__
 *
 * To run a mutation, you first call `useCreateIndexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndexMutation, { data, loading, error }] = useCreateIndexMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndexMutation(baseOptions?: Apollo.MutationHookOptions<ICreateIndexMutation, ICreateIndexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateIndexMutation, ICreateIndexMutationVariables>(CreateIndexDocument, options);
      }
export type CreateIndexMutationHookResult = ReturnType<typeof useCreateIndexMutation>;
export type CreateIndexMutationResult = Apollo.MutationResult<ICreateIndexMutation>;
export type CreateIndexMutationOptions = Apollo.BaseMutationOptions<ICreateIndexMutation, ICreateIndexMutationVariables>;
export const DeleteIndexDocument = gql`
    mutation deleteIndex($id: ID!) {
  result: deleteIndex(id: $id)
}
    `;
export type IDeleteIndexMutationFn = Apollo.MutationFunction<IDeleteIndexMutation, IDeleteIndexMutationVariables>;

/**
 * __useDeleteIndexMutation__
 *
 * To run a mutation, you first call `useDeleteIndexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndexMutation, { data, loading, error }] = useDeleteIndexMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndexMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteIndexMutation, IDeleteIndexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteIndexMutation, IDeleteIndexMutationVariables>(DeleteIndexDocument, options);
      }
export type DeleteIndexMutationHookResult = ReturnType<typeof useDeleteIndexMutation>;
export type DeleteIndexMutationResult = Apollo.MutationResult<IDeleteIndexMutation>;
export type DeleteIndexMutationOptions = Apollo.BaseMutationOptions<IDeleteIndexMutation, IDeleteIndexMutationVariables>;
export const UpdateIndexDocument = gql`
    mutation updateIndex($id: ID!, $input: IndexInput!) {
  result: updateIndex(id: $id, input: $input) {
    ...IndiceDetails
  }
}
    ${IndiceDetailsFragmentDoc}`;
export type IUpdateIndexMutationFn = Apollo.MutationFunction<IUpdateIndexMutation, IUpdateIndexMutationVariables>;

/**
 * __useUpdateIndexMutation__
 *
 * To run a mutation, you first call `useUpdateIndexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndexMutation, { data, loading, error }] = useUpdateIndexMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndexMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateIndexMutation, IUpdateIndexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateIndexMutation, IUpdateIndexMutationVariables>(UpdateIndexDocument, options);
      }
export type UpdateIndexMutationHookResult = ReturnType<typeof useUpdateIndexMutation>;
export type UpdateIndexMutationResult = Apollo.MutationResult<IUpdateIndexMutation>;
export type UpdateIndexMutationOptions = Apollo.BaseMutationOptions<IUpdateIndexMutation, IUpdateIndexMutationVariables>;
export const IndexCreatedDocument = gql`
    subscription indexCreated {
  result: indexCreated {
    ...IndiceDetails
  }
}
    ${IndiceDetailsFragmentDoc}`;

/**
 * __useIndexCreatedSubscription__
 *
 * To run a query within a React component, call `useIndexCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIndexCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIndexCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IIndexCreatedSubscription, IIndexCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IIndexCreatedSubscription, IIndexCreatedSubscriptionVariables>(IndexCreatedDocument, options);
      }
export type IndexCreatedSubscriptionHookResult = ReturnType<typeof useIndexCreatedSubscription>;
export type IndexCreatedSubscriptionResult = Apollo.SubscriptionResult<IIndexCreatedSubscription>;
export const IndexDeletedDocument = gql`
    subscription indexDeleted {
  result: indexDeleted {
    ...IndiceDetails
  }
}
    ${IndiceDetailsFragmentDoc}`;

/**
 * __useIndexDeletedSubscription__
 *
 * To run a query within a React component, call `useIndexDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIndexDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIndexDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IIndexDeletedSubscription, IIndexDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IIndexDeletedSubscription, IIndexDeletedSubscriptionVariables>(IndexDeletedDocument, options);
      }
export type IndexDeletedSubscriptionHookResult = ReturnType<typeof useIndexDeletedSubscription>;
export type IndexDeletedSubscriptionResult = Apollo.SubscriptionResult<IIndexDeletedSubscription>;
export const IndexUpdatedDocument = gql`
    subscription indexUpdated {
  result: indexUpdated {
    ...IndiceDetails
  }
}
    ${IndiceDetailsFragmentDoc}`;

/**
 * __useIndexUpdatedSubscription__
 *
 * To run a query within a React component, call `useIndexUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIndexUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIndexUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IIndexUpdatedSubscription, IIndexUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IIndexUpdatedSubscription, IIndexUpdatedSubscriptionVariables>(IndexUpdatedDocument, options);
      }
export type IndexUpdatedSubscriptionHookResult = ReturnType<typeof useIndexUpdatedSubscription>;
export type IndexUpdatedSubscriptionResult = Apollo.SubscriptionResult<IIndexUpdatedSubscription>;
export const GetInterestGroupsDocument = gql`
    query getInterestGroups {
  result: interestGroups {
    id
    name
    interests {
      name
      id
    }
  }
}
    `;

/**
 * __useGetInterestGroupsQuery__
 *
 * To run a query within a React component, call `useGetInterestGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterestGroupsQuery(baseOptions?: Apollo.QueryHookOptions<IGetInterestGroupsQuery, IGetInterestGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetInterestGroupsQuery, IGetInterestGroupsQueryVariables>(GetInterestGroupsDocument, options);
      }
export function useGetInterestGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetInterestGroupsQuery, IGetInterestGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetInterestGroupsQuery, IGetInterestGroupsQueryVariables>(GetInterestGroupsDocument, options);
        }
export type GetInterestGroupsQueryHookResult = ReturnType<typeof useGetInterestGroupsQuery>;
export type GetInterestGroupsLazyQueryHookResult = ReturnType<typeof useGetInterestGroupsLazyQuery>;
export type GetInterestGroupsQueryResult = Apollo.QueryResult<IGetInterestGroupsQuery, IGetInterestGroupsQueryVariables>;
export const AddInterestToGroupDocument = gql`
    mutation addInterestToGroup($input: NewInterestInput!) {
  result: addInterestToGroup(input: $input) {
    id
    name
  }
}
    `;
export type IAddInterestToGroupMutationFn = Apollo.MutationFunction<IAddInterestToGroupMutation, IAddInterestToGroupMutationVariables>;

/**
 * __useAddInterestToGroupMutation__
 *
 * To run a mutation, you first call `useAddInterestToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInterestToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInterestToGroupMutation, { data, loading, error }] = useAddInterestToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInterestToGroupMutation(baseOptions?: Apollo.MutationHookOptions<IAddInterestToGroupMutation, IAddInterestToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddInterestToGroupMutation, IAddInterestToGroupMutationVariables>(AddInterestToGroupDocument, options);
      }
export type AddInterestToGroupMutationHookResult = ReturnType<typeof useAddInterestToGroupMutation>;
export type AddInterestToGroupMutationResult = Apollo.MutationResult<IAddInterestToGroupMutation>;
export type AddInterestToGroupMutationOptions = Apollo.BaseMutationOptions<IAddInterestToGroupMutation, IAddInterestToGroupMutationVariables>;
export const DeleteInterestDocument = gql`
    mutation deleteInterest($id: Int!) {
  result: deleteInterest(id: $id)
}
    `;
export type IDeleteInterestMutationFn = Apollo.MutationFunction<IDeleteInterestMutation, IDeleteInterestMutationVariables>;

/**
 * __useDeleteInterestMutation__
 *
 * To run a mutation, you first call `useDeleteInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInterestMutation, { data, loading, error }] = useDeleteInterestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInterestMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteInterestMutation, IDeleteInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteInterestMutation, IDeleteInterestMutationVariables>(DeleteInterestDocument, options);
      }
export type DeleteInterestMutationHookResult = ReturnType<typeof useDeleteInterestMutation>;
export type DeleteInterestMutationResult = Apollo.MutationResult<IDeleteInterestMutation>;
export type DeleteInterestMutationOptions = Apollo.BaseMutationOptions<IDeleteInterestMutation, IDeleteInterestMutationVariables>;
export const InterestDeletedDocument = gql`
    subscription InterestDeleted {
  result: interestDeleted {
    id
    interest_group {
      id
    }
  }
}
    `;

/**
 * __useInterestDeletedSubscription__
 *
 * To run a query within a React component, call `useInterestDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInterestDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterestDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useInterestDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IInterestDeletedSubscription, IInterestDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IInterestDeletedSubscription, IInterestDeletedSubscriptionVariables>(InterestDeletedDocument, options);
      }
export type InterestDeletedSubscriptionHookResult = ReturnType<typeof useInterestDeletedSubscription>;
export type InterestDeletedSubscriptionResult = Apollo.SubscriptionResult<IInterestDeletedSubscription>;
export const GetInterestsDocument = gql`
    query getInterests {
  result: interests {
    id
    name
    interest_group {
      id
    }
  }
}
    `;

/**
 * __useGetInterestsQuery__
 *
 * To run a query within a React component, call `useGetInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterestsQuery(baseOptions?: Apollo.QueryHookOptions<IGetInterestsQuery, IGetInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetInterestsQuery, IGetInterestsQueryVariables>(GetInterestsDocument, options);
      }
export function useGetInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetInterestsQuery, IGetInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetInterestsQuery, IGetInterestsQueryVariables>(GetInterestsDocument, options);
        }
export type GetInterestsQueryHookResult = ReturnType<typeof useGetInterestsQuery>;
export type GetInterestsLazyQueryHookResult = ReturnType<typeof useGetInterestsLazyQuery>;
export type GetInterestsQueryResult = Apollo.QueryResult<IGetInterestsQuery, IGetInterestsQueryVariables>;
export const InvestmentFocusesDocument = gql`
    query investmentFocuses {
  result: investmentFocuses {
    id
    name
  }
}
    `;

/**
 * __useInvestmentFocusesQuery__
 *
 * To run a query within a React component, call `useInvestmentFocusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentFocusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentFocusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestmentFocusesQuery(baseOptions?: Apollo.QueryHookOptions<IInvestmentFocusesQuery, IInvestmentFocusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IInvestmentFocusesQuery, IInvestmentFocusesQueryVariables>(InvestmentFocusesDocument, options);
      }
export function useInvestmentFocusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInvestmentFocusesQuery, IInvestmentFocusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IInvestmentFocusesQuery, IInvestmentFocusesQueryVariables>(InvestmentFocusesDocument, options);
        }
export type InvestmentFocusesQueryHookResult = ReturnType<typeof useInvestmentFocusesQuery>;
export type InvestmentFocusesLazyQueryHookResult = ReturnType<typeof useInvestmentFocusesLazyQuery>;
export type InvestmentFocusesQueryResult = Apollo.QueryResult<IInvestmentFocusesQuery, IInvestmentFocusesQueryVariables>;
export const InvoicesForMembershipDocument = gql`
    query invoicesForMembership($membership_id: Int!) {
  result: invoicesForMembership(membership_id: $membership_id) {
    ...InvoiceDtoFull
  }
}
    ${InvoiceDtoFullFragmentDoc}`;

/**
 * __useInvoicesForMembershipQuery__
 *
 * To run a query within a React component, call `useInvoicesForMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesForMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesForMembershipQuery({
 *   variables: {
 *      membership_id: // value for 'membership_id'
 *   },
 * });
 */
export function useInvoicesForMembershipQuery(baseOptions: Apollo.QueryHookOptions<IInvoicesForMembershipQuery, IInvoicesForMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IInvoicesForMembershipQuery, IInvoicesForMembershipQueryVariables>(InvoicesForMembershipDocument, options);
      }
export function useInvoicesForMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInvoicesForMembershipQuery, IInvoicesForMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IInvoicesForMembershipQuery, IInvoicesForMembershipQueryVariables>(InvoicesForMembershipDocument, options);
        }
export type InvoicesForMembershipQueryHookResult = ReturnType<typeof useInvoicesForMembershipQuery>;
export type InvoicesForMembershipLazyQueryHookResult = ReturnType<typeof useInvoicesForMembershipLazyQuery>;
export type InvoicesForMembershipQueryResult = Apollo.QueryResult<IInvoicesForMembershipQuery, IInvoicesForMembershipQueryVariables>;
export const InvoicesDocument = gql`
    query invoices {
  result: invoices {
    ...InvoiceDtoFull
  }
}
    ${InvoiceDtoFullFragmentDoc}`;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<IInvoicesQuery, IInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IInvoicesQuery, IInvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInvoicesQuery, IInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IInvoicesQuery, IInvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<IInvoicesQuery, IInvoicesQueryVariables>;
export const InvoicesFilteredDocument = gql`
    query invoicesFiltered($filter: InvoiceFilterInput) {
  result: invoicesFiltered(filter: $filter) {
    invoices {
      ...InvoiceDtoFull
    }
    total
  }
}
    ${InvoiceDtoFullFragmentDoc}`;

/**
 * __useInvoicesFilteredQuery__
 *
 * To run a query within a React component, call `useInvoicesFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesFilteredQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInvoicesFilteredQuery(baseOptions?: Apollo.QueryHookOptions<IInvoicesFilteredQuery, IInvoicesFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IInvoicesFilteredQuery, IInvoicesFilteredQueryVariables>(InvoicesFilteredDocument, options);
      }
export function useInvoicesFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInvoicesFilteredQuery, IInvoicesFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IInvoicesFilteredQuery, IInvoicesFilteredQueryVariables>(InvoicesFilteredDocument, options);
        }
export type InvoicesFilteredQueryHookResult = ReturnType<typeof useInvoicesFilteredQuery>;
export type InvoicesFilteredLazyQueryHookResult = ReturnType<typeof useInvoicesFilteredLazyQuery>;
export type InvoicesFilteredQueryResult = Apollo.QueryResult<IInvoicesFilteredQuery, IInvoicesFilteredQueryVariables>;
export const InvoiceClientOptionsDocument = gql`
    query invoiceClientOptions($membership_id: Int!) {
  result: invoiceClientOptions(membership_id: $membership_id) {
    companies {
      id
      name
      main_address {
        id
        complete_vat_number
      }
    }
    contacts {
      id
      fullName
      first_name
      last_name
      email
      title_external
      prefix
      address {
        id
        name
        street
        city
        zip
        country {
          id
          name
          region {
            id
            name
          }
        }
      }
      company {
        id
        name
        main_address {
          id
          complete_vat_number
        }
      }
    }
  }
}
    `;

/**
 * __useInvoiceClientOptionsQuery__
 *
 * To run a query within a React component, call `useInvoiceClientOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceClientOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceClientOptionsQuery({
 *   variables: {
 *      membership_id: // value for 'membership_id'
 *   },
 * });
 */
export function useInvoiceClientOptionsQuery(baseOptions: Apollo.QueryHookOptions<IInvoiceClientOptionsQuery, IInvoiceClientOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IInvoiceClientOptionsQuery, IInvoiceClientOptionsQueryVariables>(InvoiceClientOptionsDocument, options);
      }
export function useInvoiceClientOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInvoiceClientOptionsQuery, IInvoiceClientOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IInvoiceClientOptionsQuery, IInvoiceClientOptionsQueryVariables>(InvoiceClientOptionsDocument, options);
        }
export type InvoiceClientOptionsQueryHookResult = ReturnType<typeof useInvoiceClientOptionsQuery>;
export type InvoiceClientOptionsLazyQueryHookResult = ReturnType<typeof useInvoiceClientOptionsLazyQuery>;
export type InvoiceClientOptionsQueryResult = Apollo.QueryResult<IInvoiceClientOptionsQuery, IInvoiceClientOptionsQueryVariables>;
export const PaymentDetailsDocument = gql`
    query paymentDetails($id: Int) {
  result: paymentDetails(id: $id) {
    ...PaymentDetails
  }
}
    ${PaymentDetailsFragmentDoc}`;

/**
 * __usePaymentDetailsQuery__
 *
 * To run a query within a React component, call `usePaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentDetailsQuery(baseOptions?: Apollo.QueryHookOptions<IPaymentDetailsQuery, IPaymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPaymentDetailsQuery, IPaymentDetailsQueryVariables>(PaymentDetailsDocument, options);
      }
export function usePaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPaymentDetailsQuery, IPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPaymentDetailsQuery, IPaymentDetailsQueryVariables>(PaymentDetailsDocument, options);
        }
export type PaymentDetailsQueryHookResult = ReturnType<typeof usePaymentDetailsQuery>;
export type PaymentDetailsLazyQueryHookResult = ReturnType<typeof usePaymentDetailsLazyQuery>;
export type PaymentDetailsQueryResult = Apollo.QueryResult<IPaymentDetailsQuery, IPaymentDetailsQueryVariables>;
export const AddPaymentDetailsDocument = gql`
    mutation addPaymentDetails($input: NewPaymentDetailsInput!) {
  result: createPaymentDetails(input: $input) {
    ...PaymentDetails
  }
}
    ${PaymentDetailsFragmentDoc}`;
export type IAddPaymentDetailsMutationFn = Apollo.MutationFunction<IAddPaymentDetailsMutation, IAddPaymentDetailsMutationVariables>;

/**
 * __useAddPaymentDetailsMutation__
 *
 * To run a mutation, you first call `useAddPaymentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentDetailsMutation, { data, loading, error }] = useAddPaymentDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPaymentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<IAddPaymentDetailsMutation, IAddPaymentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddPaymentDetailsMutation, IAddPaymentDetailsMutationVariables>(AddPaymentDetailsDocument, options);
      }
export type AddPaymentDetailsMutationHookResult = ReturnType<typeof useAddPaymentDetailsMutation>;
export type AddPaymentDetailsMutationResult = Apollo.MutationResult<IAddPaymentDetailsMutation>;
export type AddPaymentDetailsMutationOptions = Apollo.BaseMutationOptions<IAddPaymentDetailsMutation, IAddPaymentDetailsMutationVariables>;
export const DeleteInvoiceDocument = gql`
    mutation deleteInvoice($id: Int!) {
  result: deleteInvoice(id: $id)
}
    `;
export type IDeleteInvoiceMutationFn = Apollo.MutationFunction<IDeleteInvoiceMutation, IDeleteInvoiceMutationVariables>;

/**
 * __useDeleteInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceMutation, { data, loading, error }] = useDeleteInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteInvoiceMutation, IDeleteInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteInvoiceMutation, IDeleteInvoiceMutationVariables>(DeleteInvoiceDocument, options);
      }
export type DeleteInvoiceMutationHookResult = ReturnType<typeof useDeleteInvoiceMutation>;
export type DeleteInvoiceMutationResult = Apollo.MutationResult<IDeleteInvoiceMutation>;
export type DeleteInvoiceMutationOptions = Apollo.BaseMutationOptions<IDeleteInvoiceMutation, IDeleteInvoiceMutationVariables>;
export const PayInvoiceDocument = gql`
    mutation payInvoice($id: Int!, $date_paid: String) {
  result: payInvoice(id: $id, date_paid: $date_paid) {
    ...InvoiceDtoFull
  }
}
    ${InvoiceDtoFullFragmentDoc}`;
export type IPayInvoiceMutationFn = Apollo.MutationFunction<IPayInvoiceMutation, IPayInvoiceMutationVariables>;

/**
 * __usePayInvoiceMutation__
 *
 * To run a mutation, you first call `usePayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payInvoiceMutation, { data, loading, error }] = usePayInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date_paid: // value for 'date_paid'
 *   },
 * });
 */
export function usePayInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<IPayInvoiceMutation, IPayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IPayInvoiceMutation, IPayInvoiceMutationVariables>(PayInvoiceDocument, options);
      }
export type PayInvoiceMutationHookResult = ReturnType<typeof usePayInvoiceMutation>;
export type PayInvoiceMutationResult = Apollo.MutationResult<IPayInvoiceMutation>;
export type PayInvoiceMutationOptions = Apollo.BaseMutationOptions<IPayInvoiceMutation, IPayInvoiceMutationVariables>;
export const CreateInvoiceDocument = gql`
    mutation createInvoice($input: InvoiceInput!) {
  result: createInvoice(input: $input) {
    ...InvoiceDtoFull
  }
}
    ${InvoiceDtoFullFragmentDoc}`;
export type ICreateInvoiceMutationFn = Apollo.MutationFunction<ICreateInvoiceMutation, ICreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ICreateInvoiceMutation, ICreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateInvoiceMutation, ICreateInvoiceMutationVariables>(CreateInvoiceDocument, options);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<ICreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<ICreateInvoiceMutation, ICreateInvoiceMutationVariables>;
export const UpdateInvoiceDocument = gql`
    mutation updateInvoice($id: Int!, $input: InvoiceInput!) {
  result: updateInvoice(id: $id, input: $input) {
    ...InvoiceDtoFull
  }
}
    ${InvoiceDtoFullFragmentDoc}`;
export type IUpdateInvoiceMutationFn = Apollo.MutationFunction<IUpdateInvoiceMutation, IUpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateInvoiceMutation, IUpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateInvoiceMutation, IUpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<IUpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<IUpdateInvoiceMutation, IUpdateInvoiceMutationVariables>;
export const CreateCreditNoteDocument = gql`
    mutation createCreditNote($id: Int!) {
  result: createCreditNote(id: $id) {
    ...InvoiceDtoFull
  }
}
    ${InvoiceDtoFullFragmentDoc}`;
export type ICreateCreditNoteMutationFn = Apollo.MutationFunction<ICreateCreditNoteMutation, ICreateCreditNoteMutationVariables>;

/**
 * __useCreateCreditNoteMutation__
 *
 * To run a mutation, you first call `useCreateCreditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditNoteMutation, { data, loading, error }] = useCreateCreditNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateCreditNoteMutation(baseOptions?: Apollo.MutationHookOptions<ICreateCreditNoteMutation, ICreateCreditNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateCreditNoteMutation, ICreateCreditNoteMutationVariables>(CreateCreditNoteDocument, options);
      }
export type CreateCreditNoteMutationHookResult = ReturnType<typeof useCreateCreditNoteMutation>;
export type CreateCreditNoteMutationResult = Apollo.MutationResult<ICreateCreditNoteMutation>;
export type CreateCreditNoteMutationOptions = Apollo.BaseMutationOptions<ICreateCreditNoteMutation, ICreateCreditNoteMutationVariables>;
export const ConfirmInvoiceDocument = gql`
    mutation confirmInvoice($id: Int!) {
  result: confirmInvoice(id: $id) {
    ...InvoiceDtoFull
  }
}
    ${InvoiceDtoFullFragmentDoc}`;
export type IConfirmInvoiceMutationFn = Apollo.MutationFunction<IConfirmInvoiceMutation, IConfirmInvoiceMutationVariables>;

/**
 * __useConfirmInvoiceMutation__
 *
 * To run a mutation, you first call `useConfirmInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmInvoiceMutation, { data, loading, error }] = useConfirmInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<IConfirmInvoiceMutation, IConfirmInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IConfirmInvoiceMutation, IConfirmInvoiceMutationVariables>(ConfirmInvoiceDocument, options);
      }
export type ConfirmInvoiceMutationHookResult = ReturnType<typeof useConfirmInvoiceMutation>;
export type ConfirmInvoiceMutationResult = Apollo.MutationResult<IConfirmInvoiceMutation>;
export type ConfirmInvoiceMutationOptions = Apollo.BaseMutationOptions<IConfirmInvoiceMutation, IConfirmInvoiceMutationVariables>;
export const InvoiceDeletedDocument = gql`
    subscription invoiceDeleted {
  result: invoiceDeleted {
    id
  }
}
    `;

/**
 * __useInvoiceDeletedSubscription__
 *
 * To run a query within a React component, call `useInvoiceDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useInvoiceDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IInvoiceDeletedSubscription, IInvoiceDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IInvoiceDeletedSubscription, IInvoiceDeletedSubscriptionVariables>(InvoiceDeletedDocument, options);
      }
export type InvoiceDeletedSubscriptionHookResult = ReturnType<typeof useInvoiceDeletedSubscription>;
export type InvoiceDeletedSubscriptionResult = Apollo.SubscriptionResult<IInvoiceDeletedSubscription>;
export const InvoiceUpdatedDocument = gql`
    subscription invoiceUpdated {
  result: invoiceUpdated {
    ...InvoiceDtoFull
  }
}
    ${InvoiceDtoFullFragmentDoc}`;

/**
 * __useInvoiceUpdatedSubscription__
 *
 * To run a query within a React component, call `useInvoiceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useInvoiceUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IInvoiceUpdatedSubscription, IInvoiceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IInvoiceUpdatedSubscription, IInvoiceUpdatedSubscriptionVariables>(InvoiceUpdatedDocument, options);
      }
export type InvoiceUpdatedSubscriptionHookResult = ReturnType<typeof useInvoiceUpdatedSubscription>;
export type InvoiceUpdatedSubscriptionResult = Apollo.SubscriptionResult<IInvoiceUpdatedSubscription>;
export const InvoiceCreatedDocument = gql`
    subscription invoiceCreated {
  result: invoiceCreated {
    ...InvoiceDtoFull
  }
}
    ${InvoiceDtoFullFragmentDoc}`;

/**
 * __useInvoiceCreatedSubscription__
 *
 * To run a query within a React component, call `useInvoiceCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useInvoiceCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IInvoiceCreatedSubscription, IInvoiceCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IInvoiceCreatedSubscription, IInvoiceCreatedSubscriptionVariables>(InvoiceCreatedDocument, options);
      }
export type InvoiceCreatedSubscriptionHookResult = ReturnType<typeof useInvoiceCreatedSubscription>;
export type InvoiceCreatedSubscriptionResult = Apollo.SubscriptionResult<IInvoiceCreatedSubscription>;
export const SinginDocument = gql`
    mutation singin($input: SigninInput!) {
  result: signin(input: $input) {
    token
    user {
      id
      username
      roles
      first_name
      last_name
      password
    }
  }
}
    `;
export type ISinginMutationFn = Apollo.MutationFunction<ISinginMutation, ISinginMutationVariables>;

/**
 * __useSinginMutation__
 *
 * To run a mutation, you first call `useSinginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [singinMutation, { data, loading, error }] = useSinginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinginMutation(baseOptions?: Apollo.MutationHookOptions<ISinginMutation, ISinginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISinginMutation, ISinginMutationVariables>(SinginDocument, options);
      }
export type SinginMutationHookResult = ReturnType<typeof useSinginMutation>;
export type SinginMutationResult = Apollo.MutationResult<ISinginMutation>;
export type SinginMutationOptions = Apollo.BaseMutationOptions<ISinginMutation, ISinginMutationVariables>;
export const SendInvoiceForApprovalDocument = gql`
    mutation sendInvoiceForApproval($id: Int!, $pdf_content: String!) {
  result: sendInvoiceForApproval(id: $id, pdf_content: $pdf_content)
}
    `;
export type ISendInvoiceForApprovalMutationFn = Apollo.MutationFunction<ISendInvoiceForApprovalMutation, ISendInvoiceForApprovalMutationVariables>;

/**
 * __useSendInvoiceForApprovalMutation__
 *
 * To run a mutation, you first call `useSendInvoiceForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoiceForApprovalMutation, { data, loading, error }] = useSendInvoiceForApprovalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pdf_content: // value for 'pdf_content'
 *   },
 * });
 */
export function useSendInvoiceForApprovalMutation(baseOptions?: Apollo.MutationHookOptions<ISendInvoiceForApprovalMutation, ISendInvoiceForApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISendInvoiceForApprovalMutation, ISendInvoiceForApprovalMutationVariables>(SendInvoiceForApprovalDocument, options);
      }
export type SendInvoiceForApprovalMutationHookResult = ReturnType<typeof useSendInvoiceForApprovalMutation>;
export type SendInvoiceForApprovalMutationResult = Apollo.MutationResult<ISendInvoiceForApprovalMutation>;
export type SendInvoiceForApprovalMutationOptions = Apollo.BaseMutationOptions<ISendInvoiceForApprovalMutation, ISendInvoiceForApprovalMutationVariables>;
export const SendInvoiceToCustomerDocument = gql`
    mutation sendInvoiceToCustomer($id: Int!, $pdf_content: String!, $cc_emails: [String]) {
  result: sendInvoiceToCustomer(
    id: $id
    pdf_content: $pdf_content
    cc_emails: $cc_emails
  )
}
    `;
export type ISendInvoiceToCustomerMutationFn = Apollo.MutationFunction<ISendInvoiceToCustomerMutation, ISendInvoiceToCustomerMutationVariables>;

/**
 * __useSendInvoiceToCustomerMutation__
 *
 * To run a mutation, you first call `useSendInvoiceToCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceToCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoiceToCustomerMutation, { data, loading, error }] = useSendInvoiceToCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pdf_content: // value for 'pdf_content'
 *      cc_emails: // value for 'cc_emails'
 *   },
 * });
 */
export function useSendInvoiceToCustomerMutation(baseOptions?: Apollo.MutationHookOptions<ISendInvoiceToCustomerMutation, ISendInvoiceToCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISendInvoiceToCustomerMutation, ISendInvoiceToCustomerMutationVariables>(SendInvoiceToCustomerDocument, options);
      }
export type SendInvoiceToCustomerMutationHookResult = ReturnType<typeof useSendInvoiceToCustomerMutation>;
export type SendInvoiceToCustomerMutationResult = Apollo.MutationResult<ISendInvoiceToCustomerMutation>;
export type SendInvoiceToCustomerMutationOptions = Apollo.BaseMutationOptions<ISendInvoiceToCustomerMutation, ISendInvoiceToCustomerMutationVariables>;
export const MarketActivitiesDocument = gql`
    query marketActivities {
  result: marketActivities {
    id
    name
  }
}
    `;

/**
 * __useMarketActivitiesQuery__
 *
 * To run a query within a React component, call `useMarketActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<IMarketActivitiesQuery, IMarketActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMarketActivitiesQuery, IMarketActivitiesQueryVariables>(MarketActivitiesDocument, options);
      }
export function useMarketActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMarketActivitiesQuery, IMarketActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMarketActivitiesQuery, IMarketActivitiesQueryVariables>(MarketActivitiesDocument, options);
        }
export type MarketActivitiesQueryHookResult = ReturnType<typeof useMarketActivitiesQuery>;
export type MarketActivitiesLazyQueryHookResult = ReturnType<typeof useMarketActivitiesLazyQuery>;
export type MarketActivitiesQueryResult = Apollo.QueryResult<IMarketActivitiesQuery, IMarketActivitiesQueryVariables>;
export const MeetingsMeetingTypeDocument = gql`
    query meetingsMeetingType {
  result: meetingsMeetingType {
    ...MeetingsMeetingTypeDetails
  }
}
    ${MeetingsMeetingTypeDetailsFragmentDoc}`;

/**
 * __useMeetingsMeetingTypeQuery__
 *
 * To run a query within a React component, call `useMeetingsMeetingTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingsMeetingTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingsMeetingTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeetingsMeetingTypeQuery(baseOptions?: Apollo.QueryHookOptions<IMeetingsMeetingTypeQuery, IMeetingsMeetingTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMeetingsMeetingTypeQuery, IMeetingsMeetingTypeQueryVariables>(MeetingsMeetingTypeDocument, options);
      }
export function useMeetingsMeetingTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMeetingsMeetingTypeQuery, IMeetingsMeetingTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMeetingsMeetingTypeQuery, IMeetingsMeetingTypeQueryVariables>(MeetingsMeetingTypeDocument, options);
        }
export type MeetingsMeetingTypeQueryHookResult = ReturnType<typeof useMeetingsMeetingTypeQuery>;
export type MeetingsMeetingTypeLazyQueryHookResult = ReturnType<typeof useMeetingsMeetingTypeLazyQuery>;
export type MeetingsMeetingTypeQueryResult = Apollo.QueryResult<IMeetingsMeetingTypeQuery, IMeetingsMeetingTypeQueryVariables>;
export const GetMeetingTypesDocument = gql`
    query getMeetingTypes {
  result: getMeetingTypes {
    ...MeetingsMeetingTypeDetails
  }
}
    ${MeetingsMeetingTypeDetailsFragmentDoc}`;

/**
 * __useGetMeetingTypesQuery__
 *
 * To run a query within a React component, call `useGetMeetingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeetingTypesQuery(baseOptions?: Apollo.QueryHookOptions<IGetMeetingTypesQuery, IGetMeetingTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetMeetingTypesQuery, IGetMeetingTypesQueryVariables>(GetMeetingTypesDocument, options);
      }
export function useGetMeetingTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetMeetingTypesQuery, IGetMeetingTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetMeetingTypesQuery, IGetMeetingTypesQueryVariables>(GetMeetingTypesDocument, options);
        }
export type GetMeetingTypesQueryHookResult = ReturnType<typeof useGetMeetingTypesQuery>;
export type GetMeetingTypesLazyQueryHookResult = ReturnType<typeof useGetMeetingTypesLazyQuery>;
export type GetMeetingTypesQueryResult = Apollo.QueryResult<IGetMeetingTypesQuery, IGetMeetingTypesQueryVariables>;
export const CreateMeetingTypeDocument = gql`
    mutation createMeetingType($name: String!) {
  result: createMeetingType(name: $name) {
    ...MeetingsMeetingTypeDetails
  }
}
    ${MeetingsMeetingTypeDetailsFragmentDoc}`;
export type ICreateMeetingTypeMutationFn = Apollo.MutationFunction<ICreateMeetingTypeMutation, ICreateMeetingTypeMutationVariables>;

/**
 * __useCreateMeetingTypeMutation__
 *
 * To run a mutation, you first call `useCreateMeetingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingTypeMutation, { data, loading, error }] = useCreateMeetingTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateMeetingTypeMutation(baseOptions?: Apollo.MutationHookOptions<ICreateMeetingTypeMutation, ICreateMeetingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateMeetingTypeMutation, ICreateMeetingTypeMutationVariables>(CreateMeetingTypeDocument, options);
      }
export type CreateMeetingTypeMutationHookResult = ReturnType<typeof useCreateMeetingTypeMutation>;
export type CreateMeetingTypeMutationResult = Apollo.MutationResult<ICreateMeetingTypeMutation>;
export type CreateMeetingTypeMutationOptions = Apollo.BaseMutationOptions<ICreateMeetingTypeMutation, ICreateMeetingTypeMutationVariables>;
export const UpdateMeetingTypeDocument = gql`
    mutation updateMeetingType($id: ID!, $name: String!) {
  result: updateMeetingType(id: $id, name: $name) {
    ...MeetingsMeetingTypeDetails
  }
}
    ${MeetingsMeetingTypeDetailsFragmentDoc}`;
export type IUpdateMeetingTypeMutationFn = Apollo.MutationFunction<IUpdateMeetingTypeMutation, IUpdateMeetingTypeMutationVariables>;

/**
 * __useUpdateMeetingTypeMutation__
 *
 * To run a mutation, you first call `useUpdateMeetingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeetingTypeMutation, { data, loading, error }] = useUpdateMeetingTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateMeetingTypeMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateMeetingTypeMutation, IUpdateMeetingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateMeetingTypeMutation, IUpdateMeetingTypeMutationVariables>(UpdateMeetingTypeDocument, options);
      }
export type UpdateMeetingTypeMutationHookResult = ReturnType<typeof useUpdateMeetingTypeMutation>;
export type UpdateMeetingTypeMutationResult = Apollo.MutationResult<IUpdateMeetingTypeMutation>;
export type UpdateMeetingTypeMutationOptions = Apollo.BaseMutationOptions<IUpdateMeetingTypeMutation, IUpdateMeetingTypeMutationVariables>;
export const DeleteMeetingTypeDocument = gql`
    mutation deleteMeetingType($id: ID!) {
  result: deleteMeetingType(id: $id)
}
    `;
export type IDeleteMeetingTypeMutationFn = Apollo.MutationFunction<IDeleteMeetingTypeMutation, IDeleteMeetingTypeMutationVariables>;

/**
 * __useDeleteMeetingTypeMutation__
 *
 * To run a mutation, you first call `useDeleteMeetingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeetingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeetingTypeMutation, { data, loading, error }] = useDeleteMeetingTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMeetingTypeMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteMeetingTypeMutation, IDeleteMeetingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteMeetingTypeMutation, IDeleteMeetingTypeMutationVariables>(DeleteMeetingTypeDocument, options);
      }
export type DeleteMeetingTypeMutationHookResult = ReturnType<typeof useDeleteMeetingTypeMutation>;
export type DeleteMeetingTypeMutationResult = Apollo.MutationResult<IDeleteMeetingTypeMutation>;
export type DeleteMeetingTypeMutationOptions = Apollo.BaseMutationOptions<IDeleteMeetingTypeMutation, IDeleteMeetingTypeMutationVariables>;
export const MeetingsDocument = gql`
    query meetings {
  result: meetings {
    ...MeetingDetails
  }
}
    ${MeetingDetailsFragmentDoc}`;

/**
 * __useMeetingsQuery__
 *
 * To run a query within a React component, call `useMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeetingsQuery(baseOptions?: Apollo.QueryHookOptions<IMeetingsQuery, IMeetingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMeetingsQuery, IMeetingsQueryVariables>(MeetingsDocument, options);
      }
export function useMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMeetingsQuery, IMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMeetingsQuery, IMeetingsQueryVariables>(MeetingsDocument, options);
        }
export type MeetingsQueryHookResult = ReturnType<typeof useMeetingsQuery>;
export type MeetingsLazyQueryHookResult = ReturnType<typeof useMeetingsLazyQuery>;
export type MeetingsQueryResult = Apollo.QueryResult<IMeetingsQuery, IMeetingsQueryVariables>;
export const MeetingDocument = gql`
    query meeting($id: Int!) {
  result: meeting(id: $id) {
    ...MeetingDetails
  }
}
    ${MeetingDetailsFragmentDoc}`;

/**
 * __useMeetingQuery__
 *
 * To run a query within a React component, call `useMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMeetingQuery(baseOptions: Apollo.QueryHookOptions<IMeetingQuery, IMeetingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMeetingQuery, IMeetingQueryVariables>(MeetingDocument, options);
      }
export function useMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMeetingQuery, IMeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMeetingQuery, IMeetingQueryVariables>(MeetingDocument, options);
        }
export type MeetingQueryHookResult = ReturnType<typeof useMeetingQuery>;
export type MeetingLazyQueryHookResult = ReturnType<typeof useMeetingLazyQuery>;
export type MeetingQueryResult = Apollo.QueryResult<IMeetingQuery, IMeetingQueryVariables>;
export const AllMeetingsForContactDocument = gql`
    query allMeetingsForContact($contact_id: Int!) {
  result: allMeetingsForContact(contact_id: $contact_id) {
    ...MeetingDetails
  }
}
    ${MeetingDetailsFragmentDoc}`;

/**
 * __useAllMeetingsForContactQuery__
 *
 * To run a query within a React component, call `useAllMeetingsForContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMeetingsForContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMeetingsForContactQuery({
 *   variables: {
 *      contact_id: // value for 'contact_id'
 *   },
 * });
 */
export function useAllMeetingsForContactQuery(baseOptions: Apollo.QueryHookOptions<IAllMeetingsForContactQuery, IAllMeetingsForContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllMeetingsForContactQuery, IAllMeetingsForContactQueryVariables>(AllMeetingsForContactDocument, options);
      }
export function useAllMeetingsForContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllMeetingsForContactQuery, IAllMeetingsForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllMeetingsForContactQuery, IAllMeetingsForContactQueryVariables>(AllMeetingsForContactDocument, options);
        }
export type AllMeetingsForContactQueryHookResult = ReturnType<typeof useAllMeetingsForContactQuery>;
export type AllMeetingsForContactLazyQueryHookResult = ReturnType<typeof useAllMeetingsForContactLazyQuery>;
export type AllMeetingsForContactQueryResult = Apollo.QueryResult<IAllMeetingsForContactQuery, IAllMeetingsForContactQueryVariables>;
export const MeetingsFilteredDocument = gql`
    query meetingsFiltered($filter: MeetingFilterInput) {
  result: meetingsFiltered(filter: $filter) {
    meetings {
      ...MeetingDetails
    }
    total
  }
}
    ${MeetingDetailsFragmentDoc}`;

/**
 * __useMeetingsFilteredQuery__
 *
 * To run a query within a React component, call `useMeetingsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingsFilteredQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMeetingsFilteredQuery(baseOptions?: Apollo.QueryHookOptions<IMeetingsFilteredQuery, IMeetingsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMeetingsFilteredQuery, IMeetingsFilteredQueryVariables>(MeetingsFilteredDocument, options);
      }
export function useMeetingsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMeetingsFilteredQuery, IMeetingsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMeetingsFilteredQuery, IMeetingsFilteredQueryVariables>(MeetingsFilteredDocument, options);
        }
export type MeetingsFilteredQueryHookResult = ReturnType<typeof useMeetingsFilteredQuery>;
export type MeetingsFilteredLazyQueryHookResult = ReturnType<typeof useMeetingsFilteredLazyQuery>;
export type MeetingsFilteredQueryResult = Apollo.QueryResult<IMeetingsFilteredQuery, IMeetingsFilteredQueryVariables>;
export const CreateMeetingDocument = gql`
    mutation createMeeting($input: AddMeetingInput!) {
  result: createMeeting(input: $input) {
    id
    name
  }
}
    `;
export type ICreateMeetingMutationFn = Apollo.MutationFunction<ICreateMeetingMutation, ICreateMeetingMutationVariables>;

/**
 * __useCreateMeetingMutation__
 *
 * To run a mutation, you first call `useCreateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingMutation, { data, loading, error }] = useCreateMeetingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<ICreateMeetingMutation, ICreateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateMeetingMutation, ICreateMeetingMutationVariables>(CreateMeetingDocument, options);
      }
export type CreateMeetingMutationHookResult = ReturnType<typeof useCreateMeetingMutation>;
export type CreateMeetingMutationResult = Apollo.MutationResult<ICreateMeetingMutation>;
export type CreateMeetingMutationOptions = Apollo.BaseMutationOptions<ICreateMeetingMutation, ICreateMeetingMutationVariables>;
export const UpdateMeetingDocument = gql`
    mutation updateMeeting($id: ID!, $input: AddMeetingInput!) {
  result: updateMeeting(id: $id, input: $input) {
    id
    name
  }
}
    `;
export type IUpdateMeetingMutationFn = Apollo.MutationFunction<IUpdateMeetingMutation, IUpdateMeetingMutationVariables>;

/**
 * __useUpdateMeetingMutation__
 *
 * To run a mutation, you first call `useUpdateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeetingMutation, { data, loading, error }] = useUpdateMeetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateMeetingMutation, IUpdateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateMeetingMutation, IUpdateMeetingMutationVariables>(UpdateMeetingDocument, options);
      }
export type UpdateMeetingMutationHookResult = ReturnType<typeof useUpdateMeetingMutation>;
export type UpdateMeetingMutationResult = Apollo.MutationResult<IUpdateMeetingMutation>;
export type UpdateMeetingMutationOptions = Apollo.BaseMutationOptions<IUpdateMeetingMutation, IUpdateMeetingMutationVariables>;
export const DeleteMeetingDocument = gql`
    mutation deleteMeeting($id: ID!) {
  result: deleteMeeting(id: $id)
}
    `;
export type IDeleteMeetingMutationFn = Apollo.MutationFunction<IDeleteMeetingMutation, IDeleteMeetingMutationVariables>;

/**
 * __useDeleteMeetingMutation__
 *
 * To run a mutation, you first call `useDeleteMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeetingMutation, { data, loading, error }] = useDeleteMeetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMeetingMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteMeetingMutation, IDeleteMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteMeetingMutation, IDeleteMeetingMutationVariables>(DeleteMeetingDocument, options);
      }
export type DeleteMeetingMutationHookResult = ReturnType<typeof useDeleteMeetingMutation>;
export type DeleteMeetingMutationResult = Apollo.MutationResult<IDeleteMeetingMutation>;
export type DeleteMeetingMutationOptions = Apollo.BaseMutationOptions<IDeleteMeetingMutation, IDeleteMeetingMutationVariables>;
export const MeetingCreatedDocument = gql`
    subscription meetingCreated {
  result: meetingCreated {
    ...MeetingDetails
  }
}
    ${MeetingDetailsFragmentDoc}`;

/**
 * __useMeetingCreatedSubscription__
 *
 * To run a query within a React component, call `useMeetingCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMeetingCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMeetingCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IMeetingCreatedSubscription, IMeetingCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IMeetingCreatedSubscription, IMeetingCreatedSubscriptionVariables>(MeetingCreatedDocument, options);
      }
export type MeetingCreatedSubscriptionHookResult = ReturnType<typeof useMeetingCreatedSubscription>;
export type MeetingCreatedSubscriptionResult = Apollo.SubscriptionResult<IMeetingCreatedSubscription>;
export const MeetingUpdatedDocument = gql`
    subscription meetingUpdated {
  result: meetingUpdated {
    ...MeetingDetails
  }
}
    ${MeetingDetailsFragmentDoc}`;

/**
 * __useMeetingUpdatedSubscription__
 *
 * To run a query within a React component, call `useMeetingUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMeetingUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMeetingUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IMeetingUpdatedSubscription, IMeetingUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IMeetingUpdatedSubscription, IMeetingUpdatedSubscriptionVariables>(MeetingUpdatedDocument, options);
      }
export type MeetingUpdatedSubscriptionHookResult = ReturnType<typeof useMeetingUpdatedSubscription>;
export type MeetingUpdatedSubscriptionResult = Apollo.SubscriptionResult<IMeetingUpdatedSubscription>;
export const MeetingDeletedDocument = gql`
    subscription meetingDeleted {
  result: meetingDeleted {
    ...MeetingDetails
  }
}
    ${MeetingDetailsFragmentDoc}`;

/**
 * __useMeetingDeletedSubscription__
 *
 * To run a query within a React component, call `useMeetingDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMeetingDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMeetingDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IMeetingDeletedSubscription, IMeetingDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IMeetingDeletedSubscription, IMeetingDeletedSubscriptionVariables>(MeetingDeletedDocument, options);
      }
export type MeetingDeletedSubscriptionHookResult = ReturnType<typeof useMeetingDeletedSubscription>;
export type MeetingDeletedSubscriptionResult = Apollo.SubscriptionResult<IMeetingDeletedSubscription>;
export const MembershipTypesDocument = gql`
    query membershipTypes {
  result: membershipTypes {
    id
    name
  }
}
    `;

/**
 * __useMembershipTypesQuery__
 *
 * To run a query within a React component, call `useMembershipTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMembershipTypesQuery(baseOptions?: Apollo.QueryHookOptions<IMembershipTypesQuery, IMembershipTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMembershipTypesQuery, IMembershipTypesQueryVariables>(MembershipTypesDocument, options);
      }
export function useMembershipTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMembershipTypesQuery, IMembershipTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMembershipTypesQuery, IMembershipTypesQueryVariables>(MembershipTypesDocument, options);
        }
export type MembershipTypesQueryHookResult = ReturnType<typeof useMembershipTypesQuery>;
export type MembershipTypesLazyQueryHookResult = ReturnType<typeof useMembershipTypesLazyQuery>;
export type MembershipTypesQueryResult = Apollo.QueryResult<IMembershipTypesQuery, IMembershipTypesQueryVariables>;
export const MembershipsDocument = gql`
    query memberships {
  result: memberships {
    ...MembershipOverview
  }
}
    ${MembershipOverviewFragmentDoc}`;

/**
 * __useMembershipsQuery__
 *
 * To run a query within a React component, call `useMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<IMembershipsQuery, IMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMembershipsQuery, IMembershipsQueryVariables>(MembershipsDocument, options);
      }
export function useMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMembershipsQuery, IMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMembershipsQuery, IMembershipsQueryVariables>(MembershipsDocument, options);
        }
export type MembershipsQueryHookResult = ReturnType<typeof useMembershipsQuery>;
export type MembershipsLazyQueryHookResult = ReturnType<typeof useMembershipsLazyQuery>;
export type MembershipsQueryResult = Apollo.QueryResult<IMembershipsQuery, IMembershipsQueryVariables>;
export const MembershipsFilteredDocument = gql`
    query membershipsFiltered($filter: MembershipFilterInput) {
  result: membershipsFiltered(filter: $filter) {
    total
    memberships {
      ...MembershipOverview
    }
  }
}
    ${MembershipOverviewFragmentDoc}`;

/**
 * __useMembershipsFilteredQuery__
 *
 * To run a query within a React component, call `useMembershipsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipsFilteredQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMembershipsFilteredQuery(baseOptions?: Apollo.QueryHookOptions<IMembershipsFilteredQuery, IMembershipsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMembershipsFilteredQuery, IMembershipsFilteredQueryVariables>(MembershipsFilteredDocument, options);
      }
export function useMembershipsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMembershipsFilteredQuery, IMembershipsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMembershipsFilteredQuery, IMembershipsFilteredQueryVariables>(MembershipsFilteredDocument, options);
        }
export type MembershipsFilteredQueryHookResult = ReturnType<typeof useMembershipsFilteredQuery>;
export type MembershipsFilteredLazyQueryHookResult = ReturnType<typeof useMembershipsFilteredLazyQuery>;
export type MembershipsFilteredQueryResult = Apollo.QueryResult<IMembershipsFilteredQuery, IMembershipsFilteredQueryVariables>;
export const MembershipDocument = gql`
    query membership($id: Int!) {
  result: membership(id: $id) {
    ...MembershipDetails
  }
}
    ${MembershipDetailsFragmentDoc}`;

/**
 * __useMembershipQuery__
 *
 * To run a query within a React component, call `useMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMembershipQuery(baseOptions: Apollo.QueryHookOptions<IMembershipQuery, IMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMembershipQuery, IMembershipQueryVariables>(MembershipDocument, options);
      }
export function useMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMembershipQuery, IMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMembershipQuery, IMembershipQueryVariables>(MembershipDocument, options);
        }
export type MembershipQueryHookResult = ReturnType<typeof useMembershipQuery>;
export type MembershipLazyQueryHookResult = ReturnType<typeof useMembershipLazyQuery>;
export type MembershipQueryResult = Apollo.QueryResult<IMembershipQuery, IMembershipQueryVariables>;
export const MembershipCompaniesDocument = gql`
    query membershipCompanies($membership_id: Int!) {
  result: membershipCompanies(membership_id: $membership_id) {
    id
    name
    is_main_member
    main_address {
      id
      street
      city
      country {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useMembershipCompaniesQuery__
 *
 * To run a query within a React component, call `useMembershipCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipCompaniesQuery({
 *   variables: {
 *      membership_id: // value for 'membership_id'
 *   },
 * });
 */
export function useMembershipCompaniesQuery(baseOptions: Apollo.QueryHookOptions<IMembershipCompaniesQuery, IMembershipCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMembershipCompaniesQuery, IMembershipCompaniesQueryVariables>(MembershipCompaniesDocument, options);
      }
export function useMembershipCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMembershipCompaniesQuery, IMembershipCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMembershipCompaniesQuery, IMembershipCompaniesQueryVariables>(MembershipCompaniesDocument, options);
        }
export type MembershipCompaniesQueryHookResult = ReturnType<typeof useMembershipCompaniesQuery>;
export type MembershipCompaniesLazyQueryHookResult = ReturnType<typeof useMembershipCompaniesLazyQuery>;
export type MembershipCompaniesQueryResult = Apollo.QueryResult<IMembershipCompaniesQuery, IMembershipCompaniesQueryVariables>;
export const MembershipTypeOptionsDocument = gql`
    query membershipTypeOptions {
  result: membershipTypeOptions {
    membership_types {
      id
      name
    }
    taken_option_ids
  }
}
    `;

/**
 * __useMembershipTypeOptionsQuery__
 *
 * To run a query within a React component, call `useMembershipTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipTypeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMembershipTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<IMembershipTypeOptionsQuery, IMembershipTypeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMembershipTypeOptionsQuery, IMembershipTypeOptionsQueryVariables>(MembershipTypeOptionsDocument, options);
      }
export function useMembershipTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMembershipTypeOptionsQuery, IMembershipTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMembershipTypeOptionsQuery, IMembershipTypeOptionsQueryVariables>(MembershipTypeOptionsDocument, options);
        }
export type MembershipTypeOptionsQueryHookResult = ReturnType<typeof useMembershipTypeOptionsQuery>;
export type MembershipTypeOptionsLazyQueryHookResult = ReturnType<typeof useMembershipTypeOptionsLazyQuery>;
export type MembershipTypeOptionsQueryResult = Apollo.QueryResult<IMembershipTypeOptionsQuery, IMembershipTypeOptionsQueryVariables>;
export const MembershipContactsDocument = gql`
    query membershipContacts($id: Int!) {
  result: membershipContacts(id: $id) {
    id
    is_main
    fullName
    email
    titleInternal {
      id
      name
    }
    address {
      id
      street
    }
    company {
      id
      name
    }
  }
}
    `;

/**
 * __useMembershipContactsQuery__
 *
 * To run a query within a React component, call `useMembershipContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMembershipContactsQuery(baseOptions: Apollo.QueryHookOptions<IMembershipContactsQuery, IMembershipContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMembershipContactsQuery, IMembershipContactsQueryVariables>(MembershipContactsDocument, options);
      }
export function useMembershipContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMembershipContactsQuery, IMembershipContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMembershipContactsQuery, IMembershipContactsQueryVariables>(MembershipContactsDocument, options);
        }
export type MembershipContactsQueryHookResult = ReturnType<typeof useMembershipContactsQuery>;
export type MembershipContactsLazyQueryHookResult = ReturnType<typeof useMembershipContactsLazyQuery>;
export type MembershipContactsQueryResult = Apollo.QueryResult<IMembershipContactsQuery, IMembershipContactsQueryVariables>;
export const CreateMembershipDocument = gql`
    mutation createMembership($input: MembershipInput!) {
  result: createMembership(input: $input) {
    ...MembershipOverview
  }
}
    ${MembershipOverviewFragmentDoc}`;
export type ICreateMembershipMutationFn = Apollo.MutationFunction<ICreateMembershipMutation, ICreateMembershipMutationVariables>;

/**
 * __useCreateMembershipMutation__
 *
 * To run a mutation, you first call `useCreateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMembershipMutation, { data, loading, error }] = useCreateMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<ICreateMembershipMutation, ICreateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateMembershipMutation, ICreateMembershipMutationVariables>(CreateMembershipDocument, options);
      }
export type CreateMembershipMutationHookResult = ReturnType<typeof useCreateMembershipMutation>;
export type CreateMembershipMutationResult = Apollo.MutationResult<ICreateMembershipMutation>;
export type CreateMembershipMutationOptions = Apollo.BaseMutationOptions<ICreateMembershipMutation, ICreateMembershipMutationVariables>;
export const UpdateMembershipDocument = gql`
    mutation updateMembership($id: Int!, $input: MembershipInput!) {
  result: updateMembership(id: $id, input: $input) {
    ...MembershipOverview
  }
}
    ${MembershipOverviewFragmentDoc}`;
export type IUpdateMembershipMutationFn = Apollo.MutationFunction<IUpdateMembershipMutation, IUpdateMembershipMutationVariables>;

/**
 * __useUpdateMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipMutation, { data, loading, error }] = useUpdateMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateMembershipMutation, IUpdateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateMembershipMutation, IUpdateMembershipMutationVariables>(UpdateMembershipDocument, options);
      }
export type UpdateMembershipMutationHookResult = ReturnType<typeof useUpdateMembershipMutation>;
export type UpdateMembershipMutationResult = Apollo.MutationResult<IUpdateMembershipMutation>;
export type UpdateMembershipMutationOptions = Apollo.BaseMutationOptions<IUpdateMembershipMutation, IUpdateMembershipMutationVariables>;
export const DeleteMembershipDocument = gql`
    mutation deleteMembership($id: Int!) {
  result: deleteMembership(id: $id)
}
    `;
export type IDeleteMembershipMutationFn = Apollo.MutationFunction<IDeleteMembershipMutation, IDeleteMembershipMutationVariables>;

/**
 * __useDeleteMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMembershipMutation, { data, loading, error }] = useDeleteMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMembershipMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteMembershipMutation, IDeleteMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteMembershipMutation, IDeleteMembershipMutationVariables>(DeleteMembershipDocument, options);
      }
export type DeleteMembershipMutationHookResult = ReturnType<typeof useDeleteMembershipMutation>;
export type DeleteMembershipMutationResult = Apollo.MutationResult<IDeleteMembershipMutation>;
export type DeleteMembershipMutationOptions = Apollo.BaseMutationOptions<IDeleteMembershipMutation, IDeleteMembershipMutationVariables>;
export const MembershipCreatedDocument = gql`
    subscription MembershipCreated {
  result: membershipCreated {
    ...MembershipOverview
  }
}
    ${MembershipOverviewFragmentDoc}`;

/**
 * __useMembershipCreatedSubscription__
 *
 * To run a query within a React component, call `useMembershipCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMembershipCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMembershipCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IMembershipCreatedSubscription, IMembershipCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IMembershipCreatedSubscription, IMembershipCreatedSubscriptionVariables>(MembershipCreatedDocument, options);
      }
export type MembershipCreatedSubscriptionHookResult = ReturnType<typeof useMembershipCreatedSubscription>;
export type MembershipCreatedSubscriptionResult = Apollo.SubscriptionResult<IMembershipCreatedSubscription>;
export const MembershipUpdatedDocument = gql`
    subscription MembershipUpdated {
  result: membershipUpdated {
    ...MembershipOverview
  }
}
    ${MembershipOverviewFragmentDoc}`;

/**
 * __useMembershipUpdatedSubscription__
 *
 * To run a query within a React component, call `useMembershipUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMembershipUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMembershipUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IMembershipUpdatedSubscription, IMembershipUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IMembershipUpdatedSubscription, IMembershipUpdatedSubscriptionVariables>(MembershipUpdatedDocument, options);
      }
export type MembershipUpdatedSubscriptionHookResult = ReturnType<typeof useMembershipUpdatedSubscription>;
export type MembershipUpdatedSubscriptionResult = Apollo.SubscriptionResult<IMembershipUpdatedSubscription>;
export const MembershipDeletedDocument = gql`
    subscription MembershipDeleted {
  result: membershipDeleted {
    id
  }
}
    `;

/**
 * __useMembershipDeletedSubscription__
 *
 * To run a query within a React component, call `useMembershipDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMembershipDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMembershipDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IMembershipDeletedSubscription, IMembershipDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IMembershipDeletedSubscription, IMembershipDeletedSubscriptionVariables>(MembershipDeletedDocument, options);
      }
export type MembershipDeletedSubscriptionHookResult = ReturnType<typeof useMembershipDeletedSubscription>;
export type MembershipDeletedSubscriptionResult = Apollo.SubscriptionResult<IMembershipDeletedSubscription>;
export const MsbReportsDocument = gql`
    query msbReports {
  result: msbReports {
    ...MsbReportOverview
  }
}
    ${MsbReportOverviewFragmentDoc}`;

/**
 * __useMsbReportsQuery__
 *
 * To run a query within a React component, call `useMsbReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMsbReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMsbReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMsbReportsQuery(baseOptions?: Apollo.QueryHookOptions<IMsbReportsQuery, IMsbReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMsbReportsQuery, IMsbReportsQueryVariables>(MsbReportsDocument, options);
      }
export function useMsbReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMsbReportsQuery, IMsbReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMsbReportsQuery, IMsbReportsQueryVariables>(MsbReportsDocument, options);
        }
export type MsbReportsQueryHookResult = ReturnType<typeof useMsbReportsQuery>;
export type MsbReportsLazyQueryHookResult = ReturnType<typeof useMsbReportsLazyQuery>;
export type MsbReportsQueryResult = Apollo.QueryResult<IMsbReportsQuery, IMsbReportsQueryVariables>;
export const ScheduleReportDocument = gql`
    mutation scheduleReport($input: ScheduleInput!) {
  result: scheduleReport(input: $input) {
    ...MsbReportOverview
  }
}
    ${MsbReportOverviewFragmentDoc}`;
export type IScheduleReportMutationFn = Apollo.MutationFunction<IScheduleReportMutation, IScheduleReportMutationVariables>;

/**
 * __useScheduleReportMutation__
 *
 * To run a mutation, you first call `useScheduleReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleReportMutation, { data, loading, error }] = useScheduleReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleReportMutation(baseOptions?: Apollo.MutationHookOptions<IScheduleReportMutation, IScheduleReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IScheduleReportMutation, IScheduleReportMutationVariables>(ScheduleReportDocument, options);
      }
export type ScheduleReportMutationHookResult = ReturnType<typeof useScheduleReportMutation>;
export type ScheduleReportMutationResult = Apollo.MutationResult<IScheduleReportMutation>;
export type ScheduleReportMutationOptions = Apollo.BaseMutationOptions<IScheduleReportMutation, IScheduleReportMutationVariables>;
export const GetNavsDocument = gql`
    query getNavs($stock_id: Int!) {
  result: getNavs(stock_id: $stock_id) {
    ...NavDetails
  }
}
    ${NavDetailsFragmentDoc}`;

/**
 * __useGetNavsQuery__
 *
 * To run a query within a React component, call `useGetNavsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavsQuery({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useGetNavsQuery(baseOptions: Apollo.QueryHookOptions<IGetNavsQuery, IGetNavsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetNavsQuery, IGetNavsQueryVariables>(GetNavsDocument, options);
      }
export function useGetNavsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetNavsQuery, IGetNavsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetNavsQuery, IGetNavsQueryVariables>(GetNavsDocument, options);
        }
export type GetNavsQueryHookResult = ReturnType<typeof useGetNavsQuery>;
export type GetNavsLazyQueryHookResult = ReturnType<typeof useGetNavsLazyQuery>;
export type GetNavsQueryResult = Apollo.QueryResult<IGetNavsQuery, IGetNavsQueryVariables>;
export const CreateNavDocument = gql`
    mutation createNav($stock_id: ID!, $input: NavInput!) {
  result: createNav(stock_id: $stock_id, input: $input) {
    ...NavDetails
  }
}
    ${NavDetailsFragmentDoc}`;
export type ICreateNavMutationFn = Apollo.MutationFunction<ICreateNavMutation, ICreateNavMutationVariables>;

/**
 * __useCreateNavMutation__
 *
 * To run a mutation, you first call `useCreateNavMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNavMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNavMutation, { data, loading, error }] = useCreateNavMutation({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNavMutation(baseOptions?: Apollo.MutationHookOptions<ICreateNavMutation, ICreateNavMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateNavMutation, ICreateNavMutationVariables>(CreateNavDocument, options);
      }
export type CreateNavMutationHookResult = ReturnType<typeof useCreateNavMutation>;
export type CreateNavMutationResult = Apollo.MutationResult<ICreateNavMutation>;
export type CreateNavMutationOptions = Apollo.BaseMutationOptions<ICreateNavMutation, ICreateNavMutationVariables>;
export const UpdateNavDocument = gql`
    mutation updateNav($id: ID!, $input: NavInput!) {
  result: updateNav(id: $id, input: $input) {
    ...NavDetails
  }
}
    ${NavDetailsFragmentDoc}`;
export type IUpdateNavMutationFn = Apollo.MutationFunction<IUpdateNavMutation, IUpdateNavMutationVariables>;

/**
 * __useUpdateNavMutation__
 *
 * To run a mutation, you first call `useUpdateNavMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNavMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNavMutation, { data, loading, error }] = useUpdateNavMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNavMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateNavMutation, IUpdateNavMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateNavMutation, IUpdateNavMutationVariables>(UpdateNavDocument, options);
      }
export type UpdateNavMutationHookResult = ReturnType<typeof useUpdateNavMutation>;
export type UpdateNavMutationResult = Apollo.MutationResult<IUpdateNavMutation>;
export type UpdateNavMutationOptions = Apollo.BaseMutationOptions<IUpdateNavMutation, IUpdateNavMutationVariables>;
export const DeleteNavDocument = gql`
    mutation deleteNav($id: ID!) {
  result: deleteNav(id: $id)
}
    `;
export type IDeleteNavMutationFn = Apollo.MutationFunction<IDeleteNavMutation, IDeleteNavMutationVariables>;

/**
 * __useDeleteNavMutation__
 *
 * To run a mutation, you first call `useDeleteNavMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNavMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNavMutation, { data, loading, error }] = useDeleteNavMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNavMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteNavMutation, IDeleteNavMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteNavMutation, IDeleteNavMutationVariables>(DeleteNavDocument, options);
      }
export type DeleteNavMutationHookResult = ReturnType<typeof useDeleteNavMutation>;
export type DeleteNavMutationResult = Apollo.MutationResult<IDeleteNavMutation>;
export type DeleteNavMutationOptions = Apollo.BaseMutationOptions<IDeleteNavMutation, IDeleteNavMutationVariables>;
export const NavCreatedDocument = gql`
    subscription navCreated($stock_id: ID!) {
  result: navCreated(stock_id: $stock_id) {
    ...NavDetails
  }
}
    ${NavDetailsFragmentDoc}`;

/**
 * __useNavCreatedSubscription__
 *
 * To run a query within a React component, call `useNavCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNavCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavCreatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useNavCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<INavCreatedSubscription, INavCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<INavCreatedSubscription, INavCreatedSubscriptionVariables>(NavCreatedDocument, options);
      }
export type NavCreatedSubscriptionHookResult = ReturnType<typeof useNavCreatedSubscription>;
export type NavCreatedSubscriptionResult = Apollo.SubscriptionResult<INavCreatedSubscription>;
export const NavUpdatedDocument = gql`
    subscription navUpdated($stock_id: ID!) {
  result: navUpdated(stock_id: $stock_id) {
    ...NavDetails
  }
}
    ${NavDetailsFragmentDoc}`;

/**
 * __useNavUpdatedSubscription__
 *
 * To run a query within a React component, call `useNavUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNavUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavUpdatedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useNavUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<INavUpdatedSubscription, INavUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<INavUpdatedSubscription, INavUpdatedSubscriptionVariables>(NavUpdatedDocument, options);
      }
export type NavUpdatedSubscriptionHookResult = ReturnType<typeof useNavUpdatedSubscription>;
export type NavUpdatedSubscriptionResult = Apollo.SubscriptionResult<INavUpdatedSubscription>;
export const NavDeletedDocument = gql`
    subscription navDeleted($stock_id: ID!) {
  result: navDeleted(stock_id: $stock_id) {
    ...NavDetails
  }
}
    ${NavDetailsFragmentDoc}`;

/**
 * __useNavDeletedSubscription__
 *
 * To run a query within a React component, call `useNavDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNavDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavDeletedSubscription({
 *   variables: {
 *      stock_id: // value for 'stock_id'
 *   },
 * });
 */
export function useNavDeletedSubscription(baseOptions: Apollo.SubscriptionHookOptions<INavDeletedSubscription, INavDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<INavDeletedSubscription, INavDeletedSubscriptionVariables>(NavDeletedDocument, options);
      }
export type NavDeletedSubscriptionHookResult = ReturnType<typeof useNavDeletedSubscription>;
export type NavDeletedSubscriptionResult = Apollo.SubscriptionResult<INavDeletedSubscription>;
export const ProductCodesDocument = gql`
    query productCodes {
  result: productCodes {
    id
    name
  }
}
    `;

/**
 * __useProductCodesQuery__
 *
 * To run a query within a React component, call `useProductCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductCodesQuery(baseOptions?: Apollo.QueryHookOptions<IProductCodesQuery, IProductCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IProductCodesQuery, IProductCodesQueryVariables>(ProductCodesDocument, options);
      }
export function useProductCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IProductCodesQuery, IProductCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IProductCodesQuery, IProductCodesQueryVariables>(ProductCodesDocument, options);
        }
export type ProductCodesQueryHookResult = ReturnType<typeof useProductCodesQuery>;
export type ProductCodesLazyQueryHookResult = ReturnType<typeof useProductCodesLazyQuery>;
export type ProductCodesQueryResult = Apollo.QueryResult<IProductCodesQuery, IProductCodesQueryVariables>;
export const ProductsDocument = gql`
    query products {
  result: products {
    ...ProductDetails
  }
}
    ${ProductDetailsFragmentDoc}`;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<IProductsQuery, IProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IProductsQuery, IProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IProductsQuery, IProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IProductsQuery, IProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<IProductsQuery, IProductsQueryVariables>;
export const ProductDocument = gql`
    query product($id: Int!) {
  result: product(id: $id) {
    ...ProductDetailsFull
  }
}
    ${ProductDetailsFullFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<IProductQuery, IProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IProductQuery, IProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IProductQuery, IProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IProductQuery, IProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductQueryResult = Apollo.QueryResult<IProductQuery, IProductQueryVariables>;
export const MembershipProductsDocument = gql`
    query membershipProducts {
  result: membershipProducts {
    id
    membership_type {
      id
      name
    }
    price
  }
}
    `;

/**
 * __useMembershipProductsQuery__
 *
 * To run a query within a React component, call `useMembershipProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMembershipProductsQuery(baseOptions?: Apollo.QueryHookOptions<IMembershipProductsQuery, IMembershipProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMembershipProductsQuery, IMembershipProductsQueryVariables>(MembershipProductsDocument, options);
      }
export function useMembershipProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMembershipProductsQuery, IMembershipProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMembershipProductsQuery, IMembershipProductsQueryVariables>(MembershipProductsDocument, options);
        }
export type MembershipProductsQueryHookResult = ReturnType<typeof useMembershipProductsQuery>;
export type MembershipProductsLazyQueryHookResult = ReturnType<typeof useMembershipProductsLazyQuery>;
export type MembershipProductsQueryResult = Apollo.QueryResult<IMembershipProductsQuery, IMembershipProductsQueryVariables>;
export const DeleteProductDocument = gql`
    mutation deleteProduct($id: Int!) {
  result: deleteProduct(id: $id)
}
    `;
export type IDeleteProductMutationFn = Apollo.MutationFunction<IDeleteProductMutation, IDeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteProductMutation, IDeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteProductMutation, IDeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<IDeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<IDeleteProductMutation, IDeleteProductMutationVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($input: ProductInput!) {
  result: createProduct(input: $input) {
    ...ProductDetails
  }
}
    ${ProductDetailsFragmentDoc}`;
export type ICreateProductMutationFn = Apollo.MutationFunction<ICreateProductMutation, ICreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<ICreateProductMutation, ICreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateProductMutation, ICreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<ICreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<ICreateProductMutation, ICreateProductMutationVariables>;
export const UpdateProductGeneralInfoDocument = gql`
    mutation updateProductGeneralInfo($id: Int!, $input: ProductInput!) {
  result: updateProductGeneralInfo(id: $id, input: $input) {
    ...ProductDetailsFull
  }
}
    ${ProductDetailsFullFragmentDoc}`;
export type IUpdateProductGeneralInfoMutationFn = Apollo.MutationFunction<IUpdateProductGeneralInfoMutation, IUpdateProductGeneralInfoMutationVariables>;

/**
 * __useUpdateProductGeneralInfoMutation__
 *
 * To run a mutation, you first call `useUpdateProductGeneralInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductGeneralInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductGeneralInfoMutation, { data, loading, error }] = useUpdateProductGeneralInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductGeneralInfoMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateProductGeneralInfoMutation, IUpdateProductGeneralInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateProductGeneralInfoMutation, IUpdateProductGeneralInfoMutationVariables>(UpdateProductGeneralInfoDocument, options);
      }
export type UpdateProductGeneralInfoMutationHookResult = ReturnType<typeof useUpdateProductGeneralInfoMutation>;
export type UpdateProductGeneralInfoMutationResult = Apollo.MutationResult<IUpdateProductGeneralInfoMutation>;
export type UpdateProductGeneralInfoMutationOptions = Apollo.BaseMutationOptions<IUpdateProductGeneralInfoMutation, IUpdateProductGeneralInfoMutationVariables>;
export const UpdateProductEmailInfoDocument = gql`
    mutation updateProductEmailInfo($id: Int!, $input: EmailInput!) {
  result: updateProductEmailInfo(id: $id, input: $input) {
    ...ProductDetailsFull
  }
}
    ${ProductDetailsFullFragmentDoc}`;
export type IUpdateProductEmailInfoMutationFn = Apollo.MutationFunction<IUpdateProductEmailInfoMutation, IUpdateProductEmailInfoMutationVariables>;

/**
 * __useUpdateProductEmailInfoMutation__
 *
 * To run a mutation, you first call `useUpdateProductEmailInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductEmailInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductEmailInfoMutation, { data, loading, error }] = useUpdateProductEmailInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductEmailInfoMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateProductEmailInfoMutation, IUpdateProductEmailInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateProductEmailInfoMutation, IUpdateProductEmailInfoMutationVariables>(UpdateProductEmailInfoDocument, options);
      }
export type UpdateProductEmailInfoMutationHookResult = ReturnType<typeof useUpdateProductEmailInfoMutation>;
export type UpdateProductEmailInfoMutationResult = Apollo.MutationResult<IUpdateProductEmailInfoMutation>;
export type UpdateProductEmailInfoMutationOptions = Apollo.BaseMutationOptions<IUpdateProductEmailInfoMutation, IUpdateProductEmailInfoMutationVariables>;
export const ProductCreatedDocument = gql`
    subscription ProductCreated {
  result: productCreated {
    ...ProductDetails
  }
}
    ${ProductDetailsFragmentDoc}`;

/**
 * __useProductCreatedSubscription__
 *
 * To run a query within a React component, call `useProductCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProductCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProductCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IProductCreatedSubscription, IProductCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IProductCreatedSubscription, IProductCreatedSubscriptionVariables>(ProductCreatedDocument, options);
      }
export type ProductCreatedSubscriptionHookResult = ReturnType<typeof useProductCreatedSubscription>;
export type ProductCreatedSubscriptionResult = Apollo.SubscriptionResult<IProductCreatedSubscription>;
export const ProductUpdatedDocument = gql`
    subscription ProductUpdated {
  result: productUpdated {
    ...ProductDetails
  }
}
    ${ProductDetailsFragmentDoc}`;

/**
 * __useProductUpdatedSubscription__
 *
 * To run a query within a React component, call `useProductUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProductUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProductUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IProductUpdatedSubscription, IProductUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IProductUpdatedSubscription, IProductUpdatedSubscriptionVariables>(ProductUpdatedDocument, options);
      }
export type ProductUpdatedSubscriptionHookResult = ReturnType<typeof useProductUpdatedSubscription>;
export type ProductUpdatedSubscriptionResult = Apollo.SubscriptionResult<IProductUpdatedSubscription>;
export const ProductDeletedDocument = gql`
    subscription ProductDeleted {
  result: productDeleted {
    id
  }
}
    `;

/**
 * __useProductDeletedSubscription__
 *
 * To run a query within a React component, call `useProductDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProductDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProductDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IProductDeletedSubscription, IProductDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IProductDeletedSubscription, IProductDeletedSubscriptionVariables>(ProductDeletedDocument, options);
      }
export type ProductDeletedSubscriptionHookResult = ReturnType<typeof useProductDeletedSubscription>;
export type ProductDeletedSubscriptionResult = Apollo.SubscriptionResult<IProductDeletedSubscription>;
export const RecipientListsDocument = gql`
    query recipientLists {
  result: recipientLists {
    ...RecipientListProps
  }
}
    ${RecipientListPropsFragmentDoc}`;

/**
 * __useRecipientListsQuery__
 *
 * To run a query within a React component, call `useRecipientListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecipientListsQuery(baseOptions?: Apollo.QueryHookOptions<IRecipientListsQuery, IRecipientListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRecipientListsQuery, IRecipientListsQueryVariables>(RecipientListsDocument, options);
      }
export function useRecipientListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRecipientListsQuery, IRecipientListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRecipientListsQuery, IRecipientListsQueryVariables>(RecipientListsDocument, options);
        }
export type RecipientListsQueryHookResult = ReturnType<typeof useRecipientListsQuery>;
export type RecipientListsLazyQueryHookResult = ReturnType<typeof useRecipientListsLazyQuery>;
export type RecipientListsQueryResult = Apollo.QueryResult<IRecipientListsQuery, IRecipientListsQueryVariables>;
export const ExcludedContactsDocument = gql`
    query excludedContacts($id: Int!) {
  result: excludedContacts(id: $id) {
    id
    first_name
    last_name
    titleInternal {
      id
      name
    }
    email
  }
}
    `;

/**
 * __useExcludedContactsQuery__
 *
 * To run a query within a React component, call `useExcludedContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExcludedContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExcludedContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExcludedContactsQuery(baseOptions: Apollo.QueryHookOptions<IExcludedContactsQuery, IExcludedContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IExcludedContactsQuery, IExcludedContactsQueryVariables>(ExcludedContactsDocument, options);
      }
export function useExcludedContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IExcludedContactsQuery, IExcludedContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IExcludedContactsQuery, IExcludedContactsQueryVariables>(ExcludedContactsDocument, options);
        }
export type ExcludedContactsQueryHookResult = ReturnType<typeof useExcludedContactsQuery>;
export type ExcludedContactsLazyQueryHookResult = ReturnType<typeof useExcludedContactsLazyQuery>;
export type ExcludedContactsQueryResult = Apollo.QueryResult<IExcludedContactsQuery, IExcludedContactsQueryVariables>;
export const RecipientsDocument = gql`
    query recipients($id: Int!) {
  result: recipients(id: $id) {
    id
    first_name
    last_name
    titleInternal {
      id
      name
    }
    email
  }
}
    `;

/**
 * __useRecipientsQuery__
 *
 * To run a query within a React component, call `useRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecipientsQuery(baseOptions: Apollo.QueryHookOptions<IRecipientsQuery, IRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRecipientsQuery, IRecipientsQueryVariables>(RecipientsDocument, options);
      }
export function useRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRecipientsQuery, IRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRecipientsQuery, IRecipientsQueryVariables>(RecipientsDocument, options);
        }
export type RecipientsQueryHookResult = ReturnType<typeof useRecipientsQuery>;
export type RecipientsLazyQueryHookResult = ReturnType<typeof useRecipientsLazyQuery>;
export type RecipientsQueryResult = Apollo.QueryResult<IRecipientsQuery, IRecipientsQueryVariables>;
export const DeleteRecipientListDocument = gql`
    mutation deleteRecipientList($id: Int!) {
  result: deleteRecipientList(id: $id)
}
    `;
export type IDeleteRecipientListMutationFn = Apollo.MutationFunction<IDeleteRecipientListMutation, IDeleteRecipientListMutationVariables>;

/**
 * __useDeleteRecipientListMutation__
 *
 * To run a mutation, you first call `useDeleteRecipientListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecipientListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecipientListMutation, { data, loading, error }] = useDeleteRecipientListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRecipientListMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteRecipientListMutation, IDeleteRecipientListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteRecipientListMutation, IDeleteRecipientListMutationVariables>(DeleteRecipientListDocument, options);
      }
export type DeleteRecipientListMutationHookResult = ReturnType<typeof useDeleteRecipientListMutation>;
export type DeleteRecipientListMutationResult = Apollo.MutationResult<IDeleteRecipientListMutation>;
export type DeleteRecipientListMutationOptions = Apollo.BaseMutationOptions<IDeleteRecipientListMutation, IDeleteRecipientListMutationVariables>;
export const ExcludeRecipientDocument = gql`
    mutation excludeRecipient($recipient_list_id: Int!, $contact_id: Int!) {
  result: excludeRecipient(
    recipient_list_id: $recipient_list_id
    contact_id: $contact_id
  ) {
    ...RecipientListProps
  }
}
    ${RecipientListPropsFragmentDoc}`;
export type IExcludeRecipientMutationFn = Apollo.MutationFunction<IExcludeRecipientMutation, IExcludeRecipientMutationVariables>;

/**
 * __useExcludeRecipientMutation__
 *
 * To run a mutation, you first call `useExcludeRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcludeRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excludeRecipientMutation, { data, loading, error }] = useExcludeRecipientMutation({
 *   variables: {
 *      recipient_list_id: // value for 'recipient_list_id'
 *      contact_id: // value for 'contact_id'
 *   },
 * });
 */
export function useExcludeRecipientMutation(baseOptions?: Apollo.MutationHookOptions<IExcludeRecipientMutation, IExcludeRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IExcludeRecipientMutation, IExcludeRecipientMutationVariables>(ExcludeRecipientDocument, options);
      }
export type ExcludeRecipientMutationHookResult = ReturnType<typeof useExcludeRecipientMutation>;
export type ExcludeRecipientMutationResult = Apollo.MutationResult<IExcludeRecipientMutation>;
export type ExcludeRecipientMutationOptions = Apollo.BaseMutationOptions<IExcludeRecipientMutation, IExcludeRecipientMutationVariables>;
export const CreateRecipientListDocument = gql`
    mutation createRecipientList($input: RecipientListInput!) {
  result: createRecipientList(input: $input) {
    ...RecipientListProps
  }
}
    ${RecipientListPropsFragmentDoc}`;
export type ICreateRecipientListMutationFn = Apollo.MutationFunction<ICreateRecipientListMutation, ICreateRecipientListMutationVariables>;

/**
 * __useCreateRecipientListMutation__
 *
 * To run a mutation, you first call `useCreateRecipientListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecipientListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecipientListMutation, { data, loading, error }] = useCreateRecipientListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRecipientListMutation(baseOptions?: Apollo.MutationHookOptions<ICreateRecipientListMutation, ICreateRecipientListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateRecipientListMutation, ICreateRecipientListMutationVariables>(CreateRecipientListDocument, options);
      }
export type CreateRecipientListMutationHookResult = ReturnType<typeof useCreateRecipientListMutation>;
export type CreateRecipientListMutationResult = Apollo.MutationResult<ICreateRecipientListMutation>;
export type CreateRecipientListMutationOptions = Apollo.BaseMutationOptions<ICreateRecipientListMutation, ICreateRecipientListMutationVariables>;
export const UpdateRecipientListDocument = gql`
    mutation updateRecipientList($input: RecipientListInput!) {
  result: updateRecipientList(input: $input) {
    ...RecipientListProps
  }
}
    ${RecipientListPropsFragmentDoc}`;
export type IUpdateRecipientListMutationFn = Apollo.MutationFunction<IUpdateRecipientListMutation, IUpdateRecipientListMutationVariables>;

/**
 * __useUpdateRecipientListMutation__
 *
 * To run a mutation, you first call `useUpdateRecipientListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecipientListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecipientListMutation, { data, loading, error }] = useUpdateRecipientListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRecipientListMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateRecipientListMutation, IUpdateRecipientListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateRecipientListMutation, IUpdateRecipientListMutationVariables>(UpdateRecipientListDocument, options);
      }
export type UpdateRecipientListMutationHookResult = ReturnType<typeof useUpdateRecipientListMutation>;
export type UpdateRecipientListMutationResult = Apollo.MutationResult<IUpdateRecipientListMutation>;
export type UpdateRecipientListMutationOptions = Apollo.BaseMutationOptions<IUpdateRecipientListMutation, IUpdateRecipientListMutationVariables>;
export const RecipientListDeletedDocument = gql`
    subscription RecipientListDeleted {
  result: recipientListDeleted {
    id
  }
}
    `;

/**
 * __useRecipientListDeletedSubscription__
 *
 * To run a query within a React component, call `useRecipientListDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRecipientListDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientListDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRecipientListDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IRecipientListDeletedSubscription, IRecipientListDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IRecipientListDeletedSubscription, IRecipientListDeletedSubscriptionVariables>(RecipientListDeletedDocument, options);
      }
export type RecipientListDeletedSubscriptionHookResult = ReturnType<typeof useRecipientListDeletedSubscription>;
export type RecipientListDeletedSubscriptionResult = Apollo.SubscriptionResult<IRecipientListDeletedSubscription>;
export const RecipientListCreatedDocument = gql`
    subscription RecipientListCreated {
  result: recipientListCreated {
    ...RecipientListProps
  }
}
    ${RecipientListPropsFragmentDoc}`;

/**
 * __useRecipientListCreatedSubscription__
 *
 * To run a query within a React component, call `useRecipientListCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRecipientListCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientListCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRecipientListCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IRecipientListCreatedSubscription, IRecipientListCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IRecipientListCreatedSubscription, IRecipientListCreatedSubscriptionVariables>(RecipientListCreatedDocument, options);
      }
export type RecipientListCreatedSubscriptionHookResult = ReturnType<typeof useRecipientListCreatedSubscription>;
export type RecipientListCreatedSubscriptionResult = Apollo.SubscriptionResult<IRecipientListCreatedSubscription>;
export const RecipientListUpdatedDocument = gql`
    subscription RecipientListUpdated {
  result: recipientListUpdated {
    ...RecipientListProps
  }
}
    ${RecipientListPropsFragmentDoc}`;

/**
 * __useRecipientListUpdatedSubscription__
 *
 * To run a query within a React component, call `useRecipientListUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRecipientListUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientListUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRecipientListUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IRecipientListUpdatedSubscription, IRecipientListUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IRecipientListUpdatedSubscription, IRecipientListUpdatedSubscriptionVariables>(RecipientListUpdatedDocument, options);
      }
export type RecipientListUpdatedSubscriptionHookResult = ReturnType<typeof useRecipientListUpdatedSubscription>;
export type RecipientListUpdatedSubscriptionResult = Apollo.SubscriptionResult<IRecipientListUpdatedSubscription>;
export const RegionsDocument = gql`
    query regions {
  result: regions {
    id
    name
  }
}
    `;

/**
 * __useRegionsQuery__
 *
 * To run a query within a React component, call `useRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionsQuery(baseOptions?: Apollo.QueryHookOptions<IRegionsQuery, IRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRegionsQuery, IRegionsQueryVariables>(RegionsDocument, options);
      }
export function useRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRegionsQuery, IRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRegionsQuery, IRegionsQueryVariables>(RegionsDocument, options);
        }
export type RegionsQueryHookResult = ReturnType<typeof useRegionsQuery>;
export type RegionsLazyQueryHookResult = ReturnType<typeof useRegionsLazyQuery>;
export type RegionsQueryResult = Apollo.QueryResult<IRegionsQuery, IRegionsQueryVariables>;
export const GetRolesDocument = gql`
    query getRoles {
  result: roles {
    id
    name
    users {
      id
      username
      first_name
      last_name
    }
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<IGetRolesQuery, IGetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRolesQuery, IGetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRolesQuery, IGetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRolesQuery, IGetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<IGetRolesQuery, IGetRolesQueryVariables>;
export const RemoveRoleFromUserDocument = gql`
    mutation removeRoleFromUser($input: UserRoleInput!) {
  result: removeRoleFromUser(input: $input)
}
    `;
export type IRemoveRoleFromUserMutationFn = Apollo.MutationFunction<IRemoveRoleFromUserMutation, IRemoveRoleFromUserMutationVariables>;

/**
 * __useRemoveRoleFromUserMutation__
 *
 * To run a mutation, you first call `useRemoveRoleFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleFromUserMutation, { data, loading, error }] = useRemoveRoleFromUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveRoleFromUserMutation(baseOptions?: Apollo.MutationHookOptions<IRemoveRoleFromUserMutation, IRemoveRoleFromUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRemoveRoleFromUserMutation, IRemoveRoleFromUserMutationVariables>(RemoveRoleFromUserDocument, options);
      }
export type RemoveRoleFromUserMutationHookResult = ReturnType<typeof useRemoveRoleFromUserMutation>;
export type RemoveRoleFromUserMutationResult = Apollo.MutationResult<IRemoveRoleFromUserMutation>;
export type RemoveRoleFromUserMutationOptions = Apollo.BaseMutationOptions<IRemoveRoleFromUserMutation, IRemoveRoleFromUserMutationVariables>;
export const GetAllScheduledDocument = gql`
    query getAllScheduled {
  result: getAllScheduled {
    ...SchedulerDetails
  }
}
    ${SchedulerDetailsFragmentDoc}`;

/**
 * __useGetAllScheduledQuery__
 *
 * To run a query within a React component, call `useGetAllScheduledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllScheduledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllScheduledQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllScheduledQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllScheduledQuery, IGetAllScheduledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllScheduledQuery, IGetAllScheduledQueryVariables>(GetAllScheduledDocument, options);
      }
export function useGetAllScheduledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllScheduledQuery, IGetAllScheduledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllScheduledQuery, IGetAllScheduledQueryVariables>(GetAllScheduledDocument, options);
        }
export type GetAllScheduledQueryHookResult = ReturnType<typeof useGetAllScheduledQuery>;
export type GetAllScheduledLazyQueryHookResult = ReturnType<typeof useGetAllScheduledLazyQuery>;
export type GetAllScheduledQueryResult = Apollo.QueryResult<IGetAllScheduledQuery, IGetAllScheduledQueryVariables>;
export const CreateSchedulerDocument = gql`
    mutation createScheduler($input: SchedulerInput!) {
  result: createScheduler(input: $input) {
    ...SchedulerDetails
  }
}
    ${SchedulerDetailsFragmentDoc}`;
export type ICreateSchedulerMutationFn = Apollo.MutationFunction<ICreateSchedulerMutation, ICreateSchedulerMutationVariables>;

/**
 * __useCreateSchedulerMutation__
 *
 * To run a mutation, you first call `useCreateSchedulerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchedulerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchedulerMutation, { data, loading, error }] = useCreateSchedulerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSchedulerMutation(baseOptions?: Apollo.MutationHookOptions<ICreateSchedulerMutation, ICreateSchedulerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateSchedulerMutation, ICreateSchedulerMutationVariables>(CreateSchedulerDocument, options);
      }
export type CreateSchedulerMutationHookResult = ReturnType<typeof useCreateSchedulerMutation>;
export type CreateSchedulerMutationResult = Apollo.MutationResult<ICreateSchedulerMutation>;
export type CreateSchedulerMutationOptions = Apollo.BaseMutationOptions<ICreateSchedulerMutation, ICreateSchedulerMutationVariables>;
export const UpdateSchedulerDocument = gql`
    mutation updateScheduler($id: Int!, $input: SchedulerInput!) {
  result: updateScheduler(id: $id, input: $input) {
    ...SchedulerDetails
  }
}
    ${SchedulerDetailsFragmentDoc}`;
export type IUpdateSchedulerMutationFn = Apollo.MutationFunction<IUpdateSchedulerMutation, IUpdateSchedulerMutationVariables>;

/**
 * __useUpdateSchedulerMutation__
 *
 * To run a mutation, you first call `useUpdateSchedulerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchedulerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchedulerMutation, { data, loading, error }] = useUpdateSchedulerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSchedulerMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateSchedulerMutation, IUpdateSchedulerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateSchedulerMutation, IUpdateSchedulerMutationVariables>(UpdateSchedulerDocument, options);
      }
export type UpdateSchedulerMutationHookResult = ReturnType<typeof useUpdateSchedulerMutation>;
export type UpdateSchedulerMutationResult = Apollo.MutationResult<IUpdateSchedulerMutation>;
export type UpdateSchedulerMutationOptions = Apollo.BaseMutationOptions<IUpdateSchedulerMutation, IUpdateSchedulerMutationVariables>;
export const DeleteSchedulerDocument = gql`
    mutation deleteScheduler($id: Int!) {
  result: deleteScheduler(id: $id)
}
    `;
export type IDeleteSchedulerMutationFn = Apollo.MutationFunction<IDeleteSchedulerMutation, IDeleteSchedulerMutationVariables>;

/**
 * __useDeleteSchedulerMutation__
 *
 * To run a mutation, you first call `useDeleteSchedulerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchedulerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchedulerMutation, { data, loading, error }] = useDeleteSchedulerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSchedulerMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteSchedulerMutation, IDeleteSchedulerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteSchedulerMutation, IDeleteSchedulerMutationVariables>(DeleteSchedulerDocument, options);
      }
export type DeleteSchedulerMutationHookResult = ReturnType<typeof useDeleteSchedulerMutation>;
export type DeleteSchedulerMutationResult = Apollo.MutationResult<IDeleteSchedulerMutation>;
export type DeleteSchedulerMutationOptions = Apollo.BaseMutationOptions<IDeleteSchedulerMutation, IDeleteSchedulerMutationVariables>;
export const DeleteRecipientListFromSchedulerDocument = gql`
    mutation deleteRecipientListFromScheduler($scheduler_id: ID!, $recipient_list_id: ID!) {
  result: deleteRecipientListFromScheduler(
    scheduler_id: $scheduler_id
    recipient_list_id: $recipient_list_id
  ) {
    ...SchedulerDetails
  }
}
    ${SchedulerDetailsFragmentDoc}`;
export type IDeleteRecipientListFromSchedulerMutationFn = Apollo.MutationFunction<IDeleteRecipientListFromSchedulerMutation, IDeleteRecipientListFromSchedulerMutationVariables>;

/**
 * __useDeleteRecipientListFromSchedulerMutation__
 *
 * To run a mutation, you first call `useDeleteRecipientListFromSchedulerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecipientListFromSchedulerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecipientListFromSchedulerMutation, { data, loading, error }] = useDeleteRecipientListFromSchedulerMutation({
 *   variables: {
 *      scheduler_id: // value for 'scheduler_id'
 *      recipient_list_id: // value for 'recipient_list_id'
 *   },
 * });
 */
export function useDeleteRecipientListFromSchedulerMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteRecipientListFromSchedulerMutation, IDeleteRecipientListFromSchedulerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteRecipientListFromSchedulerMutation, IDeleteRecipientListFromSchedulerMutationVariables>(DeleteRecipientListFromSchedulerDocument, options);
      }
export type DeleteRecipientListFromSchedulerMutationHookResult = ReturnType<typeof useDeleteRecipientListFromSchedulerMutation>;
export type DeleteRecipientListFromSchedulerMutationResult = Apollo.MutationResult<IDeleteRecipientListFromSchedulerMutation>;
export type DeleteRecipientListFromSchedulerMutationOptions = Apollo.BaseMutationOptions<IDeleteRecipientListFromSchedulerMutation, IDeleteRecipientListFromSchedulerMutationVariables>;
export const SendTestEmailDocument = gql`
    mutation sendTestEmail($template_id: Int!, $sender_id: String!, $recipient: String!) {
  result: sendTestEmail(
    template_id: $template_id
    sender_id: $sender_id
    recipient: $recipient
  )
}
    `;
export type ISendTestEmailMutationFn = Apollo.MutationFunction<ISendTestEmailMutation, ISendTestEmailMutationVariables>;

/**
 * __useSendTestEmailMutation__
 *
 * To run a mutation, you first call `useSendTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestEmailMutation, { data, loading, error }] = useSendTestEmailMutation({
 *   variables: {
 *      template_id: // value for 'template_id'
 *      sender_id: // value for 'sender_id'
 *      recipient: // value for 'recipient'
 *   },
 * });
 */
export function useSendTestEmailMutation(baseOptions?: Apollo.MutationHookOptions<ISendTestEmailMutation, ISendTestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISendTestEmailMutation, ISendTestEmailMutationVariables>(SendTestEmailDocument, options);
      }
export type SendTestEmailMutationHookResult = ReturnType<typeof useSendTestEmailMutation>;
export type SendTestEmailMutationResult = Apollo.MutationResult<ISendTestEmailMutation>;
export type SendTestEmailMutationOptions = Apollo.BaseMutationOptions<ISendTestEmailMutation, ISendTestEmailMutationVariables>;
export const SchedulerDeletedDocument = gql`
    subscription schedulerDeleted {
  result: schedulerDeleted {
    id
  }
}
    `;

/**
 * __useSchedulerDeletedSubscription__
 *
 * To run a query within a React component, call `useSchedulerDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSchedulerDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ISchedulerDeletedSubscription, ISchedulerDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ISchedulerDeletedSubscription, ISchedulerDeletedSubscriptionVariables>(SchedulerDeletedDocument, options);
      }
export type SchedulerDeletedSubscriptionHookResult = ReturnType<typeof useSchedulerDeletedSubscription>;
export type SchedulerDeletedSubscriptionResult = Apollo.SubscriptionResult<ISchedulerDeletedSubscription>;
export const SchedulerCreatedDocument = gql`
    subscription schedulerCreated {
  result: schedulerCreated {
    ...SchedulerDetails
  }
}
    ${SchedulerDetailsFragmentDoc}`;

/**
 * __useSchedulerCreatedSubscription__
 *
 * To run a query within a React component, call `useSchedulerCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSchedulerCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ISchedulerCreatedSubscription, ISchedulerCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ISchedulerCreatedSubscription, ISchedulerCreatedSubscriptionVariables>(SchedulerCreatedDocument, options);
      }
export type SchedulerCreatedSubscriptionHookResult = ReturnType<typeof useSchedulerCreatedSubscription>;
export type SchedulerCreatedSubscriptionResult = Apollo.SubscriptionResult<ISchedulerCreatedSubscription>;
export const SchedulerUpdatedDocument = gql`
    subscription schedulerUpdated {
  result: schedulerUpdated {
    ...SchedulerDetails
  }
}
    ${SchedulerDetailsFragmentDoc}`;

/**
 * __useSchedulerUpdatedSubscription__
 *
 * To run a query within a React component, call `useSchedulerUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSchedulerUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ISchedulerUpdatedSubscription, ISchedulerUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ISchedulerUpdatedSubscription, ISchedulerUpdatedSubscriptionVariables>(SchedulerUpdatedDocument, options);
      }
export type SchedulerUpdatedSubscriptionHookResult = ReturnType<typeof useSchedulerUpdatedSubscription>;
export type SchedulerUpdatedSubscriptionResult = Apollo.SubscriptionResult<ISchedulerUpdatedSubscription>;
export const SectorsDocument = gql`
    query sectors {
  result: allSectors {
    id
    name
  }
}
    `;

/**
 * __useSectorsQuery__
 *
 * To run a query within a React component, call `useSectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSectorsQuery(baseOptions?: Apollo.QueryHookOptions<ISectorsQuery, ISectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISectorsQuery, ISectorsQueryVariables>(SectorsDocument, options);
      }
export function useSectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISectorsQuery, ISectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISectorsQuery, ISectorsQueryVariables>(SectorsDocument, options);
        }
export type SectorsQueryHookResult = ReturnType<typeof useSectorsQuery>;
export type SectorsLazyQueryHookResult = ReturnType<typeof useSectorsLazyQuery>;
export type SectorsQueryResult = Apollo.QueryResult<ISectorsQuery, ISectorsQueryVariables>;
export const GetAllSendersDocument = gql`
    query getAllSenders {
  result: getAllSenders {
    id
    email
  }
}
    `;

/**
 * __useGetAllSendersQuery__
 *
 * To run a query within a React component, call `useGetAllSendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSendersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSendersQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllSendersQuery, IGetAllSendersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllSendersQuery, IGetAllSendersQueryVariables>(GetAllSendersDocument, options);
      }
export function useGetAllSendersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllSendersQuery, IGetAllSendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllSendersQuery, IGetAllSendersQueryVariables>(GetAllSendersDocument, options);
        }
export type GetAllSendersQueryHookResult = ReturnType<typeof useGetAllSendersQuery>;
export type GetAllSendersLazyQueryHookResult = ReturnType<typeof useGetAllSendersLazyQuery>;
export type GetAllSendersQueryResult = Apollo.QueryResult<IGetAllSendersQuery, IGetAllSendersQueryVariables>;
export const GetSendGridStatisticsDocument = gql`
    query getSendGridStatistics {
  result: getSendGridStatistics {
    month
    sent
    delivered
    read
    blocks
    bounces
    spam_reports
  }
}
    `;

/**
 * __useGetSendGridStatisticsQuery__
 *
 * To run a query within a React component, call `useGetSendGridStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendGridStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendGridStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSendGridStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<IGetSendGridStatisticsQuery, IGetSendGridStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSendGridStatisticsQuery, IGetSendGridStatisticsQueryVariables>(GetSendGridStatisticsDocument, options);
      }
export function useGetSendGridStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSendGridStatisticsQuery, IGetSendGridStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSendGridStatisticsQuery, IGetSendGridStatisticsQueryVariables>(GetSendGridStatisticsDocument, options);
        }
export type GetSendGridStatisticsQueryHookResult = ReturnType<typeof useGetSendGridStatisticsQuery>;
export type GetSendGridStatisticsLazyQueryHookResult = ReturnType<typeof useGetSendGridStatisticsLazyQuery>;
export type GetSendGridStatisticsQueryResult = Apollo.QueryResult<IGetSendGridStatisticsQuery, IGetSendGridStatisticsQueryVariables>;
export const GetSendGridMessagesDocument = gql`
    query getSendGridMessages($scheduler_id: Int!) {
  result: getSendGridMessages(scheduler_id: $scheduler_id) {
    id
    sg_message_id
    opens_count
    clicks_count
    email
    status
  }
}
    `;

/**
 * __useGetSendGridMessagesQuery__
 *
 * To run a query within a React component, call `useGetSendGridMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendGridMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendGridMessagesQuery({
 *   variables: {
 *      scheduler_id: // value for 'scheduler_id'
 *   },
 * });
 */
export function useGetSendGridMessagesQuery(baseOptions: Apollo.QueryHookOptions<IGetSendGridMessagesQuery, IGetSendGridMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSendGridMessagesQuery, IGetSendGridMessagesQueryVariables>(GetSendGridMessagesDocument, options);
      }
export function useGetSendGridMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSendGridMessagesQuery, IGetSendGridMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSendGridMessagesQuery, IGetSendGridMessagesQueryVariables>(GetSendGridMessagesDocument, options);
        }
export type GetSendGridMessagesQueryHookResult = ReturnType<typeof useGetSendGridMessagesQuery>;
export type GetSendGridMessagesLazyQueryHookResult = ReturnType<typeof useGetSendGridMessagesLazyQuery>;
export type GetSendGridMessagesQueryResult = Apollo.QueryResult<IGetSendGridMessagesQuery, IGetSendGridMessagesQueryVariables>;
export const GetSendGridDataForExcelDocument = gql`
    query getSendGridDataForExcel($scheduler_id: Int!) {
  result: getSendGridMessages(scheduler_id: $scheduler_id) {
    id
    scheduler {
      id
      name
    }
    opens_count
    clicks_count
    email
    status
  }
}
    `;

/**
 * __useGetSendGridDataForExcelQuery__
 *
 * To run a query within a React component, call `useGetSendGridDataForExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendGridDataForExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendGridDataForExcelQuery({
 *   variables: {
 *      scheduler_id: // value for 'scheduler_id'
 *   },
 * });
 */
export function useGetSendGridDataForExcelQuery(baseOptions: Apollo.QueryHookOptions<IGetSendGridDataForExcelQuery, IGetSendGridDataForExcelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSendGridDataForExcelQuery, IGetSendGridDataForExcelQueryVariables>(GetSendGridDataForExcelDocument, options);
      }
export function useGetSendGridDataForExcelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSendGridDataForExcelQuery, IGetSendGridDataForExcelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSendGridDataForExcelQuery, IGetSendGridDataForExcelQueryVariables>(GetSendGridDataForExcelDocument, options);
        }
export type GetSendGridDataForExcelQueryHookResult = ReturnType<typeof useGetSendGridDataForExcelQuery>;
export type GetSendGridDataForExcelLazyQueryHookResult = ReturnType<typeof useGetSendGridDataForExcelLazyQuery>;
export type GetSendGridDataForExcelQueryResult = Apollo.QueryResult<IGetSendGridDataForExcelQuery, IGetSendGridDataForExcelQueryVariables>;
export const GetSendGridEventsDocument = gql`
    query getSendGridEvents($sg_message_id: String!) {
  result: getSendGridEvents(sg_message_id: $sg_message_id) {
    id
    name
    timestamp
    url
  }
}
    `;

/**
 * __useGetSendGridEventsQuery__
 *
 * To run a query within a React component, call `useGetSendGridEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendGridEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendGridEventsQuery({
 *   variables: {
 *      sg_message_id: // value for 'sg_message_id'
 *   },
 * });
 */
export function useGetSendGridEventsQuery(baseOptions: Apollo.QueryHookOptions<IGetSendGridEventsQuery, IGetSendGridEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSendGridEventsQuery, IGetSendGridEventsQueryVariables>(GetSendGridEventsDocument, options);
      }
export function useGetSendGridEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSendGridEventsQuery, IGetSendGridEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSendGridEventsQuery, IGetSendGridEventsQueryVariables>(GetSendGridEventsDocument, options);
        }
export type GetSendGridEventsQueryHookResult = ReturnType<typeof useGetSendGridEventsQuery>;
export type GetSendGridEventsLazyQueryHookResult = ReturnType<typeof useGetSendGridEventsLazyQuery>;
export type GetSendGridEventsQueryResult = Apollo.QueryResult<IGetSendGridEventsQuery, IGetSendGridEventsQueryVariables>;
export const GetSiteSectionsDocument = gql`
    query getSiteSections {
  result: getSiteSections {
    ...SiteSectionDetails
  }
}
    ${SiteSectionDetailsFragmentDoc}`;

/**
 * __useGetSiteSectionsQuery__
 *
 * To run a query within a React component, call `useGetSiteSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSiteSectionsQuery(baseOptions?: Apollo.QueryHookOptions<IGetSiteSectionsQuery, IGetSiteSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSiteSectionsQuery, IGetSiteSectionsQueryVariables>(GetSiteSectionsDocument, options);
      }
export function useGetSiteSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSiteSectionsQuery, IGetSiteSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSiteSectionsQuery, IGetSiteSectionsQueryVariables>(GetSiteSectionsDocument, options);
        }
export type GetSiteSectionsQueryHookResult = ReturnType<typeof useGetSiteSectionsQuery>;
export type GetSiteSectionsLazyQueryHookResult = ReturnType<typeof useGetSiteSectionsLazyQuery>;
export type GetSiteSectionsQueryResult = Apollo.QueryResult<IGetSiteSectionsQuery, IGetSiteSectionsQueryVariables>;
export const CreateSiteSectionDocument = gql`
    mutation createSiteSection($name: String!) {
  result: createSiteSection(name: $name) {
    ...SiteSectionDetails
  }
}
    ${SiteSectionDetailsFragmentDoc}`;
export type ICreateSiteSectionMutationFn = Apollo.MutationFunction<ICreateSiteSectionMutation, ICreateSiteSectionMutationVariables>;

/**
 * __useCreateSiteSectionMutation__
 *
 * To run a mutation, you first call `useCreateSiteSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteSectionMutation, { data, loading, error }] = useCreateSiteSectionMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateSiteSectionMutation(baseOptions?: Apollo.MutationHookOptions<ICreateSiteSectionMutation, ICreateSiteSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateSiteSectionMutation, ICreateSiteSectionMutationVariables>(CreateSiteSectionDocument, options);
      }
export type CreateSiteSectionMutationHookResult = ReturnType<typeof useCreateSiteSectionMutation>;
export type CreateSiteSectionMutationResult = Apollo.MutationResult<ICreateSiteSectionMutation>;
export type CreateSiteSectionMutationOptions = Apollo.BaseMutationOptions<ICreateSiteSectionMutation, ICreateSiteSectionMutationVariables>;
export const DeleteSiteSectionDocument = gql`
    mutation deleteSiteSection($id: ID!) {
  result: deleteSiteSection(id: $id)
}
    `;
export type IDeleteSiteSectionMutationFn = Apollo.MutationFunction<IDeleteSiteSectionMutation, IDeleteSiteSectionMutationVariables>;

/**
 * __useDeleteSiteSectionMutation__
 *
 * To run a mutation, you first call `useDeleteSiteSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteSectionMutation, { data, loading, error }] = useDeleteSiteSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSiteSectionMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteSiteSectionMutation, IDeleteSiteSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteSiteSectionMutation, IDeleteSiteSectionMutationVariables>(DeleteSiteSectionDocument, options);
      }
export type DeleteSiteSectionMutationHookResult = ReturnType<typeof useDeleteSiteSectionMutation>;
export type DeleteSiteSectionMutationResult = Apollo.MutationResult<IDeleteSiteSectionMutation>;
export type DeleteSiteSectionMutationOptions = Apollo.BaseMutationOptions<IDeleteSiteSectionMutation, IDeleteSiteSectionMutationVariables>;
export const UpdateSiteSectionDocument = gql`
    mutation updateSiteSection($id: ID!, $name: String!) {
  result: updateSiteSection(id: $id, name: $name) {
    ...SiteSectionDetails
  }
}
    ${SiteSectionDetailsFragmentDoc}`;
export type IUpdateSiteSectionMutationFn = Apollo.MutationFunction<IUpdateSiteSectionMutation, IUpdateSiteSectionMutationVariables>;

/**
 * __useUpdateSiteSectionMutation__
 *
 * To run a mutation, you first call `useUpdateSiteSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteSectionMutation, { data, loading, error }] = useUpdateSiteSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateSiteSectionMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateSiteSectionMutation, IUpdateSiteSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateSiteSectionMutation, IUpdateSiteSectionMutationVariables>(UpdateSiteSectionDocument, options);
      }
export type UpdateSiteSectionMutationHookResult = ReturnType<typeof useUpdateSiteSectionMutation>;
export type UpdateSiteSectionMutationResult = Apollo.MutationResult<IUpdateSiteSectionMutation>;
export type UpdateSiteSectionMutationOptions = Apollo.BaseMutationOptions<IUpdateSiteSectionMutation, IUpdateSiteSectionMutationVariables>;
export const SiteSectionCreatedDocument = gql`
    subscription siteSectionCreated {
  result: siteSectionCreated {
    ...SiteSectionDetails
  }
}
    ${SiteSectionDetailsFragmentDoc}`;

/**
 * __useSiteSectionCreatedSubscription__
 *
 * To run a query within a React component, call `useSiteSectionCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSiteSectionCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSectionCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSiteSectionCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ISiteSectionCreatedSubscription, ISiteSectionCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ISiteSectionCreatedSubscription, ISiteSectionCreatedSubscriptionVariables>(SiteSectionCreatedDocument, options);
      }
export type SiteSectionCreatedSubscriptionHookResult = ReturnType<typeof useSiteSectionCreatedSubscription>;
export type SiteSectionCreatedSubscriptionResult = Apollo.SubscriptionResult<ISiteSectionCreatedSubscription>;
export const SiteSectionDeletedDocument = gql`
    subscription siteSectionDeleted {
  result: siteSectionDeleted {
    ...SiteSectionDetails
  }
}
    ${SiteSectionDetailsFragmentDoc}`;

/**
 * __useSiteSectionDeletedSubscription__
 *
 * To run a query within a React component, call `useSiteSectionDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSiteSectionDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSectionDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSiteSectionDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ISiteSectionDeletedSubscription, ISiteSectionDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ISiteSectionDeletedSubscription, ISiteSectionDeletedSubscriptionVariables>(SiteSectionDeletedDocument, options);
      }
export type SiteSectionDeletedSubscriptionHookResult = ReturnType<typeof useSiteSectionDeletedSubscription>;
export type SiteSectionDeletedSubscriptionResult = Apollo.SubscriptionResult<ISiteSectionDeletedSubscription>;
export const SiteSectionUpdatedDocument = gql`
    subscription siteSectionUpdated {
  result: siteSectionUpdated {
    ...SiteSectionDetails
  }
}
    ${SiteSectionDetailsFragmentDoc}`;

/**
 * __useSiteSectionUpdatedSubscription__
 *
 * To run a query within a React component, call `useSiteSectionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSiteSectionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSectionUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSiteSectionUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ISiteSectionUpdatedSubscription, ISiteSectionUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ISiteSectionUpdatedSubscription, ISiteSectionUpdatedSubscriptionVariables>(SiteSectionUpdatedDocument, options);
      }
export type SiteSectionUpdatedSubscriptionHookResult = ReturnType<typeof useSiteSectionUpdatedSubscription>;
export type SiteSectionUpdatedSubscriptionResult = Apollo.SubscriptionResult<ISiteSectionUpdatedSubscription>;
export const StocksDocument = gql`
    query stocks {
  result: stocks {
    ...StockOverview
  }
}
    ${StockOverviewFragmentDoc}`;

/**
 * __useStocksQuery__
 *
 * To run a query within a React component, call `useStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStocksQuery({
 *   variables: {
 *   },
 * });
 */
export function useStocksQuery(baseOptions?: Apollo.QueryHookOptions<IStocksQuery, IStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IStocksQuery, IStocksQueryVariables>(StocksDocument, options);
      }
export function useStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IStocksQuery, IStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IStocksQuery, IStocksQueryVariables>(StocksDocument, options);
        }
export type StocksQueryHookResult = ReturnType<typeof useStocksQuery>;
export type StocksLazyQueryHookResult = ReturnType<typeof useStocksLazyQuery>;
export type StocksQueryResult = Apollo.QueryResult<IStocksQuery, IStocksQueryVariables>;
export const StockDocument = gql`
    query stock($id: Int!) {
  result: stock(id: $id) {
    ...StockDetails
  }
}
    ${StockDetailsFragmentDoc}`;

/**
 * __useStockQuery__
 *
 * To run a query within a React component, call `useStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStockQuery(baseOptions: Apollo.QueryHookOptions<IStockQuery, IStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IStockQuery, IStockQueryVariables>(StockDocument, options);
      }
export function useStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IStockQuery, IStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IStockQuery, IStockQueryVariables>(StockDocument, options);
        }
export type StockQueryHookResult = ReturnType<typeof useStockQuery>;
export type StockLazyQueryHookResult = ReturnType<typeof useStockLazyQuery>;
export type StockQueryResult = Apollo.QueryResult<IStockQuery, IStockQueryVariables>;
export const FilteredStocksDocument = gql`
    query filteredStocks($date: String!, $stock_ids: [Int]) {
  result: filteredStocks(date: $date, stock_ids: $stock_ids) {
    ...StockOverview
  }
}
    ${StockOverviewFragmentDoc}`;

/**
 * __useFilteredStocksQuery__
 *
 * To run a query within a React component, call `useFilteredStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredStocksQuery({
 *   variables: {
 *      date: // value for 'date'
 *      stock_ids: // value for 'stock_ids'
 *   },
 * });
 */
export function useFilteredStocksQuery(baseOptions: Apollo.QueryHookOptions<IFilteredStocksQuery, IFilteredStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFilteredStocksQuery, IFilteredStocksQueryVariables>(FilteredStocksDocument, options);
      }
export function useFilteredStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFilteredStocksQuery, IFilteredStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFilteredStocksQuery, IFilteredStocksQueryVariables>(FilteredStocksDocument, options);
        }
export type FilteredStocksQueryHookResult = ReturnType<typeof useFilteredStocksQuery>;
export type FilteredStocksLazyQueryHookResult = ReturnType<typeof useFilteredStocksLazyQuery>;
export type FilteredStocksQueryResult = Apollo.QueryResult<IFilteredStocksQuery, IFilteredStocksQueryVariables>;
export const StocksFilteredDocument = gql`
    query stocksFiltered($filter: StockFilterInput) {
  result: stocksFiltered(filter: $filter) {
    stocks {
      ...StockOverview
    }
    total
  }
}
    ${StockOverviewFragmentDoc}`;

/**
 * __useStocksFilteredQuery__
 *
 * To run a query within a React component, call `useStocksFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useStocksFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStocksFilteredQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStocksFilteredQuery(baseOptions?: Apollo.QueryHookOptions<IStocksFilteredQuery, IStocksFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IStocksFilteredQuery, IStocksFilteredQueryVariables>(StocksFilteredDocument, options);
      }
export function useStocksFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IStocksFilteredQuery, IStocksFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IStocksFilteredQuery, IStocksFilteredQueryVariables>(StocksFilteredDocument, options);
        }
export type StocksFilteredQueryHookResult = ReturnType<typeof useStocksFilteredQuery>;
export type StocksFilteredLazyQueryHookResult = ReturnType<typeof useStocksFilteredLazyQuery>;
export type StocksFilteredQueryResult = Apollo.QueryResult<IStocksFilteredQuery, IStocksFilteredQueryVariables>;
export const CreateStockDocument = gql`
    mutation createStock($input: StockInput!) {
  result: createStock(input: $input) {
    ...StockOverview
  }
}
    ${StockOverviewFragmentDoc}`;
export type ICreateStockMutationFn = Apollo.MutationFunction<ICreateStockMutation, ICreateStockMutationVariables>;

/**
 * __useCreateStockMutation__
 *
 * To run a mutation, you first call `useCreateStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockMutation, { data, loading, error }] = useCreateStockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStockMutation(baseOptions?: Apollo.MutationHookOptions<ICreateStockMutation, ICreateStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateStockMutation, ICreateStockMutationVariables>(CreateStockDocument, options);
      }
export type CreateStockMutationHookResult = ReturnType<typeof useCreateStockMutation>;
export type CreateStockMutationResult = Apollo.MutationResult<ICreateStockMutation>;
export type CreateStockMutationOptions = Apollo.BaseMutationOptions<ICreateStockMutation, ICreateStockMutationVariables>;
export const UpdateStockDocument = gql`
    mutation updateStock($id: ID!, $input: StockInput!) {
  result: updateStock(id: $id, input: $input) {
    ...StockOverview
  }
}
    ${StockOverviewFragmentDoc}`;
export type IUpdateStockMutationFn = Apollo.MutationFunction<IUpdateStockMutation, IUpdateStockMutationVariables>;

/**
 * __useUpdateStockMutation__
 *
 * To run a mutation, you first call `useUpdateStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockMutation, { data, loading, error }] = useUpdateStockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStockMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateStockMutation, IUpdateStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateStockMutation, IUpdateStockMutationVariables>(UpdateStockDocument, options);
      }
export type UpdateStockMutationHookResult = ReturnType<typeof useUpdateStockMutation>;
export type UpdateStockMutationResult = Apollo.MutationResult<IUpdateStockMutation>;
export type UpdateStockMutationOptions = Apollo.BaseMutationOptions<IUpdateStockMutation, IUpdateStockMutationVariables>;
export const DeleteHsDataDocument = gql`
    mutation deleteHSData($id: ID!, $input: DeleteHistoryStocksDataInput!) {
  result: deleteHSData(id: $id, input: $input)
}
    `;
export type IDeleteHsDataMutationFn = Apollo.MutationFunction<IDeleteHsDataMutation, IDeleteHsDataMutationVariables>;

/**
 * __useDeleteHsDataMutation__
 *
 * To run a mutation, you first call `useDeleteHsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHsDataMutation, { data, loading, error }] = useDeleteHsDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteHsDataMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteHsDataMutation, IDeleteHsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteHsDataMutation, IDeleteHsDataMutationVariables>(DeleteHsDataDocument, options);
      }
export type DeleteHsDataMutationHookResult = ReturnType<typeof useDeleteHsDataMutation>;
export type DeleteHsDataMutationResult = Apollo.MutationResult<IDeleteHsDataMutation>;
export type DeleteHsDataMutationOptions = Apollo.BaseMutationOptions<IDeleteHsDataMutation, IDeleteHsDataMutationVariables>;
export const StockCreatedDocument = gql`
    subscription StockCreated {
  result: stockCreated {
    ...StockOverview
  }
}
    ${StockOverviewFragmentDoc}`;

/**
 * __useStockCreatedSubscription__
 *
 * To run a query within a React component, call `useStockCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStockCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useStockCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IStockCreatedSubscription, IStockCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IStockCreatedSubscription, IStockCreatedSubscriptionVariables>(StockCreatedDocument, options);
      }
export type StockCreatedSubscriptionHookResult = ReturnType<typeof useStockCreatedSubscription>;
export type StockCreatedSubscriptionResult = Apollo.SubscriptionResult<IStockCreatedSubscription>;
export const StockUpdatedDocument = gql`
    subscription StockUpdated {
  result: stockUpdated {
    ...StockOverviewMini
  }
}
    ${StockOverviewMiniFragmentDoc}`;

/**
 * __useStockUpdatedSubscription__
 *
 * To run a query within a React component, call `useStockUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStockUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useStockUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IStockUpdatedSubscription, IStockUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IStockUpdatedSubscription, IStockUpdatedSubscriptionVariables>(StockUpdatedDocument, options);
      }
export type StockUpdatedSubscriptionHookResult = ReturnType<typeof useStockUpdatedSubscription>;
export type StockUpdatedSubscriptionResult = Apollo.SubscriptionResult<IStockUpdatedSubscription>;
export const TemplatesDocument = gql`
    query templates {
  result: templates {
    ...TemplateDetails
  }
}
    ${TemplateDetailsFragmentDoc}`;

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ITemplatesQuery, ITemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ITemplatesQuery, ITemplatesQueryVariables>(TemplatesDocument, options);
      }
export function useTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ITemplatesQuery, ITemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ITemplatesQuery, ITemplatesQueryVariables>(TemplatesDocument, options);
        }
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>;
export type TemplatesLazyQueryHookResult = ReturnType<typeof useTemplatesLazyQuery>;
export type TemplatesQueryResult = Apollo.QueryResult<ITemplatesQuery, ITemplatesQueryVariables>;
export const DeleteTemplateDocument = gql`
    mutation deleteTemplate($id: Int!) {
  result: deleteTemplate(id: $id)
}
    `;
export type IDeleteTemplateMutationFn = Apollo.MutationFunction<IDeleteTemplateMutation, IDeleteTemplateMutationVariables>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteTemplateMutation, IDeleteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteTemplateMutation, IDeleteTemplateMutationVariables>(DeleteTemplateDocument, options);
      }
export type DeleteTemplateMutationHookResult = ReturnType<typeof useDeleteTemplateMutation>;
export type DeleteTemplateMutationResult = Apollo.MutationResult<IDeleteTemplateMutation>;
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<IDeleteTemplateMutation, IDeleteTemplateMutationVariables>;
export const CreateTemplateDocument = gql`
    mutation createTemplate($input: TemplateInput!) {
  result: createTemplate(input: $input) {
    ...TemplateDetails
  }
}
    ${TemplateDetailsFragmentDoc}`;
export type ICreateTemplateMutationFn = Apollo.MutationFunction<ICreateTemplateMutation, ICreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ICreateTemplateMutation, ICreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateTemplateMutation, ICreateTemplateMutationVariables>(CreateTemplateDocument, options);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = Apollo.MutationResult<ICreateTemplateMutation>;
export type CreateTemplateMutationOptions = Apollo.BaseMutationOptions<ICreateTemplateMutation, ICreateTemplateMutationVariables>;
export const UpdateTemplateDocument = gql`
    mutation updateTemplate($id: Int!, $input: TemplateInput!) {
  result: updateTemplate(id: $id, input: $input) {
    ...TemplateDetails
  }
}
    ${TemplateDetailsFragmentDoc}`;
export type IUpdateTemplateMutationFn = Apollo.MutationFunction<IUpdateTemplateMutation, IUpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateTemplateMutation, IUpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateTemplateMutation, IUpdateTemplateMutationVariables>(UpdateTemplateDocument, options);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = Apollo.MutationResult<IUpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = Apollo.BaseMutationOptions<IUpdateTemplateMutation, IUpdateTemplateMutationVariables>;
export const TemplateDeletedDocument = gql`
    subscription templateDeleted {
  result: templateDeleted {
    id
  }
}
    `;

/**
 * __useTemplateDeletedSubscription__
 *
 * To run a query within a React component, call `useTemplateDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTemplateDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTemplateDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ITemplateDeletedSubscription, ITemplateDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ITemplateDeletedSubscription, ITemplateDeletedSubscriptionVariables>(TemplateDeletedDocument, options);
      }
export type TemplateDeletedSubscriptionHookResult = ReturnType<typeof useTemplateDeletedSubscription>;
export type TemplateDeletedSubscriptionResult = Apollo.SubscriptionResult<ITemplateDeletedSubscription>;
export const TemplateCreatedDocument = gql`
    subscription templateCreated {
  result: templateCreated {
    ...TemplateDetails
  }
}
    ${TemplateDetailsFragmentDoc}`;

/**
 * __useTemplateCreatedSubscription__
 *
 * To run a query within a React component, call `useTemplateCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTemplateCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTemplateCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ITemplateCreatedSubscription, ITemplateCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ITemplateCreatedSubscription, ITemplateCreatedSubscriptionVariables>(TemplateCreatedDocument, options);
      }
export type TemplateCreatedSubscriptionHookResult = ReturnType<typeof useTemplateCreatedSubscription>;
export type TemplateCreatedSubscriptionResult = Apollo.SubscriptionResult<ITemplateCreatedSubscription>;
export const TemplateUpdatedDocument = gql`
    subscription templateUpdated {
  result: templateUpdated {
    ...TemplateDetails
  }
}
    ${TemplateDetailsFragmentDoc}`;

/**
 * __useTemplateUpdatedSubscription__
 *
 * To run a query within a React component, call `useTemplateUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTemplateUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTemplateUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ITemplateUpdatedSubscription, ITemplateUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ITemplateUpdatedSubscription, ITemplateUpdatedSubscriptionVariables>(TemplateUpdatedDocument, options);
      }
export type TemplateUpdatedSubscriptionHookResult = ReturnType<typeof useTemplateUpdatedSubscription>;
export type TemplateUpdatedSubscriptionResult = Apollo.SubscriptionResult<ITemplateUpdatedSubscription>;
export const TitlesInternalDocument = gql`
    query titlesInternal {
  result: titlesInternal {
    id
    name
  }
}
    `;

/**
 * __useTitlesInternalQuery__
 *
 * To run a query within a React component, call `useTitlesInternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlesInternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitlesInternalQuery({
 *   variables: {
 *   },
 * });
 */
export function useTitlesInternalQuery(baseOptions?: Apollo.QueryHookOptions<ITitlesInternalQuery, ITitlesInternalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ITitlesInternalQuery, ITitlesInternalQueryVariables>(TitlesInternalDocument, options);
      }
export function useTitlesInternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ITitlesInternalQuery, ITitlesInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ITitlesInternalQuery, ITitlesInternalQueryVariables>(TitlesInternalDocument, options);
        }
export type TitlesInternalQueryHookResult = ReturnType<typeof useTitlesInternalQuery>;
export type TitlesInternalLazyQueryHookResult = ReturnType<typeof useTitlesInternalLazyQuery>;
export type TitlesInternalQueryResult = Apollo.QueryResult<ITitlesInternalQuery, ITitlesInternalQueryVariables>;
export const AddRoleToUserDocument = gql`
    mutation addRoleToUser($role_id: Int!, $user_ids: [Int]!) {
  result: addRoleToUser(role_id: $role_id, user_ids: $user_ids)
}
    `;
export type IAddRoleToUserMutationFn = Apollo.MutationFunction<IAddRoleToUserMutation, IAddRoleToUserMutationVariables>;

/**
 * __useAddRoleToUserMutation__
 *
 * To run a mutation, you first call `useAddRoleToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleToUserMutation, { data, loading, error }] = useAddRoleToUserMutation({
 *   variables: {
 *      role_id: // value for 'role_id'
 *      user_ids: // value for 'user_ids'
 *   },
 * });
 */
export function useAddRoleToUserMutation(baseOptions?: Apollo.MutationHookOptions<IAddRoleToUserMutation, IAddRoleToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddRoleToUserMutation, IAddRoleToUserMutationVariables>(AddRoleToUserDocument, options);
      }
export type AddRoleToUserMutationHookResult = ReturnType<typeof useAddRoleToUserMutation>;
export type AddRoleToUserMutationResult = Apollo.MutationResult<IAddRoleToUserMutation>;
export type AddRoleToUserMutationOptions = Apollo.BaseMutationOptions<IAddRoleToUserMutation, IAddRoleToUserMutationVariables>;
export const GetUsersDocument = gql`
    query getUsers {
  result: users {
    id
    username
    first_name
    last_name
    roles
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<IGetUsersQuery, IGetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUsersQuery, IGetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUsersQuery, IGetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUsersQuery, IGetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<IGetUsersQuery, IGetUsersQueryVariables>;
export const GetUserDocument = gql`
    query getUser($id: Int!) {
  result: user(id: $id) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<IGetUserQuery, IGetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserQuery, IGetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserQuery, IGetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserQuery, IGetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<IGetUserQuery, IGetUserQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  result: createUser(input: $input) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export type ICreateUserMutationFn = Apollo.MutationFunction<ICreateUserMutation, ICreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<ICreateUserMutation, ICreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateUserMutation, ICreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<ICreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<ICreateUserMutation, ICreateUserMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($id: Int!, $newPass: String!) {
  result: updatePassword(id: $id, newPass: $newPass)
}
    `;
export type IUpdatePasswordMutationFn = Apollo.MutationFunction<IUpdatePasswordMutation, IUpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newPass: // value for 'newPass'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<IUpdatePasswordMutation, IUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdatePasswordMutation, IUpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<IUpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<IUpdatePasswordMutation, IUpdatePasswordMutationVariables>;
export const UpdateUserDetailsDocument = gql`
    mutation updateUserDetails($id: Int!, $input: UserInput!) {
  result: updateUserDetails(id: $id, input: $input) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export type IUpdateUserDetailsMutationFn = Apollo.MutationFunction<IUpdateUserDetailsMutation, IUpdateUserDetailsMutationVariables>;

/**
 * __useUpdateUserDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailsMutation, { data, loading, error }] = useUpdateUserDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateUserDetailsMutation, IUpdateUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateUserDetailsMutation, IUpdateUserDetailsMutationVariables>(UpdateUserDetailsDocument, options);
      }
export type UpdateUserDetailsMutationHookResult = ReturnType<typeof useUpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationResult = Apollo.MutationResult<IUpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationOptions = Apollo.BaseMutationOptions<IUpdateUserDetailsMutation, IUpdateUserDetailsMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: Int!) {
  result: deleteUser(id: $id)
}
    `;
export type IDeleteUserMutationFn = Apollo.MutationFunction<IDeleteUserMutation, IDeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteUserMutation, IDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteUserMutation, IDeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<IDeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<IDeleteUserMutation, IDeleteUserMutationVariables>;
export const UserCreatedDocument = gql`
    subscription userCreated {
  result: userCreated {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useUserCreatedSubscription__
 *
 * To run a query within a React component, call `useUserCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IUserCreatedSubscription, IUserCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IUserCreatedSubscription, IUserCreatedSubscriptionVariables>(UserCreatedDocument, options);
      }
export type UserCreatedSubscriptionHookResult = ReturnType<typeof useUserCreatedSubscription>;
export type UserCreatedSubscriptionResult = Apollo.SubscriptionResult<IUserCreatedSubscription>;
export const UserUpdatedDocument = gql`
    subscription userUpdated {
  result: userUpdated {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useUserUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IUserUpdatedSubscription, IUserUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IUserUpdatedSubscription, IUserUpdatedSubscriptionVariables>(UserUpdatedDocument, options);
      }
export type UserUpdatedSubscriptionHookResult = ReturnType<typeof useUserUpdatedSubscription>;
export type UserUpdatedSubscriptionResult = Apollo.SubscriptionResult<IUserUpdatedSubscription>;
export const UserDeletedDocument = gql`
    subscription userDeleted {
  result: userDeleted {
    id
  }
}
    `;

/**
 * __useUserDeletedSubscription__
 *
 * To run a query within a React component, call `useUserDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IUserDeletedSubscription, IUserDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IUserDeletedSubscription, IUserDeletedSubscriptionVariables>(UserDeletedDocument, options);
      }
export type UserDeletedSubscriptionHookResult = ReturnType<typeof useUserDeletedSubscription>;
export type UserDeletedSubscriptionResult = Apollo.SubscriptionResult<IUserDeletedSubscription>;
export const UserRoleRemovedDocument = gql`
    subscription userRoleRemoved {
  result: userRoleRemoved {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useUserRoleRemovedSubscription__
 *
 * To run a query within a React component, call `useUserRoleRemovedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleRemovedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleRemovedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserRoleRemovedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IUserRoleRemovedSubscription, IUserRoleRemovedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IUserRoleRemovedSubscription, IUserRoleRemovedSubscriptionVariables>(UserRoleRemovedDocument, options);
      }
export type UserRoleRemovedSubscriptionHookResult = ReturnType<typeof useUserRoleRemovedSubscription>;
export type UserRoleRemovedSubscriptionResult = Apollo.SubscriptionResult<IUserRoleRemovedSubscription>;